import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.platform');
import { HostListener, OnInit, OnDestroy } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-platform',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.platform/view.scss */
@charset "UTF-8";
:host {
  --run-primary: #0f9d7a;
  --run-secondary: #14b8a6;
  --run-success: #16a34a;
  --run-warning: #f59e0b;
  --run-danger: #ef4444;
  --run-neutral: #64748b;
  --run-background: #f8fafc;
  --run-surface: #fff;
  --run-border: #e2e8f0;
  --run-card-gap: 12px;
  --run-compact-gap: 8px;
  --platform-card-gap: 12px;
  --platform-inner-gap: 8px;
  display: block;
  min-width: 1080px;
  min-height: 100%;
  color: #182236;
  background: #f5f7f7;
}

* {
  box-sizing: border-box;
}

button,
input,
select {
  font: inherit;
}

button {
  cursor: pointer;
}

.platform-demo-page {
  min-height: 100vh;
  background: radial-gradient(circle at 82% 5%, rgba(83, 118, 235, 0.055), transparent 21%), radial-gradient(circle at 12% 14%, rgba(42, 184, 154, 0.06), transparent 20%), #f6f7f6;
}

.demo-page-header {
  height: 56px;
  min-height: 56px;
  padding: 0 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  border-bottom: 1px solid rgba(231, 236, 239, 0.8);
  background: rgba(255, 255, 255, 0.72);
  backdrop-filter: blur(16px);
}

.platform-mobile-menu {
  width: 36px;
  height: 36px;
  padding: 0;
  display: none;
  place-items: center;
  flex: 0 0 auto;
  border: 1px solid #e1e7ea;
  border-radius: 10px;
  color: #344154;
  background: #fff;
}

.platform-mobile-menu svg {
  width: 20px;
  height: 20px;
}

.header-copy {
  min-width: 0;
}

.breadcrumb {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #8793a3;
  font-size: 9px;
  font-weight: 760;
  letter-spacing: 0.08em;
  white-space: nowrap;
}

.breadcrumb a {
  color: #87909f;
  text-decoration: none;
}

.breadcrumb i {
  width: 3px;
  height: 3px;
  flex: 0 0 auto;
  border-radius: 50%;
  background: #aeb7c2;
}

.breadcrumb strong {
  color: #364153;
  font-size: 10px;
  letter-spacing: 0;
}

.sr-only {
  width: 1px;
  height: 1px;
  padding: 0;
  position: absolute;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  border: 0;
  white-space: nowrap;
}

.eyebrow,
.panel-title span,
.run-detail-head > div > span,
.timeline-head span,
.approval-intro > div:last-child > span,
.approval-detail-head > div > span,
.approval-identity span,
.decision-summary > span,
.rejection-copy > span,
.change-summary-title span,
.evidence-title span,
.audit-footer span,
.knowledge-side > span,
.report-banner span,
.settings-head > span,
.settings-head-enhanced > div:first-child > span,
.authority-card > span,
.recent-decisions > span,
.guide-hero-copy > span,
.guide-section-title > div > span,
.guide-help-footer > div > span {
  color: #24917a;
  font-size: 9px;
  font-weight: 820;
  letter-spacing: 0.12em;
}

.header-actions {
  display: flex;
  align-items: center;
  gap: 15px;
  color: #4d5667;
}

.primary-link,
.secondary-button {
  min-height: 32px;
  padding: 0 11px;
  display: flex;
  align-items: center;
  gap: 7px;
  border: 1px solid #d8dfe4;
  border-radius: 9px;
  color: #435268;
  background: #fff;
  font-size: 9px;
  font-weight: 720;
  text-decoration: none;
}

.header-help {
  border: 0;
  color: inherit;
  background: transparent;
}

.header-help:hover,
.header-user:hover {
  color: #087a69;
  background: #f0f8f6;
}

.header-help {
  min-height: 30px;
  padding: 0 10px;
  display: flex;
  align-items: center;
  border-right: 1px solid #e4e8eb;
  border-radius: 7px 0 0 7px;
  font-size: 11px;
  font-weight: 680;
  text-decoration: none;
}

.header-user {
  min-height: 36px;
  padding: 0;
  display: flex;
  align-items: center;
  gap: 8px;
  border-radius: 9px;
  color: #343b4a;
  text-decoration: none;
}

.header-user > span {
  width: 28px;
  height: 28px;
  display: grid;
  place-items: center;
  border-radius: 50%;
  color: #354052;
  background: #e8ecef;
  font-size: 10px;
  font-weight: 800;
}

.header-user strong {
  font-size: 11px;
}

.linked-run-context {
  max-width: 1380px;
  min-height: 132px;
  margin: 18px auto 0;
  padding: 13px 14px;
  display: grid;
  grid-template-columns: 248px minmax(420px, 1fr) 320px;
  align-items: stretch;
  gap: 12px;
  border: 1px solid #dce4e6;
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.94);
  box-shadow: 0 9px 26px rgba(35, 48, 62, 0.04);
}

.linked-run-context.historical-run {
  border-color: #d9dfe5;
  background: rgba(250, 251, 252, 0.96);
}

.linked-run-context.historical-run .linked-run-id > span {
  color: #7d8795;
}

.linked-run-id {
  padding: 5px 8px;
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  align-content: center;
  align-items: end;
  gap: 5px 7px;
  justify-content: center;
  border-right: 1px solid #e6ebed;
}

.linked-run-id span,
.linked-run-metric span,
.linked-handoff-head span {
  color: #84909f;
  font-size: 8px;
  font-weight: 820;
  letter-spacing: 0.11em;
}

.linked-run-id em {
  width: fit-content;
  margin-top: 2px;
  padding: 3px 5px;
  border-radius: 4px;
  color: #526d9e;
  background: #edf2fb;
  font-size: 7px;
  font-style: normal;
  font-weight: 800;
  letter-spacing: 0.06em;
}

.linked-run-id > span,
.linked-run-id > em {
  grid-column: 1/-1;
}

.context-selector {
  min-width: 0;
  display: grid;
  gap: 3px;
}

.context-selector small {
  color: #7d8998;
  font-size: 7px;
  font-weight: 760;
  letter-spacing: 0.07em;
}

.context-selector select {
  width: 100%;
  height: 30px;
  padding: 0 22px 0 8px;
  overflow: hidden;
  border: 1px solid #d8e1e4;
  border-radius: 7px;
  outline: 0;
  color: #2d4055;
  background: #fff;
  font-size: 8px;
  font-weight: 720;
  text-overflow: ellipsis;
}

.context-selector select:focus-visible {
  border-color: #69ad9c;
  box-shadow: 0 0 0 3px rgba(58, 157, 132, 0.1);
}

.linked-run-context.run-context-compact {
  min-height: 60px;
  margin-top: 6px;
  padding: 5px 10px;
  grid-template-columns: 1fr;
  border-color: var(--run-border);
  border-radius: 12px;
  background: var(--run-surface);
  box-shadow: 0 4px 14px rgba(15, 23, 42, 0.035);
}

.linked-run-context.approval-context-compact {
  min-height: 82px;
  margin-top: 8px;
  padding: 7px 9px;
  grid-template-columns: 220px minmax(360px, 1fr) 290px;
  gap: 8px;
  border-radius: 10px;
  box-shadow: 0 3px 12px rgba(32, 43, 56, 0.025);
}

.linked-run-context.projects-context-compact {
  max-width: 1450px;
  min-height: 104px;
  margin-top: 10px;
  padding: 9px 11px;
  grid-template-columns: 220px minmax(390px, 1fr) 290px;
  gap: 8px;
  border-radius: 12px;
}

.linked-run-context.knowledge-context-compact {
  min-height: 88px;
  margin-top: 8px;
  padding: 7px 10px;
  grid-template-columns: 210px minmax(340px, 1fr) 260px;
  gap: 7px;
  border-radius: 10px;
}

.linked-run-context.settings-context-compact {
  max-width: 1450px;
  min-height: 82px;
  margin-top: 8px;
  padding: 7px 9px;
  grid-template-columns: 210px minmax(360px, 1fr) 270px;
  gap: 7px;
  border-radius: 10px;
  box-shadow: 0 4px 14px rgba(32, 43, 56, 0.025);
}

.settings-context-compact .linked-run-id {
  padding: 2px 6px;
}

.settings-context-compact .linked-run-metrics {
  gap: 5px;
}

.settings-context-compact .linked-run-metric,
.settings-context-compact .linked-handoff {
  padding: 6px 7px;
  border-radius: 7px;
}

.settings-context-compact .context-selector select {
  height: 27px;
}

.settings-context-compact .linked-handoff p {
  margin-top: 3px;
}

.knowledge-context-compact .linked-run-id {
  padding: 2px 6px;
}

.knowledge-context-compact .linked-run-metrics {
  gap: 5px;
}

.knowledge-context-compact .linked-run-metric,
.knowledge-context-compact .linked-handoff {
  padding: 6px 7px;
  border-radius: 7px;
}

.knowledge-context-compact .context-selector select {
  height: 27px;
}

.projects-context-compact .linked-run-id {
  padding: 2px 7px;
}

.projects-context-compact .linked-run-metrics {
  gap: 6px;
}

.projects-context-compact .linked-run-metric,
.projects-context-compact .linked-handoff {
  padding: 7px 8px;
  border-radius: 8px;
}

.approval-context-compact .linked-run-id {
  padding: 2px 7px;
}

.approval-context-compact .linked-run-metrics {
  gap: 6px;
}

.approval-context-compact .linked-run-metric,
.approval-context-compact .linked-handoff {
  padding: 6px 7px;
  border-radius: 7px;
}

.approval-context-compact .context-selector select {
  height: 27px;
}

.approval-context-compact .linked-handoff-route,
.approval-context-compact .linked-handoff p {
  margin-top: 3px;
}

.run-context-compact .linked-run-id {
  padding: 2px 5px;
  grid-template-columns: 120px minmax(190px, 0.9fr) minmax(190px, 0.9fr) minmax(220px, 1.2fr);
  align-items: center;
  gap: 10px;
  border-right: 0;
}

.run-context-compact .linked-run-id > span {
  grid-column: auto;
  color: #28816c;
}

.context-page-focus {
  min-width: 0;
  display: grid;
  gap: 4px;
}

.context-page-focus > small {
  color: #7d8998;
  font-size: 7px;
  font-weight: 760;
  letter-spacing: 0.07em;
}

.context-page-focus > div {
  min-height: 30px;
  padding: 0 8px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  border: 1px solid #d8e1e4;
  border-radius: 7px;
  background: #f8fbfa;
}

.context-page-focus strong {
  overflow: hidden;
  color: #2d4055;
  font-size: 9px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.context-page-focus .ui-status {
  min-height: 18px;
  padding: 0 5px;
  flex: 0 0 auto;
  font-size: 6px;
}

.linked-run-metrics {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 8px;
}

.linked-run-metric {
  min-width: 0;
  padding: 9px 8px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  border-radius: 9px;
  background: #f7f9f9;
}

.linked-run-metric strong {
  margin-top: 4px;
  overflow: hidden;
  color: #344257;
  font-size: 10px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.linked-handoff {
  min-width: 0;
  padding: 9px 11px;
  border: 1px solid #d9e9e5;
  border-radius: 10px;
  background: #f3faf8;
}

.linked-handoff-head,
.linked-handoff-route {
  display: flex;
  align-items: center;
}

.linked-handoff-head {
  justify-content: space-between;
}

.linked-handoff-head em {
  color: #23836f;
  font-size: 7px;
  font-style: normal;
  font-weight: 820;
}

.linked-handoff-route {
  margin-top: 5px;
  gap: 6px;
  color: #2a3c50;
  font-size: 9px;
}

.linked-handoff-route i {
  color: #35a087;
  font-style: normal;
}

.linked-handoff p {
  margin: 5px 0 0;
  overflow: hidden;
  color: #687789;
  font-size: 8px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* Shared management context: only Project, Run, stage, and the active Agent handoff. */
.linked-run-context {
  width: min(100% - 32px, 1450px);
  max-width: 1450px;
  min-height: 52px;
  margin: 6px auto 0;
  padding: 5px 10px;
  grid-template-columns: 108px minmax(180px, 1.25fr) minmax(150px, 0.8fr) minmax(210px, 1fr) minmax(260px, 1.2fr);
  align-items: center;
  gap: 8px;
  border-radius: 10px;
  box-shadow: 0 3px 12px rgba(32, 43, 56, 0.025);
}

.current-context-title {
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 7px;
  color: #28816c;
  font-size: 8px;
  font-weight: 820;
  letter-spacing: 0.1em;
  white-space: nowrap;
}

.current-context-title i {
  width: 6px;
  height: 6px;
  flex: 0 0 auto;
  border-radius: 50%;
  background: #3aaa8e;
}

.linked-run-context .context-selector,
.linked-run-context .context-page-focus {
  min-width: 0;
  display: grid;
  grid-template-columns: 48px minmax(0, 1fr);
  align-items: center;
  gap: 6px;
}

.linked-run-context .context-page-focus {
  grid-template-columns: 70px minmax(0, 1fr);
}

.linked-run-context .context-selector small,
.linked-run-context .context-page-focus > small {
  color: #7d8998;
  font-size: 7px;
  font-weight: 780;
  letter-spacing: 0.08em;
  white-space: nowrap;
}

.linked-run-context .context-page-focus > small {
  color: #28816c;
}

.linked-run-context .context-selector select,
.linked-run-context .context-page-focus > div {
  width: 100%;
  height: 32px;
  min-height: 32px;
  border-radius: 7px;
}

.linked-run-context .context-selector select {
  padding-right: 24px;
  padding-left: 9px;
  font-size: 9px;
}

.linked-run-context .context-page-focus > div {
  padding: 0 8px;
  border-color: #d4e7e2;
  background: #f4faf8;
}

.linked-run-context .context-page-focus strong {
  font-size: 9px;
}

.linked-run-context .linked-handoff {
  min-width: 0;
  height: 40px;
  padding: 4px 8px;
  display: grid;
  align-content: center;
  border-radius: 8px;
}

.linked-run-context .linked-handoff-head,
.linked-run-context .linked-handoff-route {
  min-width: 0;
}

.linked-run-context .linked-handoff-route {
  margin-top: 2px;
  overflow: hidden;
  font-size: 8px;
  white-space: nowrap;
}

.linked-run-context .linked-handoff-route strong {
  overflow: hidden;
  text-overflow: ellipsis;
}

.primary-link {
  border-color: #213047;
  color: #fff;
  background: #213047;
}

.primary-link svg {
  width: 16px;
  height: 16px;
}

.demo-content {
  max-width: 1380px;
  margin: 0 auto;
  padding: 12px 18px 40px;
}

.demo-content.projects-content {
  max-width: 1450px;
  padding: 12px 16px 36px;
}

.demo-content.knowledge-content {
  padding: 12px 18px 38px;
}

.demo-content.reports-content {
  --report-space-xs: 4px;
  --report-space-sm: 8px;
  --report-space-md: 12px;
  --report-space-lg: 16px;
  --report-type-label: 8px;
  --report-type-body: 10px;
  --report-type-title: 15px;
  padding: 8px 18px 36px;
}

.demo-content.settings-content-page {
  max-width: 1450px;
  padding: 12px 18px 38px;
}

.demo-content.guide-content {
  max-width: 1380px;
  padding-right: 18px;
  padding-left: 18px;
}

.demo-content.data-unavailable > section {
  display: none;
}

.demo-content.data-unavailable > wiz-component-ui-datastate {
  display: block;
  margin-top: 18px;
}

.project-grid > wiz-component-ui-datastate,
.component-table > wiz-component-ui-datastate,
.report-grid + wiz-component-ui-datastate,
.change-summary > wiz-component-ui-datastate,
.knowledge-results > wiz-component-ui-datastate {
  grid-column: 1/-1;
}

.project-empty-state,
.report-empty-state {
  display: block;
  margin-top: 14px;
}

.run-list > wiz-component-ui-datastate,
.knowledge-list > wiz-component-ui-datastate,
.knowledge-evidence-list + wiz-component-ui-datastate,
.audit-log-list + wiz-component-ui-datastate {
  display: block;
  margin: 10px;
}

.evidence-overview {
  min-height: 118px;
  padding: 20px 22px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  border: 1px solid #d7e4e1;
  border-radius: 15px;
  background: linear-gradient(115deg, #f2faf7, #fff 58%);
}

.evidence-overview-copy > span,
.evidence-card-head span {
  color: #25816c;
  font-size: 8px;
  font-weight: 820;
  letter-spacing: 0.11em;
}

.evidence-overview-copy h2 {
  margin: 6px 0 0;
  color: #24364a;
  font-size: 19px;
}

.evidence-overview-copy p {
  max-width: 750px;
  margin: 7px 0 0;
  color: #6c7b8d;
  font-size: 10px;
  line-height: 1.55;
}

.evidence-overview-actions {
  display: flex;
  gap: 8px;
  flex: 0 0 auto;
}

.evidence-overview-actions a {
  min-height: 35px;
  padding: 0 12px;
  display: flex;
  align-items: center;
  border: 1px solid #d5dfe3;
  border-radius: 8px;
  color: #536378;
  background: #fff;
  font-size: 9px;
  font-weight: 740;
  text-decoration: none;
}

.evidence-overview-actions a.primary {
  border-color: #328d77;
  color: #fff;
  background: #328d77;
}

.knowledge-evidence-focus {
  min-height: 108px;
  margin-top: 12px;
  padding: 15px 17px;
  display: grid;
  grid-template-columns: 42px minmax(0, 1fr) minmax(245px, 0.72fr);
  align-items: center;
  gap: 14px;
  border: 1px solid #bcdcd3;
  border-left: 4px solid #32977f;
  border-radius: 12px;
  background: linear-gradient(110deg, #eef9f5, #fff 64%);
  box-shadow: 0 8px 22px rgba(34, 97, 80, 0.055);
}

.knowledge-evidence-focus-icon {
  width: 42px;
  height: 42px;
  display: grid;
  place-items: center;
  border-radius: 11px;
  color: #277e69;
  background: #dcefe9;
}

.knowledge-evidence-focus-icon svg {
  width: 21px;
  height: 21px;
}

.knowledge-evidence-focus-copy,
.knowledge-evidence-focus-decision {
  min-width: 0;
  display: grid;
}

.knowledge-evidence-focus-copy > span {
  color: #28856f;
  font-size: 7px;
  font-weight: 820;
  letter-spacing: 0.1em;
}

.knowledge-evidence-focus-copy h3 {
  margin: 4px 0 0;
  color: #2c3e53;
  font-size: 13px;
}

.knowledge-evidence-focus-copy p {
  margin: 4px 0 0;
  color: #6b7a8d;
  font-size: 8px;
  line-height: 1.45;
}

.knowledge-evidence-focus-meta {
  margin-top: 7px;
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
}

.knowledge-evidence-focus-meta em {
  padding: 3px 5px;
  border-radius: 5px;
  color: #637487;
  background: rgba(255, 255, 255, 0.82);
  font-size: 7px;
  font-style: normal;
}

.knowledge-evidence-focus-decision {
  padding: 10px 12px;
  border-left: 1px solid #d9e6e2;
}

.knowledge-evidence-focus-decision span {
  color: #2f806d;
  font-size: 7px;
  font-weight: 790;
}

.knowledge-evidence-focus-decision strong {
  margin-top: 3px;
  color: #405166;
  font-size: 9px;
  line-height: 1.4;
}

.knowledge-evidence-focus-decision small {
  margin-top: 3px;
  color: #85909e;
  font-size: 7px;
}

.knowledge-evidence-focus-decision a {
  width: fit-content;
  margin-top: 7px;
  color: #277b68;
  font-size: 7px;
  font-weight: 760;
  text-decoration: none;
}

.evidence-metric-strip {
  margin-top: 12px;
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: var(--platform-card-gap);
}

.evidence-metric-strip article {
  min-height: 83px;
  padding: 13px 15px;
  display: grid;
  align-content: center;
  border: 1px solid #dde4e7;
  border-radius: 11px;
  background: #fff;
}

.evidence-metric-strip span {
  color: #7a8797;
  font-size: 8px;
}

.evidence-metric-strip strong {
  margin-top: 3px;
  color: #334359;
  font-size: 21px;
}

.evidence-metric-strip small {
  margin-top: 2px;
  color: #929ca9;
  font-size: 7px;
}

.evidence-metric-strip article.verified {
  border-top: 2px solid #48a58e;
}

.evidence-metric-strip article.attention {
  border-top: 2px solid #8468b8;
}

.evidence-metric-strip article.waiting {
  border-top: 2px solid #aeb8c2;
}

.evidence-lineage {
  min-height: 54px;
  margin-top: 12px;
  padding: 8px 14px;
  display: flex;
  align-items: center;
  border: 1px solid #dce4e7;
  border-radius: 11px;
  background: #f9fbfb;
}

.evidence-lineage > div {
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 7px;
  flex: 1;
  color: #728093;
}

.evidence-lineage > div > i {
  width: 22px;
  height: 22px;
  display: grid;
  place-items: center;
  border: 1px solid #d3dce1;
  border-radius: 50%;
  color: #748294;
  background: #fff;
  font-size: 7px;
  font-style: normal;
  font-weight: 800;
}

.evidence-lineage > div.complete > i {
  border-color: #6bb5a2;
  color: #fff;
  background: #3c9a82;
}

.evidence-lineage > div.attention > i {
  border-color: #9478c2;
  color: #fff;
  background: #8063b0;
}

.evidence-lineage span {
  overflow: hidden;
  font-size: 7px;
  font-weight: 760;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.evidence-lineage > em {
  margin: 0 10px;
  color: #b3bdc6;
  font-size: 9px;
  font-style: normal;
}

.evidence-registry {
  margin-top: 12px;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: var(--platform-card-gap);
}

.evidence-card {
  min-width: 0;
  min-height: 204px;
  padding: 17px 18px;
  display: flex;
  flex-direction: column;
  border: 1px solid #dce3e6;
  border-radius: 13px;
  color: inherit;
  background: #fff;
  text-decoration: none;
  transition: border-color 0.16s, box-shadow 0.16s, transform 0.16s;
}

.evidence-card:hover,
.evidence-card:focus-visible {
  border-color: #8bc2b4;
  box-shadow: 0 11px 26px rgba(38, 91, 77, 0.08);
  transform: translateY(-1px);
  outline: 0;
}

.evidence-card-head,
.evidence-card-head > div,
.evidence-card-footer {
  display: flex;
  align-items: center;
}

.evidence-card-head {
  justify-content: space-between;
  gap: 12px;
}

.evidence-card-head > div {
  min-width: 0;
  gap: 8px;
}

.evidence-card-head code {
  overflow: hidden;
  color: #8a96a4;
  font-size: 7px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.evidence-card h3 {
  margin: 15px 0 0;
  color: #2c3d52;
  font-size: 14px;
}

.evidence-card > p {
  min-height: 34px;
  margin: 6px 0 0;
  color: #758294;
  font-size: 10px;
  line-height: 1.5;
}

.evidence-card dl {
  margin: 13px 0 0;
  padding: 10px 0;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
  border-top: 1px solid #edf0f2;
  border-bottom: 1px solid #edf0f2;
}

.evidence-card dl > div {
  min-width: 0;
  display: grid;
  gap: 3px;
}

.evidence-card dt {
  color: #929daa;
  font-size: 7px;
}

.evidence-card dd {
  margin: 0;
  overflow: hidden;
  color: #536277;
  font-size: 8px;
  font-weight: 720;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.evidence-card-footer {
  margin-top: auto;
  padding-top: 10px;
  justify-content: space-between;
  color: #7e8998;
  font-size: 8px;
}

.evidence-card-footer strong {
  color: #297d68;
  font-size: 8px;
}

.evidence-empty-state {
  display: block;
  margin-top: 12px;
}

/* Evidence is organized as a decision chain, not a document registry. */
.demo-content.evidence-content {
  max-width: 1450px;
  padding: 14px 20px 52px;
}

.evidence-traceability {
  min-height: 62px;
  margin-bottom: 18px;
  padding: 9px 12px;
  display: grid;
  grid-template-columns: 160px minmax(0, 1fr);
  align-items: center;
  gap: 14px;
  position: sticky;
  top: 0;
  z-index: 12;
  border: 1px solid #d8e4e1;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.96);
  box-shadow: 0 7px 22px rgba(30, 50, 62, 0.07);
  backdrop-filter: blur(14px);
}

.evidence-traceability-title {
  padding: 3px 11px 3px 2px;
  display: grid;
  gap: 3px;
  border-right: 1px solid #e4eae9;
}

.evidence-traceability-title span,
.evidence-section-heading span,
.evidence-registry-heading span,
.evidence-detail-section-head span,
.evidence-detail-identity > div > span {
  color: #27826d;
  font-size: 8px;
  font-weight: 840;
  letter-spacing: 0.11em;
}

.evidence-traceability-title strong {
  color: #34475b;
  font-size: 10px;
}

.evidence-traceability-track {
  min-width: 0;
  display: flex;
  align-items: center;
}

.evidence-trace-node {
  min-width: 0;
  display: grid;
  grid-template-columns: 22px minmax(0, 1fr);
  align-items: center;
  gap: 6px;
  flex: 1;
  color: inherit;
  text-decoration: none;
}

.evidence-trace-node > i {
  width: 22px;
  height: 22px;
  display: grid;
  place-items: center;
  border: 1px solid #d4dde0;
  border-radius: 50%;
  color: #768596;
  background: #fff;
  font-size: 7px;
  font-style: normal;
  font-weight: 840;
}

.evidence-trace-node > div {
  min-width: 0;
  display: grid;
  gap: 1px;
}

.evidence-trace-node strong,
.evidence-trace-node small {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.evidence-trace-node strong {
  color: #526174;
  font-size: 8px;
}

.evidence-trace-node small {
  color: #939da9;
  font-size: 6.5px;
}

.evidence-trace-node.done > i {
  border-color: #72b7a6;
  color: #fff;
  background: #3b9a82;
}

.evidence-trace-node.active > i {
  border-color: #7763ba;
  color: #fff;
  background: #7763ba;
  box-shadow: 0 0 0 4px rgba(119, 99, 186, 0.11);
}

.evidence-trace-node.active strong {
  color: #5d4c99;
}

.evidence-trace-node.ready > i {
  border-color: #5e8dc0;
  color: #4577aa;
  background: #eef5fb;
}

.evidence-trace-node.attention > i {
  border-color: #d79555;
  color: #a56628;
  background: #fff5e9;
}

.evidence-traceability-track > em {
  margin: 0 8px;
  color: #b5c0c6;
  font-size: 8px;
  font-style: normal;
}

.evidence-overview {
  min-height: 98px;
  padding: 17px 20px;
  border-color: #cfe2dd;
  border-radius: 16px;
  background: radial-gradient(circle at 94% 8%, rgba(86, 104, 194, 0.09), transparent 26%), linear-gradient(115deg, #eff9f6, #fff 62%);
}

.evidence-overview-copy h2 {
  font-size: 19px;
}

.evidence-overview-copy p {
  max-width: 820px;
  font-size: 10.5px;
}

.evidence-chain-primary {
  margin-top: 30px;
  padding: 20px;
  border: 1px solid #dbe4e6;
  border-radius: 16px;
  background: #fff;
  box-shadow: 0 9px 25px rgba(31, 49, 62, 0.045);
}

.evidence-section-heading,
.evidence-registry-heading,
.evidence-detail-section-head {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 18px;
}

.evidence-section-heading > div,
.evidence-registry-heading > div,
.evidence-detail-section-head > div {
  min-width: 0;
  display: grid;
}

.evidence-section-heading h3,
.evidence-registry-heading h3,
.evidence-detail-section-head h3 {
  margin: 4px 0 0;
  color: #2d3f54;
  font-size: 15px;
}

.evidence-section-heading p {
  margin: 4px 0 0;
  color: #7d8998;
  font-size: 9px;
}

.evidence-section-heading > em,
.evidence-detail-section-head > em {
  padding: 5px 8px;
  flex: 0 0 auto;
  border-radius: 999px;
  color: #347b69;
  background: #eaf5f2;
  font-size: 7px;
  font-style: normal;
  font-weight: 800;
}

.evidence-section-heading > button {
  min-height: 32px;
  padding: 0 10px;
  flex: 0 0 auto;
  border: 1px solid #dccfbf;
  border-radius: 8px;
  color: #8b6336;
  background: #fff;
  font-size: 8px;
  font-weight: 760;
}

.evidence-chain {
  margin-top: 17px;
  display: flex;
  align-items: stretch;
}

.evidence-chain-step {
  min-width: 0;
  min-height: 250px;
  padding: 13px 12px;
  display: flex;
  align-items: stretch;
  flex-direction: column;
  gap: 6px;
  flex: 1;
  border: 1px solid #dfe5e7;
  border-top: 3px solid var(--evidence-color, #3b9a82);
  border-radius: 12px;
  color: inherit;
  background: var(--evidence-soft, #f4faf8);
  text-align: left;
  transition: transform 0.16s, border-color 0.16s, box-shadow 0.16s;
}

.evidence-chain-step:hover,
.evidence-chain-step:focus-visible {
  border-color: var(--evidence-color, #3b9a82);
  outline: 0;
  box-shadow: 0 9px 22px rgba(32, 55, 67, 0.08);
  transform: translateY(-2px);
}

.evidence-chain-step.input,
.evidence-card.input,
.evidence-drawer.input {
  --evidence-color: #287fa1;
  --evidence-soft: #f0f8fb;
  --evidence-icon: #d9eef6;
}

.evidence-chain-step.decision,
.evidence-card.decision,
.evidence-drawer.decision {
  --evidence-color: #7660b0;
  --evidence-soft: #f6f3fb;
  --evidence-icon: #e8e1f5;
}

.evidence-chain-step.simulation,
.evidence-card.simulation,
.evidence-drawer.simulation {
  --evidence-color: #cb772d;
  --evidence-soft: #fff7ed;
  --evidence-icon: #f9e5cc;
}

.evidence-chain-step.approval,
.evidence-card.approval,
.evidence-drawer.approval {
  --evidence-color: #248466;
  --evidence-soft: #eff9f5;
  --evidence-icon: #d9efe7;
}

.evidence-type-icon {
  width: 38px;
  height: 38px;
  display: grid;
  place-items: center;
  flex: 0 0 auto;
  border-radius: 10px;
  color: var(--evidence-color, #2f8872);
  background: var(--evidence-icon, #dff0eb);
  font-size: 8px;
  font-style: normal;
  font-weight: 900;
  letter-spacing: -0.02em;
}

.evidence-chain-copy {
  min-width: 0;
  display: grid;
}

.evidence-chain-stage,
.evidence-chain-main,
.evidence-chain-action {
  display: flex;
  align-items: center;
}

.evidence-chain-stage {
  min-height: 20px;
  justify-content: space-between;
  gap: 8px;
}

.evidence-chain-stage > span {
  color: var(--evidence-color, #2f8872);
  font-size: 7px;
  font-weight: 880;
  letter-spacing: 0.12em;
}

.evidence-chain-stage > .ui-status {
  min-height: 20px;
  padding: 0 6px;
  display: inline-flex;
  align-items: center;
  border-radius: 999px;
  color: var(--evidence-color, #2f8872);
  background: rgba(255, 255, 255, 0.82);
  font-size: 6.5px;
  font-style: normal;
  font-weight: 820;
  white-space: nowrap;
}

.evidence-chain-main {
  min-height: 56px;
  align-items: flex-start;
  gap: 10px;
}

.evidence-chain-copy span {
  color: var(--evidence-color, #2f8872);
  font-size: 7px;
  font-weight: 840;
  letter-spacing: 0.08em;
}

.evidence-chain-copy strong {
  margin-top: 4px;
  color: #35465a;
  font-size: 11px;
}

.evidence-chain-copy small {
  margin-top: 4px;
  color: #758294;
  font-size: 7.5px;
  line-height: 1.45;
}

.evidence-basic-preview,
.evidence-decision-preview,
.evidence-approval-preview {
  display: grid;
  gap: 3px;
}

.evidence-basic-preview > div,
.evidence-decision-preview > div,
.evidence-approval-preview > div {
  min-width: 0;
  padding: 4px 6px;
  display: grid;
  gap: 2px;
  border: 1px solid color-mix(in srgb, var(--evidence-color) 18%, transparent);
  border-radius: 7px;
  background: rgba(255, 255, 255, 0.72);
}

.evidence-basic-preview span,
.evidence-decision-preview span,
.evidence-approval-preview span {
  color: var(--evidence-color, #2f8872);
  font-size: 6.5px;
  font-weight: 820;
}

.evidence-basic-preview strong,
.evidence-decision-preview strong,
.evidence-approval-preview strong {
  overflow: hidden;
  color: #526174;
  font-size: 7px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.evidence-chain-action {
  min-height: 24px;
  margin-top: auto;
  padding-top: 6px;
  justify-content: space-between;
  gap: 8px;
  border-top: 1px solid rgba(100, 120, 130, 0.13);
}

.evidence-chain-action span {
  overflow: hidden;
  color: #8995a2;
  font-size: 6.5px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.evidence-chain-action strong {
  flex: 0 0 auto;
  color: var(--evidence-color, #2f8872);
  font-size: 7.5px;
}

.evidence-chain-arrow {
  width: 38px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  position: relative;
  color: #3d6e68;
  font-style: normal;
}

.evidence-chain-arrow::before {
  width: calc(100% + 8px);
  height: 3px;
  position: absolute;
  content: "";
  border-radius: 999px;
  background: linear-gradient(90deg, #8fb4ae, #4f8f84);
}

.evidence-chain-arrow > span {
  width: 24px;
  height: 24px;
  display: grid;
  place-items: center;
  z-index: 1;
  border: 2px solid #83aaa3;
  border-radius: 50%;
  background: #fff;
  box-shadow: 0 3px 9px rgba(54, 102, 94, 0.13);
  font-size: 12px;
  font-style: normal;
  font-weight: 850;
}

.evidence-metric-strip {
  margin-top: 18px;
  gap: 16px;
}

.evidence-metric-strip article {
  min-height: 102px;
  padding: 17px 18px;
  border-radius: 13px;
  border-top: 3px solid var(--metric-color, #708092);
}

.evidence-metric-strip article.overall {
  --metric-color: #287fa1;
}

.evidence-metric-strip article.trace {
  --metric-color: #7660b0;
}

.evidence-metric-strip article.review {
  --metric-color: #cb772d;
}

.evidence-metric-strip article.gate {
  --metric-color: #248466;
}

.evidence-metric-strip strong {
  margin-top: 5px;
  font-size: 23px;
}

.evidence-metric-strip small {
  margin-top: 4px;
  font-size: 7.5px;
}

.evidence-reasoning-spotlight {
  margin-top: 24px;
  padding: 21px;
  border: 1px solid #eadcc9;
  border-radius: 16px;
  background: linear-gradient(110deg, #fffaf3, #fff 58%, #f2faf7);
}

.evidence-recovery-chain {
  margin-top: 17px;
  display: grid;
  grid-template-columns: minmax(0, 1fr) 28px minmax(0, 1fr) 28px minmax(0, 1fr);
  align-items: stretch;
}

.evidence-recovery-chain > article {
  min-width: 0;
  min-height: 125px;
  padding: 14px;
  display: grid;
  grid-template-columns: 30px minmax(0, 1fr);
  align-items: start;
  gap: 10px;
  border: 1px solid #e4e7e8;
  border-radius: 12px;
  background: #fff;
}

.evidence-recovery-chain > article.fail {
  border-color: #eccfca;
  background: #fff7f5;
}

.evidence-recovery-chain > article.retry {
  border-color: #ead9bd;
  background: #fffaf1;
}

.evidence-recovery-chain > article.pass {
  border-color: #cde4dc;
  background: #f3faf7;
}

.evidence-recovery-index {
  width: 30px;
  height: 30px;
  display: grid;
  place-items: center;
  border-radius: 9px;
  color: #fff;
  background: #9b6e58;
  font-size: 8px;
  font-weight: 850;
}

.evidence-recovery-chain > article.fail .evidence-recovery-index {
  background: #c65d4c;
}

.evidence-recovery-chain > article.retry .evidence-recovery-index {
  background: #c1843e;
}

.evidence-recovery-chain > article.pass .evidence-recovery-index {
  background: #2f9877;
}

.evidence-recovery-chain article > div:last-child {
  min-width: 0;
  display: grid;
}

.evidence-recovery-chain article span {
  color: #8a6d5a;
  font-size: 7px;
  font-weight: 820;
}

.evidence-recovery-chain article strong {
  margin-top: 5px;
  color: #3e4e61;
  font-size: 10px;
}

.evidence-recovery-chain article p {
  margin: 4px 0 0;
  color: #687789;
  font-size: 8px;
  line-height: 1.45;
}

.evidence-recovery-chain article small {
  margin-top: 8px;
  padding-top: 7px;
  border-top: 1px solid rgba(120, 110, 95, 0.12);
  color: #8b96a2;
  font-size: 7px;
}

.evidence-recovery-chain article small.evidence-recovery-reason {
  display: grid;
  grid-template-columns: auto minmax(0, 1fr);
  gap: 6px;
}

.evidence-recovery-reason b {
  color: #6d594b;
  white-space: nowrap;
}

.evidence-recovery-reason span {
  overflow: hidden;
  color: #7b8794;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.evidence-recovery-chain > i {
  display: grid;
  place-items: center;
  color: #b99c79;
  font-size: 11px;
  font-style: normal;
}

.evidence-registry-heading {
  margin-top: 28px;
  padding-top: 4px;
}

.evidence-registry-heading > small {
  color: #929ca8;
  font-size: 8px;
}

.evidence-registry {
  margin-top: 14px;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 16px;
}

.evidence-card {
  min-height: 280px;
  padding: 20px;
  border-top: 3px solid var(--evidence-color, #3b9a82);
  border-radius: 14px;
  font: inherit;
  text-align: left;
}

.evidence-card:hover,
.evidence-card:focus-visible {
  border-color: var(--evidence-color, #3b9a82);
}

.evidence-card-head > div {
  gap: 7px;
}

.evidence-card-head .evidence-type-icon {
  width: 28px;
  height: 28px;
  border-radius: 8px;
  font-size: 7px;
}

.evidence-card-head span {
  color: var(--evidence-color, #25816c);
}

.evidence-card h3 {
  margin-top: 17px;
}

.evidence-card-rationale {
  margin-top: 13px;
  padding: 10px;
  display: grid;
  gap: 3px;
  border-radius: 9px;
  background: var(--evidence-soft, #f4faf8);
}

.evidence-card-rationale span {
  color: var(--evidence-color, #2f8872);
  font-size: 7px;
  font-weight: 820;
}

.evidence-card-rationale strong {
  overflow: hidden;
  color: #4a5b6e;
  font-size: 8px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.evidence-card dl {
  margin-top: 13px;
}

.evidence-drawer {
  width: min(680px, 100vw - 28px);
}

.evidence-drawer-head {
  border-top: 4px solid var(--evidence-color, #2f8872);
}

.evidence-drawer-head span {
  color: var(--evidence-color, #24856f);
}

.evidence-detail-scroll {
  padding: 20px 22px 32px;
  overflow-y: auto;
}

.evidence-detail-identity {
  min-height: 76px;
  padding: 13px 14px;
  display: grid;
  grid-template-columns: 44px minmax(0, 1fr) auto;
  align-items: center;
  gap: 12px;
  border: 1px solid #dce4e6;
  border-radius: 12px;
  background: var(--evidence-soft, #f4faf8);
}

.evidence-detail-identity > div {
  min-width: 0;
  display: grid;
  gap: 4px;
}

.evidence-detail-identity > div > span {
  color: var(--evidence-color, #27826d);
}

.evidence-detail-identity > div > strong {
  color: #405166;
  font-size: 10px;
}

.evidence-detail-identity > .ui-status {
  min-height: 23px;
  padding: 0 8px;
  display: inline-flex;
  align-items: center;
  border-radius: 999px;
  color: var(--evidence-color, #2f8872);
  background: rgba(255, 255, 255, 0.84);
  font-size: 7px;
  font-style: normal;
  font-weight: 820;
  white-space: nowrap;
}

.evidence-detail-meta {
  margin-top: 12px;
  display: grid;
  grid-template-columns: 1fr 1.35fr;
  overflow: hidden;
  border: 1px solid #dfe5e7;
  border-radius: 10px;
  background: #fff;
}

.evidence-detail-meta > div {
  min-width: 0;
  padding: 10px 11px;
  display: grid;
  gap: 3px;
  border-right: 1px solid #e6eaec;
  border-bottom: 1px solid #e6eaec;
}

.evidence-detail-meta > div:nth-child(2n) {
  border-right: 0;
}

.evidence-detail-meta > div:nth-last-child(-n+2) {
  border-bottom: 0;
}

.evidence-detail-meta span {
  color: #929ca8;
  font-size: 7px;
}

.evidence-detail-meta strong {
  overflow: hidden;
  color: #4d5c6f;
  font-size: 8px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.evidence-detail-section {
  margin-top: 14px;
  padding: 17px;
  border: 1px solid #dfe5e7;
  border-radius: 12px;
  background: #fff;
}

.evidence-detail-record-grid {
  margin-top: 12px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
}

.evidence-detail-record-grid article {
  min-width: 0;
  min-height: 64px;
  padding: 10px;
  display: grid;
  align-content: center;
  gap: 4px;
  border: 1px solid #e0e6e8;
  border-left: 3px solid #7d8d9d;
  border-radius: 8px;
  background: #fafcfc;
}

.evidence-detail-record-grid article.decision,
.evidence-detail-record-grid article.knowledge {
  border-left-color: #7660b0;
}

.evidence-detail-record-grid article.simulation,
.evidence-detail-record-grid article.fail,
.evidence-detail-record-grid article.retry {
  border-left-color: #cb772d;
}

.evidence-detail-record-grid article.pass,
.evidence-detail-record-grid article.approval,
.evidence-detail-record-grid article.person {
  border-left-color: #248466;
}

.evidence-detail-record-grid article.input,
.evidence-detail-record-grid article.asset {
  border-left-color: #287fa1;
}

.evidence-detail-record-grid span {
  color: #8793a1;
  font-size: 7px;
  font-weight: 780;
}

.evidence-detail-record-grid strong {
  color: #4c5c6f;
  font-size: 8px;
  line-height: 1.4;
}

.evidence-ai-rationale {
  border-color: color-mix(in srgb, var(--evidence-color, #2f8872) 28%, #dfe5e7);
  background: linear-gradient(120deg, var(--evidence-soft, #f4faf8), #fff 58%);
}

.evidence-rationale-title {
  margin-top: 13px;
  display: block;
  color: #374a5e;
  font-size: 12px;
}

.evidence-detail-section > p {
  margin: 6px 0 0;
  color: #667589;
  font-size: 9px;
  line-height: 1.6;
}

.evidence-rule-list {
  margin: 13px 0 0;
  padding: 11px 0 0;
  display: grid;
  gap: 8px;
  border-top: 1px solid #e7ebed;
  list-style: none;
}

.evidence-rule-list li {
  display: grid;
  grid-template-columns: 19px minmax(0, 1fr);
  align-items: start;
  gap: 8px;
  color: #59697b;
  font-size: 8px;
  line-height: 1.45;
}

.evidence-rule-list i {
  width: 19px;
  height: 19px;
  display: grid;
  place-items: center;
  border-radius: 50%;
  color: var(--evidence-color, #2f8872);
  background: var(--evidence-icon, #dff0eb);
  font-size: 7px;
  font-style: normal;
  font-weight: 850;
}

.evidence-drawer-recovery {
  margin-top: 12px;
  display: grid;
  grid-template-columns: minmax(0, 1fr) 18px minmax(0, 1fr) 18px minmax(0, 1fr);
  align-items: stretch;
}

.evidence-drawer-recovery article {
  min-width: 0;
  padding: 10px;
  display: grid;
  align-content: start;
  gap: 4px;
  border: 1px solid #e3e6e8;
  border-radius: 9px;
  background: #fafbfb;
}

.evidence-drawer-recovery article.fail {
  border-color: #ecd0cb;
  background: #fff7f5;
}

.evidence-drawer-recovery article.retry {
  border-color: #eadabd;
  background: #fffaf2;
}

.evidence-drawer-recovery article.pass {
  border-color: #cce4dc;
  background: #f3faf7;
}

.evidence-drawer-recovery article span {
  color: #8c6e58;
  font-size: 6.5px;
  font-weight: 820;
}

.evidence-drawer-recovery article strong {
  color: #425266;
  font-size: 8px;
}

.evidence-drawer-recovery article small {
  color: #7b8795;
  font-size: 7px;
  line-height: 1.4;
}

.evidence-drawer-recovery article em {
  margin-top: 4px;
  padding-top: 5px;
  overflow: hidden;
  border-top: 1px solid rgba(120, 110, 95, 0.12);
  color: #6f7d8c;
  font-size: 6.5px;
  font-style: normal;
  line-height: 1.4;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.evidence-drawer-recovery > i {
  display: grid;
  place-items: center;
  color: #bba382;
  font-size: 8px;
  font-style: normal;
}

.evidence-asset-trace {
  margin: 12px 0 0;
  padding: 0;
  display: grid;
  gap: 7px;
  list-style: none;
}

.evidence-asset-trace li {
  position: relative;
}

.evidence-asset-trace li:not(:last-child)::after {
  width: 2px;
  height: 9px;
  position: absolute;
  bottom: -8px;
  left: 13px;
  z-index: 1;
  content: "";
  background: #8db8ad;
}

.evidence-asset-trace a {
  min-height: 56px;
  padding: 8px 10px;
  display: grid;
  grid-template-columns: 26px 34px minmax(0, 1fr) 18px;
  align-items: center;
  gap: 8px;
  border: 1px solid #e0e6e8;
  border-radius: 9px;
  color: inherit;
  background: #fbfcfc;
  text-decoration: none;
  transition: border-color 0.15s, background 0.15s;
}

.evidence-asset-trace a:hover,
.evidence-asset-trace a:focus-visible {
  border-color: #98c5b9;
  outline: 0;
  background: #f3faf8;
}

.evidence-asset-trace a > b {
  width: 26px;
  height: 26px;
  display: grid;
  place-items: center;
  z-index: 2;
  border: 2px solid #8db8ad;
  border-radius: 50%;
  color: #2f7967;
  background: #fff;
  font-size: 6.5px;
}

.evidence-asset-trace a > i {
  width: 34px;
  height: 34px;
  display: grid;
  place-items: center;
  border-radius: 8px;
  color: #337b69;
  background: #e4f1ed;
  font-size: 7px;
  font-style: normal;
  font-weight: 850;
}

.evidence-asset-trace a > div {
  min-width: 0;
  display: grid;
  gap: 2px;
}

.evidence-asset-trace span {
  color: #2f826e;
  font-size: 6.5px;
  font-weight: 800;
}

.evidence-asset-trace strong,
.evidence-asset-trace small {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.evidence-asset-trace strong {
  color: #47576a;
  font-size: 8.5px;
}

.evidence-asset-trace small {
  color: #8a95a2;
  font-size: 7px;
}

.evidence-asset-trace a > em {
  color: #6b9d90;
  font-size: 11px;
  font-style: normal;
}

.evidence-drawer-footer {
  margin-top: 14px;
  padding: 13px 2px 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  border-top: 1px solid #dfe5e7;
}

.evidence-drawer-footer span {
  color: #8a95a2;
  font-size: 7px;
}

.evidence-drawer-footer a {
  color: #287c68;
  font-size: 8px;
  font-weight: 780;
  text-decoration: none;
}

@media (max-width: 1180px) {
  .evidence-traceability {
    grid-template-columns: 1fr;
  }
  .evidence-traceability-title {
    grid-template-columns: auto auto;
    justify-content: start;
    border-right: 0;
  }
  .evidence-registry {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
@media (max-width: 860px) {
  .evidence-chain,
  .evidence-recovery-chain,
  .evidence-drawer-recovery {
    display: grid;
    grid-template-columns: 1fr;
  }
  .evidence-chain-arrow,
  .evidence-recovery-chain > i,
  .evidence-drawer-recovery > i {
    width: auto;
    min-height: 22px;
    transform: rotate(90deg);
  }
  .evidence-metric-strip,
  .evidence-registry {
    grid-template-columns: 1fr 1fr;
  }
}
.demo-content > section {
  animation: section-enter 0.2s cubic-bezier(0.2, 0.75, 0.35, 1);
}

.metric-strip {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: var(--platform-card-gap);
}

.metric-card {
  min-height: 100px;
  padding: 15px 17px;
  display: grid;
  align-content: center;
  border: 1px solid #dde4e7;
  border-radius: 13px;
  background: rgba(255, 255, 255, 0.92);
  box-shadow: 0 8px 22px rgba(32, 43, 56, 0.03);
}

.metric-card span {
  color: #7d8a9b;
  font-size: 11px;
}

.metric-card strong {
  margin-top: 5px;
  color: #26364c;
  font-size: 25px;
  letter-spacing: -0.035em;
}

.metric-card small {
  margin-top: 3px;
  color: #929ca9;
  font-size: 10px;
}

.run-metrics .metric-card,
.project-metrics .metric-card {
  width: 100%;
  position: relative;
  color: inherit;
  text-align: left;
  transition: border-color 0.16s, box-shadow 0.16s, transform 0.16s;
}

.run-metrics .metric-card > span {
  color: #66768a;
  font-weight: 760;
}

.demo-content.runs-content {
  padding: 8px 18px 36px;
}

.demo-content.approvals-content {
  padding: 10px 18px 32px;
}

.run-metrics {
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: var(--run-card-gap);
}

.project-metrics {
  gap: var(--platform-card-gap);
}

.project-metrics .metric-card {
  min-height: 68px;
  padding: 8px 13px;
}

.project-metrics .metric-card strong {
  margin-top: 1px;
  font-size: 20px;
}

.project-metrics .metric-card small {
  margin-top: 1px;
  font-size: 9px;
}

.run-metrics .metric-card {
  min-height: 76px;
  padding: 10px 13px;
  border-color: var(--run-border);
  border-radius: 12px;
  background: var(--run-surface);
  box-shadow: 0 3px 12px rgba(15, 23, 42, 0.035);
}

.run-metrics .metric-card strong {
  margin-top: 1px;
  font-size: 19px;
}

.run-metrics .metric-card small {
  margin-top: 2px;
  font-size: 9px;
}

.run-kpi-card::after {
  display: none;
}

.run-kpi-label {
  display: flex;
  align-items: center;
  gap: 6px;
}

.run-kpi-label > i {
  width: 7px;
  height: 7px;
  flex: 0 0 auto;
  border-radius: 50%;
  background: #7d8a9b;
  box-shadow: 0 0 0 3px #eef1f4;
}

.run-kpi-card.running .run-kpi-label > i {
  background: var(--run-secondary);
  box-shadow: 0 0 0 3px #e8effa;
}

.run-kpi-card.iteration .run-kpi-label > i {
  background: #8c6db2;
  box-shadow: 0 0 0 3px #f0eaf8;
}

.run-kpi-card.redesign .run-kpi-label > i {
  background: #cf9241;
  box-shadow: 0 0 0 3px #fbefdd;
}

.run-kpi-card.duration .run-kpi-label > i,
.run-kpi-card.neutral .run-kpi-label > i {
  background: #4b9c88;
  box-shadow: 0 0 0 3px #e6f3ef;
}

.run-kpi-card.fail {
  border-color: #ebc9c5;
  background: #fff9f8;
}

.run-kpi-card.fail .run-kpi-label > i {
  background: var(--run-danger);
  box-shadow: 0 0 0 3px #f9e8e5;
}

.run-metrics .metric-card::after,
.project-metrics .metric-card::after {
  width: 6px;
  height: 6px;
  position: absolute;
  top: 14px;
  right: 14px;
  border: 1px solid #cbd5dc;
  border-radius: 50%;
  content: "";
  background: #fff;
}

.run-metrics .metric-card:hover,
.run-metrics .metric-card:focus-visible,
.project-metrics .metric-card:hover,
.project-metrics .metric-card:focus-visible {
  border-color: #b9d7cf;
  box-shadow: 0 10px 25px rgba(32, 93, 78, 0.08);
  transform: translateY(-1px);
  outline: 0;
}

.run-metrics .metric-card.active,
.project-metrics .metric-card.active {
  border-color: #78baa9;
  background: #f2faf7;
  box-shadow: 0 0 0 2px rgba(73, 164, 141, 0.09);
}

.run-metrics .metric-card.active::after,
.project-metrics .metric-card.active::after {
  border-color: #39aa8d;
  background: #39aa8d;
  box-shadow: 0 0 0 3px #e1f3ee;
}

.section-toolbar {
  min-height: 72px;
  margin-top: 21px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
}

.section-toolbar h2 {
  margin: 0;
  color: #27364b;
  font-size: 19px;
}

.section-toolbar p {
  margin: 5px 0 0;
  color: #7a8798;
  font-size: 12px;
}

.projects-content .section-toolbar {
  min-height: 50px;
  margin-top: 8px;
}

.search-box {
  width: 245px;
  height: 39px;
  padding: 0 11px;
  display: flex;
  align-items: center;
  gap: 8px;
  border: 1px solid #dce2e6;
  border-radius: 9px;
  background: #fff;
}

.search-box svg {
  width: 17px;
  height: 17px;
  color: #8793a3;
}

.search-box input {
  min-width: 0;
  flex: 1;
  border: 0;
  outline: 0;
  color: #445267;
  background: transparent;
  font-size: 10px;
}

.project-filter-bar {
  min-height: 61px;
  margin: 0 0 12px;
  padding: 9px 11px;
  display: grid;
  grid-template-columns: minmax(200px, 1.45fr) repeat(4, minmax(110px, 1fr)) auto auto;
  align-items: end;
  gap: 8px;
  border: 1px solid #dfe5e7;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.8);
}

.project-filter-bar > label,
.project-filter-control {
  min-width: 0;
  display: grid;
  gap: 5px;
}

.project-filter-bar > label > span,
.project-filter-control > span {
  color: #8591a0;
  font-size: 8px;
  font-weight: 720;
}

.project-filter-bar select {
  width: 100%;
  height: 36px;
  padding: 0 28px 0 9px;
  border: 1px solid #dce3e6;
  border-radius: 8px;
  outline: 0;
  color: #536176;
  background: #fff;
  font-size: 9px;
}

.project-search-filter .search-box {
  width: 100%;
  height: 36px;
  border-radius: 8px;
}

.project-filter-bar select:focus {
  border-color: #77b7a7;
  box-shadow: 0 0 0 2px rgba(61, 164, 139, 0.08);
}

.project-filter-result {
  height: 36px;
  padding: 0 4px;
  display: flex;
  align-items: center;
  gap: 3px;
  color: #8a96a5;
  white-space: nowrap;
}

.project-filter-result strong {
  color: #2c806d;
  font-size: 11px;
}

.project-filter-result span {
  font-size: 8px;
}

.project-filter-reset {
  height: 36px;
  padding: 0 10px;
  border: 1px solid #cfe2dd;
  border-radius: 8px;
  color: #2b7d6a;
  background: #f2f9f7;
  font-size: 8px;
  font-weight: 720;
  white-space: nowrap;
}

.project-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: var(--platform-card-gap);
}

.project-card {
  min-width: 0;
  min-height: 370px;
  padding: 12px;
  position: relative;
  overflow: hidden;
  border: 1px solid #e3e7e9;
  border-radius: 13px;
  background: #fff;
  box-shadow: 0 2px 8px rgba(31, 43, 57, 0.025);
  cursor: pointer;
  transition: border-color 0.18s, transform 0.18s, box-shadow 0.18s;
}

.project-card::before {
  width: 100%;
  height: 3px;
  position: absolute;
  top: 0;
  left: 0;
  content: "";
  background: linear-gradient(90deg, #5b7fe8, #42bca2);
}

.project-card.completed {
  border-color: #dce8e4;
  background: #fbfdfc;
}

.project-card.completed::before {
  background: #34aa8c;
}

.project-card.in-progress {
  background: #fff;
}

.project-card:hover,
.project-card:focus-visible {
  border-color: #8fc6b9;
  background: #fcfefd;
  box-shadow: 0 9px 20px rgba(34, 92, 80, 0.09);
  transform: translateY(-2px);
  outline: 0;
}

.project-card.selected {
  border-color: #2f947b;
  background: #f1f9f6;
  box-shadow: 0 0 0 2px rgba(47, 148, 123, 0.14), 0 8px 20px rgba(34, 92, 80, 0.08);
  transform: none;
}

.project-card.selected::before {
  background: #32977e;
}

.project-card-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.project-identity {
  display: flex;
  align-items: center;
  gap: 7px;
}

.project-state-label {
  color: #8b97a5;
  font-size: 7px;
  font-weight: 820;
  letter-spacing: 0.11em;
}

.project-card.completed .project-state-label {
  color: #2b846f;
}

.project-code {
  width: 34px;
  height: 34px;
  display: grid;
  place-items: center;
  border-radius: 10px;
  color: #397567;
  background: #e9f6f2;
  font-size: 10px;
  font-weight: 820;
}

.project-card-head em,
.run-item-top em,
.run-detail-head > em,
.approval-list-top em,
.approval-detail-head > em {
  padding: 5px 7px;
  border-radius: 6px;
  font-size: 8px;
  font-style: normal;
  font-weight: 780;
}

em.approved {
  color: #267763;
  background: #dff3ed;
}

em.review {
  color: #91652c;
  background: #f8ecd9;
}

em.running {
  color: #486fae;
  background: #e6eefb;
}

em.rejected {
  color: #a44c43;
  background: #f9e5e2;
}

.project-card h3 {
  margin: 9px 0 0;
  color: #28374b;
  font-size: 16px;
}

.project-primary-context {
  min-height: 50px;
  margin-top: 8px;
  padding: 7px 9px;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 9px;
  border: 1px solid #dce5e7;
  border-radius: 11px;
  background: #f6f9f9;
}

.project-card.selected .project-primary-context {
  border-color: #9dcec2;
  background: #eff8f5;
  box-shadow: 0 0 0 2px rgba(57, 161, 136, 0.07);
}

.project-primary-context > div {
  min-width: 0;
  display: grid;
  grid-template-rows: 11px 22px;
  align-content: center;
  gap: 3px;
}

.project-current-run {
  padding-left: 9px;
  border-left: 1px solid #dce4e7;
}

.project-primary-context span {
  color: #7f8c9b;
  font-size: 7px;
  font-weight: 820;
  letter-spacing: 0.1em;
}

.project-primary-context strong {
  overflow: hidden;
  color: #25384d;
  font-size: 13px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.project-stage-badge {
  width: fit-content;
  max-width: 100%;
  min-height: 22px;
  padding: 0 7px;
  display: inline-flex;
  align-items: center;
  overflow: hidden;
  border-radius: 999px;
  font-size: 9px;
  font-style: normal;
  font-weight: 780;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.project-primary-context code {
  min-height: 22px;
  display: flex;
  align-items: center;
  overflow: hidden;
  color: #376b61;
  font-family: "D2Coding", monospace;
  font-size: 10px;
  font-weight: 720;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.project-type {
  color: #318571;
  font-size: 10px;
  font-weight: 740;
}

.project-progress {
  margin-top: 8px;
}

.project-progress-head {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 12px;
}

.project-progress-head > div {
  min-width: 0;
  display: grid;
  gap: 2px;
}

.project-progress-head span {
  color: #617187;
  font-size: 8px;
  font-weight: 800;
  letter-spacing: 0.07em;
}

.project-progress-head small {
  color: #8793a2;
  font-size: 8px;
}

.project-progress-head > strong {
  color: #34465b;
  font-size: 16px;
  letter-spacing: -0.02em;
}

.project-progress > i {
  height: 7px;
  margin-top: 5px;
  display: block;
  overflow: hidden;
  border-radius: 99px;
  background: #d9e0e6;
  box-shadow: inset 0 0 0 1px rgba(78, 94, 116, 0.05);
}

.project-progress > i em {
  height: 100%;
  display: block;
  border-radius: inherit;
  background: #416bd3;
}

.project-card.completed .project-progress > i em {
  background: #239a7d;
}

.project-progress > p {
  margin: 4px 0 0;
  color: #98a2ae;
  font-size: 7px;
  line-height: 1.45;
}

.project-secondary-info {
  margin-top: 7px;
  padding-top: 6px;
  border-top: 1px solid #edf0f2;
}

.project-secondary-info > p {
  height: 30px;
  min-height: 0;
  margin: 3px 0 0;
  display: -webkit-box;
  overflow: hidden;
  color: #929ba7;
  font-size: 10px;
  line-height: 1.5;
  text-overflow: ellipsis;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}

.project-approval-summary {
  margin-top: 4px;
  display: flex;
  align-items: center;
  gap: 7px;
}

.project-approval-summary > span {
  color: #929ca9;
  font-size: 7px;
}

.project-approval-summary .ui-status {
  min-height: 18px;
  padding: 0 5px;
  font-size: 7px;
}

.project-meta {
  margin-top: 6px;
  padding: 5px 0;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  border-top: 1px solid #e9edef;
  border-bottom: 1px solid #e9edef;
}

.project-meta div {
  min-width: 0;
  display: grid;
  grid-template-rows: 10px 13px;
  align-content: center;
  gap: 1px;
  padding: 0 7px;
}

.project-meta div:first-child {
  padding-left: 0;
}

.project-meta div + div {
  border-left: 1px solid #eef1f3;
}

.project-meta span {
  color: #a0a8b2;
  font-size: 7px;
}

.project-meta strong {
  overflow: hidden;
  color: #7a8594;
  font-size: 8px;
  font-weight: 650;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.project-actions {
  margin-top: 6px;
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 6px;
}

.project-actions a {
  min-width: 0;
  height: 32px;
  min-height: 32px;
  padding: 0 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  border: 1px solid #dce2e6;
  border-radius: 7px;
  color: #59687b;
  background: #fff;
  font-size: 8px;
  font-weight: 720;
  text-decoration: none;
  white-space: nowrap;
}

.project-actions a:hover,
.project-actions a:focus-visible {
  border-color: #9fcbbf;
  outline: 0;
}

.project-actions a svg {
  width: 13px;
  height: 13px;
  flex: 0 0 auto;
}

.project-actions a.new-run {
  border-color: #cce4df;
  color: #277b68;
  background: #f1f9f7;
}

.project-actions a.primary {
  border-color: #243349;
  color: #fff;
  background: #243349;
}

.project-empty {
  min-height: 190px;
  padding: 35px;
  display: grid;
  place-items: center;
  align-content: center;
  gap: 7px;
  border: 1px dashed #ccd6da;
  border-radius: 14px;
  color: #8591a0;
  background: rgba(255, 255, 255, 0.68);
}

.project-empty strong {
  color: #4a586c;
  font-size: 13px;
}

.project-empty span {
  font-size: 9px;
}

.project-empty button {
  height: 32px;
  margin-top: 5px;
  padding: 0 11px;
  border: 1px solid #cde2dc;
  border-radius: 8px;
  color: #277c68;
  background: #f1f9f7;
  font-size: 8px;
  font-weight: 720;
}

.run-workbench,
.approval-layout {
  display: grid;
  grid-template-columns: 345px minmax(0, 1fr);
  gap: var(--platform-card-gap);
}

.run-workbench {
  margin-top: var(--run-compact-gap);
  grid-template-columns: 290px minmax(0, 1fr);
  gap: var(--run-card-gap);
}

.approval-layout {
  grid-template-columns: 274px minmax(0, 1fr);
  gap: var(--platform-card-gap);
}

.run-list,
.run-detail,
.approval-list,
.approval-detail,
.knowledge-results,
.knowledge-side,
.component-table,
.settings-nav,
.settings-content,
.guide-hero,
.guide-toc,
.guide-section,
.profile-card,
.authority-card,
.recent-decisions,
.profile-guide-shortcut {
  border: 1px solid #dce3e6;
  border-radius: 15px;
  background: rgba(255, 255, 255, 0.95);
  box-shadow: 0 8px 24px rgba(32, 43, 56, 0.03);
}

.run-list,
.approval-list {
  padding: 10px;
}

.run-list,
.run-detail {
  border-color: var(--run-border);
  border-radius: 12px;
  background: var(--run-surface);
  box-shadow: 0 4px 16px rgba(15, 23, 42, 0.04);
}

.panel-title {
  min-height: 44px;
  padding: 2px 3px 8px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #e6eaed;
}

.panel-title > div {
  display: grid;
}

.panel-title h2 {
  margin: 4px 0 0;
  color: #344258;
  font-size: 15px;
}

.panel-title > em {
  color: #8a95a4;
  font-size: 8px;
  font-style: normal;
}

.run-filters {
  margin: 8px 0 0;
  padding-bottom: 8px;
  border-bottom: 1px solid #e8ecef;
}

.run-search {
  height: 32px;
  padding: 0 10px;
  display: flex;
  align-items: center;
  gap: 7px;
  border: 1px solid #dbe2e6;
  border-radius: 8px;
  background: #fff;
}

.run-search:focus-within {
  border-color: #75b6a6;
  box-shadow: 0 0 0 2px rgba(59, 163, 137, 0.08);
}

.run-search svg {
  width: 15px;
  height: 15px;
  flex: 0 0 auto;
  color: #8795a4;
}

.run-search input {
  width: 100%;
  min-width: 0;
  border: 0;
  color: #405066;
  background: transparent;
  font-size: 9px;
  outline: 0;
}

.run-search input::placeholder {
  color: #9ca6b2;
}

.run-filter-selects {
  margin-top: 7px;
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 6px;
}

.run-filter-selects label {
  min-width: 0;
  display: grid;
  gap: 3px;
}

.run-filter-selects span {
  padding-left: 2px;
  color: #8b97a5;
  font-size: 7px;
  font-weight: 720;
}

.run-filter-selects select {
  width: 100%;
  height: 32px;
  padding: 0 23px 0 7px;
  overflow: hidden;
  border: 1px solid #dce2e6;
  border-radius: 7px;
  color: #536277;
  text-overflow: ellipsis;
  background: #fff;
  font-size: 8px;
  outline: 0;
}

.run-filter-selects select:focus {
  border-color: #75b6a6;
}

.run-filter-reset {
  margin: 8px 1px 0 auto;
  padding: 0;
  display: block;
  border: 0;
  color: #2b8873;
  background: transparent;
  font-size: 8px;
  font-weight: 750;
}

.run-component-filter-note {
  margin: 8px 13px 0;
  padding: 9px 10px;
  display: grid;
  grid-template-columns: auto auto minmax(0, 1fr) auto;
  align-items: center;
  gap: 7px;
  border: 1px solid #bee0d7;
  border-radius: 8px;
  color: #647486;
  background: #eef8f5;
  font-size: 7px;
}

.run-component-filter-note > span {
  color: #299079;
  font-size: 6px;
  font-weight: 820;
  letter-spacing: 0.1em;
}

.run-component-filter-note > strong {
  color: #335367;
  font-family: "D2Coding", monospace;
  font-size: 8px;
}

.run-component-filter-note > em {
  overflow: hidden;
  font-style: normal;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.run-component-filter-note > button {
  border: 0;
  color: #4f796f;
  background: transparent;
  font-size: 14px;
  line-height: 1;
}

.run-list-empty {
  min-height: 170px;
  display: grid;
  place-content: center;
  justify-items: center;
  color: #8793a2;
  text-align: center;
}

.run-list-empty strong {
  color: #46556a;
  font-size: 11px;
}

.run-list-empty span {
  margin-top: 5px;
  font-size: 8px;
}

.run-list-empty button {
  height: 29px;
  margin-top: 11px;
  padding: 0 10px;
  border: 1px solid #cfe2dd;
  border-radius: 7px;
  color: #2a806c;
  background: #f2f9f7;
  font-size: 8px;
  font-weight: 720;
}

.run-list-item,
.approval-list-item {
  width: 100%;
  margin-top: var(--run-compact-gap);
  padding: 10px;
  display: grid;
  border: 1px solid var(--run-border);
  border-radius: 12px;
  color: #576579;
  text-align: left;
  background: #f8fafb;
}

.run-list-item {
  position: relative;
  overflow: hidden;
  transition: border-color 0.16s, background 0.16s, box-shadow 0.16s, transform 0.16s;
}

.run-list-item:not(.active) {
  color: #64748b;
  background: #f8fafc;
  opacity: 1;
}

.run-list-item:hover,
.run-list-item:focus-visible {
  border-color: #c8ddd7;
  background: #f5faf8;
  outline: 0;
  opacity: 1;
}

.run-list-item.active,
.approval-list-item.active {
  border-color: var(--run-primary);
  background: linear-gradient(110deg, #ecfdf8, #f8fffd);
  box-shadow: 0 6px 16px rgba(15, 157, 122, 0.1), inset 4px 0 var(--run-primary);
}

.run-list-item.active {
  transform: none;
  opacity: 1;
}

.run-item-top,
.approval-list-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}

.run-item-top > strong,
.run-item-top > div > strong {
  color: #506077;
  font-size: 9px;
  font-weight: 760;
}

.run-item-top > div {
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 6px;
}

.run-item-badges,
.run-detail-status {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 5px;
}

.run-state-badge {
  min-height: 21px;
  padding: 0 7px;
  display: inline-flex;
  align-items: center;
  gap: 5px;
  border: 1px solid #d8e0e5;
  border-radius: 999px;
  color: #657487;
  background: #f4f6f8;
  font-size: 7px;
  font-style: normal;
  font-weight: 850;
  letter-spacing: 0.03em;
  white-space: nowrap;
}

.run-state-badge > i {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: currentColor;
}

.run-state-badge.running {
  border-color: #b9cdeb;
  color: #3e6ead;
  background: #eef4fd;
}

.run-state-badge.running > i {
  box-shadow: 0 0 0 3px rgba(62, 110, 173, 0.12);
}

.run-state-badge.complete {
  border-color: #b9ded4;
  color: #247762;
  background: #eaf8f4;
}

.run-state-badge.fail {
  border-color: #edc4bf;
  color: #ac463d;
  background: #fff0ee;
}

.run-state-badge.fail > i {
  box-shadow: 0 0 0 3px rgba(172, 70, 61, 0.11);
}

.run-substatus {
  min-height: 20px;
  font-size: 6px;
}

.run-agent-stage {
  min-height: 20px;
  padding: 0 6px;
  display: inline-flex;
  align-items: center;
  border: 1px solid #d6dfe5;
  border-radius: 6px;
  color: #53677e;
  background: #f2f5f7;
  font-size: 7px;
  font-style: normal;
  font-weight: 760;
  white-space: nowrap;
}

.run-scope {
  min-height: 17px;
  padding: 0 5px;
  display: inline-flex;
  align-items: center;
  flex: 0 0 auto;
  border: 1px solid #dce2e6;
  border-radius: 5px;
  color: #7c8795;
  background: #fff;
  font-size: 6px;
  font-weight: 800;
}

.run-scope.current {
  border-color: #bfe1d8;
  color: #287e69;
  background: #e9f7f3;
}

.run-list-item h3 {
  margin: 7px 0 0;
  color: #344258;
  font-size: 12px;
}

.run-list-item p {
  min-height: 42px;
  margin: 6px 0 0;
  color: #7d8998;
  font-size: 10px;
  line-height: 1.48;
}

.run-item-progress {
  margin-top: 7px;
}

.run-item-progress > div {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  color: #728093;
  font-size: 8px;
}

.run-item-progress > div span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.run-item-progress > div strong {
  color: #3c6f63;
  font-size: 8px;
}

.run-item-progress > i {
  height: 5px;
  margin-top: 5px;
  display: block;
  overflow: hidden;
  border-radius: 99px;
  background: #e4e9ec;
}

.run-item-progress > i > em {
  height: 100%;
  display: block;
  border-radius: inherit;
  background: linear-gradient(90deg, #6385df, #36b596);
}

.run-item-meta {
  margin-top: 8px;
  display: flex;
  justify-content: space-between;
  color: #939daa;
  font-size: 8px;
}

.run-detail,
.approval-detail {
  min-width: 0;
  padding: 20px;
}

.run-detail {
  padding: 16px 18px 18px;
  border-color: #9ed8ca;
  box-shadow: 0 6px 20px rgba(15, 157, 122, 0.07), inset 3px 0 var(--run-primary);
}

.run-detail-head,
.approval-detail-head {
  min-height: 91px;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  border-bottom: 1px solid #e4e9ec;
}

.run-detail-head {
  min-height: 54px;
  align-items: center;
}

.run-detail-head > div,
.approval-detail-head > div {
  min-width: 0;
}

.run-detail-head h2,
.approval-detail-head h2 {
  margin: 3px 0 0;
  color: #26364b;
  font-size: 20px;
}

.run-detail-head p,
.approval-detail-head p {
  max-width: 650px;
  margin: 7px 0 0;
  color: #768497;
  font-size: 10px;
  line-height: 1.45;
}

.run-detail-context-line {
  display: flex;
  align-items: center;
  gap: 8px;
}

.run-detail-context-line > span:last-child {
  color: #708093;
  font-size: 8px;
  font-weight: 780;
  letter-spacing: 0.08em;
}

.run-selection-chip {
  min-height: 21px;
  padding: 0 7px;
  display: inline-flex;
  align-items: center;
  gap: 5px;
  border: 1px solid #a9d5ca;
  border-radius: 999px;
  color: #247964;
  background: #e7f5f1;
  font-size: 7px;
  font-weight: 820;
}

.run-selection-chip > i {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #32a88b;
  box-shadow: 0 0 0 3px rgba(50, 168, 139, 0.12);
}

.run-detail-status {
  flex-wrap: wrap;
}

.run-evidence-banner.run-evidence-compact {
  min-height: 46px;
  margin-top: var(--run-compact-gap);
  padding: 7px 10px;
  grid-template-columns: minmax(0, 1fr) auto;
  gap: var(--run-compact-gap);
  border-radius: 9px;
}

.run-evidence-compact > div:first-child {
  min-width: 0;
  display: grid;
}

.run-evidence-compact strong {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.run-evidence-compact .run-evidence-actions {
  display: flex;
  align-items: center;
  gap: 10px;
}

.run-facts {
  margin-top: var(--run-card-gap);
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: var(--run-compact-gap);
}

.run-facts > div {
  min-height: 58px;
  padding: 8px 10px;
  display: grid;
  align-content: center;
  border: 1px solid #e0e5e8;
  border-radius: 9px;
  background: #f9fafb;
}

.run-facts span {
  color: #8d98a6;
  font-size: 8px;
}

.run-facts strong {
  margin-top: 4px;
  color: #3d4b60;
  font-size: 11px;
}

.run-evidence-banner {
  margin-top: var(--run-card-gap);
  padding: 10px 12px;
  display: grid;
  grid-template-columns: 34px minmax(0, 1fr) auto;
  align-items: center;
  gap: 10px;
  border: 1px solid #cde4de;
  border-radius: 11px;
  background: #f2f9f7;
}

.evidence-icon {
  width: 34px;
  height: 34px;
  display: grid;
  place-items: center;
  border-radius: 9px;
  color: #247b67;
  background: #dcefe9;
  font-size: 13px;
  font-weight: 820;
}

.run-evidence-banner > div:nth-child(2) {
  min-width: 0;
  display: grid;
}

.run-evidence-banner span {
  color: #318371;
  font-size: 8px;
  font-weight: 780;
}

.run-evidence-banner strong {
  margin-top: 3px;
  color: #3c5260;
  font-size: 10px;
}

.run-evidence-banner p {
  margin: 3px 0 0;
  color: #71847f;
  font-size: 8px;
}

.run-evidence-banner a {
  color: #287c69;
  font-size: 9px;
  font-weight: 730;
  text-decoration: none;
}

.run-evidence-actions {
  display: grid;
  justify-items: end;
  gap: 6px;
}

.run-evidence-actions a:last-child {
  color: #496b89;
}

.timeline-head {
  margin-top: 16px;
  display: flex;
  align-items: end;
  justify-content: space-between;
  gap: 16px;
}

.timeline-head h3 {
  margin: 4px 0 0;
  color: #354359;
  font-size: 15px;
}

.timeline-head p {
  margin: 3px 0 0;
  color: #7d8a99;
  font-size: 8px;
  line-height: 1.45;
}

.timeline-eyebrow,
.design-journey-eyebrow {
  display: flex;
  align-items: center;
  gap: 7px;
}

.timeline-eyebrow > span,
.design-journey-eyebrow > span {
  color: #27806d;
  font-size: 8px;
  font-weight: 840;
  letter-spacing: 0.12em;
}

.timeline-eyebrow > em,
.design-journey-eyebrow > em {
  min-height: 18px;
  padding: 0 6px;
  display: inline-flex;
  align-items: center;
  border: 1px solid #d8e2e5;
  border-radius: 999px;
  color: #68788a;
  background: #f6f8f9;
  font-size: 6px;
  font-style: normal;
  font-weight: 780;
  letter-spacing: 0.03em;
}

.timeline-head button {
  height: 32px;
  padding: 0 11px;
  border: 1px solid #dce2e6;
  border-radius: 7px;
  color: #5c6b7e;
  background: #fff;
  font-size: 8px;
}

.run-timeline {
  margin-top: 9px;
}

.agent-flow-overview {
  margin-top: 11px;
  padding: 11px 12px;
  display: flex;
  align-items: center;
  border: 1px solid #dce4e7;
  border-radius: 11px;
  background: #f8fafb;
}

.agent-flow-step {
  min-width: 0;
  min-height: 46px;
  padding: 7px 8px;
  display: grid;
  grid-template-columns: 27px minmax(0, 1fr);
  align-items: center;
  gap: 7px;
  flex: 1;
  position: relative;
  border: 1px solid transparent;
  border-radius: 8px;
  color: inherit;
  text-align: left;
  background: transparent;
  transition: border-color 0.16s, background 0.16s, box-shadow 0.16s, transform 0.16s;
}

.agent-flow-step:hover,
.agent-flow-step:focus-visible {
  border-color: #afcec6;
  background: #f1f8f6;
  outline: 0;
}

.agent-flow-step > i {
  width: 27px;
  height: 27px;
  display: grid;
  place-items: center;
  border: 1px solid #d4dce2;
  border-radius: 50%;
  color: #7e8b9a;
  background: #fff;
  font-size: 8px;
  font-style: normal;
  font-weight: 820;
}

.agent-flow-step > div {
  min-width: 0;
  display: grid;
  gap: 2px;
}

.agent-flow-step strong {
  overflow: hidden;
  color: #49596d;
  font-size: 8px;
  text-overflow: ellipsis;
}

.agent-flow-step small {
  color: #8b97a5;
  font-size: 7px;
}

.agent-flow-overview > em {
  margin: 0 2px;
  color: #a2acb6;
  font-size: 10px;
  font-style: normal;
}

.agent-flow-overview > em.pass {
  color: #4fae96;
}

.agent-flow-overview > em.running {
  color: #6f94ce;
}

.agent-flow-overview > em.review {
  color: #cf9a50;
}

.agent-flow-overview > em.retry {
  color: #8a6caf;
}

.agent-flow-step.pass > i {
  border-color: var(--run-success);
  color: #fff;
  background: var(--run-success);
}

.agent-flow-step.running,
.agent-flow-step.review,
.agent-flow-step.retry,
.agent-flow-step.current {
  border-color: #b6d8d0;
  background: #edf7f4;
}

.agent-flow-step.running > i {
  border-color: var(--run-secondary);
  color: #fff;
  background: var(--run-secondary);
}

.agent-flow-step.review > i {
  border-color: var(--run-warning);
  color: #fff;
  background: var(--run-warning);
}

.agent-flow-step.retry > i {
  border-color: #a989cb;
  color: #fff;
  background: #8567ad;
}

.agent-flow-step.waiting {
  color: var(--run-neutral);
  opacity: 0.78;
}

.agent-flow-step.current {
  border-width: 2px;
  border-color: #278f75;
  background: linear-gradient(120deg, #e4f6f1, #f3fbf8);
  box-shadow: 0 0 0 3px rgba(39, 143, 117, 0.13), 0 8px 18px rgba(39, 103, 87, 0.08);
}

.agent-flow-step.current > div strong {
  color: #1f6e5b;
  font-weight: 860;
}

.agent-flow-step > b {
  min-height: 17px;
  padding: 0 5px;
  position: absolute;
  top: -8px;
  right: 6px;
  display: inline-flex;
  align-items: center;
  border-radius: 999px;
  color: #fff;
  background: #258a71;
  box-shadow: 0 2px 7px rgba(37, 138, 113, 0.2);
  font-size: 5.5px;
  font-weight: 850;
  letter-spacing: 0.08em;
}

.agent-flow-step.selected {
  border-color: var(--run-primary);
  background: #eaf8f4;
  box-shadow: 0 0 0 2px rgba(15, 157, 122, 0.12);
  transform: translateY(-1px);
}

.stage-execution-context {
  margin-top: 8px;
  padding: 11px 12px;
  border: 1px solid #bcdad2;
  border-radius: 10px;
  background: linear-gradient(115deg, #f1f9f7, #f8fbfc);
}

.stage-execution-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.stage-execution-head > div {
  display: grid;
  gap: 3px;
}

.stage-execution-head span,
.timeline-log-toolbar span {
  color: #2c8873;
  font-size: 7px;
  font-weight: 820;
  letter-spacing: 0.09em;
}

.stage-execution-head strong {
  color: #33475b;
  font-size: 10px;
}

.stage-execution-context dl {
  margin: 9px 0 0;
  display: grid;
  grid-template-columns: 0.8fr 1.35fr 1.35fr 1.35fr;
  gap: 0;
  border-top: 1px solid #dbe9e5;
}

.stage-execution-context dl > div {
  min-width: 0;
  padding: 9px 10px 0;
  border-left: 1px solid #dbe9e5;
}

.stage-execution-context dl > div:first-child {
  padding-left: 0;
  border-left: 0;
}

.stage-execution-context dt {
  color: #84929f;
  font-size: 7px;
  font-weight: 760;
}

.stage-execution-context dd {
  margin: 4px 0 0;
  color: #536579;
  font-size: 8px;
  line-height: 1.45;
}

.timeline-log-toolbar {
  min-height: 44px;
  margin-top: 11px;
  padding: 8px 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  border-bottom: 1px solid #e4e9ec;
}

.timeline-log-toolbar > div {
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 7px;
}

.timeline-log-toolbar strong {
  color: #405166;
  font-size: 10px;
}

.timeline-log-toolbar small {
  color: #8d99a6;
  font-size: 8px;
}

.timeline-log-toolbar em {
  padding-left: 7px;
  border-left: 1px solid var(--run-border);
  color: var(--run-neutral);
  font-size: 8px;
  font-style: normal;
  white-space: nowrap;
}

.timeline-log-toolbar button {
  height: 28px;
  padding: 0 9px;
  border: 1px solid #cfe0dc;
  border-radius: 7px;
  color: #2b806c;
  background: #f3f9f7;
  font-size: 8px;
  font-weight: 740;
}

.timeline-stage-empty {
  min-height: 96px;
  display: grid;
  place-content: center;
  justify-items: center;
  color: #8a96a4;
  text-align: center;
}

.timeline-stage-empty strong {
  color: #4c5c70;
  font-size: 10px;
}

.timeline-stage-empty span {
  margin-top: 4px;
  font-size: 8px;
}

.recovery-flow {
  margin-top: 11px;
  padding: 11px 12px;
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto minmax(0, 1fr) auto minmax(0, 1fr);
  align-items: center;
  gap: 10px;
  border: 1px solid #e0e4e7;
  border-radius: 10px;
  background: linear-gradient(90deg, #fff6f4, #fffaf0 49%, #f1faf7);
}

.recovery-flow > div {
  min-width: 0;
  display: grid;
  grid-template-columns: auto minmax(0, 1fr);
  align-items: center;
  column-gap: 7px;
}

.recovery-flow > div > span {
  width: 25px;
  height: 25px;
  grid-row: 1/span 2;
  display: grid;
  place-items: center;
  border-radius: 7px;
  font-size: 7px;
  font-weight: 850;
}

.recovery-flow-copy {
  min-width: 0;
  display: grid;
  gap: 2px;
}

.recovery-flow-copy > em {
  color: #8994a1;
  font-size: 6px;
  font-style: normal;
  font-weight: 780;
  letter-spacing: 0.04em;
}

.recovery-flow strong {
  color: #455469;
  font-size: 9px;
}

.recovery-flow small {
  margin-top: 2px;
  color: #8a95a2;
  font-size: 7px;
  line-height: 1.4;
}

.recovery-flow > i {
  color: #9aa5b0;
  font-size: 13px;
  font-style: normal;
}

.recovery-flow .fail > span {
  color: #a4473d;
  background: #fae3df;
}

.recovery-flow .retry > span {
  color: #76569f;
  background: #eee7f8;
}

.recovery-flow .pass > span {
  color: #217761;
  background: #ddf2eb;
}

.recovery-flow .running > span {
  color: #426fa8;
  background: #e6eef9;
}

.timeline-event {
  min-height: 62px;
  position: relative;
  padding-bottom: 7px;
}

.timeline-event::after {
  width: 1px;
  position: absolute;
  top: 26px;
  bottom: -3px;
  left: 82px;
  content: "";
  background: #dce3e7;
}

.timeline-event.done::after,
.timeline-event.pass::after,
.timeline-event.approval::after {
  background: var(--run-success);
}

.timeline-event.running::after {
  background: var(--run-secondary);
}

.timeline-event.review::after {
  background: var(--run-warning);
}

.timeline-event.fail::after {
  background: linear-gradient(var(--run-danger), var(--run-warning));
}

.timeline-event.retry::after {
  background: #b19acb;
}

.timeline-event:last-child::after {
  display: none;
}

.timeline-event-summary {
  width: 100%;
  min-height: 56px;
  padding: 9px 10px 9px 0;
  display: grid;
  grid-template-columns: 65px 18px minmax(0, 1fr) 22px;
  align-items: flex-start;
  gap: 9px;
  border: 1px solid transparent;
  border-radius: 9px;
  color: inherit;
  text-align: left;
  background: transparent;
  transition: border-color 0.16s, background 0.16s;
}

.timeline-event-summary:hover,
.timeline-event-summary:focus-visible,
.timeline-event.expanded .timeline-event-summary {
  border-color: #dce5e7;
  background: #f8fafb;
  outline: 0;
}

.timeline-event.fail .timeline-event-summary {
  border-color: #f0d2ce;
  background: #fff8f7;
}

.timeline-event.retry .timeline-event-summary {
  border-color: #dfd5ed;
  background: #faf8fd;
}

.timeline-event.pass .timeline-event-summary {
  border-color: #cce5dd;
  background: #f5fbf9;
}

.timeline-event.review .timeline-event-summary {
  border-color: #ead8bb;
  background: #fffaf2;
}

.timeline-event.current-log .timeline-event-summary {
  border-color: #7ca6db;
  background: #f2f6fc;
  box-shadow: inset 3px 0 #5c82c0;
}

.timeline-event-summary > time {
  padding: 3px 0 0 6px;
  color: #9aa3af;
  font-size: 8px;
}

.timeline-event-summary > i {
  width: 17px;
  height: 17px;
  margin-top: 1px;
  display: grid;
  place-items: center;
  z-index: 1;
  border: 2px solid #fff;
  border-radius: 50%;
  background: #8fa0b1;
  box-shadow: 0 0 0 1px #cbd4dc;
}

.timeline-event-summary > i > span {
  color: #fff;
  font-size: 7px;
  font-style: normal;
  font-weight: 900;
  line-height: 1;
}

.timeline-event.done .timeline-event-summary > i,
.timeline-event.approval .timeline-event-summary > i,
.timeline-event.pass .timeline-event-summary > i {
  background: var(--run-success);
}

.timeline-event.running .timeline-event-summary > i {
  background: var(--run-secondary);
  box-shadow: 0 0 0 3px #e7eef9;
}

.timeline-event.review .timeline-event-summary > i {
  background: var(--run-warning);
  box-shadow: 0 0 0 3px #fbefdc;
}

.timeline-event.fail .timeline-event-summary > i {
  background: var(--run-danger);
  box-shadow: 0 0 0 3px #fae8e5;
}

.timeline-event.retry .timeline-event-summary > i {
  background: var(--run-warning);
  box-shadow: 0 0 0 3px #f0ebfa;
}

.timeline-event-copy {
  min-width: 0;
  display: grid;
}

.timeline-event-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}

.timeline-event-title > span {
  color: #80909f;
  font-size: 8px;
}

.timeline-agent {
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 6px;
}

.timeline-agent > i {
  min-height: 17px;
  padding: 0 5px;
  display: inline-flex;
  align-items: center;
  flex: 0 0 auto;
  border-radius: 5px;
  color: #456d88;
  background: #eaf1f6;
  font-size: 6px;
  font-style: normal;
  font-weight: 800;
}

.timeline-event-title .ui-status {
  min-height: 17px;
  padding: 0 5px;
  font-size: 6px;
}

.timeline-event-copy > strong {
  margin-top: 2px;
  color: #405066;
  font-size: 10px;
}

.timeline-event-copy > p {
  margin: 2px 0 0;
  color: #7f8a99;
  font-size: 9px;
}

.timeline-event-summary > svg {
  width: 17px;
  height: 17px;
  margin-top: 8px;
  color: #8d99a6;
  transition: transform 0.16s;
}

.timeline-event.expanded .timeline-event-summary > svg {
  transform: rotate(180deg);
}

.timeline-event-detail {
  margin: 3px 8px 7px 96px;
  padding: 12px;
  border: 1px solid #e1e7ea;
  border-radius: 10px;
  background: #fbfcfd;
  box-shadow: 0 6px 16px rgba(44, 61, 78, 0.04);
  animation: section-enter 0.16s ease-out;
}

.log-reasoning-flow {
  margin: 0;
  padding: 0;
  display: grid;
  grid-template-columns: minmax(0, 1fr) 20px minmax(0, 1fr) 20px minmax(0, 1fr);
  align-items: stretch;
  gap: 7px;
  list-style: none;
}

.log-reasoning-flow > li:not(.log-flow-arrow) {
  min-width: 0;
  min-height: 76px;
  padding: 9px 10px;
  border: 1px solid #e0e6e9;
  border-radius: 9px;
  background: #fff;
}

.log-reasoning-flow > li.input {
  border-top: 3px solid #7186a2;
}

.log-reasoning-flow > li.decision {
  border-top: 3px solid #8a6caf;
  background: #fcfaff;
}

.log-reasoning-flow > li.output {
  border-top: 3px solid #3a9c83;
  background: #f8fcfb;
}

.log-step-label {
  display: flex;
  align-items: center;
  gap: 6px;
}

.log-step-label > span {
  width: 18px;
  height: 18px;
  display: grid;
  place-items: center;
  border-radius: 5px;
  color: #fff;
  background: #7186a2;
  font-size: 6px;
  font-weight: 850;
}

.decision .log-step-label > span {
  background: #8a6caf;
}

.output .log-step-label > span {
  background: #3a9c83;
}

.log-step-label > strong {
  color: #4c5f75;
  font-size: 7px;
  letter-spacing: 0.08em;
}

.log-reasoning-flow p {
  margin: 7px 0 0;
  color: #5e6f82;
  font-size: 8px;
  line-height: 1.55;
}

.log-flow-arrow {
  display: grid;
  place-items: center;
  color: #91a0ad;
  font-size: 13px;
}

.log-handoff {
  min-height: 35px;
  margin-top: 9px;
  padding: 8px 10px;
  display: flex;
  align-items: center;
  gap: 9px;
  border: 1px dashed #ccd9dd;
  border-radius: 8px;
  background: #f5f8f9;
}

.log-handoff > span,
.log-trace-links > span {
  color: #778695;
  font-size: 6.5px;
  font-weight: 830;
  letter-spacing: 0.08em;
  white-space: nowrap;
}

.log-handoff > strong {
  color: #536679;
  font-size: 8px;
}

.log-trace-links {
  margin-top: 9px;
  display: grid;
  grid-template-columns: auto repeat(3, minmax(0, 1fr));
  align-items: center;
  gap: 7px;
}

.log-trace-links > span {
  padding-right: 3px;
  color: #2f8874;
}

.log-trace-links > a {
  min-width: 0;
  min-height: 38px;
  padding: 6px 8px;
  display: grid;
  grid-template-columns: auto minmax(0, 1fr) auto;
  align-items: center;
  column-gap: 6px;
  border: 1px solid #d9e4e2;
  border-radius: 8px;
  color: #42566b;
  background: #fff;
  text-decoration: none;
  transition: border-color 0.15s, background 0.15s, transform 0.15s;
}

.log-trace-links > a:hover,
.log-trace-links > a:focus-visible {
  border-color: #8ec4b7;
  background: #f2faf7;
  outline: 0;
  transform: translateY(-1px);
}

.log-trace-links a > i {
  width: 23px;
  height: 23px;
  grid-row: 1/span 2;
  display: grid;
  place-items: center;
  border-radius: 6px;
  color: #287f6b;
  background: #e3f3ee;
  font-size: 6px;
  font-style: normal;
  font-weight: 850;
}

.log-trace-links a > strong {
  overflow: hidden;
  font-size: 8px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.log-trace-links a > small {
  grid-column: 2;
  overflow: hidden;
  color: #8995a2;
  font-size: 6.5px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.log-trace-links a > b {
  grid-column: 3;
  grid-row: 1/span 2;
  color: #6e9b90;
  font-size: 10px;
}

.timeline-event-detail dl {
  margin: 0;
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 8px;
}

.timeline-event-detail dl > div {
  min-width: 0;
  padding-right: 8px;
  border-right: 1px solid #e6ebed;
}

.timeline-event-detail dl > div:last-child {
  padding-right: 0;
  border-right: 0;
}

.timeline-event-detail dt {
  color: #2c8a75;
  font-size: 7px;
  font-weight: 820;
  letter-spacing: 0.08em;
}

.timeline-event-detail dd {
  margin: 4px 0 0;
  color: #657386;
  font-size: 8px;
  line-height: 1.45;
}

.approval-overview {
  min-height: 88px;
  margin-bottom: 8px;
  padding: 10px 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  border: 1px solid #cfe4df;
  border-radius: 10px;
  background: linear-gradient(115deg, #f1faf7, #f8fbff);
}

.approval-intro {
  display: flex;
  align-items: center;
  gap: 10px;
}

.approval-shield {
  width: 42px;
  height: 42px;
  display: grid;
  place-items: center;
  flex: 0 0 auto;
  border-radius: 10px;
  color: #277c68;
  background: #dff2ed;
}

.approval-shield svg {
  width: 24px;
  height: 24px;
}

.approval-intro h2 {
  margin: 2px 0 0;
  color: #26374a;
  font-size: 16px;
}

.approval-intro p {
  max-width: 670px;
  margin: 3px 0 0;
  color: #6f807f;
  font-size: 9px;
  line-height: 1.4;
}

.approval-summary {
  display: flex;
  gap: 5px;
  flex: 0 0 auto;
}

.approval-summary > div {
  min-width: 68px;
  min-height: 52px;
  padding: 6px 8px;
  display: grid;
  align-content: center;
  text-align: center;
  border: 1px solid rgba(95, 128, 121, 0.13);
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.72);
}

.approval-summary > div.approved {
  color: #247864;
}

.approval-summary > div.pending {
  color: #946223;
}

.approval-summary > div.rejected {
  color: #a94f46;
}

.approval-summary > div.reviewing {
  color: #6f55a4;
}

.approval-summary > div:first-child {
  border-left: 1px solid rgba(95, 128, 121, 0.13);
}

.approval-summary strong {
  color: inherit;
  font-size: 20px;
  font-weight: 860;
  letter-spacing: -0.03em;
  line-height: 1;
}

.approval-summary span {
  margin-top: 4px;
  color: #46586a;
  font-size: 8px;
  font-weight: 760;
}

.approval-summary span::before {
  width: 5px;
  height: 5px;
  margin-right: 5px;
  display: inline-block;
  border-radius: 50%;
  background: currentColor;
  content: "";
  vertical-align: 1px;
}

.approval-list,
.approval-detail {
  border-radius: 10px;
  box-shadow: 0 3px 12px rgba(32, 43, 56, 0.028);
}

.approval-list {
  padding: 8px;
}

.approval-list .panel-title {
  min-height: 38px;
  padding: 0 2px 6px;
}

.approval-list .panel-title h2 {
  margin-top: 2px;
  font-size: 13px;
}

.approval-list .panel-title > em {
  padding: 4px;
  border: 0;
  background: transparent;
  font-size: 7px;
}

.approval-filter-panel {
  margin: 6px 0 0;
  padding: 6px;
  display: grid;
  gap: 5px;
  border: 1px solid #e1e7e9;
  border-radius: 8px;
  background: #f8faf9;
}

.approval-search {
  height: 29px;
  padding: 0 7px;
  display: flex;
  align-items: center;
  gap: 6px;
  border: 1px solid #d9e1e4;
  border-radius: 7px;
  color: #84909d;
  background: #fff;
}

.approval-search:focus-within {
  border-color: #76b7a7;
  box-shadow: 0 0 0 2px rgba(52, 151, 127, 0.1);
}

.approval-search svg {
  width: 14px;
  height: 14px;
  flex: 0 0 auto;
}

.approval-search input {
  width: 100%;
  min-width: 0;
  border: 0;
  outline: 0;
  color: #3f4e61;
  background: transparent;
  font: inherit;
  font-size: 8px;
}

.approval-search input::placeholder {
  color: #a2acb6;
}

.approval-filter-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 5px;
}

.approval-filter-grid > label {
  min-width: 0;
  display: grid;
  gap: 3px;
}

.approval-filter-grid > label:last-child {
  grid-column: 1/-1;
}

.approval-filter-grid span {
  color: #8a96a3;
  font-size: 7px;
  font-weight: 720;
}

.approval-filter-grid select {
  width: 100%;
  height: 26px;
  padding: 0 20px 0 6px;
  overflow: hidden;
  border: 1px solid #dce3e6;
  border-radius: 6px;
  outline: 0;
  color: #526174;
  background: #fff;
  font: inherit;
  font-size: 7px;
  text-overflow: ellipsis;
}

.approval-filter-grid select:focus-visible {
  border-color: #76b7a7;
}

.approval-filter-result {
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #8995a2;
  font-size: 7px;
}

.approval-filter-result button {
  padding: 0;
  border: 0;
  color: #2b806c;
  background: transparent;
  font: inherit;
  font-size: 7px;
  font-weight: 760;
}

.approval-filter-empty {
  margin-top: 7px;
}

.approval-detail {
  padding: 11px 12px;
}

.approval-detail-head {
  min-height: 60px;
  gap: 10px;
}

.approval-detail-head h2 {
  margin-top: 2px;
  font-size: 17px;
}

.approval-detail-head p {
  margin-top: 3px;
  font-size: 9px;
}

.approval-detail-head > em {
  min-width: 58px;
  min-height: 21px;
  justify-content: center;
}

.approval-timeline {
  position: relative;
  margin: 5px 0 0;
  padding: 0 0 0 15px;
  list-style: none;
}

.approval-timeline::before {
  position: absolute;
  top: 12px;
  bottom: 12px;
  left: 5px;
  width: 2px;
  border-radius: 999px;
  background: #e2e8e8;
  content: "";
}

.approval-timeline-entry {
  position: relative;
  margin-top: 4px;
}

.approval-timeline-entry:first-child {
  margin-top: 0;
}

.approval-timeline-entry::before {
  position: absolute;
  top: 12px;
  left: -14px;
  z-index: 1;
  width: 9px;
  height: 9px;
  border: 2px solid #fff;
  border-radius: 50%;
  background: #8592a2;
  box-shadow: 0 0 0 2px #dce3e6;
  content: "";
}

.approval-timeline-entry.status-approved::before {
  background: #31a487;
  box-shadow: 0 0 0 2px #bfe2d8;
}

.approval-timeline-entry.status-pending::before {
  background: #d0923d;
  box-shadow: 0 0 0 2px #efdcbf;
}

.approval-timeline-entry.status-rejected::before {
  background: #ce6358;
  box-shadow: 0 0 0 2px #efd0cc;
}

.approval-timeline-entry.status-review::before {
  background: #7962ad;
  box-shadow: 0 0 0 2px #ded6f1;
}

.approval-timeline .approval-list-item {
  margin-top: 0;
  padding: 6px 7px;
  position: relative;
  border-radius: 8px;
  transition: border-color 0.16s, background 0.16s, box-shadow 0.16s, transform 0.16s;
}

.approval-timeline-entry.status-approved .approval-list-item {
  border-color: #d6e9e4;
  background: #f7fbfa;
}

.approval-timeline-entry.status-pending .approval-list-item {
  border-color: #eddfc9;
  background: #fffaf2;
}

.approval-timeline-entry.status-rejected .approval-list-item {
  border-color: #efd8d5;
  background: #fff8f7;
}

.approval-timeline-entry.status-review .approval-list-item {
  border-color: #e2dced;
  background: #faf8fd;
}

.approval-timeline-entry .approval-list-item:not(.active) {
  border-color: #e8ecee;
  background: #fafbfb;
  box-shadow: none;
  opacity: 0.8;
}

.approval-timeline-entry .approval-list-item:not(.active):hover,
.approval-timeline-entry .approval-list-item:not(.active):focus-visible {
  border-color: #b9d7cf;
  background: #f5faf8;
  outline: 0;
  opacity: 1;
}

.approval-timeline-entry.status-approved .approval-list-item.active {
  border-color: #67ad9b;
  background: linear-gradient(110deg, #eaf7f3, #f7fbfa);
  box-shadow: 0 3px 10px rgba(34, 107, 89, 0.1), inset 3px 0 #35967f;
}

.approval-timeline-entry.status-pending .approval-list-item.active {
  border-color: #d5a35e;
  background: linear-gradient(110deg, #fff4df, #fffbf4);
  box-shadow: 0 3px 10px rgba(145, 97, 38, 0.08), inset 3px 0 #c5852e;
}

.approval-timeline-entry.status-rejected .approval-list-item.active {
  border-color: #d98279;
  background: linear-gradient(110deg, #fcebe8, #fff8f7);
  box-shadow: 0 3px 10px rgba(159, 72, 63, 0.08), inset 3px 0 #c95d52;
}

.approval-timeline-entry.status-review .approval-list-item.active {
  border-color: #9c89c6;
  background: linear-gradient(110deg, #f1edfa, #fbf9fe);
  box-shadow: 0 3px 10px rgba(93, 70, 145, 0.08), inset 3px 0 #7962ad;
}

.approval-list-top time {
  margin-left: auto;
  color: #98a2ae;
  font-size: 7px;
  white-space: nowrap;
}

.approval-record-badges {
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 4px;
}

.approval-record-badges .ui-status {
  min-width: 47px;
  min-height: 17px;
  padding: 0 4px;
  justify-content: center;
  border-radius: 5px;
  font-size: 7px;
}

.approval-type {
  min-height: 17px;
  padding: 0 4px;
  display: inline-flex;
  align-items: center;
  border: 1px solid #dce3e8;
  border-radius: 5px;
  color: #647184;
  background: #f7f9fa;
  font-size: 7px;
  font-weight: 790;
  white-space: nowrap;
}

.approval-type.requirement {
  border-color: #d5e1ef;
  color: #4d6f98;
  background: #f1f6fc;
}

.approval-type.candidate {
  border-color: #ddd8ef;
  color: #695a9c;
  background: #f6f3fc;
}

.approval-type.final {
  border-color: #c7e2da;
  color: #277a67;
  background: #edf8f5;
}

.approval-list-item > strong {
  margin-top: 4px;
  color: #354359;
  font-size: 10px;
}

.approval-list-item > span {
  margin-top: 2px;
  color: #677588;
  font-size: 8px;
}

.approval-list-item > p {
  margin: 2px 0 0;
  overflow: hidden;
  color: #758295;
  font-size: 9px;
  line-height: 1.35;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.approval-list-meta {
  margin-top: 3px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 6px;
  color: #919ba8;
  font-size: 7px;
}

.approval-list-meta > span,
.approval-list-meta > small {
  min-width: 0;
  overflow: hidden;
  font: inherit;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.approval-list-meta > small {
  flex: 0 1 auto;
}

.approval-identity {
  margin-top: 7px;
  padding: 7px 9px;
  display: grid;
  grid-template-columns: 32px minmax(0, 1fr) minmax(0, 1fr);
  align-items: center;
  gap: 10px;
  border: 1px solid #dfe5e8;
  border-radius: 8px;
  background: #f9fafb;
}

.approver-avatar {
  width: 32px;
  height: 32px;
  display: grid;
  place-items: center;
  grid-row: 1;
  border-radius: 8px;
  color: #fff;
  background: linear-gradient(145deg, #315e73, #294568);
  font-size: 13px;
  font-weight: 820;
}

.approval-identity > div:not(.approver-avatar) {
  display: grid;
}

.approval-identity strong {
  margin-top: 2px;
  color: #3b495d;
  font-size: 10px;
}

.approval-identity small {
  margin-top: 1px;
  color: #8c96a3;
  font-size: 8px;
}

.decision-summary {
  margin-top: 7px;
  padding: 8px 10px;
  display: grid;
  border-left: 3px solid #4ebda3;
  border-radius: 0 7px 7px 0;
  background: #f4f9f8;
}

.decision-summary strong {
  margin-top: 2px;
  color: #26394c;
  font-size: 14px;
  font-weight: 790;
}

.decision-object-toggle {
  width: 100%;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  border: 0;
  color: inherit;
  background: transparent;
  text-align: left;
}

.decision-object-toggle > div {
  min-width: 0;
  display: grid;
}

.decision-object-toggle > div > span {
  color: #227c68;
  font-size: 8px;
  font-weight: 820;
  letter-spacing: 0.11em;
}

.decision-object-toggle > div > strong {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.decision-object-toggle > span {
  display: inline-flex;
  align-items: center;
  flex: 0 0 auto;
  gap: 4px;
  color: #347665;
  font-size: 7px;
  font-weight: 760;
}

.decision-object-toggle svg {
  width: 15px;
  height: 15px;
  transition: transform 0.16s;
}

.decision-object-toggle[aria-expanded=true] svg {
  transform: rotate(180deg);
}

.decision-object-toggle:focus-visible {
  border-radius: 5px;
  outline: 2px solid rgba(47, 145, 121, 0.26);
  outline-offset: 3px;
}

.decision-object-conditions {
  margin-top: 8px;
  padding-top: 8px;
  border-top: 1px solid #dce9e5;
}

.decision-object-conditions dl {
  margin: 0;
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 6px;
}

.decision-object-conditions dl > div {
  min-width: 0;
  padding: 7px 8px;
  border-radius: 7px;
  background: rgba(255, 255, 255, 0.72);
}

.decision-object-conditions dt {
  color: #7c898b;
  font-size: 7px;
}

.decision-object-conditions dd {
  margin: 3px 0 0;
  color: #37594f;
  font-size: 8px;
  font-weight: 720;
  line-height: 1.35;
}

.approval-decision-rationale {
  margin-top: 6px;
  padding-top: 6px;
  display: flex;
  align-items: baseline;
  gap: 10px;
  border-top: 1px solid #dce9e5;
}

.approval-decision-rationale > span {
  flex: 0 0 auto;
  color: #246f5f;
  font-size: 8px;
  font-weight: 840;
}

.approval-decision-rationale > strong {
  margin-top: 0;
  overflow: hidden;
  color: #344c50;
  font-size: 10px;
  font-weight: 720;
  line-height: 1.4;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.rejection-detail {
  margin-top: 9px;
  padding: 9px 10px;
  display: grid;
  grid-template-columns: minmax(0, 1fr) 180px;
  align-items: center;
  gap: 16px;
  border: 1px solid #f0d2ce;
  border-radius: 9px;
  background: #fff7f6;
}

.rejection-copy {
  display: grid;
}

.rejection-copy > span {
  color: #b25b51;
}

.rejection-copy strong {
  margin-top: 4px;
  color: #7d3f39;
  font-size: 11px;
}

.rejection-copy p {
  margin: 4px 0 0;
  color: #8b5d58;
  font-size: 9px;
  line-height: 1.45;
}

.rejection-detail > a {
  min-height: 48px;
  padding: 7px 9px;
  display: grid;
  align-content: center;
  border: 1px solid #e8c5c0;
  border-radius: 8px;
  color: #76504b;
  background: #fff;
  text-decoration: none;
}

.rejection-detail > a span {
  color: #a7736d;
  font-size: 7px;
  font-weight: 760;
}

.rejection-detail > a strong {
  margin-top: 2px;
  font-size: 10px;
}

.rejection-detail > a em {
  margin-top: 4px;
  color: #b25b51;
  font-size: 7px;
  font-style: normal;
  font-weight: 760;
}

.change-summary {
  margin-top: 8px;
}

.change-summary-title {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
}

.change-summary-title > div {
  display: grid;
}

.change-summary-title strong {
  margin-top: 2px;
  color: #3d4b60;
  font-size: 12px;
}

.change-list {
  margin-top: 5px;
  overflow: hidden;
  border: 1px solid #dfe5e8;
  border-radius: 8px;
  background: #fff;
}

.change-table-head {
  min-height: 26px;
  padding: 0 8px;
  display: grid;
  grid-template-columns: 112px minmax(0, 1fr) 20px minmax(0, 1fr);
  align-items: center;
  gap: 6px;
  border-bottom: 1px solid #dce3e6;
  color: #69788a;
  background: #f5f7f8;
  font-size: 7px;
  font-weight: 800;
}

.change-table-head > i {
  color: #8da198;
  font-style: normal;
  text-align: center;
}

.change-table-head + .change-row {
  border-top: 0;
}

.change-row {
  min-width: 0;
  padding: 5px 8px 4px;
  display: grid;
  grid-template-columns: 112px minmax(0, 1fr) 20px minmax(0, 1fr);
  align-items: center;
  gap: 6px;
  border-top: 1px solid #e9edef;
}

.change-field,
.change-state {
  min-width: 0;
  display: grid;
}

.change-field span,
.change-state small {
  color: #929da9;
  font-size: 7px;
}

.change-field strong,
.change-state strong {
  margin-top: 0;
  overflow: hidden;
  color: #48566a;
  font-size: 8px;
  line-height: 1.35;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.change-state {
  min-height: 28px;
  padding: 5px 7px;
  align-content: center;
  border-radius: 6px;
}

.change-state.before {
  background: #f3f5f6;
}

.change-state.after {
  border: 1px solid #cae3dc;
  background: #edf8f5;
}

.change-state.after small,
.change-state.after strong {
  color: #287965;
}

.change-row > i {
  width: 20px;
  height: 20px;
  display: grid;
  place-items: center;
  border-radius: 50%;
  color: #31846f;
  background: #e8f5f1;
  font-size: 9px;
  font-style: normal;
  font-weight: 800;
}

.change-row > p {
  margin: 0;
  grid-column: 2/-1;
  color: #8894a1;
  font-size: 6px;
  line-height: 1.3;
}

.change-summary-title > em {
  color: #8b96a4;
  font-size: 8px;
  font-style: normal;
}

.change-grid {
  margin-top: 9px;
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 7px;
}

.change-item {
  min-width: 0;
  padding: 10px;
  border: 1px solid #e0e5e8;
  border-radius: 9px;
  background: #fbfcfc;
}

.change-item > span {
  color: #758295;
  font-size: 8px;
  font-weight: 760;
}

.change-values {
  margin-top: 7px;
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto minmax(0, 1fr);
  align-items: center;
  gap: 8px;
}

.change-values > div {
  min-width: 0;
  min-height: 57px;
  padding: 8px;
  display: grid;
  align-content: center;
  border: 1px solid #e2e7ea;
  border-radius: 8px;
}

.change-values .before {
  background: #f4f6f7;
}

.change-values .after {
  border-color: #cce5de;
  background: #eef8f5;
}

.change-values small {
  color: #9aa4b0;
  font-size: 7px;
}

.change-values strong {
  margin-top: 3px;
  color: #596779;
  font-size: 9px;
  line-height: 1.35;
}

.change-values .after strong {
  color: #277a67;
}

.change-values > i {
  width: 23px;
  height: 23px;
  display: grid;
  place-items: center;
  border: 1px solid #bfddd5;
  border-radius: 50%;
  color: #2d8b74;
  background: #fff;
  font-size: 11px;
  font-style: normal;
  font-weight: 800;
}

.change-item > p {
  margin: 7px 0 0;
  padding-top: 6px;
  border-top: 1px solid #edf0f2;
  color: #86919d;
  font-size: 7px;
  line-height: 1.4;
}

.change-empty {
  margin-top: 9px;
  padding: 12px;
  border: 1px dashed #dfe5e8;
  border-radius: 9px;
  color: #8793a1;
  background: #fafbfc;
  font-size: 8px;
  text-align: center;
}

.evidence-section {
  margin-top: 8px;
}

.evidence-title {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
}

.evidence-title > div {
  display: grid;
}

.evidence-title strong {
  margin-top: 2px;
  color: #3d4b60;
  font-size: 12px;
}

.evidence-title > em {
  color: #8b96a4;
  font-size: 8px;
  font-style: normal;
}

.evidence-title-actions {
  display: flex;
  align-items: center;
  gap: 10px;
}

.evidence-title-actions > em {
  color: #8b96a4;
  font-size: 8px;
  font-style: normal;
}

.approval-report-link {
  min-height: 23px;
  padding: 0 8px;
  display: inline-flex;
  align-items: center;
  border: 1px solid #cfe1dc;
  border-radius: 6px;
  color: #287d69;
  background: #f2f9f7;
  font-size: 8px;
  font-weight: 740;
  text-decoration: none;
}

.evidence-grid {
  margin-top: 5px;
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  grid-auto-rows: 44px;
  gap: var(--platform-inner-gap);
}

.evidence-item {
  min-width: 0;
  min-height: 0;
  height: 100%;
  padding: 5px 6px;
  display: grid;
  grid-template-columns: 22px minmax(0, 1fr) auto;
  align-items: center;
  gap: 6px;
  border: 1px solid #e0e5e8;
  border-radius: 7px;
  color: inherit;
  background: #fff;
  text-decoration: none;
  transition: border-color 0.16s, background 0.16s;
}

.evidence-item:hover,
.evidence-item:focus-visible {
  border-color: #a9d5ca;
  background: #f6fbf9;
  outline: 0;
}

.evidence-item > i {
  width: 22px;
  height: 22px;
  display: grid;
  place-items: center;
  border-radius: 6px;
  color: #317f6d;
  background: #e5f4f0;
  font-size: 8px;
  font-style: normal;
  font-weight: 780;
}

.evidence-item > div {
  min-width: 0;
  display: grid;
}

.evidence-item strong {
  overflow: hidden;
  color: #445267;
  font-size: 9px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.evidence-item span {
  margin-top: 2px;
  color: #929ca8;
  font-size: 7px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.evidence-item > em {
  color: #2c8a74;
  font-size: 6px;
  font-style: normal;
  font-weight: 760;
}

.audit-footer {
  margin-top: 7px;
  padding: 6px 2px 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border: 0;
  border-top: 1px solid #e8ecee;
  border-radius: 0;
  color: #8f99a5;
  background: transparent;
}

.audit-footer > div {
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 8px;
}

.audit-footer > div:first-child {
  flex: 1;
}

.audit-footer-actions {
  justify-content: flex-end;
  flex: 0 0 auto;
}

.audit-hash-label {
  display: flex;
  align-items: center;
  flex: 0 0 auto;
  gap: 4px;
}

.audit-hash-label > span {
  color: #7f8b98;
  font-size: 7px;
  font-weight: 780;
  letter-spacing: 0.06em;
}

.audit-hash-label > em {
  min-height: 16px;
  padding: 0 5px;
  display: inline-flex;
  align-items: center;
  border: 1px solid #e2d6b8;
  border-radius: 5px;
  color: #8e672d;
  background: #fff7e8;
  font-size: 6px;
  font-style: normal;
  font-weight: 820;
  letter-spacing: 0.06em;
}

.audit-footer strong {
  margin-top: 0;
  flex: 0 0 auto;
  color: #737f8d;
  font-family: monospace;
  font-size: 7px;
}

.audit-footer small {
  min-width: 0;
  margin-top: 0;
  color: #929da9;
  font-size: 6px;
  line-height: 1.3;
}

.audit-footer button {
  height: 23px;
  padding: 0 7px;
  flex: 0 0 auto;
  border: 1px solid #d7dfe4;
  border-radius: 6px;
  color: #7a8694;
  background: #fafbfb;
  font-size: 7px;
}

.knowledge-purpose-banner {
  min-height: 80px;
  margin-bottom: 24px;
  padding: 16px 20px;
  display: grid;
  grid-template-columns: 42px minmax(0, 1fr) auto;
  align-items: center;
  gap: 16px;
  border: 1px solid #cfe4de;
  border-radius: 14px;
  background: linear-gradient(115deg, #f3faf8 0%, #fff 68%);
  box-shadow: 0 8px 24px rgba(32, 91, 76, 0.035);
}

.knowledge-purpose-icon {
  width: 36px;
  height: 36px;
  display: grid;
  place-items: center;
  border-radius: 12px;
  color: #23856f;
  background: #dff2ed;
}

.knowledge-purpose-icon svg {
  width: 19px;
  height: 19px;
}

.knowledge-purpose-banner > div:nth-child(2) {
  display: grid;
}

.knowledge-purpose-banner > div:nth-child(2) > span {
  color: #24917a;
  font-size: 9px;
  font-weight: 820;
  letter-spacing: 0.12em;
}

.knowledge-purpose-banner > div:nth-child(2) > strong {
  margin-top: 4px;
  color: #26364b;
  font-size: 15px;
}

.knowledge-purpose-banner p {
  margin: 4px 0 0;
  color: #708092;
  font-size: 10px;
  line-height: 1.6;
}

.knowledge-purpose-legend {
  padding-left: 14px;
  display: grid;
  gap: 7px;
  border-left: 1px solid #deebe7;
}

.knowledge-purpose-legend span {
  display: flex;
  align-items: center;
  gap: 7px;
  color: #657487;
  font-size: 8px;
  white-space: nowrap;
}

.knowledge-purpose-legend i,
.knowledge-status i {
  width: 6px;
  height: 6px;
  border-radius: 50%;
}

.knowledge-purpose-legend i.approved,
.knowledge-status.approved i {
  background: #24a686;
  box-shadow: 0 0 0 3px #def2ed;
}

.knowledge-purpose-legend i.unverified,
.knowledge-status.unverified i {
  background: #d68a2b;
  box-shadow: 0 0 0 3px #fbecd6;
}

.knowledge-purpose-legend .knowledge-access-badge {
  color: #657487;
  font-weight: 720;
}

.knowledge-purpose-legend .knowledge-access-badge i.lock {
  width: 12px;
  height: 12px;
  position: relative;
  border: 1px solid #8593a2;
  border-radius: 3px;
  background: #f4f6f7;
}

.knowledge-purpose-legend .knowledge-access-badge i.lock::before {
  width: 6px;
  height: 5px;
  position: absolute;
  top: -5px;
  left: 2px;
  border: 1px solid #8593a2;
  border-bottom: 0;
  border-radius: 5px 5px 0 0;
  content: "";
}

.knowledge-purpose-legend .knowledge-access-badge.manage {
  color: #287865;
}

.knowledge-purpose-legend .knowledge-access-badge.manage i.lock,
.knowledge-purpose-legend .knowledge-access-badge.manage i.lock::before {
  border-color: #4a9a85;
}

.knowledge-content .metric-strip {
  gap: 16px;
}

.knowledge-metrics {
  margin-bottom: 24px;
}

.knowledge-content .metric-card {
  min-height: 80px;
  padding: 14px 16px;
  border-radius: 12px;
  box-shadow: 0 6px 18px rgba(32, 43, 56, 0.04);
}

.knowledge-metrics .metric-card {
  width: 100%;
  position: relative;
  color: inherit;
  text-align: left;
  transition: border-color 0.15s, background 0.15s, box-shadow 0.15s, transform 0.15s;
}

.knowledge-metrics .metric-card::after {
  width: 7px;
  height: 7px;
  position: absolute;
  top: 14px;
  right: 14px;
  border: 1px solid #cbd5dc;
  border-radius: 50%;
  content: "";
  background: #fff;
}

.knowledge-metrics .metric-card:hover,
.knowledge-metrics .metric-card:focus-visible {
  border-color: #a9cfc4;
  box-shadow: 0 10px 24px rgba(36, 98, 81, 0.1);
  outline: 0;
  transform: translateY(-1px);
}

.knowledge-metrics .metric-card.active {
  border-color: #66ad9a;
  background: #eff8f5;
  box-shadow: inset 3px 0 #39947d;
}

.knowledge-metrics .metric-card.active::after {
  border-color: #39947d;
  background: #39947d;
}

.knowledge-metrics .metric-card.review::after {
  border-color: #d9a04f;
  background: #d9a04f;
}

.knowledge-metrics .metric-card.auto::after {
  border-color: #6a92ba;
  background: #6a92ba;
}

.knowledge-metrics .metric-card.recent::after {
  border-color: #8477b5;
  background: #8477b5;
}

.knowledge-ingestion {
  min-height: 88px;
  margin: 0 0 24px;
  padding: 12px;
  display: grid;
  grid-template-columns: 200px 248px minmax(340px, 1fr);
  align-items: stretch;
  gap: 12px;
  border: 1px solid #dbe5e2;
  border-radius: 14px;
  background: #fff;
}

.knowledge-ingestion-scope,
.knowledge-review-pipeline {
  min-width: 0;
  padding: 10px 12px;
  display: grid;
  align-content: center;
  gap: 4px;
  border-radius: 10px;
}

.knowledge-ingestion-scope {
  border: 1px solid #e1e7e9;
  background: #f8f9fa;
}

.knowledge-ingestion-scope.automated {
  border-color: #d7e8e3;
  background: #f2f8f6;
}

.knowledge-ingestion-scope > span,
.knowledge-review-pipeline > span {
  color: #6f7f90;
  font-size: 8px;
  font-weight: 820;
  letter-spacing: 0.08em;
}

.knowledge-ingestion-scope.automated > span,
.knowledge-review-pipeline > span {
  color: #36816f;
}

.knowledge-ingestion-scope strong {
  overflow: hidden;
  color: #3e4f63;
  font-size: 10px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.knowledge-ingestion-scope small,
.knowledge-review-pipeline > small {
  color: #8793a0;
  font-size: 8px;
  line-height: 1.45;
}

.knowledge-review-pipeline {
  background: linear-gradient(105deg, #f4f9f7, #f7f8fb);
}

.knowledge-review-steps {
  display: flex;
  align-items: center;
  gap: 8px;
}

.knowledge-review-steps em {
  min-height: 24px;
  padding: 0 8px;
  display: inline-flex;
  align-items: center;
  border: 1px solid #dfe5e7;
  border-radius: 5px;
  color: #637184;
  background: #fff;
  font-size: 8px;
  font-style: normal;
  font-weight: 740;
  white-space: nowrap;
}

.knowledge-review-steps em.approved {
  border-color: #b9d9d0;
  color: #2d7b68;
  background: #e9f5f1;
}

.knowledge-review-steps em.agent {
  border-color: #b7cada;
  color: #426985;
  background: #edf3f8;
}

.knowledge-review-steps i {
  color: #9ba6b1;
  font-size: 8px;
  font-style: normal;
}

.knowledge-content .metric-card strong {
  margin-top: 4px;
  font-size: 24px;
}

.knowledge-content .metric-card small {
  margin-top: 3px;
  font-size: 8px;
}

.knowledge-content .section-toolbar {
  min-height: 56px;
  margin: 0 0 8px;
}

.knowledge-content .section-toolbar h2 {
  font-size: 16px;
}

.knowledge-content .section-toolbar p {
  margin-top: 4px;
  font-size: 10px;
}

.knowledge-content .secondary-button {
  min-height: 32px;
  border-radius: 7px;
  font-size: 8px;
}

.knowledge-readonly-note {
  min-height: 30px;
  padding: 0 9px;
  display: flex;
  align-items: center;
  gap: 6px;
  border: 1px solid #e0e5e8;
  border-radius: 7px;
  color: #768394;
  background: #f6f8f9;
  font-size: 7.5px;
}

.knowledge-readonly-note i {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #8392a2;
}

.knowledge-filter-panel {
  min-height: 72px;
  margin-bottom: 24px;
  padding: 12px 16px;
  display: flex;
  align-items: flex-end;
  gap: 12px;
  border: 1px solid #dce3e6;
  border-radius: 13px;
  background: rgba(255, 255, 255, 0.92);
}

.knowledge-search {
  width: 248px;
  height: 44px;
  padding: 0 14px;
  display: flex;
  align-items: center;
  gap: 10px;
  flex: 0 0 auto;
  border: 1px solid #dbe2e6;
  border-radius: 8px;
  background: #f9fafb;
}

.knowledge-search:focus-within {
  border-color: #75b9a8;
  box-shadow: 0 0 0 3px rgba(68, 165, 140, 0.09);
}

.knowledge-search svg {
  width: 17px;
  height: 17px;
  flex: 0 0 auto;
  color: #8b97a5;
}

.knowledge-search input {
  width: 100%;
  border: 0;
  outline: 0;
  color: #435166;
  background: transparent;
  font-size: 10px;
}

.knowledge-search input::placeholder {
  color: #9aa4af;
}

.knowledge-type-tabs {
  min-width: 0;
  display: flex;
  gap: 8px;
  flex: 1;
  overflow-x: auto;
}

.knowledge-type-tabs button {
  height: 44px;
  padding: 0 12px;
  display: inline-flex;
  align-items: center;
  gap: 7px;
  flex: 0 0 auto;
  border: 1px solid #e0e5e8;
  border-radius: 8px;
  color: #657386;
  background: #fff;
  font-size: 9px;
  font-weight: 700;
}

.knowledge-type-tabs button em {
  min-width: 20px;
  padding: 3px 5px;
  border-radius: 999px;
  color: #8c97a4;
  background: #f0f2f4;
  font-size: 8px;
  font-style: normal;
  text-align: center;
}

.knowledge-type-tabs button.active {
  border-color: #6eb29f;
  color: #237763;
  background: #edf8f5;
}

.knowledge-type-tabs button.active em {
  color: #247d69;
  background: #d9eee8;
}

.knowledge-status-filter {
  min-width: 128px;
  display: grid;
  gap: 6px;
}

.knowledge-status-filter > span {
  color: #8a96a3;
  font-size: 8px;
  font-weight: 740;
}

.knowledge-status-filter select {
  height: 44px;
  padding: 0 28px 0 12px;
  border: 1px solid #dce3e6;
  border-radius: 8px;
  outline: 0;
  color: #5b697c;
  background: #fff;
  font-size: 9px;
}

.knowledge-filter-reset {
  height: 44px;
  padding: 0 12px;
  border: 0;
  border-radius: 8px;
  color: #7a8797;
  background: #f1f3f4;
  font-size: 9px;
}

.knowledge-layout {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 232px;
  align-items: start;
  gap: 16px;
}

.knowledge-results {
  min-width: 0;
  overflow: hidden;
  border-color: #d7e1e3;
  box-shadow: 0 10px 28px rgba(32, 43, 56, 0.05);
}

.knowledge-results-head {
  min-height: 56px;
  padding: 0 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #e6eaed;
}

.knowledge-results-head > div:first-child {
  display: flex;
  align-items: baseline;
  gap: 8px;
}

.knowledge-results-head strong {
  color: #3b4a5e;
  font-size: 12px;
}

.knowledge-results-head span {
  color: #929daa;
  font-size: 9px;
}

.knowledge-results-head span.filtering {
  color: #397b6c;
}

.knowledge-active-map {
  height: 32px;
  padding: 0 6px 0 10px;
  display: flex;
  align-items: center;
  gap: 6px;
  border-radius: 8px;
  color: #257762;
  background: #e7f5f1;
}

.knowledge-active-map span {
  color: #559384;
  font-size: 6px;
  font-weight: 820;
  letter-spacing: 0.09em;
}

.knowledge-active-map strong {
  color: #247662;
  font-size: 8px;
}

.knowledge-active-map button {
  width: 17px;
  height: 17px;
  border: 0;
  border-radius: 50%;
  color: #518c7d;
  background: rgba(255, 255, 255, 0.7);
  font-size: 11px;
  line-height: 1;
}

.knowledge-list {
  padding: 16px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
}

.knowledge-card {
  min-width: 0;
  padding: 16px;
  position: relative;
  border: 1px solid #e5e9eb;
  border-radius: 12px;
  background: #fff;
  box-shadow: 0 4px 14px rgba(32, 43, 56, 0.035);
  opacity: 1;
  transition: border-color 0.18s, background 0.18s, box-shadow 0.18s, transform 0.18s;
}

.knowledge-card::before {
  width: 3px;
  position: absolute;
  top: 12px;
  bottom: 12px;
  left: -1px;
  border-radius: 0 3px 3px 0;
  content: "";
  background: #d9e2e4;
}

.knowledge-card.unverified::before {
  background: #e2d4c2;
}

.knowledge-card:hover {
  border-color: #91bfb2;
  background: #fbfefd;
  box-shadow: 0 12px 28px rgba(40, 75, 66, 0.11);
  transform: translateY(-2px);
}

.knowledge-card.filter-match {
  border-color: #bfd5cf;
  background: #fbfefd;
  box-shadow: inset 3px 0 #75ad9e, 0 6px 16px rgba(36, 105, 87, 0.06);
}

.knowledge-card.selected {
  border-color: #378e76;
  background: #eef8f5;
  box-shadow: inset 4px 0 #247c65, 0 12px 28px rgba(36, 105, 87, 0.16);
}

.knowledge-card.filter-match::before,
.knowledge-card.selected::before {
  background: #3c987f;
}

.knowledge-card-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.knowledge-card-tags {
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 8px;
}

.knowledge-origin-badge {
  min-height: 22px;
  padding: 0 8px;
  display: inline-flex;
  align-items: center;
  border: 1px solid #dce3e6;
  border-radius: 6px;
  color: #667587;
  background: #f7f8f9;
  font-size: 8px;
  font-style: normal;
  font-weight: 730;
  white-space: nowrap;
}

.knowledge-origin-badge.agent {
  border-color: #c7d9e7;
  color: #426b89;
  background: #edf4f9;
}

.knowledge-origin-badge.system {
  border-color: #d6cfee;
  color: #66578e;
  background: #f2eff9;
}

.knowledge-origin-badge.user {
  border-color: #d8e1e4;
  color: #607282;
  background: #f4f7f8;
}

.knowledge-type {
  display: inline-flex;
  min-height: 22px;
  padding: 0 8px;
  align-items: center;
  border-radius: 6px;
  color: #2d816e;
  background: #e4f3ef;
  font-size: 9px;
  font-weight: 760;
}

.knowledge-status {
  padding: 4px 7px;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  border: 1px solid #dce8e4;
  border-radius: 999px;
  color: #347d6c;
  background: #f4faf8;
  font-size: 7px;
  font-style: normal;
  font-weight: 760;
}

.knowledge-status.unverified {
  border-color: #eddcc5;
  color: #a36b26;
  background: #fff9f0;
}

.knowledge-card h3 {
  margin: 12px 0 0;
  color: #23364c;
  font-size: 15px;
  line-height: 1.35;
  letter-spacing: -0.01em;
}

.knowledge-card > p {
  min-height: 0;
  margin: 6px 0 0;
  display: -webkit-box;
  overflow: hidden;
  color: #5f6f83;
  font-size: 11px;
  line-height: 1.55;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}

.knowledge-card-status {
  min-width: 64px;
  min-height: 24px;
  padding: 0 8px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #cce2dc;
  border-radius: 6px;
  color: #397966;
  background: #eef7f4;
  font-size: 8px;
  font-style: normal;
  font-weight: 710;
  letter-spacing: 0.02em;
}

.knowledge-card-status::before {
  width: 6px;
  height: 6px;
  margin-right: 6px;
  display: inline-block;
  border-radius: 50%;
  background: #67a898;
  content: "";
  vertical-align: 1px;
}

.knowledge-card-status.unverified {
  border-color: #e7d8c2;
  color: #93652d;
  background: #fff7eb;
}

.knowledge-card-status.unverified::before {
  background: #c9995c;
}

.knowledge-source {
  min-width: 0;
  min-height: 48px;
  margin-top: 16px;
  padding: 8px 10px;
  display: flex;
  align-items: center;
  gap: 10px;
  border: 1px solid #d9e6e2;
  border-radius: 8px;
  background: #f3f8f6;
}

.knowledge-source > i {
  width: 32px;
  height: 32px;
  display: grid;
  place-items: center;
  flex: 0 0 auto;
  border-radius: 8px;
  color: #287d69;
  background: #dceee9;
  font-style: normal;
}

.knowledge-source > i svg {
  width: 17px;
  height: 17px;
}

.knowledge-source > i.source-rule {
  color: #3a6f9b;
  background: #e4edf6;
}

.knowledge-source > i.source-test {
  color: #7b5ca4;
  background: #eee8f6;
}

.knowledge-source > i.source-cae {
  color: #a16235;
  background: #f7eadf;
}

.knowledge-source > i.source-expert {
  color: #287d69;
  background: #dceee9;
}

.knowledge-source > div {
  min-width: 0;
  display: grid;
  gap: 4px;
  flex: 1;
}

.knowledge-source span,
.knowledge-agent-row > span,
.knowledge-usage-row span {
  color: #929da9;
  font-size: 7px;
  font-weight: 790;
  letter-spacing: 0.06em;
}

.knowledge-source strong {
  overflow: hidden;
  color: #344f49;
  font-size: 10px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.knowledge-source > em {
  max-width: 112px;
  padding: 5px 7px;
  overflow: hidden;
  border-radius: 5px;
  color: #668078;
  background: #fff;
  font-size: 7px;
  font-style: normal;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.knowledge-agent-row {
  min-height: 40px;
  margin-top: 12px;
  padding: 7px 10px;
  display: grid;
  grid-template-columns: 72px minmax(0, 1fr);
  align-items: center;
  gap: 8px;
  border: 1px solid #e3e9e8;
  border-radius: 7px;
  background: #fff;
}

.knowledge-agent-chips,
.knowledge-detail-agents {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.knowledge-agent-chips em,
.knowledge-detail-agents em {
  padding: 5px 8px;
  border: 1px solid #bad8d0;
  border-radius: 6px;
  color: #286c5d;
  background: #e5f3ef;
  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.55);
  font-size: 8px;
  font-style: normal;
  font-weight: 780;
}

.knowledge-agent-row > span {
  color: #407767;
}

.knowledge-usage-row {
  min-height: 48px;
  margin-top: 12px;
  display: grid;
  grid-template-columns: 1fr 0.72fr 1.28fr;
  overflow: hidden;
  border: 1px solid #e3e8ea;
  border-radius: 7px;
  background: #fff;
}

.knowledge-usage-row > div {
  min-width: 0;
  padding: 8px 10px;
  display: grid;
  grid-template-columns: 1fr;
  align-items: center;
  gap: 4px;
  border-left: 1px solid #e7ebed;
}

.knowledge-usage-row > div:first-child {
  border-left: 0;
}

.knowledge-usage-row strong {
  overflow: hidden;
  color: #526074;
  font-size: 9px;
  font-weight: 780;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.knowledge-usage-row .recent-usage {
  background: #f2f8f6;
}

.knowledge-usage-row > div:first-child {
  background: #f1f6fa;
}

.knowledge-usage-row > div:first-child span {
  color: #5f7d90;
}

.knowledge-usage-row > div:first-child strong {
  color: #345a70;
}

.knowledge-usage-row .recent-usage span {
  color: #568579;
}

.knowledge-usage-row .recent-usage strong {
  color: #286f5f;
}

.knowledge-failure-trace {
  min-height: 56px;
  margin-top: 12px;
  padding: 8px;
  display: flex;
  align-items: center;
  gap: 8px;
  overflow: hidden;
  border: 1px solid #ecdcca;
  border-radius: 7px;
  background: #fffaf4;
}

.knowledge-failure-trace > div {
  min-width: 0;
  display: grid;
  gap: 4px;
  flex: 1;
}

.knowledge-failure-trace span {
  color: #a16e32;
  font-size: 7px;
  font-weight: 800;
}

.knowledge-failure-trace strong {
  overflow: hidden;
  color: #745c42;
  font-size: 8px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.knowledge-failure-trace > i {
  color: #c5a77f;
  font-size: 7px;
  font-style: normal;
}

.knowledge-secondary-meta {
  min-height: 24px;
  padding: 8px 2px 0;
  display: flex;
  align-items: center;
  gap: 8px;
  color: #929ba6;
  font-size: 7px;
}

.knowledge-secondary-meta span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.knowledge-secondary-meta i {
  width: 2px;
  height: 2px;
  flex: 0 0 auto;
  border-radius: 50%;
  background: #aeb7c0;
}

.knowledge-card-actions {
  margin-top: 12px;
  display: grid;
  grid-template-columns: 0.78fr 1.22fr;
  gap: 8px;
}

.knowledge-detail-button {
  width: 100%;
  height: 36px;
  padding: 0 12px;
  border: 1px solid #d4dfdc;
  border-radius: 7px;
  color: #617083;
  background: #fff;
  font-size: 9px;
  font-weight: 720;
}

.knowledge-evidence-button {
  min-width: 0;
  height: 36px;
  padding: 0 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border: 1px solid #2f866f;
  border-radius: 7px;
  color: #fff;
  background: #348d75;
  box-shadow: 0 5px 12px rgba(39, 116, 95, 0.18);
  font-size: 9px;
  font-weight: 780;
  text-decoration: none;
}

.knowledge-evidence-button em {
  color: rgba(255, 255, 255, 0.82);
  font-size: 8px;
  font-style: normal;
}

.knowledge-evidence-button.disabled {
  justify-content: center;
  border-color: #e1e5e7;
  color: #a0a8b1;
  background: #f4f5f6;
  box-shadow: none;
}

.knowledge-empty {
  min-height: 250px;
  margin: 11px;
  display: grid;
  place-content: center;
  justify-items: center;
  gap: 6px;
  border: 1px dashed #d7dfe3;
  border-radius: 11px;
  color: #8994a2;
  text-align: center;
}

.knowledge-empty strong {
  color: #59677a;
  font-size: 11px;
}

.knowledge-empty span {
  font-size: 8px;
}

.knowledge-empty button {
  height: 29px;
  margin-top: 4px;
  padding: 0 9px;
  border: 1px solid #cee3dd;
  border-radius: 7px;
  color: #277b68;
  background: #eef8f5;
  font-size: 8px;
}

.knowledge-side {
  padding: 16px;
  position: sticky;
  top: 24px;
  border-color: #e3e8ea;
  background: rgba(255, 255, 255, 0.76);
  box-shadow: none;
}

.knowledge-side h2 {
  margin: 4px 0;
  color: #4c5a6d;
  font-size: 13px;
}

.knowledge-side > p {
  margin: 0 0 12px;
  color: #939daa;
  font-size: 8px;
  line-height: 1.6;
}

.data-map-row {
  width: 100%;
  min-height: 48px;
  padding: 6px;
  display: flex;
  align-items: center;
  gap: 8px;
  border: 0;
  border-top: 1px solid #e7ebee;
  color: inherit;
  background: transparent;
  text-align: left;
  transition: background 0.15s, border-color 0.15s;
}

.data-map-row:hover,
.data-map-row:focus-visible,
.data-map-row.active {
  border-top-color: transparent;
  border-radius: 9px;
  outline: 0;
  background: #eef8f5;
}

.data-map-row > i {
  width: 28px;
  height: 28px;
  display: grid;
  place-items: center;
  flex: 0 0 auto;
  border-radius: 8px;
  color: #538276;
  background: #edf4f2;
  font-size: 7px;
  font-style: normal;
  font-weight: 800;
}

.data-map-row.active > i {
  color: #fff;
  background: #2d9179;
}

.data-map-row > div {
  min-width: 0;
  display: grid;
  flex: 1;
}

.data-map-row strong {
  color: #596678;
  font-size: 8px;
}

.data-map-row span {
  margin-top: 3px;
  color: #99a2ad;
  font-size: 6.5px;
}

.data-map-row > em {
  min-width: 20px;
  padding: 3px 5px;
  border-radius: 999px;
  color: #658579;
  background: #edf3f1;
  font-size: 7px;
  font-style: normal;
  text-align: center;
}

.knowledge-side-summary {
  margin-top: 12px;
  padding-top: 12px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
  border-top: 1px solid #e4e9eb;
}

.knowledge-side-summary div {
  padding: 8px;
  display: grid;
  gap: 2px;
  border-radius: 8px;
  background: #f6f8f8;
}

.knowledge-side-summary span {
  color: #8995a2;
  font-size: 7px;
}

.knowledge-side-summary strong {
  color: #3f4f62;
  font-size: 12px;
}

.knowledge-layer-backdrop {
  position: fixed;
  z-index: 120;
  inset: 0;
  display: flex;
  justify-content: flex-end;
  background: rgba(16, 27, 43, 0.46);
  backdrop-filter: blur(3px);
  animation: knowledge-backdrop-in 0.17s ease-out;
}

.knowledge-drawer {
  width: min(610px, 100vw - 28px);
  height: 100%;
  display: flex;
  flex-direction: column;
  background: #f7f9f9;
  box-shadow: -22px 0 55px rgba(12, 25, 40, 0.18);
  animation: knowledge-drawer-in 0.22s cubic-bezier(0.2, 0.78, 0.28, 1);
}

.knowledge-drawer-head {
  min-height: 78px;
  padding: 17px 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  border-bottom: 1px solid #dfe5e7;
  background: #fff;
}

.knowledge-drawer-head > div {
  min-width: 0;
  display: grid;
  gap: 4px;
}

.knowledge-drawer-head span,
.knowledge-detail-section > span,
.knowledge-evidence-head > div > span {
  color: #24856f;
  font-size: 8px;
  font-weight: 820;
  letter-spacing: 0.11em;
}

.knowledge-drawer-head strong {
  overflow: hidden;
  color: #26364a;
  font-size: 16px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.knowledge-drawer-head button {
  width: 32px;
  height: 32px;
  flex: 0 0 auto;
  border: 1px solid #dce3e6;
  border-radius: 8px;
  color: #697789;
  background: #fff;
  font-size: 18px;
  line-height: 1;
}

.knowledge-detail-scroll {
  padding: 18px 20px 28px;
  overflow-y: auto;
}

.knowledge-detail-identity {
  display: flex;
  align-items: center;
  gap: 7px;
}

.knowledge-detail-identity code {
  margin-left: auto;
  color: #758294;
  font-family: "D2Coding", monospace;
  font-size: 8px;
}

.knowledge-detail-meta {
  margin-top: 13px;
  display: grid;
  grid-template-columns: 1.5fr 1fr;
  overflow: hidden;
  border: 1px solid #dfe5e7;
  border-radius: 10px;
  background: #fff;
}

.knowledge-detail-meta > div {
  min-width: 0;
  padding: 10px 11px;
  display: grid;
  gap: 3px;
  border-right: 1px solid #e5eaec;
  border-bottom: 1px solid #e5eaec;
}

.knowledge-detail-meta > div:nth-child(2n) {
  border-right: 0;
}

.knowledge-detail-meta > div:nth-last-child(-n+2) {
  border-bottom: 0;
}

.knowledge-detail-meta span {
  color: #909ba8;
  font-size: 7px;
}

.knowledge-detail-meta strong {
  overflow: hidden;
  color: #4c5b6f;
  font-size: 9px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.knowledge-approval-gate {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
  border-color: #ead9be;
  background: #fff9ef;
}

.knowledge-approval-gate.ready {
  border-color: #cce2dc;
  background: #f2f9f7;
}

.knowledge-approval-copy {
  min-width: 0;
  display: grid;
}

.knowledge-approval-copy > span {
  color: #a06e30;
  font-size: 8px;
  font-weight: 820;
  letter-spacing: 0.11em;
}

.knowledge-approval-gate.ready .knowledge-approval-copy > span {
  color: #24856f;
}

.knowledge-approval-copy h3 {
  margin-top: 4px;
}

.knowledge-approval-copy p {
  margin: 5px 0 0;
  color: #7c6a55;
  font-size: 8px;
  line-height: 1.5;
}

.knowledge-approval-gate.ready .knowledge-approval-copy p {
  color: #667c76;
}

.knowledge-approval-actions {
  display: flex;
  gap: 6px;
  flex: 0 0 auto;
}

.knowledge-approval-actions button {
  min-height: 31px;
  padding: 0 9px;
  border: 1px solid #d9e0e3;
  border-radius: 7px;
  color: #5c6b7e;
  background: #fff;
  font-size: 8px;
  font-weight: 730;
}

.knowledge-approval-actions button.primary {
  border-color: #348d75;
  color: #fff;
  background: #348d75;
}

.knowledge-detail-section {
  margin-top: 12px;
  padding: 15px;
  border: 1px solid #dfe5e7;
  border-radius: 11px;
  background: #fff;
}

.knowledge-detail-section h3,
.knowledge-evidence-head h3 {
  margin: 4px 0 0;
  color: #354459;
  font-size: 12px;
}

.knowledge-detail-section > p {
  margin: 8px 0 0;
  color: #667589;
  font-size: 9px;
  line-height: 1.65;
}

.knowledge-detail-section blockquote {
  margin: 9px 0 0;
  padding: 11px 12px;
  border-left: 3px solid #5cad98;
  border-radius: 0 8px 8px 0;
  color: #59697c;
  background: #f3f8f6;
  font-size: 9px;
  font-style: normal;
  line-height: 1.65;
}

.knowledge-rule-list {
  margin: 9px 0 0;
  padding: 0;
  display: grid;
  gap: 7px;
  list-style: none;
}

.knowledge-rule-list li {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  color: #59687b;
  font-size: 9px;
  line-height: 1.45;
}

.knowledge-rule-list i {
  width: 17px;
  height: 17px;
  display: grid;
  place-items: center;
  flex: 0 0 auto;
  border-radius: 50%;
  color: #277c68;
  background: #e6f4f0;
  font-size: 7px;
  font-style: normal;
  font-weight: 820;
}

.knowledge-detail-agents {
  margin-top: 9px;
}

.knowledge-detail-agents em {
  padding: 6px 8px;
  font-size: 8px;
}

.knowledge-detail-failure-flow {
  margin-top: 10px;
  display: flex;
  align-items: center;
  gap: 7px;
}

.knowledge-detail-failure-flow > div {
  min-width: 0;
  padding: 8px;
  display: grid;
  gap: 3px;
  flex: 1;
  border: 1px solid #eadfce;
  border-radius: 8px;
  background: #fffaf4;
}

.knowledge-detail-failure-flow > div > em {
  width: 17px;
  height: 17px;
  display: grid;
  place-items: center;
  border-radius: 50%;
  color: #fff;
  background: #b88243;
  font-size: 7px;
  font-style: normal;
  font-weight: 800;
}

.knowledge-detail-failure-flow span {
  color: #9b6b32;
  font-size: 7px;
  font-weight: 800;
}

.knowledge-detail-failure-flow strong {
  color: #695846;
  font-size: 7.5px;
  line-height: 1.4;
}

.knowledge-detail-failure-flow > i {
  flex: 0 0 auto;
  color: #bfa17e;
  font-size: 9px;
  font-style: normal;
}

.knowledge-evidence-head {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
}

.knowledge-evidence-head > div {
  display: grid;
}

.knowledge-evidence-head > em {
  padding: 4px 6px;
  border-radius: 5px;
  color: #437b6e;
  background: #e8f3f0;
  font-size: 7px;
  font-style: normal;
}

.knowledge-evidence-list {
  margin-top: 10px;
  display: grid;
  gap: 7px;
}

.knowledge-evidence-row {
  min-height: 67px;
  padding: 9px 10px;
  display: grid;
  grid-template-columns: 92px minmax(0, 1fr) auto;
  align-items: center;
  gap: 10px;
  border: 1px solid #e0e6e8;
  border-radius: 9px;
  color: inherit;
  background: #fbfcfc;
  text-decoration: none;
  transition: border-color 0.15s, background 0.15s;
}

.knowledge-evidence-row:hover,
.knowledge-evidence-row:focus-visible {
  border-color: #9fcabc;
  outline: 0;
  background: #f3faf8;
}

.knowledge-evidence-id,
.knowledge-evidence-decision {
  min-width: 0;
  display: grid;
  gap: 3px;
}

.knowledge-evidence-id span,
.knowledge-evidence-decision span {
  color: #8995a3;
  font-size: 7px;
}

.knowledge-evidence-id strong {
  color: #3d5267;
  font-family: "D2Coding", monospace;
  font-size: 8px;
}

.knowledge-evidence-decision strong {
  overflow: hidden;
  color: #46566a;
  font-size: 9px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.knowledge-evidence-decision small {
  color: #929ca9;
  font-size: 7px;
}

.knowledge-evidence-row > em {
  max-width: 108px;
  color: #2c7c69;
  font-size: 7px;
  font-style: normal;
  text-align: right;
}

.knowledge-evidence-empty {
  margin-top: 10px;
  padding: 20px;
  display: grid;
  gap: 4px;
  border: 1px dashed #d8e0e3;
  border-radius: 9px;
  color: #8b96a4;
  font-size: 8px;
  text-align: center;
}

.knowledge-evidence-empty strong {
  color: #59677a;
  font-size: 9px;
}

.knowledge-registration {
  width: min(570px, 100vw - 28px);
}

.knowledge-register-form {
  padding: 20px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  align-content: start;
  gap: 13px;
  overflow-y: auto;
}

.knowledge-register-notice {
  grid-column: 1/-1;
  padding: 12px;
  display: flex;
  align-items: center;
  gap: 10px;
  border: 1px solid #ead9be;
  border-radius: 9px;
  background: #fff9ef;
}

.knowledge-register-notice > i {
  width: 25px;
  height: 25px;
  display: grid;
  place-items: center;
  flex: 0 0 auto;
  border-radius: 50%;
  color: #a86c22;
  background: #f7e7cc;
  font-size: 10px;
  font-style: normal;
  font-weight: 820;
}

.knowledge-register-notice > div {
  display: grid;
  gap: 3px;
}

.knowledge-register-notice strong {
  color: #73552e;
  font-size: 9px;
}

.knowledge-register-notice span {
  color: #98784e;
  font-size: 8px;
}

.knowledge-register-form label {
  min-width: 0;
  display: grid;
  gap: 5px;
}

.knowledge-register-form label.wide,
.knowledge-register-actions.wide {
  grid-column: 1/-1;
}

.knowledge-register-form label > span {
  color: #59677a;
  font-size: 8px;
  font-weight: 720;
}

.knowledge-register-form input,
.knowledge-register-form select,
.knowledge-register-form textarea {
  width: 100%;
  border: 1px solid #dbe2e6;
  border-radius: 8px;
  outline: 0;
  color: #425166;
  background: #fff;
  font: inherit;
  font-size: 9px;
}

.knowledge-register-form input,
.knowledge-register-form select {
  height: 40px;
  padding: 0 10px;
}

.knowledge-register-form textarea {
  padding: 10px;
  resize: vertical;
  line-height: 1.55;
}

.knowledge-register-form input:focus,
.knowledge-register-form select:focus,
.knowledge-register-form textarea:focus {
  border-color: #68ad9b;
  box-shadow: 0 0 0 3px rgba(65, 160, 136, 0.1);
}

.knowledge-register-form input::placeholder,
.knowledge-register-form textarea::placeholder {
  color: #a0a9b3;
}

.knowledge-register-actions {
  padding-top: 4px;
  display: flex;
  justify-content: flex-end;
  gap: 8px;
}

.knowledge-register-actions button {
  height: 38px;
  padding: 0 14px;
  border: 1px solid #d8e0e3;
  border-radius: 8px;
  color: #617084;
  background: #fff;
  font-size: 9px;
  font-weight: 720;
}

.knowledge-register-actions button.primary {
  border-color: #26394e;
  color: #fff;
  background: #26394e;
}

@keyframes knowledge-backdrop-in {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@keyframes knowledge-drawer-in {
  from {
    transform: translateX(28px);
    opacity: 0.5;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}
.component-library-page .component-kpi-section {
  gap: 16px;
}

.component-library-page .metric-card {
  min-height: 112px;
  padding: 24px;
}

.component-run-banner {
  min-height: 88px;
  margin-top: 24px;
  padding: 16px;
  display: grid;
  grid-template-columns: 248px minmax(0, 1fr) 160px;
  align-items: center;
  gap: 16px;
  overflow: hidden;
  border: 1px solid #cfe3de;
  border-radius: 16px;
  background: radial-gradient(circle at 94% 20%, rgba(77, 188, 161, 0.13), transparent 24%), linear-gradient(115deg, #f7fbfa, #eef7f5);
  box-shadow: 0 6px 18px rgba(32, 74, 63, 0.035);
}

.component-run-banner + .section-toolbar {
  min-height: 56px;
  margin-top: 24px;
}

.component-run-copy {
  min-width: 0;
  display: grid;
  gap: 4px;
}

.component-run-copy > span,
.component-detail-section > span,
.component-section-head > div > span,
.component-exclusion-reason > span {
  color: #24856f;
  font-size: 7px;
  font-weight: 820;
  letter-spacing: 0.11em;
}

.component-run-copy > strong {
  color: #2f4357;
  font-family: "D2Coding", monospace;
  font-size: 11px;
}

.component-run-copy > p {
  margin: 0;
  overflow: hidden;
  color: #718092;
  font-size: 8px;
  line-height: 1.35;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.component-run-constraints {
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  gap: 8px;
}

.component-run-constraints > div {
  min-width: 0;
  min-height: 48px;
  padding: 8px;
  display: grid;
  align-content: center;
  gap: 4px;
  border: 1px solid rgba(198, 222, 216, 0.8);
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.82);
}

.component-run-constraints span {
  overflow: hidden;
  color: #87949f;
  font-size: 6px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.component-run-constraints strong {
  overflow: hidden;
  color: #44576b;
  font-size: 8px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.component-run-result {
  display: flex;
  align-items: center;
  gap: 8px;
}

.component-run-result > i {
  width: 24px;
  height: 24px;
  display: grid;
  place-items: center;
  flex: 0 0 auto;
  border-radius: 50%;
  color: #247c68;
  background: #dff2ed;
  font-size: 10px;
  font-style: normal;
  font-weight: 820;
}

.component-run-result > div {
  display: grid;
  gap: 4px;
}

.component-run-result strong {
  color: #3d5366;
  font-size: 8px;
}

.component-run-result span {
  color: #81909d;
  font-size: 7px;
}

.component-state-summary {
  margin: 16px 0 0;
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 8px;
}

.component-state-summary > button {
  min-height: 56px;
  padding: 8px 16px;
  display: grid;
  grid-template-columns: 8px minmax(0, 1fr) auto;
  align-items: center;
  gap: 8px;
  border: 1px solid #dce3e6;
  border-radius: 8px;
  color: #59687a;
  background: #fff;
  text-align: left;
  transition: border-color 0.15s, box-shadow 0.15s, transform 0.15s;
}

.component-state-summary > button:hover,
.component-state-summary > button:focus-visible,
.component-state-summary > button.active {
  border-color: #9bc9bd;
  box-shadow: 0 7px 18px rgba(35, 97, 82, 0.07);
  transform: translateY(-1px);
  outline: 0;
}

.component-state-summary > button.active {
  background: #f3faf8;
  box-shadow: 0 0 0 2px rgba(55, 161, 134, 0.08);
}

.component-state-summary i {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #9aa6b2;
}

.component-state-summary .applied i {
  background: #2d8d78;
}

.component-state-summary .recommended i {
  background: #4b70c6;
}

.component-state-summary .candidate i {
  background: #d1983a;
}

.component-state-summary .excluded i {
  background: #c85d61;
}

.component-state-summary span {
  font-size: 9px;
  font-weight: 720;
}

.component-state-summary strong {
  color: #324458;
  font-size: 14px;
}

.component-state-summary small {
  grid-column: 2/-1;
  margin-top: 0;
  color: #8b97a4;
  font-size: 7px;
}

.component-filter-suite {
  margin-top: 16px;
  display: grid;
  gap: 16px;
}

.component-quick-filters {
  min-height: 56px;
  margin: 0;
  padding: 12px 16px;
  display: flex;
  align-items: center;
  gap: 8px;
  border: 1px solid #d8e3e1;
  border-radius: 16px;
  background: linear-gradient(90deg, #f2faf7, #fff 70%);
  box-shadow: 0 8px 24px rgba(32, 55, 68, 0.035);
}

.component-quick-filters > span {
  margin: 0 8px 0 0;
  color: #25836e;
  font-size: 7px;
  font-weight: 840;
  letter-spacing: 0.11em;
}

.component-quick-filters > button {
  min-width: 64px;
  height: 32px;
  padding: 0 16px;
  border: 1px solid #d4dfdc;
  border-radius: 8px;
  color: #526477;
  background: #fff;
  font-size: 8px;
  font-weight: 760;
  transition: border-color 0.14s, color 0.14s, background 0.14s, box-shadow 0.14s;
}

.component-quick-filters > button:hover,
.component-quick-filters > button:focus-visible,
.component-quick-filters > button.active {
  border-color: #64ac99;
  color: #23745f;
  outline: 0;
  background: #e7f5f1;
  box-shadow: 0 0 0 2px rgba(63, 157, 133, 0.08);
}

.component-quick-filters > em {
  margin-left: 8px;
  color: #8995a2;
  font-size: 7px;
  font-style: normal;
}

.component-filter-summary {
  margin-left: auto;
  display: flex;
  align-items: center;
  gap: 8px;
  white-space: nowrap;
}

.component-filter-summary .component-filter-reset {
  min-height: 28px;
  padding: 0 8px;
  border: 1px solid #cfe0dc;
  border-radius: 7px;
  background: #f5faf9;
}

.component-filter-panel {
  margin: 0;
  padding: 0;
  overflow: hidden;
  border: 1px solid #d8e3e1;
  border-radius: 16px;
  background: #fff;
  box-shadow: 0 8px 24px rgba(32, 55, 68, 0.035);
}

.component-filter-panel-head {
  min-height: 64px;
  padding: 12px 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  border-bottom: 1px solid #e2e9e8;
  background: #f8faf9;
}

.component-filter-heading {
  display: grid;
  gap: 4px;
}

.component-filter-heading > span {
  color: #25836e;
  font-size: 7px;
  font-weight: 840;
  letter-spacing: 0.11em;
}

.component-filter-heading > strong {
  color: #405166;
  font-size: 11px;
}

.component-search-row {
  display: flex;
  align-items: center;
  gap: 7px;
}

.component-search {
  width: 100%;
  height: 40px;
  padding: 0 12px;
  display: flex;
  align-items: center;
  gap: 8px;
  border: 1px solid #dbe2e6;
  border-radius: 8px;
  background: #fff;
}

.component-search:focus-within {
  border-color: #6fb09f;
  box-shadow: 0 0 0 3px rgba(63, 159, 135, 0.08);
}

.component-search svg {
  width: 15px;
  height: 15px;
  flex: 0 0 auto;
  color: #8795a4;
}

.component-search input {
  width: 100%;
  min-width: 0;
  border: 0;
  color: #405066;
  background: transparent;
  font-size: 9px;
  outline: 0;
}

.component-search input::placeholder {
  color: #9ca6b2;
}

.component-result-count {
  color: #8d98a4;
  font-size: 8px;
}

.component-result-count strong {
  color: #2a816d;
  font-size: 11px;
}

.component-filter-mode {
  color: #7c8b98;
  font-size: 7px;
  font-style: normal;
}

.component-filter-reset {
  margin-left: auto;
  padding: 0;
  border: 0;
  color: #2b8873;
  background: transparent;
  font-size: 8px;
  font-weight: 750;
}

.component-filter-grid {
  margin: 0;
  padding: 16px;
  display: grid;
  grid-template-columns: repeat(9, minmax(0, 1fr));
  align-items: end;
  gap: 8px;
}

.component-filter-grid label {
  min-width: 0;
  display: grid;
  gap: 8px;
}

.component-filter-grid label > span {
  padding-left: 2px;
  color: #8794a2;
  font-size: 7px;
  font-weight: 720;
}

.component-filter-grid select {
  width: 100%;
  height: 40px;
  padding: 0 24px 0 8px;
  overflow: hidden;
  border: 1px solid #dce2e6;
  border-radius: 7px;
  outline: 0;
  color: #536277;
  text-overflow: ellipsis;
  background: #fff;
  font-size: 8px;
}

.component-filter-grid select:focus {
  border-color: #70b09f;
}

.component-table {
  max-height: 480px;
  margin-top: 24px;
  overflow: auto;
  border-radius: 16px;
  box-shadow: 0 8px 24px rgba(32, 55, 68, 0.045);
}

.component-row {
  min-width: 1100px;
  min-height: 72px;
  padding: 0 16px;
  display: grid;
  grid-template-columns: 64px 116px 96px minmax(158px, 1.45fr) 76px 84px 96px 118px 108px 76px;
  align-items: center;
  gap: 8px;
  border-top: 1px solid #e8ecef;
  color: #68768a;
  font-size: 9px;
  font-variant-numeric: tabular-nums;
}

.component-row:first-child {
  border-top: 0;
}

.component-row.table-head {
  min-height: 48px;
  position: sticky;
  z-index: 6;
  top: 0;
  color: #526274;
  background: #eaf0f2;
  font-size: 8px;
  font-weight: 780;
  box-shadow: 0 1px 0 #ccd6da, 0 6px 14px rgba(31, 48, 60, 0.08);
}

.component-data-row {
  cursor: pointer;
  transition: background 0.14s, box-shadow 0.14s, transform 0.14s;
}

.component-data-row:hover,
.component-data-row:focus-visible {
  position: relative;
  z-index: 1;
  background: #f0f8f6;
  box-shadow: inset 3px 0 #55a994, 0 3px 10px rgba(39, 104, 87, 0.055);
  outline: 0;
}

.component-data-row.selected {
  position: relative;
  z-index: 2;
  background: #e8f5f1;
  box-shadow: inset 3px 0 #2e9178, inset 0 0 0 1px #8bc0b2;
}

.component-data-row.selected:hover,
.component-data-row.selected:focus-visible {
  background: #e2f2ed;
  box-shadow: inset 4px 0 #26836c, inset 0 0 0 1px #72b09f, 0 4px 12px rgba(35, 105, 87, 0.08);
}

.component-data-row.excluded {
  background: #fdfafa;
}

.component-data-row.excluded:hover,
.component-data-row.excluded:focus-visible {
  background: #fff6f6;
  box-shadow: inset 3px 0 #c86b70;
}

.component-data-row.excluded.selected {
  background: #f7eeee;
  box-shadow: inset 3px 0 #bb5960, inset 0 0 0 1px #db9da1;
}

.component-row > :nth-child(5),
.component-row > :nth-child(7),
.component-row > :nth-child(10) {
  text-align: center;
}

.component-row > strong {
  color: #405066;
}

.component-row > span,
.component-row > strong,
.component-row code {
  padding-right: 8px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.component-row code {
  color: #2d7566;
  font-family: "D2Coding", monospace;
  font-size: 9px;
  font-weight: 700;
}

.component-confidence-trigger {
  min-width: 0;
  padding: 4px;
  display: grid;
  gap: 3px;
  border: 0;
  border-radius: 7px;
  color: inherit;
  background: transparent;
  text-align: center;
  justify-items: center;
}

.component-confidence-trigger:hover,
.component-confidence-trigger:focus-visible {
  outline: 0;
  background: #eaf5f2;
  box-shadow: 0 0 0 1px #bad9d1;
}

.component-confidence-trigger > em {
  color: #2d8b74;
  font-style: normal;
  font-weight: 780;
}

.component-confidence-trigger > small,
.component-verification {
  width: fit-content;
  color: #778696;
  font-size: 6px;
}

.component-confidence-trigger > small.verified,
.component-verification.verified {
  color: #247e6b;
}

.component-confidence-trigger > small.conditional,
.component-verification.conditional {
  color: #a26c21;
}

.component-confidence-trigger > small.review,
.component-verification.review {
  color: #b04f56;
}

.component-compatibility-head {
  color: #267c68;
  font-weight: 820;
}

.component-compatibility {
  min-height: 30px;
  padding: 0 7px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  border: 1px solid #d3dfdc;
  border-radius: 7px;
  color: #5b6c7f;
  background: #f7faf9;
  font-size: 8px;
  font-weight: 760;
}

.component-compatibility > i {
  width: 7px;
  height: 7px;
  flex: 0 0 auto;
  border-radius: 50%;
  background: #97a4b0;
}

.component-compatibility.compatible {
  border-color: #b9ddd4;
  color: #287d69;
  background: #edf8f5;
}

.component-compatibility.compatible > i {
  background: #3baa8d;
}

.component-compatibility.conditional {
  border-color: #ead7b5;
  color: #9b6b27;
  background: #fff8eb;
}

.component-compatibility.conditional > i {
  background: #d59a40;
}

.component-compatibility.incompatible {
  border-color: #ecc9cc;
  color: #ae5158;
  background: #fff3f4;
}

.component-compatibility.incompatible > i {
  background: #ca6268;
}

.component-state-cell {
  min-width: 0;
  display: grid;
  gap: 3px;
}

.component-state-cell > small {
  overflow: hidden;
  color: #b15a60;
  font-size: 6px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.component-state-cell > small.component-recommendation-reason {
  display: block;
  overflow: hidden;
  color: #4d6d94;
  font-size: 6px;
  line-height: 1.3;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.component-state-chip {
  width: fit-content;
  min-height: 20px;
  padding: 0 6px;
  display: inline-flex;
  align-items: center;
  border-radius: 999px;
  font-size: 7px;
  font-style: normal;
  font-weight: 780;
}

.component-state-chip.applied {
  color: #236f5f;
  background: #dff2ed;
}

.component-state-chip.recommended {
  color: #4968ae;
  background: #e9eefb;
}

.component-state-chip.candidate {
  color: #956522;
  background: #f8eedb;
}

.component-state-chip.excluded {
  color: #a84d54;
  background: #f9e7e8;
}

.component-history-link {
  width: 100%;
  min-height: 31px;
  padding: 0;
  display: grid;
  place-content: center;
  gap: 1px;
  border: 1px solid #d6e5e1;
  border-radius: 7px;
  color: #2c7968;
  background: #f4f9f8;
}

.component-history-link:hover,
.component-history-link:focus-visible {
  border-color: #8ec3b6;
  outline: 0;
}

.component-history-link strong {
  font-size: 10px;
}

.component-history-link span {
  font-size: 6px;
}

.component-empty {
  min-width: 1080px;
  min-height: 170px;
  display: grid;
  place-content: center;
  justify-items: center;
  color: #8995a2;
  text-align: center;
}

.component-empty strong {
  color: #46556a;
  font-size: 11px;
}

.component-empty span {
  margin-top: 5px;
  font-size: 8px;
}

.component-empty button {
  height: 30px;
  margin-top: 11px;
  padding: 0 11px;
  border: 1px solid #cfe2dd;
  border-radius: 7px;
  color: #2a806c;
  background: #f2f9f7;
  font-size: 8px;
}

.component-drawer {
  width: min(650px, 100vw - 28px);
}

.component-detail-scroll {
  padding: 18px 20px 28px;
  overflow-y: auto;
}

.component-detail-identity {
  display: flex;
  align-items: center;
  gap: 7px;
}

.component-verification {
  min-height: 21px;
  padding: 0 7px;
  display: inline-flex;
  align-items: center;
  border: 1px solid #dce3e6;
  border-radius: 999px;
  background: #fff;
}

.component-detail-identity code {
  margin-left: auto;
  color: #758294;
  font-family: "D2Coding", monospace;
  font-size: 8px;
}

.component-compatibility-hero {
  min-height: 108px;
  margin-top: 12px;
  padding: 15px;
  display: grid;
  grid-template-columns: 74px minmax(0, 1fr) 38px;
  align-items: center;
  gap: 13px;
  border: 1px solid #cce4dd;
  border-radius: 12px;
  background: linear-gradient(120deg, #f2faf8, #edf7f4);
}

.component-compatibility-hero.conditional {
  border-color: #ead8ba;
  background: linear-gradient(120deg, #fffbf3, #fbf3e6);
}

.component-compatibility-hero.incompatible {
  border-color: #eacccd;
  background: linear-gradient(120deg, #fff8f8, #faeeee);
}

.component-compatibility-score {
  display: flex;
  align-items: baseline;
  gap: 2px;
}

.component-compatibility-score strong {
  color: #287c68;
  font-size: 27px;
  letter-spacing: -0.04em;
}

.conditional .component-compatibility-score strong {
  color: #a16d27;
}

.incompatible .component-compatibility-score strong {
  color: #b14e55;
}

.component-compatibility-score span {
  color: #8a98a4;
  font-size: 8px;
}

.component-compatibility-copy {
  min-width: 0;
  display: grid;
  gap: 3px;
}

.component-compatibility-copy > span {
  color: #318973;
  font-size: 7px;
  font-weight: 820;
  letter-spacing: 0.1em;
}

.component-compatibility-copy > strong {
  color: #364b5d;
  font-size: 13px;
}

.component-compatibility-copy > p {
  margin: 0;
  color: #738292;
  font-size: 8px;
}

.component-compatibility-hero > i {
  width: 36px;
  height: 36px;
  display: grid;
  place-items: center;
  border-radius: 50%;
  color: #287e69;
  background: #d9eee8;
  font-size: 14px;
  font-style: normal;
  font-weight: 820;
}

.component-compatibility-hero.conditional > i {
  color: #9b6824;
  background: #f3dfbc;
}

.component-compatibility-hero.incompatible > i {
  color: #ab4d54;
  background: #f2d7d9;
}

.component-design-role {
  margin-top: 9px;
  padding: 12px 13px;
  display: grid;
  grid-template-columns: 34px minmax(0, 1fr);
  align-items: center;
  gap: 11px;
  border: 1px solid #d9e3e6;
  border-radius: 10px;
  background: #fff;
}

.component-design-role > i {
  width: 34px;
  height: 34px;
  display: grid;
  place-items: center;
  border-radius: 9px;
  color: #2a7b68;
  background: #e3f2ee;
  font-size: 11px;
  font-style: normal;
  font-weight: 820;
}

.component-design-role > div {
  min-width: 0;
  display: grid;
  gap: 3px;
}

.component-design-role span,
.component-recommendation-callout > span {
  color: #27826d;
  font-size: 7px;
  font-weight: 820;
  letter-spacing: 0.1em;
}

.component-design-role strong {
  color: #3f5064;
  font-size: 10px;
}

.component-design-role p {
  margin: 0;
  color: #8793a0;
  font-size: 7px;
}

.component-recommendation-callout {
  margin-top: 9px;
  padding: 11px 13px;
  display: grid;
  gap: 4px;
  border: 1px solid #cbded9;
  border-left: 3px solid #4fa58f;
  border-radius: 9px;
  background: #f1f8f6;
}

.component-recommendation-callout > strong {
  color: #3f5a58;
  font-size: 9px;
}

.component-confidence-detail {
  border-color: #d2dfe6;
  background: linear-gradient(145deg, #fff, #f8fafb);
}

.component-confidence-score {
  min-width: 45px;
  padding: 6px 8px;
  border-radius: 8px;
  color: #fff !important;
  background: #2c8973 !important;
  font-size: 13px !important;
  font-weight: 820;
  text-align: center;
}

.component-confidence-basis {
  margin-top: 10px;
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 6px;
}

.component-confidence-basis-row {
  min-width: 0;
  min-height: 82px;
  padding: 9px;
  display: grid;
  grid-template-columns: 7px minmax(0, 1fr);
  align-content: start;
  gap: 7px;
  border: 1px solid #dde5e7;
  border-radius: 8px;
  background: #fff;
}

.component-confidence-basis-row > i {
  width: 7px;
  height: 7px;
  margin-top: 3px;
  border-radius: 50%;
  background: #42a58b;
}

.component-confidence-basis-row.conditional > i {
  background: #d59a40;
}

.component-confidence-basis-row.incompatible > i {
  background: #c95f66;
}

.component-confidence-basis-row > div {
  min-width: 0;
  display: grid;
  align-content: start;
  gap: 3px;
}

.component-confidence-basis-row span {
  color: #84919f;
  font-size: 6px;
}

.component-confidence-basis-row strong {
  color: #405165;
  font-size: 9px;
}

.component-confidence-basis-row small {
  overflow: hidden;
  color: #8b97a4;
  font-size: 6px;
  line-height: 1.4;
  text-overflow: ellipsis;
}

.component-selection-notice {
  margin-top: 9px;
  padding: 10px 12px;
  display: flex;
  align-items: center;
  gap: 8px;
  border: 1px solid #bfe0d7;
  border-radius: 9px;
  color: #347564;
  background: #eff9f6;
  font-size: 8px;
  line-height: 1.45;
}

.component-selection-notice.blocked {
  border-color: #e5c9cb;
  color: #9e5056;
  background: #fff4f4;
}

.component-selection-notice > i {
  width: 20px;
  height: 20px;
  display: grid;
  place-items: center;
  flex: 0 0 auto;
  border-radius: 50%;
  color: #fff;
  background: #4ba28c;
  font-style: normal;
  font-weight: 820;
}

.component-selection-notice.blocked > i {
  background: #c4666b;
}

.component-exclusion-reason {
  margin-top: 9px;
  padding: 12px;
  border: 1px solid #e7cacc;
  border-radius: 10px;
  background: #fff6f6;
}

.component-exclusion-reason > span {
  color: #b04d54;
}

.component-exclusion-reason > strong {
  margin-top: 5px;
  display: block;
  color: #854348;
  font-size: 10px;
}

.component-exclusion-reason > p {
  margin: 5px 0 0;
  color: #9e6d71;
  font-size: 8px;
}

.component-detail-section {
  margin-top: 11px;
  padding: 14px;
  border: 1px solid #dfe5e7;
  border-radius: 11px;
  background: #fff;
}

.component-detail-section > h3,
.component-section-head h3 {
  margin: 4px 0 0;
  color: #354459;
  font-size: 12px;
}

.component-detail-section > p {
  margin: 8px 0 0;
  color: #657487;
  font-size: 9px;
  line-height: 1.6;
}

.component-spec-grid {
  margin-top: 10px;
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  overflow: hidden;
  border: 1px solid #e1e6e8;
  border-radius: 9px;
}

.component-spec-grid > div {
  min-width: 0;
  padding: 10px;
  display: grid;
  gap: 4px;
  border-right: 1px solid #e5eaec;
  background: #fafbfb;
}

.component-spec-grid > div:last-child {
  border-right: 0;
}

.component-spec-grid span {
  color: #8a96a3;
  font-size: 7px;
}

.component-spec-grid strong {
  overflow: hidden;
  color: #46576a;
  font-size: 9px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.component-scope-list {
  margin-top: 9px;
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.component-scope-list > em {
  padding: 6px 8px;
  border: 1px solid #d5e4e0;
  border-radius: 7px;
  color: #397464;
  background: #f2f8f6;
  font-size: 8px;
  font-style: normal;
}

.component-section-head {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 12px;
}

.component-section-head > div {
  display: grid;
}

.component-section-head > em {
  padding: 5px 7px;
  border-radius: 6px;
  color: #357866;
  background: #eaf4f1;
  font-size: 7px;
  font-style: normal;
}

.component-check-list,
.component-asset-list,
.component-run-history {
  margin-top: 10px;
  display: grid;
  gap: 6px;
}

.component-check-row {
  min-height: 44px;
  padding: 8px 10px;
  display: grid;
  grid-template-columns: 22px minmax(0, 1fr) auto;
  align-items: center;
  gap: 8px;
  border: 1px solid #e2e7e9;
  border-radius: 8px;
  background: #fafbfb;
}

.component-check-row > i {
  width: 22px;
  height: 22px;
  display: grid;
  place-items: center;
  border-radius: 50%;
  color: #2c806c;
  background: #e3f2ee;
  font-size: 8px;
  font-style: normal;
  font-weight: 820;
}

.component-check-row.fail > i {
  color: #ad5057;
  background: #f4dddd;
}

.component-check-row.check > i {
  color: #986623;
  background: #f5e8cd;
}

.component-check-row > div {
  min-width: 0;
  display: grid;
  gap: 2px;
}

.component-check-row strong {
  color: #48586b;
  font-size: 8px;
}

.component-check-row span {
  color: #8995a2;
  font-size: 7px;
}

.component-check-row > em {
  color: #2b806c;
  font-size: 7px;
  font-style: normal;
  font-weight: 800;
}

.component-check-row.fail > em {
  color: #ad5057;
}

.component-check-row.check > em {
  color: #986623;
}

.component-asset-list > button,
.component-run-history > button {
  min-height: 57px;
  padding: 9px 10px;
  display: grid;
  grid-template-columns: 38px minmax(0, 1fr) auto;
  align-items: center;
  gap: 10px;
  border: 1px solid #e0e6e8;
  border-radius: 9px;
  color: inherit;
  background: #fbfcfc;
  text-align: left;
}

.component-asset-list > button:hover,
.component-asset-list > button:focus-visible,
.component-run-history > button:hover,
.component-run-history > button:focus-visible {
  border-color: #9fcabc;
  outline: 0;
  background: #f3faf8;
}

.component-asset-list > button > i {
  width: 38px;
  height: 30px;
  display: grid;
  place-items: center;
  border-radius: 6px;
  color: #367867;
  background: #e7f2ef;
  font-size: 7px;
  font-style: normal;
  font-weight: 820;
}

.component-asset-list > button > div,
.component-run-history > button > div,
.component-run-history-id {
  min-width: 0;
  display: grid;
  gap: 3px;
}

.component-asset-list strong,
.component-run-history > button > div > strong {
  overflow: hidden;
  color: #46566a;
  font-size: 9px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.component-asset-list span,
.component-run-history > button > div > span {
  color: #929ca9;
  font-size: 7px;
}

.component-asset-list > button > em,
.component-run-history > button > em {
  color: #2c7c69;
  font-size: 7px;
  font-style: normal;
}

.component-run-count {
  min-width: 104px;
  padding: 6px 8px;
  display: grid;
  grid-template-columns: auto 1fr;
  align-items: center;
  gap: 5px;
  border: 1px solid #cfe2dd;
  border-radius: 7px;
  color: #2c7968;
  background: #f2f9f7;
}

.component-run-count strong {
  font-size: 13px;
}

.component-run-count span {
  font-size: 6px;
}

.component-run-history > button {
  grid-template-columns: 104px minmax(0, 1fr) auto;
}

.component-run-history-id span {
  color: #8a96a3;
  font-size: 6px;
}

.component-run-history-id strong {
  color: #3d5267;
  font-family: "D2Coding", monospace;
  font-size: 8px;
}

.component-detail-actions {
  margin-top: 12px;
  display: flex;
  justify-content: flex-end;
  gap: 8px;
}

.component-detail-actions > button {
  min-height: 38px;
  padding: 0 14px;
  border: 1px solid #d8e0e3;
  border-radius: 8px;
  color: #617084;
  background: #fff;
  font-size: 9px;
  font-weight: 720;
}

.component-detail-actions > button.primary {
  border-color: #26394e;
  color: #fff;
  background: #26394e;
}

.report-banner {
  min-height: 72px;
  padding: 10px 14px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  border-radius: 12px;
  color: #fff;
  background: radial-gradient(circle at 86% 28%, rgba(94, 221, 193, 0.25), transparent 23%), linear-gradient(125deg, #1a283d, #263b50);
  box-shadow: 0 8px 20px rgba(23, 36, 54, 0.1);
}

.report-banner span {
  color: #75d9c3;
}

.report-banner h2 {
  margin: 3px 0 0;
  font-size: 15px;
  line-height: 1.3;
}

.report-banner p {
  max-width: 720px;
  margin: 3px 0 0;
  color: #b4c1cf;
  font-size: 9px;
  line-height: 1.4;
}

.report-banner button {
  height: 30px;
  padding: 0 11px;
  border: 1px solid rgba(255, 255, 255, 0.18);
  border-radius: 8px;
  color: #eafffa;
  background: rgba(255, 255, 255, 0.1);
  font-size: 9px;
  font-weight: 720;
}

.report-banner-side {
  display: flex;
  align-items: center;
  justify-items: end;
  gap: 8px;
}

.report-package-control {
  position: relative;
}

.report-package-trigger {
  min-width: 148px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 6px;
}

.report-package-trigger > span {
  color: #eafffa;
}

.report-package-trigger > strong {
  margin-left: auto;
  color: #78dcc5;
  font-size: 8px;
}

.report-package-trigger > i {
  color: #a8c9c2;
  font-style: normal;
}

.report-package-menu-backdrop {
  width: auto;
  height: auto !important;
  padding: 0 !important;
  position: fixed;
  inset: 0;
  z-index: 20;
  border: 0 !important;
  border-radius: 0 !important;
  background: transparent !important;
}

.report-package-menu {
  width: 340px;
  padding: 13px;
  position: absolute;
  top: calc(100% + 7px);
  right: 0;
  z-index: 21;
  border: 1px solid #d6e1df;
  border-radius: 12px;
  color: #425164;
  background: #fff;
  box-shadow: 0 18px 45px rgba(14, 30, 44, 0.22);
}

.report-package-menu-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.report-package-menu-head > div {
  display: grid;
  gap: 2px;
}

.report-package-menu-head span {
  color: #338873;
  font-size: 7px;
  font-weight: 820;
  letter-spacing: 0.08em;
}

.report-package-menu-head strong {
  color: #344357;
  font-size: 11px;
}

.report-package-menu-head > em {
  padding: 4px 7px;
  border-radius: 999px;
  color: #287c68;
  background: #e9f5f2;
  font-size: 8px;
  font-style: normal;
  font-weight: 760;
}

.report-package-list {
  margin-top: 10px;
  display: grid;
  gap: 6px;
}

.report-banner .report-package-item {
  width: 100%;
  min-height: 48px;
  padding: 7px 9px;
  display: grid;
  grid-template-columns: 18px minmax(0, 1fr) auto;
  align-items: center;
  gap: 8px;
  border: 1px solid #e0e6e8 !important;
  border-radius: 9px !important;
  color: #5e6d7e !important;
  background: #fff !important;
  text-align: left;
}

.report-banner .report-package-item.selected {
  border-color: #abd5cb !important;
  background: #f3faf8 !important;
}

.report-package-item > i {
  width: 18px;
  height: 18px;
  display: grid;
  place-items: center;
  border: 1px solid #cbd7d6;
  border-radius: 5px;
  color: #fff;
  background: #fff;
  font-size: 9px;
  font-style: normal;
}

.report-package-item.selected > i {
  border-color: #318b75;
  background: #318b75;
}

.report-package-item > div {
  min-width: 0;
  display: grid;
  gap: 2px;
}

.report-package-item span {
  color: #36836f;
  font-size: 7px;
  font-weight: 780;
}

.report-package-item strong {
  overflow: hidden;
  color: #465467;
  font-size: 9px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.report-package-item > em {
  color: #778697;
  font-size: 8px;
  font-style: normal;
  font-weight: 700;
}

.report-package-menu-footer {
  margin-top: 10px;
  padding-top: 10px;
  border-top: 1px solid #e3e8ea;
}

.report-package-menu-footer label {
  display: grid;
  gap: 5px;
}

.report-package-menu-footer label > span {
  color: #7b8898;
  font-size: 7px;
  font-weight: 740;
}

.report-package-download {
  display: grid;
  grid-template-columns: 82px minmax(0, 1fr);
  align-items: center;
}

.report-package-download select {
  width: 100%;
  height: 34px;
  padding: 0 25px 0 10px;
  border: 1px solid #d6dfe2;
  border-right: 0;
  border-radius: 9px 0 0 9px;
  color: #4d5e70;
  background: #fff;
  font: inherit;
  font-size: 8px;
  font-weight: 740;
}

.report-package-download button {
  width: 100%;
  border-radius: 0 9px 9px 0;
  border-color: #263b50;
  color: #fff;
  background: #263b50;
}

.report-package-download button:disabled {
  cursor: not-allowed;
  opacity: 0.45;
}

.report-source-legend {
  display: flex;
  gap: 6px;
}

.report-source-legend span {
  min-height: 22px;
  padding: 0 8px;
  display: inline-flex;
  align-items: center;
  border: 1px solid rgba(255, 255, 255, 0.14);
  border-radius: 999px;
  color: #d7eee8;
  background: rgba(255, 255, 255, 0.07);
  font-size: 7px;
  font-weight: 780;
}

.report-source-legend span.demo {
  border-color: rgba(247, 192, 99, 0.3);
  color: #f7d399;
  background: rgba(247, 192, 99, 0.08);
}

.report-direct-notice {
  min-height: 54px;
  margin-top: 12px;
  padding: 9px 12px;
  display: grid;
  grid-template-columns: 30px minmax(0, 1fr) auto;
  align-items: center;
  gap: 10px;
  border: 1px solid #b8ddd3;
  border-radius: 11px;
  background: #f0faf7;
}

.report-direct-notice > i {
  width: 30px;
  height: 30px;
  display: grid;
  place-items: center;
  border-radius: 8px;
  color: #257763;
  background: #dcefe9;
  font-size: 11px;
  font-style: normal;
}

.report-direct-notice > div {
  min-width: 0;
  display: grid;
}

.report-direct-notice strong {
  color: #315d54;
  font-size: 10px;
}

.report-direct-notice span {
  margin-top: 2px;
  color: #718b84;
  font-size: 8px;
}

.report-direct-notice > button {
  width: 28px;
  height: 28px;
  border: 0;
  border-radius: 7px;
  color: #6d887f;
  background: transparent;
  font-size: 15px;
}

.report-filter-panel {
  margin-top: 8px;
  padding: 8px 10px 9px;
  border: 1px solid #dce4e7;
  border-radius: 10px;
  background: #fff;
}

.report-filter-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}

.report-filter-head > div {
  display: flex;
  align-items: baseline;
  gap: 7px;
}

.report-filter-head span {
  color: #328773;
  font-size: var(--report-type-label);
  font-weight: 800;
  letter-spacing: 0.08em;
}

.report-filter-head strong {
  margin-top: 0;
  color: #3d4b60;
  font-size: 10px;
}

.report-filter-head p {
  margin: 0;
  color: #8793a1;
  font-size: var(--report-type-label);
}

.report-filter-grid {
  margin-top: 6px;
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr)) auto auto;
  align-items: end;
  gap: 7px;
}

.report-filter-grid label {
  min-width: 0;
  display: grid;
  gap: 4px;
}

.report-filter-grid label > span {
  color: #778496;
  font-size: var(--report-type-label);
  font-weight: 720;
}

.report-filter-grid select {
  width: 100%;
  height: 32px;
  padding: 0 28px 0 9px;
  border: 1px solid #d9e1e5;
  border-radius: 7px;
  color: #4e5d70;
  background: #fbfcfc;
  font: inherit;
  font-size: 9px;
}

.report-filter-result {
  height: 32px;
  padding: 0 10px;
  display: flex;
  align-items: center;
  gap: 4px;
  border-radius: 7px;
  color: #66768a;
  background: #f0f4f5;
  white-space: nowrap;
}

.report-filter-result strong {
  color: #27816c;
  font-size: 13px;
}

.report-filter-result span {
  font-size: 8px;
}

.report-filter-reset {
  height: 32px;
  padding: 0 10px;
  border: 1px solid #d9e1e5;
  border-radius: 7px;
  color: #627186;
  background: #fff;
  font-size: 8px;
  font-weight: 700;
  white-space: nowrap;
}

.report-grid {
  margin-top: 8px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
}

.report-card {
  min-height: 184px;
  height: 100%;
  padding: var(--report-space-md);
  position: relative;
  display: flex;
  flex-direction: column;
  border: 1px solid #dde4e7;
  border-radius: 12px;
  background: #fff;
  cursor: pointer;
  transition: border-color 0.18s, box-shadow 0.18s, transform 0.18s;
}

.report-card:focus-visible {
  border-color: #54a991;
  outline: 3px solid rgba(84, 169, 145, 0.16);
}

.report-card.primary-report {
  min-height: 184px;
  padding: var(--report-space-md);
  grid-column: 1/-1;
  border-color: #a9d6ca;
  background: radial-gradient(circle at 94% 12%, rgba(89, 193, 168, 0.13), transparent 22%), linear-gradient(135deg, #fff, #f7fcfa);
  box-shadow: 0 6px 18px rgba(41, 106, 89, 0.06);
}

.report-card.support-report {
  min-height: 184px;
}

.report-card:hover {
  border-color: #c7d6d3;
  box-shadow: 0 10px 25px rgba(37, 51, 69, 0.07);
  transform: translateY(-1px);
}

.report-card.demo-report {
  border-style: dashed;
  border-color: #dfcfb3;
  background: linear-gradient(145deg, #fff, #fffcf6);
}

.report-card.direct-report {
  border-color: #4daf97;
  box-shadow: 0 0 0 3px rgba(77, 175, 151, 0.1), 0 12px 28px rgba(37, 111, 92, 0.11);
}

.report-card.direct-report::before {
  content: "LINKED";
  padding: 4px 7px;
  position: absolute;
  top: -8px;
  left: 16px;
  border-radius: 5px;
  color: #fff;
  background: #318a75;
  font-size: 6px;
  font-weight: 820;
  letter-spacing: 0.08em;
}

.report-card-main {
  min-width: 0;
  display: grid;
  grid-template-columns: minmax(0, 1fr) 112px;
  align-items: stretch;
  gap: var(--report-space-md);
}

.report-card-head {
  display: grid;
  grid-template-columns: 40px minmax(0, 1fr) auto;
  align-items: start;
  gap: 10px;
}

.report-card.primary-report .report-card-head {
  grid-template-columns: 40px minmax(0, 1fr) auto;
  gap: 10px;
}

.report-icon {
  width: 40px;
  height: 40px;
  display: grid;
  place-items: center;
  border-radius: 10px;
  color: #317b6c;
  background: #e8f5f1;
}

.report-icon svg {
  width: 21px;
  height: 21px;
}

.report-card.primary-report .report-icon {
  width: 40px;
  height: 40px;
  color: #1d6f5c;
  background: #d9f0ea;
  box-shadow: inset 0 0 0 1px rgba(44, 137, 113, 0.08);
}

.report-card.primary-report .report-icon svg {
  width: 21px;
  height: 21px;
}

.report-copy {
  min-width: 0;
}

.report-priority-label {
  color: #2d8b76;
  font-size: var(--report-type-label);
  font-weight: 790;
}

.report-priority-label.primary {
  color: #16755f;
  letter-spacing: 0.07em;
}

.report-copy h3 {
  margin: 4px 0 0;
  color: #364459;
  font-size: var(--report-type-title);
  line-height: 1.3;
}

.report-card.primary-report .report-copy h3 {
  margin-top: 4px;
  color: #273c4e;
  font-size: 17px;
}

.report-key-facts {
  margin-top: 5px;
  display: flex;
  align-items: center;
  gap: 7px;
}

.report-key-facts > strong {
  color: #263f52;
  font-size: 11px;
  font-weight: 820;
}

.report-key-facts .ui-status {
  min-width: 56px;
  justify-content: center;
}

.report-copy p {
  margin: 4px 0 0;
  display: -webkit-box;
  overflow: hidden;
  color: #7f8b9a;
  font-size: var(--report-type-body);
  line-height: 1.4;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}

.report-card.primary-report .report-copy p {
  max-width: 760px;
  color: #657a7a;
  font-size: var(--report-type-body);
}

.report-meta-line {
  min-width: 0;
  margin-top: 6px;
  display: flex;
  align-items: center;
  gap: 5px;
  overflow: hidden;
  color: #8a96a4;
  font-size: var(--report-type-label);
  white-space: nowrap;
}

.report-meta-line span {
  overflow: hidden;
  text-overflow: ellipsis;
}

.report-meta-line i {
  width: 2px;
  height: 2px;
  flex: 0 0 auto;
  border-radius: 50%;
  background: #b4bdc5;
}

.report-card-badges {
  display: grid;
  justify-items: end;
  gap: 4px;
}

.report-card-badges .ui-status {
  min-width: 56px;
  justify-content: center;
}

.report-source-badge {
  min-height: 18px;
  padding: 0 7px;
  display: inline-flex;
  align-items: center;
  border: 1px solid #b9dcd3;
  border-radius: 999px;
  color: #287d69;
  background: #eef8f5;
  font-size: var(--report-type-label);
  font-style: normal;
  font-weight: 780;
}

.report-source-badge.demo {
  border-color: #e7cda0;
  color: #9a6d23;
  background: #fff7e8;
}

.report-version-badge {
  min-height: 18px;
  padding: 0 7px;
  display: inline-flex;
  align-items: center;
  border-radius: 999px;
  color: #5f7182;
  background: #edf2f4;
  font-size: var(--report-type-label);
  font-style: normal;
  font-weight: 740;
}

.report-version-badge.outdated {
  color: #a56b20;
  background: #fff3dc;
}

.report-card-preview {
  width: 112px;
  min-height: 104px;
  padding: 0;
  overflow: hidden;
  display: grid;
  grid-template-rows: minmax(0, 1fr) 25px;
  border: 1px solid #d5dfe2;
  border-radius: 8px;
  color: #4b5c6e;
  background: #eef2f3;
  text-align: left;
  transition: border-color 0.16s, box-shadow 0.16s, transform 0.16s;
}

.report-card-preview:hover,
.report-card-preview:focus-visible {
  border-color: #72b8a6;
  outline: 0;
  box-shadow: 0 5px 14px rgba(37, 93, 78, 0.13);
  transform: translateY(-1px);
}

.report-thumbnail-page {
  min-width: 0;
  padding: 7px 8px 6px;
  position: relative;
  display: grid;
  align-content: start;
  border-bottom: 1px solid #dbe2e4;
  background: #fff;
}

.report-thumbnail-masthead {
  display: flex;
  align-items: center;
  gap: 5px;
  color: #31816d;
}

.report-thumbnail-masthead i {
  width: 16px;
  height: 16px;
  display: grid;
  place-items: center;
  border-radius: 4px;
  color: #153c35;
  background: #66d2bb;
  font-size: 5px;
  font-style: normal;
  font-weight: 850;
}

.report-thumbnail-masthead span {
  overflow: hidden;
  font-size: 5px;
  font-weight: 800;
  letter-spacing: 0.05em;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.report-thumbnail-page > strong {
  margin-top: 5px;
  overflow: hidden;
  color: #344456;
  font-size: 7px;
  line-height: 1.25;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.report-thumbnail-page > p {
  margin: 2px 0 0;
  overflow: hidden;
  color: #8d98a4;
  font-size: 5px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.report-thumbnail-lines {
  margin-top: 6px;
  display: grid;
  gap: 3px;
}

.report-thumbnail-lines i {
  width: 100%;
  height: 2px;
  border-radius: 999px;
  background: #dfe6e7;
}

.report-thumbnail-lines i:nth-child(2) {
  width: 78%;
}

.report-thumbnail-lines i:nth-child(3) {
  width: 56%;
  background: #cce8e1;
}

.report-thumbnail-page > em {
  margin-top: 5px;
  color: #789087;
  font-size: 5px;
  font-style: normal;
}

.report-thumbnail-caption {
  padding: 0 7px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  color: #2d7866;
  background: #eff8f5;
  font-size: 7px;
  font-weight: 760;
}

.report-thumbnail-caption svg {
  width: 12px;
  height: 12px;
  flex: 0 0 auto;
}

.report-information {
  margin: 11px 0 0;
  padding: 9px;
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 0;
  border: 1px solid #e4e9eb;
  border-radius: 9px;
  background: #fafbfb;
}

.report-information > div {
  min-width: 0;
  padding: 0 9px;
  display: grid;
  grid-template-rows: 10px 14px;
  align-content: start;
  border-left: 1px solid #e5eaec;
}

.report-information > div:first-child {
  padding-left: 0;
  border-left: 0;
}

.report-information dt {
  color: #8a96a4;
  font-size: 7px;
}

.report-information dd {
  margin: 4px 0 0;
  overflow: hidden;
  color: #455469;
  font-size: 9px;
  font-weight: 720;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.report-version-track {
  min-width: 0;
  margin-top: 0;
  display: grid;
  grid-template-columns: auto 12px auto minmax(110px, 1fr);
  align-items: center;
  gap: 7px;
}

.report-version-track > div {
  display: grid;
  grid-template-columns: auto auto;
  align-items: baseline;
  gap: 5px;
}

.report-version-track span,
.report-version-track em {
  color: #7e8a99;
  font-size: var(--report-type-label);
  font-style: normal;
}

.report-version-track strong {
  color: #596879;
  font-size: 9px;
}

.report-version-track .current span,
.report-version-track .current strong {
  color: #2d866f;
  font-weight: 760;
}

.report-version-track > i {
  color: #a3adb8;
  font-style: normal;
  text-align: center;
}

.report-version-track > .report-version-note {
  min-width: 0;
  padding-left: 8px;
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  align-items: start;
  gap: 2px;
  border-left: 1px solid #e2e7e9;
}

.report-version-note strong {
  overflow: hidden;
  color: #536779;
  font-size: 8px;
  font-weight: 680;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.report-card-footer {
  min-width: 0;
  margin-top: 9px;
  padding-top: 8px;
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  align-items: center;
  gap: 10px;
  border-top: 1px solid #e4e9ea;
}

.report-card-actions {
  margin-top: auto;
  padding-top: 11px;
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  gap: 7px;
}

.report-card-actions button,
.report-card-actions select {
  height: 36px;
  padding: 0 11px;
  border: 1px solid #dce2e6;
  border-radius: 7px;
  color: #5b687a;
  background: #fff;
  font-size: 9px;
  font-weight: 700;
}

.report-card-actions select {
  min-width: 68px;
  padding: 0 24px 0 9px;
  border-radius: 7px 0 0 7px;
  font: inherit;
  font-size: 8px;
}

.report-open-action {
  text-align: center;
}

.report-card.primary-report .report-open-action {
  border-color: #9fcfc3;
  color: #216f5d;
  background: #eef8f5;
}

.report-card-export {
  display: flex;
  align-items: center;
}

.report-card-export select,
.report-card-export button {
  height: 32px;
  padding: 0 10px;
  border: 1px solid #dce2e6;
  color: #5b687a;
  background: #fff;
  font-size: 8px;
  font-weight: 720;
}

.report-card-export select {
  min-width: 64px;
  padding-right: 23px;
  border-radius: 7px 0 0 7px;
}

.report-card-export button.primary {
  border-radius: 0 7px 7px 0;
  border-color: #243349;
  color: #fff;
  background: #243349;
}

.report-card-actions button.primary {
  color: #fff;
  background: #243349;
}

.report-empty {
  min-height: 160px;
  margin-top: 13px;
  display: grid;
  place-content: center;
  justify-items: center;
  border: 1px dashed #d6dee2;
  border-radius: 13px;
  color: #7b8999;
  background: #fff;
}

.report-empty strong {
  color: #4f5d70;
  font-size: 12px;
}

.report-empty span {
  margin-top: 5px;
  font-size: 9px;
}

.report-empty button {
  min-height: 32px;
  margin-top: 12px;
  padding: 0 10px;
  border: 1px solid #cfe0dc;
  border-radius: 7px;
  color: #2a806b;
  background: #f0f8f6;
  font-size: 8px;
  font-weight: 720;
}

.report-layer-backdrop {
  padding: 16px;
  position: fixed;
  inset: 0;
  z-index: 120;
  display: grid;
  place-items: center;
  background: rgba(16, 25, 39, 0.48);
  backdrop-filter: blur(3px);
}

.report-layer {
  width: min(1160px, 100%);
  height: min(860px, 100vh - 32px);
  max-height: calc(100vh - 32px);
  overflow: hidden;
  display: flex;
  flex-direction: column;
  border-radius: 14px;
  background: #f5f7f7;
  box-shadow: 0 28px 70px rgba(7, 17, 30, 0.3);
}

.report-layer-head {
  min-height: 76px;
  padding: 14px 18px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 18px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  color: #fff;
  background: linear-gradient(120deg, #1b2b40, #284254);
}

.report-layer-head > div {
  min-width: 0;
  display: grid;
}

.report-layer-head span {
  color: #71d3bd;
  font-size: 8px;
  font-weight: 800;
  letter-spacing: 0.08em;
}

.report-layer-head h2 {
  margin: 6px 0 0;
  overflow: hidden;
  font-size: 17px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.report-layer-head p {
  margin: 5px 0 0;
  color: #aab9c8;
  font-size: 9px;
}

.report-layer-head > button {
  width: 34px;
  height: 34px;
  flex: 0 0 auto;
  border: 1px solid rgba(255, 255, 255, 0.16);
  border-radius: 9px;
  color: #fff;
  background: rgba(255, 255, 255, 0.08);
  font-size: 18px;
}

.report-flow-steps {
  padding: 10px 18px;
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto minmax(0, 1fr) auto minmax(0, 1fr);
  align-items: center;
  gap: 8px;
  border-bottom: 1px solid #dce3e5;
  background: #fff;
}

.report-flow-steps button,
.report-flow-steps > div {
  min-height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  border: 0;
  border-radius: 8px;
  color: #7b8795;
  background: #f3f6f7;
  font: inherit;
  font-size: 9px;
  font-weight: 720;
}

.report-flow-steps button.active,
.report-flow-steps > div.active {
  color: #226e5d;
  background: #e8f5f1;
  box-shadow: inset 0 0 0 1px #c4e3db;
}

.report-flow-steps i {
  width: 20px;
  height: 20px;
  display: grid;
  place-items: center;
  border-radius: 50%;
  color: #fff;
  background: #8c9aa8;
  font-size: 7px;
  font-style: normal;
}

.report-flow-steps .active i {
  background: #319079;
}

.report-flow-steps > em {
  color: #a0aab4;
  font-size: 9px;
  font-style: normal;
}

.report-preview-document,
.report-compare-document {
  margin: 16px 18px 0;
  padding: 22px;
  border: 1px solid #dce3e5;
  border-radius: 12px;
  background: #fff;
  box-shadow: 0 8px 22px rgba(34, 48, 64, 0.06);
}

.report-preview-title {
  display: grid;
  grid-template-columns: 43px minmax(0, 1fr) auto;
  align-items: center;
  gap: 12px;
}

.report-preview-mark {
  width: 43px;
  height: 43px;
  display: grid;
  place-items: center;
  border-radius: 11px;
  color: #123c35;
  background: #64d1bb;
  font-size: 10px;
  font-weight: 850;
}

.report-preview-title > div {
  min-width: 0;
  display: grid;
}

.report-preview-title span {
  color: #31856f;
  font-size: 7px;
  font-weight: 800;
}

.report-preview-title strong {
  margin-top: 4px;
  color: #314054;
  font-size: 14px;
}

.report-preview-title small {
  margin-top: 3px;
  color: #8d98a4;
  font-size: 8px;
}

.report-preview-title > em {
  padding: 5px 7px;
  border-radius: 6px;
  color: #2b806b;
  background: #ecf7f4;
  font-size: 8px;
  font-style: normal;
  font-weight: 780;
}

.report-preview-version-picker {
  margin-top: 12px;
  padding: 5px;
  display: flex;
  align-items: center;
  gap: 5px;
  border: 1px solid #e0e6e8;
  border-radius: 9px;
  background: #f7f9f9;
}

.report-preview-version-picker > span {
  margin: 0 5px;
  color: #7d8a99;
  font-size: 8px;
  font-weight: 740;
}

.report-preview-version-picker > button {
  min-height: 28px;
  padding: 0 9px;
  border: 1px solid transparent;
  border-radius: 6px;
  color: #647386;
  background: transparent;
  font-size: 8px;
  font-weight: 720;
}

.report-preview-version-picker > button.active {
  border-color: #b6d9d1;
  color: #247561;
  background: #fff;
  box-shadow: 0 2px 7px rgba(37, 91, 77, 0.08);
}

.report-selected-version-summary {
  margin-top: 8px;
  padding: 10px 11px;
  border: 1px solid #cde4de;
  border-radius: 9px;
  background: #f2faf7;
}

.report-selected-version-summary.previous {
  border-color: #dfe4e7;
  background: #f7f9f9;
}

.report-selected-version-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
}

.report-selected-version-head span {
  color: #2e846f;
  font-size: 7px;
  font-weight: 820;
  letter-spacing: 0.08em;
}

.report-selected-version-head strong {
  color: #344b5e;
  font-size: 9px;
}

.report-selected-version-summary > p {
  margin: 5px 0 0;
  color: #5f7180;
  font-size: 9px;
  line-height: 1.45;
}

.report-selected-version-points {
  margin-top: 7px;
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
}

.report-selected-version-points span {
  min-height: 21px;
  padding: 0 7px;
  display: inline-flex;
  align-items: center;
  border: 1px solid #d9e7e3;
  border-radius: 999px;
  color: #577368;
  background: #fff;
  font-size: 7px;
  font-weight: 680;
}

.report-preview-summary {
  margin: 18px 0 0;
  padding: 13px 14px;
  border-left: 3px solid #56bca4;
  color: #647184;
  background: #f5faf8;
  font-size: 10px;
  line-height: 1.55;
}

.report-preview-sections {
  margin-top: 16px;
  display: grid;
  gap: 8px;
}

.report-preview-sections article {
  padding: 10px 0;
  display: grid;
  grid-template-columns: 30px minmax(0, 1fr);
  align-items: center;
  gap: 10px;
  border-bottom: 1px solid #e8ecee;
}

.report-preview-sections i {
  width: 30px;
  height: 30px;
  display: grid;
  place-items: center;
  border-radius: 8px;
  color: #558174;
  background: #edf4f2;
  font-size: 8px;
  font-style: normal;
  font-weight: 780;
}

.report-preview-sections article > div {
  display: grid;
}

.report-preview-sections span {
  color: #8c97a4;
  font-size: 8px;
}

.report-preview-sections strong {
  margin-top: 3px;
  color: #465468;
  font-size: 10px;
}

.report-preview-footer {
  margin-top: 18px;
  padding-top: 10px;
  display: flex;
  justify-content: space-between;
  border-top: 1px solid #dfe5e7;
  color: #81909d;
  font-size: 8px;
}

.report-preview-footer em {
  font-style: normal;
}

.report-version-columns {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 28px minmax(0, 1fr);
  align-items: center;
  gap: 10px;
}

.report-version-columns button {
  padding: 16px;
  display: grid;
  border: 1px solid #dde4e7;
  border-radius: 10px;
  color: inherit;
  background: #fafbfb;
  font: inherit;
  text-align: left;
}

.report-version-columns button.current {
  border-color: #b9dcd3;
  background: #f1faf7;
}

.report-version-columns button.selected {
  border-color: #36927b;
  box-shadow: 0 0 0 3px rgba(54, 146, 123, 0.11);
}

.report-version-columns > i {
  color: #7c8a99;
  font-style: normal;
  text-align: center;
}

.report-version-columns span {
  color: #8793a1;
  font-size: 8px;
  font-weight: 780;
}

.report-version-columns strong {
  margin-top: 5px;
  color: #3e4d61;
  font-size: 16px;
}

.report-version-columns small {
  margin-top: 4px;
  color: #909ba7;
  font-size: 9px;
}

.report-change-list {
  margin-top: 16px;
  display: grid;
  gap: 9px;
}

.report-change-list article {
  padding: 12px 13px;
  border: 1px solid #e2e7e9;
  border-radius: 9px;
}

.report-change-list article > span {
  color: #748294;
  font-size: 8px;
  font-weight: 740;
}

.report-layer-actions {
  padding: 12px 18px 16px;
  display: flex;
  justify-content: flex-end;
  gap: 8px;
}

.report-layer-actions button {
  min-height: 40px;
  padding: 0 16px;
  border: 1px solid #d6dfe2;
  border-radius: 8px;
  color: #627184;
  background: #fff;
  font-size: 10px;
  font-weight: 720;
}

.report-layer-actions button.primary {
  border-color: #26394d;
  color: #fff;
  background: #26394d;
}

.report-layer-actions button.report-download-primary {
  min-width: 210px;
  min-height: 42px;
  border-color: #1d725f;
  background: #1d725f;
  box-shadow: 0 7px 16px rgba(29, 114, 95, 0.2);
}

.report-layer-actions.compare-actions {
  align-items: flex-end;
  justify-content: space-between;
}

.report-layer-download {
  display: flex;
  align-items: flex-end;
}

.report-layer-download label {
  display: grid;
  gap: 4px;
}

.report-layer-download label > span {
  color: #7e8a98;
  font-size: 7px;
  font-weight: 720;
}

.report-layer-download select {
  height: 36px;
  min-width: 82px;
  padding: 0 25px 0 10px;
  border: 1px solid #d6dfe2;
  border-right: 0;
  border-radius: 8px 0 0 8px;
  color: #546477;
  background: #fff;
  font: inherit;
  font-size: 9px;
}

.report-layer-download button.primary {
  border-radius: 0 8px 8px 0;
}

/* A4 report viewer */
.report-document-workspace {
  min-height: 0;
  flex: 1;
  display: grid;
  grid-template-columns: 104px minmax(0, 1fr);
  overflow: hidden;
  background: #e6eaec;
}

.report-page-rail {
  min-height: 0;
  padding: 10px 7px;
  overflow-y: auto;
  border-right: 1px solid #d0d7da;
  background: #f4f6f6;
}

.report-page-rail-head {
  padding: 0 2px 9px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.report-page-rail-head span {
  color: #73808e;
  font-size: 7px;
  font-weight: 820;
  letter-spacing: 0.1em;
}

.report-page-rail-head strong {
  color: #465468;
  font-size: 7px;
}

.report-page-thumbnail {
  width: 100%;
  padding: 5px;
  display: grid;
  grid-template-columns: minmax(0, 1fr) 15px;
  align-items: end;
  gap: 4px;
  border: 1px solid transparent;
  border-radius: 7px;
  color: #697789;
  background: transparent;
}

.report-page-thumbnail + .report-page-thumbnail {
  margin-top: 5px;
}

.report-page-thumbnail.active {
  border-color: #79b9aa;
  color: #23725f;
  background: #e8f4f1;
}

.report-page-thumbnail > span {
  padding-bottom: 2px;
  font-size: 7px;
  font-weight: 780;
  text-align: center;
}

.report-page-thumbnail-sheet {
  aspect-ratio: 210/297;
  padding: 6px;
  overflow: hidden;
  display: grid;
  align-content: start;
  border: 1px solid #d7dddf;
  background: #fff;
  box-shadow: 0 2px 5px rgba(41, 52, 66, 0.08);
}

.report-page-thumbnail-brand {
  width: 13px;
  height: 13px;
  display: grid;
  place-items: center;
  color: #103c33;
  background: #62cfb7;
  font-size: 4px;
  font-weight: 850;
}

.report-page-thumbnail-sheet strong {
  margin-top: 6px;
  overflow: hidden;
  color: #425164;
  font-size: 5px;
  line-height: 1.25;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.report-page-thumbnail-sheet > i {
  width: 100%;
  height: 2px;
  margin-top: 5px;
  background: #e3e8e9;
}

.report-page-thumbnail-sheet > i + i {
  width: 78%;
  margin-top: 3px;
}

.report-page-thumbnail-sheet > i:last-child {
  width: 52%;
  background: #cce7e0;
}

.report-page-stage {
  min-width: 0;
  min-height: 0;
  display: flex;
  flex-direction: column;
}

.report-page-toolbar {
  min-height: 48px;
  padding: 7px 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  border-bottom: 1px solid #cfd6d9;
  background: #f8f9f9;
}

.report-page-toolbar .report-preview-version-picker {
  margin-top: 0;
  padding: 3px;
}

.report-page-tools,
.report-zoom-controls {
  display: flex;
  align-items: center;
}

.report-page-tools {
  gap: 12px;
}

.report-zoom-controls {
  min-height: 30px;
  padding: 2px;
  gap: 2px;
  border: 1px solid #d6dddf;
  border-radius: 7px;
  background: #fff;
}

.report-zoom-controls button {
  min-width: 26px;
  height: 24px;
  padding: 0 7px;
  border: 0;
  border-radius: 5px;
  color: #4a596b;
  background: transparent;
  font-size: 11px;
  font-weight: 760;
}

.report-zoom-controls button:hover:not(:disabled),
.report-zoom-controls .report-fit-page.active {
  color: #176b5a;
  background: #e5f4f0;
}

.report-zoom-controls button:disabled {
  cursor: not-allowed;
  opacity: 0.32;
}

.report-zoom-controls .report-fit-page {
  min-width: 54px;
  font-size: 8px;
}

.report-zoom-controls output {
  min-width: 34px;
  color: #5e6b7a;
  font-size: 8px;
  font-weight: 760;
  text-align: center;
}

.report-page-pagination {
  display: flex;
  align-items: center;
  gap: 5px;
}

.report-page-pagination button {
  width: 28px;
  height: 28px;
  border: 1px solid #d6dddf;
  border-radius: 6px;
  color: #536174;
  background: #fff;
  font-size: 10px;
}

.report-page-pagination button:disabled {
  cursor: not-allowed;
  opacity: 0.38;
}

.report-page-pagination strong {
  min-width: 72px;
  color: #3e4d5f;
  font-size: 9px;
  text-align: center;
}

.report-page-viewport {
  min-height: 0;
  padding: 22px 24px 34px;
  flex: 1;
  overflow: auto;
  display: grid;
  justify-items: center;
  align-items: start;
  background: radial-gradient(circle at 50% 0, rgba(255, 255, 255, 0.5), transparent 45%), #d9dfe1;
}

.report-page-viewport.fit-page {
  overflow: hidden;
  place-items: center;
}

.report-a4-page {
  width: min(630px, 100%);
  min-height: 891px;
  padding: 34px 40px 30px;
  position: relative;
  display: flex;
  flex-direction: column;
  color: #273544;
  background: #fff;
  box-shadow: 0 12px 32px rgba(26, 38, 50, 0.2);
  font-family: "SUIT", Arial, sans-serif;
}

.report-page-viewport > .report-a4-page {
  width: 630px;
  height: 891px;
  overflow: hidden;
}

.report-a4-header {
  min-height: 38px;
  padding-bottom: 12px;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 18px;
  border-bottom: 2px solid #263a4c;
}

.report-a4-brand {
  display: flex;
  align-items: center;
  gap: 9px;
}

.report-a4-brand > i {
  width: 29px;
  height: 29px;
  display: grid;
  place-items: center;
  border-radius: 4px;
  color: #113a33;
  background: #5ed1b8;
  font-size: 8px;
  font-style: normal;
  font-weight: 850;
}

.report-a4-brand > div {
  display: grid;
}

.report-a4-brand strong {
  color: #26394b;
  font-size: 10px;
  letter-spacing: 0.06em;
}

.report-a4-brand span {
  margin-top: 2px;
  color: #86919c;
  font-size: 6px;
  font-weight: 720;
  letter-spacing: 0.12em;
}

.report-a4-classification {
  display: grid;
  justify-items: end;
  gap: 3px;
}

.report-a4-classification span {
  color: #758390;
  font-size: 6px;
  font-weight: 760;
  letter-spacing: 0.08em;
}

.report-a4-classification strong {
  color: #267966;
  font-size: 9px;
}

.report-a4-document-title {
  padding: 26px 0 18px;
}

.report-a4-document-title > span,
.report-a4-page-title > span {
  color: #23836d;
  font-size: 7px;
  font-weight: 820;
  letter-spacing: 0.11em;
}

.report-a4-document-title h1,
.report-a4-page-title h1 {
  margin: 7px 0 0;
  color: #1e3041;
  font-size: 24px;
  line-height: 1.23;
  letter-spacing: -0.025em;
}

.report-a4-document-title p,
.report-a4-page-title p {
  margin: 7px 0 0;
  color: #7d8995;
  font-size: 9px;
  line-height: 1.45;
}

.report-a4-meta {
  margin: 0;
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  border-top: 1px solid #dbe1e3;
  border-bottom: 1px solid #dbe1e3;
}

.report-a4-meta > div {
  min-width: 0;
  padding: 9px 8px;
  border-left: 1px solid #e3e7e8;
}

.report-a4-meta > div:first-child {
  padding-left: 0;
  border-left: 0;
}

.report-a4-meta dt {
  color: #89949e;
  font-size: 6px;
  font-weight: 760;
  letter-spacing: 0.08em;
}

.report-a4-meta dd {
  margin: 4px 0 0;
  overflow: hidden;
  color: #3d4c5d;
  font-size: 8px;
  font-weight: 720;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.report-a4-summary-status {
  margin-top: 12px;
  padding: 10px 12px;
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  align-items: center;
  gap: 14px;
  border: 1px solid #cce2dc;
  background: #f2f8f6;
}

.report-a4-summary-status > div {
  display: grid;
}

.report-a4-summary-status span {
  color: #277a66;
  font-size: 6px;
  font-weight: 820;
  letter-spacing: 0.09em;
}

.report-a4-summary-status p {
  margin: 4px 0 0;
  color: #52645e;
  font-size: 7px;
  line-height: 1.45;
}

.report-a4-summary-status > em {
  min-height: 28px;
  padding: 0 10px;
  display: inline-flex;
  align-items: center;
  border-radius: 999px;
  color: #fff;
  background: #2c8c74;
  font-size: 7px;
  font-style: normal;
  font-weight: 840;
}

.report-a4-summary-status > em.fail {
  background: #b95a52;
}

.report-a4-section-head {
  margin-top: 22px;
  display: grid;
  grid-template-columns: 27px minmax(0, 1fr);
  align-items: center;
  gap: 10px;
}

.report-a4-section-head.compact {
  margin-top: 18px;
}

.report-a4-section-head > span {
  width: 27px;
  height: 27px;
  display: grid;
  place-items: center;
  border-radius: 50%;
  color: #fff;
  background: #2d7e6b;
  font-size: 7px;
  font-weight: 780;
}

.report-a4-section-head > div {
  display: grid;
}

.report-a4-section-head small {
  color: #2b806c;
  font-size: 6px;
  font-weight: 820;
  letter-spacing: 0.1em;
}

.report-a4-section-head h2 {
  margin: 2px 0 0;
  color: #253646;
  font-size: 14px;
}

.report-a4-lead {
  margin: 10px 0 0;
  padding: 11px 13px;
  border-left: 3px solid #5abca5;
  color: #526170;
  background: #f3f8f7;
  font-size: 9px;
  line-height: 1.6;
}

.report-a4-kpi-grid {
  margin-top: 12px;
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 7px;
}

.report-a4-kpi-grid article {
  min-width: 0;
  padding: 10px;
  display: grid;
  border: 1px solid #dce3e4;
  background: #fafbfb;
}

.report-a4-kpi-grid span {
  color: #75828e;
  font-size: 7px;
  font-weight: 720;
}

.report-a4-kpi-grid strong {
  margin-top: 5px;
  color: #20384a;
  font-size: 18px;
  letter-spacing: -0.03em;
}

.report-a4-kpi-grid small {
  margin-top: 2px;
  overflow: hidden;
  color: #929ca5;
  font-size: 6px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.report-a4-decision-grid {
  margin-top: 10px;
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 7px;
}

.report-a4-decision-grid article {
  padding: 9px 10px;
  display: grid;
  border-top: 2px solid #91cabc;
  background: #f7f9f9;
}

.report-a4-decision-grid span {
  color: #82909a;
  font-size: 6px;
}

.report-a4-decision-grid strong {
  margin-top: 4px;
  color: #354657;
  font-size: 8px;
  line-height: 1.35;
}

.report-a4-callout {
  margin-top: 13px;
  padding: 11px 13px;
  display: grid;
  gap: 4px;
  color: #fff;
  background: #263b4d;
}

.report-a4-callout span {
  color: #77d6c1;
  font-size: 6px;
  font-weight: 820;
  letter-spacing: 0.1em;
}

.report-a4-callout strong {
  font-size: 10px;
  line-height: 1.4;
}

.report-a4-page-title {
  padding: 27px 0 20px;
  border-bottom: 1px solid #dce2e4;
}

.report-a4-table {
  width: 100%;
  margin-top: 22px;
  border-collapse: collapse;
  table-layout: fixed;
  font-size: 8px;
}

.report-a4-table th {
  padding: 8px 7px;
  color: #fff;
  background: #2c4051;
  font-size: 7px;
  font-weight: 760;
  text-align: left;
}

.report-a4-table th:first-child {
  width: 31%;
}

.report-a4-table td {
  padding: 11px 7px;
  border-bottom: 1px solid #dfe4e6;
  color: #4f5e6d;
  vertical-align: middle;
}

.report-a4-table td:first-child {
  display: grid;
}

.report-a4-table td strong {
  color: #2d3e4e;
  font-size: 9px;
}

.report-a4-table td span {
  margin-top: 2px;
  color: #8c97a1;
  font-size: 6px;
}

.report-a4-table td em {
  min-height: 18px;
  padding: 0 6px;
  display: inline-flex;
  align-items: center;
  border-radius: 999px;
  color: #22715e;
  background: #e5f4f0;
  font-size: 6px;
  font-style: normal;
  font-weight: 820;
}

.report-a4-table td em.fail {
  color: #b04f48;
  background: #fae9e7;
}

.report-a4-requirement-table {
  margin-top: 16px;
}

.report-a4-requirement-table th:first-child {
  width: 54px;
}

.report-a4-requirement-table th:nth-child(2) {
  width: 29%;
}

.report-a4-requirement-table th:nth-child(3) {
  width: 39%;
}

.report-a4-requirement-table th:last-child {
  width: 84px;
}

.report-a4-requirement-table td {
  padding: 7px 6px;
  font-size: 7px;
  line-height: 1.35;
}

.report-a4-requirement-table td:last-child {
  display: grid;
  justify-items: start;
  gap: 3px;
}

.report-a4-requirement-table td:last-child > strong {
  font-size: 7px;
}

.report-a4-candidate-table {
  margin-top: 18px;
}

.report-a4-candidate-table th,
.report-a4-candidate-table td {
  padding-right: 5px;
  padding-left: 5px;
  text-align: center;
}

.report-a4-candidate-table th:first-child {
  width: 26%;
  text-align: left;
}

.report-a4-candidate-table td:first-child {
  grid-template-columns: 20px minmax(0, 1fr);
  align-items: center;
  text-align: left;
}

.report-a4-candidate-table tr.selected td {
  background: #eef8f5;
}

.report-a4-candidate-table tr.selected td:first-child {
  box-shadow: inset 3px 0 0 #3da087;
}

.report-a4-candidate-table td:last-child em {
  min-width: 26px;
  justify-content: center;
}

.report-a4-selection-reason {
  margin-top: 24px;
  padding: 15px 16px;
  display: grid;
  gap: 9px;
  color: #fff;
  background: #263b4d;
}

.report-a4-selection-reason > span {
  color: #70d5bf;
  font-size: 6px;
  font-weight: 820;
  letter-spacing: 0.09em;
}

.report-a4-selection-reason article {
  display: grid;
  grid-template-columns: 24px minmax(0, 1fr);
  align-items: start;
  gap: 8px;
}

.report-a4-selection-reason i {
  color: #70d5bf;
  font-size: 7px;
  font-style: normal;
  font-weight: 800;
}

.report-a4-selection-reason p {
  margin: 0;
  color: #d2dbe0;
  font-size: 8px;
  line-height: 1.45;
}

.report-a4-bom-table {
  margin-top: 17px;
}

.report-a4-bom-table th:first-child {
  width: 19%;
}

.report-a4-bom-table th:nth-child(2) {
  width: 22%;
}

.report-a4-bom-table th:nth-child(3) {
  width: 33%;
}

.report-a4-bom-table th:nth-child(4) {
  width: 8%;
}

.report-a4-bom-table td {
  padding: 8px 6px;
  font-size: 7px;
}

.report-a4-parameter-grid {
  margin-top: 10px;
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 7px;
}

.report-a4-parameter-grid article {
  min-width: 0;
  padding: 9px 10px;
  display: grid;
  border: 1px solid #dce3e4;
  background: #f8fafa;
}

.report-a4-parameter-grid span,
.report-a4-parameter-grid small {
  color: #83909b;
  font-size: 6px;
}

.report-a4-parameter-grid strong {
  margin-top: 4px;
  color: #304354;
  font-size: 10px;
}

.report-a4-parameter-grid small {
  margin-top: 3px;
}

.report-a4-rationale-list {
  margin-top: 18px;
  display: grid;
  gap: 8px;
}

.report-a4-rationale-list article {
  padding: 11px 13px;
  display: grid;
  border: 1px solid #dce3e4;
  border-left: 3px solid #4aa98f;
  background: #fafbfb;
}

.report-a4-rationale-list article > div {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
}

.report-a4-rationale-list span,
.report-a4-rationale-list em {
  color: #28806b;
  font-size: 6px;
  font-style: normal;
  font-weight: 800;
}

.report-a4-rationale-list article > strong {
  margin-top: 5px;
  color: #334656;
  font-size: 9px;
}

.report-a4-rationale-list p {
  margin: 4px 0 0;
  color: #6c7984;
  font-size: 7px;
  line-height: 1.45;
}

.report-a4-tradeoff-list {
  margin-top: 10px;
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 7px;
}

.report-a4-tradeoff-list article {
  padding: 10px;
  display: grid;
  border-top: 2px solid #8bc6b8;
  background: #f5f8f8;
}

.report-a4-tradeoff-list span {
  color: #2c806c;
  font-size: 6px;
  font-weight: 780;
}

.report-a4-tradeoff-list strong {
  margin-top: 5px;
  color: #374959;
  font-size: 8px;
}

.report-a4-tradeoff-list p {
  margin: 4px 0 0;
  color: #788590;
  font-size: 7px;
  line-height: 1.4;
}

.report-a4-chart {
  margin-top: 22px;
  padding: 15px 16px;
  border: 1px solid #dbe2e4;
  background: #fafbfb;
}

.report-a4-chart-head {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
}

.report-a4-chart-head > div {
  display: grid;
}

.report-a4-chart-head span {
  color: #27816c;
  font-size: 6px;
  font-weight: 820;
  letter-spacing: 0.08em;
}

.report-a4-chart-head strong {
  margin-top: 3px;
  color: #344657;
  font-size: 11px;
}

.report-a4-chart-head > em {
  color: #8b96a0;
  font-size: 6px;
  font-style: normal;
}

.report-a4-chart-row {
  margin-top: 11px;
  display: grid;
  grid-template-columns: 46px minmax(0, 1fr) 24px;
  align-items: center;
  gap: 8px;
}

.report-a4-chart-row > span,
.report-a4-chart-row > strong {
  color: #596877;
  font-size: 7px;
}

.report-a4-chart-row > strong {
  text-align: right;
}

.report-a4-chart-row > div {
  height: 8px;
  position: relative;
  overflow: hidden;
  border-radius: 999px;
  background: #e4e9ea;
}

.report-a4-chart-row > div > i {
  width: 1px;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 70%;
  z-index: 2;
  background: #8c979f;
}

.report-a4-chart-row > div > em {
  height: 100%;
  display: block;
  border-radius: inherit;
  background: linear-gradient(90deg, #3e9b84, #66cbb5);
}

.report-a4-chart-row > div > em.fail {
  background: linear-gradient(90deg, #c45d54, #e58b80);
}

.report-a4-method-note {
  margin-top: 18px;
  padding: 12px 14px;
  border-left: 3px solid #92a2ae;
  background: #f4f6f7;
}

.report-a4-method-note strong {
  color: #3f4f5f;
  font-size: 8px;
}

.report-a4-method-note p {
  margin: 4px 0 0;
  color: #6e7c88;
  font-size: 7px;
  line-height: 1.55;
}

.report-a4-evidence-list {
  margin-top: 18px;
  border-top: 1px solid #dce2e4;
}

.report-a4-evidence-list article {
  min-height: 64px;
  padding: 10px 0;
  display: grid;
  grid-template-columns: 94px minmax(0, 1fr) auto;
  align-items: center;
  gap: 12px;
  border-bottom: 1px solid #e1e6e7;
}

.report-a4-evidence-id {
  display: grid;
}

.report-a4-evidence-id span {
  color: #2c856f;
  font-size: 6px;
  font-weight: 820;
}

.report-a4-evidence-id strong {
  margin-top: 3px;
  color: #314454;
  font-family: "D2Coding", monospace;
  font-size: 8px;
}

.report-a4-evidence-list article > div:nth-child(2) {
  min-width: 0;
  display: grid;
}

.report-a4-evidence-list article > div:nth-child(2) > strong {
  color: #3c4c5c;
  font-size: 9px;
}

.report-a4-evidence-list article > div:nth-child(2) > p {
  margin: 3px 0 0;
  color: #89949e;
  font-size: 7px;
}

.report-a4-evidence-list article > em {
  min-height: 20px;
  padding: 0 7px;
  display: inline-flex;
  align-items: center;
  border-radius: 999px;
  color: #24735f;
  background: #e7f4f1;
  font-size: 6px;
  font-style: normal;
  font-weight: 800;
}

.report-a4-evidence-list article > em.review {
  color: #9b6d2d;
  background: #fff3dd;
}

.report-a4-evidence-note {
  margin-top: 20px;
  padding: 14px 16px;
  display: grid;
  border: 1px solid #bfded6;
  background: #f0f8f6;
}

.report-a4-evidence-note span {
  color: #27806b;
  font-size: 6px;
  font-weight: 820;
  letter-spacing: 0.09em;
}

.report-a4-evidence-note strong {
  margin-top: 5px;
  color: #315147;
  font-size: 9px;
}

.report-a4-evidence-note p {
  margin: 4px 0 0;
  color: #71877f;
  font-size: 7px;
}

.report-a4-change-history {
  margin-top: 16px;
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 7px;
}

.report-a4-change-history article {
  min-width: 0;
  padding: 9px 10px;
  display: grid;
  border: 1px solid #dce3e4;
  background: #fafbfb;
}

.report-a4-change-history article > div {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 6px;
}

.report-a4-change-history span {
  color: #277e69;
  font-size: 8px;
  font-weight: 820;
}

.report-a4-change-history em {
  color: #83909b;
  font-size: 5px;
  font-style: normal;
  font-weight: 780;
}

.report-a4-change-history strong {
  margin-top: 6px;
  color: #425363;
  font-size: 7px;
  line-height: 1.4;
}

.report-a4-change-history small {
  margin-top: 5px;
  color: #919ca5;
  font-size: 6px;
}

.report-a4-mini-diff {
  margin-top: 10px;
  display: grid;
  gap: 4px;
}

.report-a4-mini-diff article {
  min-height: 30px;
  padding: 5px 7px;
  display: grid;
  grid-template-columns: 70px minmax(0, 1fr) minmax(0, 1fr);
  align-items: center;
  gap: 6px;
  border: 1px solid #e0e5e6;
}

.report-a4-mini-diff article.hidden {
  display: none;
}

.report-a4-mini-diff span {
  color: #687684;
  font-size: 6px;
  font-weight: 760;
}

.report-a4-mini-diff del,
.report-a4-mini-diff ins {
  padding: 3px 5px;
  overflow: hidden;
  border-radius: 3px;
  font-size: 6px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.report-a4-mini-diff del {
  color: #a54e52;
  background: #fde9e8;
}

.report-a4-mini-diff ins {
  color: #226f5c;
  background: #dff3ec;
  text-decoration: none;
}

.report-a4-evidence-links {
  margin-top: 11px;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 6px;
}

.report-a4-evidence-links a {
  min-width: 0;
  min-height: 42px;
  padding: 7px 8px;
  display: grid;
  grid-template-columns: 48px minmax(0, 1fr) auto;
  align-items: center;
  gap: 7px;
  border: 1px solid #d7e4e0;
  color: inherit;
  background: #f7fbfa;
  text-decoration: none;
}

.report-a4-evidence-links a > span {
  color: #287c68;
  font-size: 6px;
  font-weight: 820;
}

.report-a4-evidence-links a > div {
  min-width: 0;
  display: grid;
}

.report-a4-evidence-links strong {
  overflow: hidden;
  color: #3d4f5f;
  font-size: 7px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.report-a4-evidence-links small {
  margin-top: 2px;
  color: #89959f;
  font-size: 6px;
}

.report-a4-evidence-links em {
  color: #307e6c;
  font-size: 5px;
  font-style: normal;
  font-weight: 780;
}

.report-a4-conclusion-hero {
  margin-top: 22px;
  padding: 18px;
  display: grid;
  grid-template-columns: 42px minmax(0, 1fr);
  align-items: center;
  gap: 14px;
  color: #fff;
  background: #263b4d;
}

.report-a4-conclusion-hero > i {
  width: 42px;
  height: 42px;
  display: grid;
  place-items: center;
  border-radius: 50%;
  color: #153b34;
  background: #62d0b8;
  font-size: 17px;
  font-style: normal;
  font-weight: 850;
}

.report-a4-conclusion-hero > div {
  display: grid;
}

.report-a4-conclusion-hero span {
  color: #70d5bf;
  font-size: 6px;
  font-weight: 820;
  letter-spacing: 0.1em;
}

.report-a4-conclusion-hero strong {
  margin-top: 4px;
  font-size: 12px;
}

.report-a4-conclusion-hero p {
  margin: 5px 0 0;
  color: #b9c6cf;
  font-size: 7px;
}

.report-a4-conclusion-list {
  margin-top: 18px;
  display: grid;
  gap: 8px;
}

.report-a4-conclusion-list article {
  padding: 11px 12px;
  display: grid;
  grid-template-columns: 28px minmax(0, 1fr);
  align-items: center;
  gap: 10px;
  border: 1px solid #dfe4e5;
}

.report-a4-conclusion-list article > i {
  width: 28px;
  height: 28px;
  display: grid;
  place-items: center;
  color: #347e6d;
  background: #e9f3f0;
  font-size: 7px;
  font-style: normal;
  font-weight: 780;
}

.report-a4-conclusion-list article > div {
  display: grid;
}

.report-a4-conclusion-list span {
  color: #85919b;
  font-size: 6px;
}

.report-a4-conclusion-list strong {
  margin-top: 3px;
  color: #3f4f5f;
  font-size: 8px;
}

.report-a4-approval-control {
  margin-top: 18px;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  border-top: 1px solid #ccd4d7;
  border-left: 1px solid #ccd4d7;
}

.report-a4-approval-control > div {
  min-width: 0;
  min-height: 46px;
  padding: 8px 10px;
  display: grid;
  align-content: center;
  border-right: 1px solid #ccd4d7;
  border-bottom: 1px solid #ccd4d7;
}

.report-a4-approval-control span {
  color: #87929c;
  font-size: 6px;
}

.report-a4-approval-control strong {
  margin-top: 4px;
  overflow: hidden;
  color: #344657;
  font-size: 8px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.report-a4-signoff {
  margin-top: 22px;
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  border-top: 1px solid #ccd4d7;
  border-bottom: 1px solid #ccd4d7;
}

.report-a4-signoff > div {
  min-width: 0;
  min-height: 60px;
  padding: 11px;
  display: grid;
  align-content: center;
  border-left: 1px solid #dce2e4;
}

.report-a4-signoff > div:first-child {
  border-left: 0;
}

.report-a4-signoff span {
  color: #89949e;
  font-size: 6px;
}

.report-a4-signoff strong {
  margin-top: 5px;
  overflow: hidden;
  color: #394a5a;
  font-size: 8px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.report-a4-appendix-table {
  width: 100%;
  margin-top: 20px;
  border-collapse: collapse;
}

.report-a4-appendix-table th,
.report-a4-appendix-table td {
  padding: 10px 9px;
  border-bottom: 1px solid #dfe4e6;
  color: #667480;
  font-size: 7px;
  text-align: left;
}

.report-a4-appendix-table th {
  width: 50px;
  color: #2e7f6c;
}

.report-a4-appendix-table td:nth-child(2) {
  display: grid;
}

.report-a4-appendix-table td strong {
  color: #3b4b5a;
  font-size: 8px;
}

.report-a4-appendix-table td span {
  margin-top: 2px;
  color: #8c97a1;
  font-size: 6px;
}

.report-a4-appendix-placeholder {
  margin-top: 22px;
  display: grid;
  gap: 10px;
}

.report-a4-appendix-placeholder i {
  height: 11px;
  background: linear-gradient(90deg, #e4e8ea 64%, transparent 64%);
}

.report-a4-footer {
  margin-top: auto;
  padding-top: 10px;
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  align-items: center;
  border-top: 1px solid #dce2e4;
  color: #87929c;
  font-size: 6px;
}

.report-a4-footer em {
  font-style: normal;
  letter-spacing: 0.08em;
}

.report-a4-footer strong {
  color: #526170;
  font-size: 7px;
  text-align: right;
}

/* Version comparison presents changed copy as semantic removed/added text. */
.report-compare-document {
  min-height: 0;
  overflow-y: auto;
  flex: 1;
}

.report-change-legend {
  margin-top: 16px;
  padding: 10px 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  border: 1px solid #dfe4e6;
  border-radius: 8px;
  color: #70808e;
  background: #f7f9f9;
  font-size: 9px;
}

.report-change-legend > div,
.report-change-legend em {
  display: flex;
  align-items: center;
}

.report-change-legend > div {
  gap: 12px;
}

.report-change-legend em {
  gap: 5px;
  font-style: normal;
  font-weight: 720;
}

.report-change-legend i {
  width: 16px;
  height: 16px;
  display: grid;
  place-items: center;
  border-radius: 4px;
  font-size: 9px;
  font-style: normal;
}

.report-change-legend .removed {
  color: #a34f53;
}

.report-change-legend .removed i {
  background: #fde9e8;
}

.report-change-legend .added {
  color: #24725e;
}

.report-change-legend .added i {
  background: #dff4ed;
}

.report-change-list article.changed {
  border-color: #d5e4e0;
}

.report-change-field {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
}

.report-change-field > span {
  color: #5e6e7e;
  font-size: 9px;
  font-weight: 760;
}

.report-change-field > em {
  color: #929da6;
  font-size: 7px;
  font-style: normal;
  font-weight: 780;
  letter-spacing: 0.06em;
}

.report-change-list article.changed .report-change-field > em {
  color: #2f846e;
}

.report-text-diff {
  margin-top: 9px;
  display: grid;
  gap: 5px;
}

.report-diff-row {
  min-height: 36px;
  padding: 7px 9px;
  display: grid;
  grid-template-columns: 18px minmax(0, 1fr) auto;
  align-items: center;
  gap: 8px;
  border: 1px solid transparent;
  border-radius: 7px;
}

.report-diff-row b {
  width: 18px;
  height: 18px;
  display: grid;
  place-items: center;
  border-radius: 4px;
  font-size: 10px;
}

.report-diff-row del,
.report-diff-row ins,
.report-diff-row > span {
  width: fit-content;
  padding: 2px 4px;
  border-radius: 3px;
  font-size: 10px;
  font-weight: 680;
  line-height: 1.45;
  text-decoration-thickness: 1px;
}

.report-diff-row small {
  color: #87939f;
  font-size: 7px;
  font-weight: 720;
}

.report-diff-row.removed {
  border-color: #f0d5d4;
  background: #fff8f7;
}

.report-diff-row.removed b,
.report-diff-row.removed del {
  color: #a54349;
  background: #fde5e4;
}

.report-diff-row.removed del {
  text-decoration-color: #c35b61;
}

.report-diff-row.added {
  border-color: #cbe5dd;
  background: #f4fbf8;
}

.report-diff-row.added b,
.report-diff-row.added ins {
  color: #1f705c;
  background: #daf2ea;
}

.report-diff-row.added ins {
  text-decoration: none;
}

.report-diff-row.unchanged {
  border-color: #e1e6e8;
  color: #667584;
  background: #f7f9f9;
}

.report-diff-row.unchanged b {
  color: #778593;
  background: #e8ecee;
}

/* Final export review */
.report-confirm-document {
  min-height: 0;
  padding: 18px;
  flex: 1;
  overflow: hidden;
  display: grid;
  grid-template-columns: minmax(0, 1fr) 244px;
  gap: 14px;
  background: #e6eaec;
}

.report-confirm-preview {
  min-height: 0;
  padding: 22px;
  overflow: auto;
  display: grid;
  align-content: start;
  justify-items: center;
  background: #d9dfe1;
  scrollbar-gutter: stable;
  scroll-snap-type: y proximity;
}

.report-confirm-page-stack {
  width: 100%;
  display: grid;
  justify-items: center;
  gap: 24px;
}

.report-confirm-page-item {
  width: min(560px, 100%);
  display: grid;
  gap: 8px;
  scroll-snap-align: start;
}

.report-confirm-page-index {
  min-height: 30px;
  padding: 0 10px;
  display: grid;
  grid-template-columns: auto minmax(0, 1fr) auto;
  align-items: center;
  gap: 10px;
  border-radius: 7px;
  color: #657382;
  background: rgba(255, 255, 255, 0.82);
  box-shadow: 0 2px 7px rgba(30, 43, 56, 0.08);
}

.report-confirm-page-index span {
  color: #287c68;
  font-size: 7px;
  font-weight: 820;
  letter-spacing: 0.08em;
}

.report-confirm-page-index strong {
  overflow: hidden;
  font-size: 9px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.report-confirm-page-index em {
  color: #84909b;
  font-size: 8px;
  font-style: normal;
  font-weight: 740;
}

.report-a4-confirm-page {
  width: 100%;
  min-height: 792px;
  padding: 34px 38px 30px;
}

.report-confirm-panel {
  min-height: 0;
  padding: 20px;
  overflow-y: auto;
  border: 1px solid #d5dcdf;
  border-radius: 10px;
  background: #fff;
}

.report-confirm-panel > span {
  color: #29816c;
  font-size: 8px;
  font-weight: 820;
  letter-spacing: 0.1em;
}

.report-confirm-panel h3 {
  margin: 7px 0 0;
  color: #2f4051;
  font-size: 16px;
}

.report-confirm-panel > p {
  margin: 7px 0 0;
  color: #7d8995;
  font-size: 9px;
  line-height: 1.55;
}

.report-confirm-panel dl {
  margin: 18px 0 0;
  border-top: 1px solid #e0e5e7;
}

.report-confirm-panel dl > div {
  min-height: 44px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  border-bottom: 1px solid #e6eaeb;
}

.report-confirm-panel dt {
  color: #87929d;
  font-size: 9px;
}

.report-confirm-panel dd {
  margin: 0;
  color: #405163;
  font-size: 10px;
  font-weight: 740;
  text-align: right;
}

.report-confirm-format {
  margin-top: 18px;
  display: grid;
  gap: 6px;
}

.report-confirm-format > span {
  color: #778592;
  font-size: 9px;
  font-weight: 720;
}

.report-confirm-format select {
  width: 100%;
  height: 42px;
  padding: 0 13px;
  border: 1px solid #cfd8db;
  border-radius: 8px;
  color: #3d5061;
  background: #fff;
  font-size: 10px;
  font-weight: 720;
}

.report-confirm-checklist {
  margin-top: 18px;
  padding: 13px;
  display: grid;
  gap: 9px;
  border: 1px solid #cfe4de;
  border-radius: 8px;
  background: #f1f8f6;
}

.report-confirm-checklist span {
  display: flex;
  align-items: center;
  gap: 7px;
  color: #557069;
  font-size: 9px;
}

.report-confirm-checklist i {
  width: 16px;
  height: 16px;
  display: grid;
  place-items: center;
  border-radius: 50%;
  color: #fff;
  background: #3c9a82;
  font-size: 7px;
  font-style: normal;
}

.settings-layout {
  display: grid;
  grid-template-columns: 184px minmax(0, 1fr);
  align-items: start;
  gap: var(--platform-card-gap);
}

.settings-layout .settings-nav,
.settings-layout .settings-content {
  border-radius: 12px;
  box-shadow: 0 5px 16px rgba(32, 43, 56, 0.03);
}

.settings-nav {
  position: sticky;
  top: 12px;
  height: max-content;
  padding: 10px;
}

.settings-nav > strong {
  padding: 6px 8px 9px;
  display: block;
  color: #8994a2;
  font-size: 8px;
  letter-spacing: 0.1em;
}

.settings-nav button {
  width: 100%;
  min-height: 46px;
  margin-top: 3px;
  padding: 7px 9px;
  display: grid;
  align-content: center;
  gap: 3px;
  border: 0;
  border-radius: 7px;
  color: #667487;
  text-align: left;
  background: transparent;
}

.settings-nav button span {
  font-size: 10px;
  font-weight: 720;
}

.settings-nav button small {
  color: #9aa4b0;
  font-size: 8px;
  font-weight: 520;
}

.settings-nav button.active {
  color: #277966;
  background: #eaf6f2;
}

.settings-nav button.active small {
  color: #65a091;
}

.settings-nav-note {
  margin-top: 12px;
  padding: 10px 9px;
  display: grid;
  gap: 5px;
  border-top: 1px solid #e6ebed;
}

.settings-nav-note strong {
  color: #46566a;
  font-size: 9px;
}

.settings-nav-note span {
  color: #8b97a5;
  font-size: 8px;
  line-height: 1.55;
}

.settings-content {
  min-width: 0;
  padding: 16px;
}

.settings-demo-notice {
  min-height: 66px;
  margin-bottom: var(--platform-card-gap);
  padding: 12px 14px;
  display: grid;
  grid-template-columns: 42px minmax(0, 1fr) auto;
  align-items: center;
  gap: 12px;
  border: 1px solid #cbe7df;
  border-radius: 11px;
  background: #f0faf7;
}

.settings-demo-icon {
  width: 42px;
  height: 42px;
  display: grid;
  place-items: center;
  border-radius: 10px;
  color: #fff;
  background: #2d9c83;
  font-size: 8px;
  font-weight: 820;
  letter-spacing: 0.05em;
}

.settings-demo-notice > div:nth-child(2) {
  display: grid;
  gap: 3px;
}

.settings-demo-notice strong {
  color: #28584f;
  font-size: 11px;
}

.settings-demo-notice span {
  color: #628079;
  font-size: 9px;
  line-height: 1.5;
}

.settings-demo-notice em {
  padding: 5px 8px;
  border: 1px solid #bbded5;
  border-radius: 999px;
  color: #37806f;
  background: rgba(255, 255, 255, 0.7);
  font-size: 8px;
  font-style: normal;
  font-weight: 750;
  white-space: nowrap;
}

.settings-head {
  padding-bottom: 12px;
  border-bottom: 1px solid #e4e9ec;
}

.settings-head-enhanced {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}

.settings-head-enhanced > div:first-child {
  min-width: 0;
}

.settings-head h2,
.settings-head-enhanced h2 {
  margin: 3px 0 0;
  color: #2f3e53;
  font-size: 17px;
}

.settings-head p,
.settings-head-enhanced p {
  margin: 4px 0 0;
  color: #7b8797;
  font-size: 9px;
  line-height: 1.5;
}

.setting-save-state {
  min-width: 180px;
  padding: 8px 10px;
  display: flex;
  align-items: center;
  gap: 8px;
  border: 1px solid #d7e8e3;
  border-radius: 8px;
  background: #f7fbfa;
}

.setting-save-state > i {
  width: 9px;
  height: 9px;
  flex: 0 0 auto;
  border: 2px solid #fff;
  border-radius: 50%;
  background: #35ae92;
  box-shadow: 0 0 0 2px #bde4da;
}

.setting-save-state.saving > i {
  background: #e6a83f;
  box-shadow: 0 0 0 2px #f2dfb9;
}

.setting-save-state > div {
  display: grid;
  gap: 2px;
}

.setting-save-state strong {
  color: #3e5c55;
  font-size: 9px;
}

.setting-save-state span {
  color: #82928e;
  font-size: 8px;
}

.settings-scope-panel {
  margin-top: 12px;
  padding: 10px;
  display: grid;
  grid-template-columns: minmax(210px, 0.7fr) minmax(420px, 1.3fr);
  align-items: center;
  gap: 12px;
  border: 1px solid #dfe6e8;
  border-radius: 10px;
  background: #f9fafb;
}

.scope-panel-copy {
  display: grid;
  gap: 3px;
}

.scope-panel-copy > span,
.project-scope-picker > div > span,
.setting-group-title span {
  color: #24917a;
  font-size: 8px;
  font-weight: 800;
  letter-spacing: 0.1em;
}

.scope-panel-copy strong {
  color: #3d4c61;
  font-size: 11px;
}

.scope-panel-copy p {
  margin: 0;
  color: #8793a1;
  font-size: 8px;
  line-height: 1.45;
}

.scope-tabs {
  padding: 3px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 3px;
  border: 1px solid #dce4e7;
  border-radius: 8px;
  background: #fff;
}

.scope-tabs button {
  min-height: 42px;
  padding: 6px 10px;
  display: grid;
  gap: 3px;
  border: 1px solid transparent;
  border-radius: 6px;
  color: #667487;
  text-align: left;
  background: transparent;
}

.scope-tabs button strong {
  font-size: 10px;
}

.scope-tabs button span {
  color: #939daa;
  font-size: 8px;
}

.scope-tabs button.active {
  border-color: #bfe0d7;
  color: #246f5f;
  background: #eaf6f2;
  box-shadow: none;
}

.scope-tabs button.active span {
  color: #5e9488;
}

.project-scope-picker,
.global-scope-summary {
  min-height: 54px;
  margin-top: 7px;
  padding: 9px 11px;
  border: 1px solid #dce5e7;
  border-radius: 8px;
  background: #f7faf9;
}

.project-scope-picker {
  display: grid;
  grid-template-columns: minmax(250px, 1fr) 250px auto;
  align-items: center;
  gap: 10px;
}

.project-scope-picker > div {
  display: grid;
  gap: 3px;
}

.project-scope-picker > div > strong {
  color: #3d4c61;
  font-size: 11px;
}

.project-scope-picker p {
  margin: 0;
  color: #84919f;
  font-size: 8px;
}

.project-scope-picker label {
  display: grid;
  gap: 4px;
}

.project-scope-picker label span,
.audit-toolbar label span {
  color: #7c8998;
  font-size: 8px;
  font-weight: 680;
}

.project-scope-picker select,
.audit-toolbar select {
  height: 32px;
  padding: 0 30px 0 10px;
  border: 1px solid #d6e0e2;
  border-radius: 7px;
  color: #435267;
  background: #fff;
  font-size: 9px;
  outline: 0;
}

.project-scope-picker em {
  padding: 5px 7px;
  border-radius: 6px;
  color: #397666;
  background: #e6f4f0;
  font-size: 8px;
  font-style: normal;
  font-weight: 730;
  white-space: nowrap;
}

.global-scope-summary {
  display: flex;
  align-items: center;
  gap: 12px;
}

.global-scope-summary strong {
  color: #3e6259;
  font-size: 10px;
  white-space: nowrap;
}

.global-scope-summary span {
  padding-left: 12px;
  border-left: 1px solid #d8e5e1;
  color: #7f8e99;
  font-size: 9px;
}

.setting-group {
  margin-top: 16px;
}

.setting-group-title {
  min-height: 32px;
  padding: 0 2px 7px;
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  border-bottom: 1px solid #dfe5e8;
}

.setting-group-title > div {
  display: grid;
  gap: 3px;
}

.setting-group-title h3 {
  margin: 0;
  color: #455367;
  font-size: 12px;
}

.setting-group-title > em {
  color: #99a3ae;
  font-size: 8px;
  font-style: normal;
  letter-spacing: 0.08em;
}

.setting-card {
  min-height: 118px;
  margin-top: 7px;
  padding: 11px 11px 10px 13px;
  display: grid;
  grid-template-columns: minmax(0, 1fr) 136px;
  align-items: stretch;
  gap: 12px;
  border: 1px solid #dfe5e8;
  border-left: 3px solid transparent;
  border-radius: 10px;
  background: #fff;
  box-shadow: 0 3px 10px rgba(32, 43, 56, 0.025);
}

.setting-card.high-risk {
  border-color: #e4dfd5;
  border-left-color: #cfb98d;
  background: #fff;
}

.setting-card.off:not(.high-risk) {
  background: #fbfcfc;
}

.setting-card-main {
  min-width: 0;
}

.setting-title-row {
  display: flex;
  align-items: center;
  gap: 7px;
}

.setting-title-row > strong {
  color: #36465d;
  font-size: 11px;
}

.setting-title-row > em {
  padding: 3px 6px;
  border-radius: 5px;
  color: #68788b;
  background: #eef2f4;
  font-size: 7px;
  font-style: normal;
  font-weight: 730;
}

.setting-title-row > em.high {
  color: #88734e;
  background: #f4f0e8;
}

.setting-card-main > p {
  margin: 4px 0 0;
  color: #7a8797;
  font-size: 10px;
  line-height: 1.4;
}

.setting-system-impact {
  max-width: none;
  margin-top: 5px;
  display: flex;
  align-items: center;
  gap: 6px;
}

.setting-system-impact span {
  flex: 0 0 auto;
  padding: 3px 6px;
  border-radius: 5px;
  color: #73827f;
  background: #f0f3f3;
  font-size: 7px;
  font-weight: 770;
}

.setting-system-impact strong {
  flex: 1 1 auto;
  overflow: hidden;
  color: #5f6f80;
  font-size: 8px;
  font-weight: 620;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.setting-system-impact em {
  flex: 0 0 auto;
  padding-left: 8px;
  border-left: 1px solid #dde4e5;
  color: #87939f;
  font-size: 7px;
  font-style: normal;
  white-space: nowrap;
}

.setting-impact-grid {
  max-width: none;
  margin-top: 7px;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  grid-auto-rows: 38px;
  gap: 6px;
}

.setting-impact-grid > div {
  min-width: 0;
  padding: 6px 8px;
  display: grid;
  gap: 3px;
  border: 1px solid #e1e7e9;
  border-radius: 6px;
  background: rgba(248, 250, 251, 0.9);
}

.setting-impact-grid span {
  color: #929daa;
  font-size: 7px;
  font-weight: 750;
  letter-spacing: 0.06em;
}

.setting-impact-grid strong {
  overflow: hidden;
  color: #526174;
  font-size: 8px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.setting-risk-summary {
  margin-top: 5px;
  display: flex;
  align-items: flex-start;
  gap: 6px;
  color: #95866c;
  font-size: 7px;
  line-height: 1.35;
}

.setting-risk-summary i {
  width: 13px;
  height: 13px;
  display: grid;
  flex: 0 0 auto;
  place-items: center;
  border-radius: 50%;
  color: #fff;
  background: #bca779;
  font-size: 7px;
  font-style: normal;
  font-weight: 800;
}

.setting-disabled-help {
  max-width: none;
  margin-top: 6px;
  padding: 7px 9px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 9px;
  border: 1px solid #d8e1e5;
  border-radius: 7px;
  background: #f7f8f8;
}

.setting-disabled-help > div {
  display: grid;
  gap: 2px;
}

.setting-disabled-help strong {
  color: #58687b;
  font-size: 8px;
}

.setting-disabled-help span {
  color: #8995a2;
  font-size: 8px;
  line-height: 1.4;
}

.setting-disabled-help button {
  padding: 4px 6px;
  border: 0;
  color: #267966;
  background: transparent;
  font-size: 8px;
  font-weight: 750;
  white-space: nowrap;
}

.setting-control {
  width: 136px;
  padding-left: 12px;
  display: flex;
  align-items: flex-end;
  flex-direction: column;
  justify-content: flex-start;
  border-left: 1px solid #e4e9eb;
}

.setting-control > span {
  color: #97a2ae;
  font-size: 7px;
  font-weight: 730;
  letter-spacing: 0.05em;
}

.setting-control > strong {
  width: 116px;
  margin-top: 3px;
  overflow: hidden;
  color: #5e6d7f;
  font-size: 8px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.setting-control > small {
  margin-top: 5px;
  color: #9aa4ae;
  font-size: 7px;
}

.setting-toggle {
  width: 58px;
  height: 28px;
  margin-top: 7px;
  padding: 0 6px;
  display: flex;
  align-items: center;
  gap: 6px;
  border: 0;
  border-radius: 999px;
  color: #7c8999;
  background: #e7ebee;
}

.setting-toggle i {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: #fff;
  box-shadow: 0 2px 6px rgba(36, 48, 63, 0.14);
}

.setting-toggle span {
  margin: 0;
  font-size: 7px;
  font-weight: 780;
}

.setting-toggle.on {
  flex-direction: row-reverse;
  color: #fff;
  background: #35ae92;
}

.audit-back-button {
  min-height: 32px;
  padding: 0 10px;
  border: 1px solid #d7e1e3;
  border-radius: 7px;
  color: #4f6073;
  background: #fff;
  font-size: 8px;
  font-weight: 710;
}

.audit-overview {
  margin-top: 12px;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 7px;
}

.audit-overview article {
  min-height: 64px;
  padding: 10px 12px;
  display: grid;
  grid-template-columns: 1fr auto;
  align-content: center;
  gap: 2px 10px;
  border: 1px solid #dfe6e8;
  border-radius: 9px;
  background: #f9fbfb;
}

.audit-overview span {
  color: #718093;
  font-size: 9px;
  font-weight: 680;
}

.audit-overview strong {
  grid-row: 1/3;
  grid-column: 2;
  align-self: center;
  color: #2c8a74;
  font-size: 18px;
}

.audit-overview small {
  color: #9aa4af;
  font-size: 8px;
}

.audit-toolbar {
  min-height: 56px;
  margin-top: 12px;
  padding: 8px 11px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-top: 1px solid #e2e7e9;
  border-bottom: 1px solid #e2e7e9;
}

.audit-toolbar > div {
  display: grid;
  gap: 3px;
}

.audit-toolbar > div strong {
  color: #3f4e63;
  font-size: 12px;
}

.audit-toolbar > div span {
  color: #8994a2;
  font-size: 8px;
}

.audit-toolbar label {
  display: grid;
  grid-template-columns: auto 150px;
  align-items: center;
  gap: 8px;
}

.audit-log-list {
  display: grid;
}

.audit-log-entry {
  min-height: 112px;
  padding: 10px 11px;
  display: grid;
  grid-template-columns: 120px 150px minmax(0, 1fr);
  align-items: center;
  gap: 12px;
  border-bottom: 1px solid #e4e9eb;
}

.audit-log-entry.latest {
  background: linear-gradient(90deg, rgba(234, 247, 243, 0.55), transparent 50%);
}

.audit-log-time {
  display: grid;
  gap: 5px;
}

.audit-log-time span {
  color: #2b8f78;
  font-size: 7px;
  font-weight: 780;
  letter-spacing: 0.07em;
}

.audit-log-time strong {
  color: #657487;
  font-size: 9px;
}

.audit-log-actor {
  display: flex;
  align-items: center;
  gap: 9px;
}

.audit-log-actor i {
  width: 28px;
  height: 28px;
  display: grid;
  flex: 0 0 auto;
  place-items: center;
  border-radius: 50%;
  color: #fff;
  background: #315f79;
  font-size: 9px;
  font-style: normal;
  font-weight: 750;
}

.audit-log-actor > div {
  min-width: 0;
  display: grid;
  gap: 2px;
}

.audit-log-actor strong {
  color: #435267;
  font-size: 9px;
}

.audit-log-actor span {
  color: #909ba7;
  font-size: 8px;
}

.audit-log-change {
  min-width: 0;
}

.audit-log-title {
  display: flex;
  align-items: center;
  gap: 8px;
}

.audit-log-title strong {
  color: #3b4b60;
  font-size: 10px;
}

.audit-log-values {
  margin-top: 6px;
  display: flex;
  align-items: center;
  gap: 7px;
}

.audit-log-values > div {
  min-width: 76px;
  padding: 5px 8px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 9px;
  border: 1px solid #e0e6e8;
  border-radius: 6px;
  background: #f8fafb;
}

.audit-log-values > div.after {
  border-color: #cce5de;
  background: #eef8f5;
}

.audit-log-values span {
  color: #919ca8;
  font-size: 7px;
}

.audit-log-values strong {
  color: #627184;
  font-size: 9px;
}

.audit-log-values .after strong {
  color: #287966;
}

.audit-log-values > i {
  color: #a1abb5;
  font-size: 10px;
  font-style: normal;
}

.audit-log-target {
  margin-top: 5px;
  display: flex;
  align-items: center;
  gap: 6px;
}

.audit-log-target > span {
  color: #929da9;
  font-size: 7px;
}

.audit-log-target > strong {
  color: #556477;
  font-size: 8px;
}

.audit-log-target > em {
  padding: 3px 6px;
  border-radius: 5px;
  color: #497568;
  background: #edf5f2;
  font-size: 7px;
  font-style: normal;
  font-weight: 700;
}

.audit-log-impact {
  margin-top: 6px;
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
}

.audit-log-impact span {
  padding: 4px 6px;
  border: 1px solid #e1e7e9;
  border-radius: 6px;
  color: #697789;
  background: #fafbfb;
  font-size: 7px;
}

.audit-empty {
  min-height: 130px;
  display: grid;
  place-items: center;
  color: #8c98a5;
  font-size: 9px;
}

.guide-page {
  --guide-ink: #29394e;
  --guide-muted: #748296;
  --guide-line: #dce4e7;
}

.guide-hero {
  min-height: 260px;
  padding: 30px;
  display: grid;
  grid-template-columns: minmax(0, 1.4fr) minmax(320px, 0.8fr);
  gap: 32px;
  overflow: hidden;
  background: radial-gradient(circle at 96% 2%, rgba(79, 209, 197, 0.15), transparent 37%), linear-gradient(135deg, #18263a 0%, #23364c 64%, #244b50 100%);
  border-color: #21364b;
  box-shadow: 0 18px 44px rgba(27, 46, 65, 0.13);
}

.guide-hero-copy {
  align-self: center;
}

.guide-hero-copy > span {
  color: #69d6c0;
}

.guide-hero-copy h2 {
  max-width: 650px;
  margin: 9px 0 0;
  color: #f3f8fb;
  font-size: 27px;
  line-height: 1.25;
  letter-spacing: -0.035em;
}

.guide-hero-copy > p {
  max-width: 660px;
  margin: 12px 0 0;
  color: #b4c2d0;
  font-size: 13px;
  line-height: 1.7;
}

.guide-hero-actions {
  margin-top: 21px;
  display: flex;
  align-items: center;
  gap: 9px;
}

.guide-hero-actions a,
.guide-hero-actions button {
  min-height: 39px;
  padding: 0 14px;
  display: flex;
  align-items: center;
  gap: 17px;
  border: 1px solid rgba(255, 255, 255, 0.13);
  border-radius: 9px;
  color: #c4d2de;
  background: rgba(255, 255, 255, 0.055);
  font-size: 10px;
  font-weight: 730;
  text-decoration: none;
}

.guide-hero-actions a {
  border-color: #66d9c3;
  color: #15322f;
  background: #69ddc6;
}

.guide-hero-actions em {
  font-style: normal;
}

.guide-principles {
  align-self: stretch;
  padding: 6px 0 6px 25px;
  display: grid;
  align-content: center;
  gap: 0;
  border-left: 1px solid rgba(255, 255, 255, 0.11);
}

.guide-principle {
  min-height: 64px;
  display: grid;
  grid-template-columns: 31px minmax(0, 1fr);
  align-items: center;
  gap: 12px;
}

.guide-principle + .guide-principle {
  border-top: 1px solid rgba(255, 255, 255, 0.08);
}

.guide-principle > i {
  width: 29px;
  height: 29px;
  display: grid;
  place-items: center;
  border: 1px solid rgba(105, 221, 198, 0.28);
  border-radius: 9px;
  color: #69ddc6;
  background: rgba(105, 221, 198, 0.07);
  font-size: 9px;
  font-style: normal;
  font-weight: 820;
}

.guide-principle > div {
  display: grid;
}

.guide-principle strong {
  color: #edf5f8;
  font-size: 11px;
}

.guide-principle span {
  margin-top: 4px;
  color: #93a7b9;
  font-size: 9px;
}

.guide-layout {
  margin-top: 14px;
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  align-items: start;
  gap: var(--platform-card-gap);
}

.guide-toc {
  position: sticky;
  top: 0;
  z-index: 4;
  min-width: 0;
  padding: 9px 11px;
  display: flex;
  align-items: center;
  gap: 4px;
  overflow-x: auto;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.96);
  backdrop-filter: blur(14px);
}

.guide-toc > span {
  display: none;
}

.guide-toc > strong {
  margin: 0 9px 0 3px;
  display: inline-flex;
  flex: 0 0 auto;
  color: var(--guide-ink);
  font-size: 13px;
  white-space: nowrap;
}

.guide-toc > button {
  width: auto;
  min-width: 116px;
  min-height: 41px;
  padding: 0 10px;
  display: flex;
  flex: 0 0 auto;
  align-items: center;
  gap: 9px;
  border: 0;
  border-radius: 8px;
  color: #6e7b8d;
  text-align: left;
  background: transparent;
  font-size: 11px;
  font-weight: 670;
}

.guide-toc > button:hover {
  color: #277b68;
  background: #eff8f5;
}

.guide-toc > button i {
  color: #a0aab6;
  font-size: 9px;
  font-style: normal;
  font-weight: 800;
}

.guide-toc-tip {
  display: none;
}

.guide-toc-tip strong {
  color: #435368;
  font-size: 9px;
}

.guide-toc-tip span {
  margin-top: 4px;
  color: #84909e;
  font-size: 8px;
  line-height: 1.5;
}

.guide-toc-tip a {
  margin-top: 9px;
  color: #267c68;
  font-size: 8px;
  font-weight: 750;
  text-decoration: none;
}

.guide-main {
  min-width: 0;
  display: grid;
  gap: 14px;
}

.guide-section {
  padding: 31px;
  scroll-margin-top: 14px;
}

.guide-section-title {
  display: grid;
  grid-template-columns: 38px minmax(0, 1fr);
  gap: 13px;
}

.guide-section-title > i {
  width: 38px;
  height: 38px;
  display: grid;
  place-items: center;
  border-radius: 11px;
  color: #267e6a;
  background: #e8f5f1;
  font-size: 9px;
  font-style: normal;
  font-weight: 830;
}

.guide-section-title h2 {
  margin: 4px 0 0;
  color: var(--guide-ink);
  font-size: 24px;
  letter-spacing: -0.02em;
}

.guide-section-title p {
  margin: 6px 0 0;
  color: var(--guide-muted);
  font-size: 12px;
  line-height: 1.55;
}

.guide-check-grid {
  margin-top: 22px;
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 10px;
}

.guide-check-grid article {
  min-height: 190px;
  padding: 17px;
  display: flex;
  flex-direction: column;
  border: 1px solid #e0e6e9;
  border-radius: 12px;
  background: #fafbfb;
}

.guide-card-icon {
  width: 37px;
  height: 37px;
  display: grid;
  place-items: center;
  border-radius: 10px;
  color: #4874b6;
  background: #eaf0fa;
}

.guide-card-icon.input {
  color: #33836f;
  background: #e8f5f1;
}

.guide-card-icon.gate {
  color: #94672d;
  background: #f8eedc;
}

.guide-card-icon svg {
  width: 19px;
  height: 19px;
}

.guide-check-grid article > strong {
  margin-top: 13px;
  color: #3b4b61;
  font-size: 11px;
}

.guide-check-grid article > p {
  margin: 6px 0 0;
  color: #7d8998;
  font-size: 9px;
  line-height: 1.55;
}

.guide-check-grid article > a {
  margin-top: auto;
  padding-top: 15px;
  color: #287d69;
  font-size: 9px;
  font-weight: 720;
  text-decoration: none;
}

.guide-flow-visual {
  margin: 22px 0 0;
  overflow: hidden;
  border: 1px solid #dce4e7;
  border-radius: 15px;
  background: #f8fafb;
}

.guide-flow-visual-head {
  min-height: 72px;
  padding: 14px 17px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  border-bottom: 1px solid #e1e7ea;
  background: #fff;
}

.guide-flow-visual-head > div:first-child {
  display: grid;
}

.guide-flow-visual-head > div:first-child > span {
  color: #29917b;
  font-size: 7px;
  font-weight: 830;
  letter-spacing: 0.11em;
}

.guide-flow-visual-head > div:first-child > strong {
  margin-top: 4px;
  color: #35465b;
  font-size: 13px;
}

.guide-flow-visual-head > div:first-child > p {
  margin: 3px 0 0;
  color: #8793a1;
  font-size: 8px;
}

.guide-flow-legend {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 8px 12px;
}

.guide-flow-legend > span {
  display: flex;
  align-items: center;
  gap: 5px;
  color: #778597;
  font-size: 7px;
  font-weight: 680;
}

.guide-flow-legend i {
  width: 8px;
  height: 8px;
  border-radius: 3px;
  background: #5da892;
}

.guide-flow-legend .agent i {
  background: #668dcc;
}

.guide-flow-legend .feedback i {
  background: #d08a42;
}

.guide-flow-legend .record i {
  background: #98a7b5;
}

.guide-flow-canvas {
  width: 100%;
  overflow-x: auto;
  background: linear-gradient(rgba(80, 102, 124, 0.022) 1px, transparent 1px), linear-gradient(90deg, rgba(80, 102, 124, 0.022) 1px, transparent 1px), #f8fafb;
  background-size: 18px 18px;
}

.guide-flow-canvas svg {
  width: 100%;
  min-width: 820px;
  height: auto;
  display: block;
}

.flow-lane {
  stroke-width: 1;
}

.flow-lane.human {
  fill: rgba(70, 156, 131, 0.055);
  stroke: rgba(70, 156, 131, 0.18);
}

.flow-lane.agent {
  fill: rgba(82, 126, 190, 0.05);
  stroke: rgba(82, 126, 190, 0.16);
}

.flow-lane.record {
  fill: rgba(119, 136, 153, 0.05);
  stroke: rgba(119, 136, 153, 0.16);
}

.flow-lane-label circle {
  fill: #e3f2ee;
  stroke: #b7d8cf;
}

.flow-lane-label.agent circle {
  fill: #e8eef8;
  stroke: #c1d0e7;
}

.flow-lane-label.record circle {
  fill: #edf1f4;
  stroke: #d2dbe2;
}

.flow-lane-symbol,
.flow-lane-name,
.flow-lane-caption,
.flow-node-step,
.flow-node-title,
.flow-node-caption,
.flow-feedback-label,
.flow-record-symbol,
.flow-record-title,
.flow-record-caption {
  font-family: SUIT, sans-serif;
}

.flow-lane-symbol {
  fill: #2f836f;
  font-size: 10px;
  font-weight: 820;
  text-anchor: middle;
}

.flow-lane-label.agent .flow-lane-symbol {
  fill: #5279b5;
}

.flow-lane-label.record .flow-lane-symbol {
  fill: #748596;
}

.flow-lane-name {
  fill: #4e5e70;
  font-size: 9px;
  font-weight: 800;
  text-anchor: middle;
}

.flow-lane-caption {
  fill: #9aa5b0;
  font-size: 7px;
  text-anchor: middle;
}

.flow-connector,
.flow-feedback-connector,
.flow-record-connector {
  fill: none;
  stroke-linecap: round;
  stroke-linejoin: round;
}

.flow-connector {
  stroke: #6d9f96;
  stroke-width: 1.6;
}

.flow-feedback-connector {
  stroke: #d08a42;
  stroke-width: 1.5;
  stroke-dasharray: 5 5;
}

.flow-record-connector {
  stroke: #98a7b5;
  stroke-width: 1.1;
  stroke-dasharray: 3 5;
  opacity: 0.7;
}

.flow-feedback-label {
  fill: #b16f2f;
  font-size: 8px;
  font-weight: 760;
  text-anchor: middle;
}

.flow-node rect {
  fill: #fff;
  stroke: #cbd7d7;
  stroke-width: 1.2;
  filter: drop-shadow(0 4px 8px rgba(41, 57, 73, 0.055));
}

.flow-node.agent rect {
  fill: #f7faff;
  stroke: #b9cbe5;
}

.flow-node.gate rect {
  fill: #eff9f6;
  stroke: #8fc7b8;
  stroke-width: 1.5;
}

.flow-node-step {
  fill: #438b79;
  font-size: 7px;
  font-weight: 830;
  letter-spacing: 0.04em;
}

.flow-node.agent .flow-node-step {
  fill: #5b7fb4;
}

.flow-node.gate .flow-node-step {
  fill: #26816b;
}

.flow-node-title {
  fill: #34465b;
  font-size: 10px;
  font-weight: 780;
}

.flow-node-caption {
  fill: #8592a1;
  font-size: 7px;
}

.flow-record-node rect {
  fill: #fff;
  stroke: #d4dde3;
  stroke-width: 1;
}

.flow-record-node circle {
  fill: #e9eef2;
}

.flow-record-symbol {
  fill: #66798b;
  font-size: 8px;
  font-weight: 820;
  text-anchor: middle;
}

.flow-record-title {
  fill: #46576a;
  font-size: 9px;
  font-weight: 760;
}

.flow-record-caption {
  fill: #8794a1;
  font-size: 7px;
}

.guide-flow-caption {
  min-height: 60px;
  padding: 12px 16px;
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 13px;
  border-top: 1px solid #e1e7ea;
  background: #fff;
}

.guide-flow-caption > div {
  display: grid;
  grid-template-columns: 21px minmax(0, 1fr);
  align-items: center;
  gap: 8px;
}

.guide-flow-caption i {
  width: 21px;
  height: 21px;
  display: grid;
  place-items: center;
  border-radius: 7px;
  color: #2f816e;
  background: #e6f3ef;
  font-size: 7px;
  font-style: normal;
  font-weight: 820;
}

.guide-flow-caption span {
  color: #7a8796;
  font-size: 8px;
  line-height: 1.5;
}

.guide-flow-caption strong {
  color: #42566c;
}

.guide-flow-detail-label {
  margin-top: 22px;
  display: flex;
  align-items: center;
  gap: 9px;
}

.guide-flow-detail-label span {
  padding: 5px 7px;
  border-radius: 6px;
  color: #317f6d;
  background: #e8f4f1;
  font-size: 7px;
  font-weight: 820;
  letter-spacing: 0.08em;
}

.guide-flow-detail-label strong {
  color: #516174;
  font-size: 10px;
}

.guide-flow {
  margin-top: 10px;
  display: grid;
  grid-template-columns: repeat(4, minmax(130px, 1fr) 13px) minmax(130px, 1fr);
  align-items: stretch;
  gap: 5px;
}

.guide-flow > i {
  align-self: center;
  color: #aeb9c3;
  font-size: 10px;
  font-style: normal;
  text-align: center;
}

.guide-flow-step {
  min-height: 185px;
  padding: 14px;
  display: flex;
  flex-direction: column;
  border: 1px solid #dfe6e9;
  border-radius: 11px;
  background: #fafcfc;
}

.guide-flow-step > em {
  width: 28px;
  height: 28px;
  display: grid;
  place-items: center;
  border-radius: 8px;
  color: #2a7f6d;
  background: #e6f4f0;
  font-size: 8px;
  font-style: normal;
  font-weight: 820;
}

.guide-flow-step > div {
  margin-top: 12px;
  display: grid;
}

.guide-flow-step > div span {
  color: #39927e;
  font-size: 7px;
  font-weight: 830;
  letter-spacing: 0.1em;
}

.guide-flow-step > div strong {
  margin-top: 5px;
  color: #39495f;
  font-size: 10px;
}

.guide-flow-step > div p {
  margin: 6px 0 0;
  color: #7b8796;
  font-size: 8px;
  line-height: 1.55;
}

.guide-flow-step > small {
  margin-top: auto;
  padding-top: 12px;
  color: #94a0ad;
  font-size: 7px;
}

.guide-flow-note {
  min-height: 68px;
  margin-top: 12px;
  padding: 12px 15px;
  display: grid;
  grid-template-columns: 30px minmax(0, 1fr);
  align-items: center;
  gap: 11px;
  border: 1px solid #d8e6e2;
  border-radius: 11px;
  background: #f2f9f7;
}

.guide-flow-note > i {
  width: 29px;
  height: 29px;
  display: grid;
  place-items: center;
  border-radius: 50%;
  color: #fff;
  background: #368d78;
  font-size: 10px;
  font-style: normal;
  font-weight: 820;
}

.guide-flow-note > div {
  display: grid;
}

.guide-flow-note strong {
  color: #3c5d55;
  font-size: 10px;
}

.guide-flow-note span {
  margin-top: 4px;
  color: #718e87;
  font-size: 9px;
  line-height: 1.5;
}

.guide-action-map {
  margin-top: 22px;
  overflow: hidden;
  border: 1px solid #dfe5e8;
  border-radius: 12px;
}

.guide-action-head,
.guide-action-row {
  display: grid;
  grid-template-columns: 1.05fr 1.55fr 1.45fr 1.1fr;
  gap: 13px;
}

.guide-action-head {
  min-height: 42px;
  padding: 0 15px;
  align-items: center;
  color: #708093;
  background: #f3f6f7;
  font-size: 8px;
  font-weight: 800;
  letter-spacing: 0.04em;
}

.guide-action-row {
  min-height: 78px;
  padding: 14px 15px;
  align-items: start;
  border-top: 1px solid #e6eaed;
  background: #fff;
}

.guide-action-row > strong {
  color: #3e4e63;
  font-size: 9px;
  line-height: 1.5;
}

.guide-action-row > p {
  margin: 0;
  color: #768496;
  font-size: 8px;
  line-height: 1.55;
}

.guide-action-row > a,
.guide-location-links a {
  color: #287d69;
  font-size: 8px;
  font-weight: 720;
  line-height: 1.45;
  text-decoration: none;
}

.guide-location-links {
  display: grid;
  gap: 5px;
}

.guide-menu-browser {
  margin-top: 22px;
  overflow: hidden;
  border: 1px solid #dce4e7;
  border-radius: 14px;
  background: #fff;
}

.guide-menu-browser-head {
  min-height: 92px;
  padding: 20px 22px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  border-bottom: 1px solid #e1e7ea;
  background: linear-gradient(100deg, #f6faf9, #fff);
}

.guide-menu-browser-head > div:first-child {
  display: grid;
}

.guide-menu-browser-head > div:first-child > span {
  color: #2f9079;
  font-size: 9px;
  font-weight: 830;
  letter-spacing: 0.11em;
}

.guide-menu-browser-head > div:first-child > strong {
  margin-top: 4px;
  color: #38495e;
  font-size: 16px;
}

.guide-menu-browser-head > div:first-child > p {
  margin: 4px 0 0;
  color: #83909f;
  font-size: 11px;
}

.guide-menu-count {
  min-width: 62px;
  height: 52px;
  padding: 0 10px;
  display: grid;
  place-content: center;
  border: 1px solid #d4e7e1;
  border-radius: 10px;
  text-align: center;
  background: #edf7f4;
}

.guide-menu-count strong {
  color: #287e69;
  font-size: 20px;
  line-height: 1;
}

.guide-menu-count span {
  margin-top: 3px;
  color: #7a9a92;
  font-size: 8px;
  font-weight: 820;
  letter-spacing: 0.08em;
}

.guide-menu-browser-body {
  display: grid;
  grid-template-columns: 258px minmax(0, 1fr);
  align-items: stretch;
}

.guide-menu-index {
  padding: 18px 14px;
  border-right: 1px solid #e1e7ea;
  background: #f6f8f9;
}

.guide-menu-index-group + .guide-menu-index-group {
  margin-top: 16px;
}

.guide-menu-group-label {
  min-height: 29px;
  padding: 0 7px 6px;
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 8px;
}

.guide-menu-group-label span {
  color: #94a0ad;
  font-size: 8px;
  font-weight: 820;
  letter-spacing: 0.08em;
}

.guide-menu-group-label strong {
  color: #68788a;
  font-size: 10px;
}

.guide-menu-index-group > button {
  width: 100%;
  min-height: 56px;
  margin-top: 4px;
  padding: 8px 10px;
  display: grid;
  grid-template-columns: 38px minmax(0, 1fr) 14px;
  align-items: center;
  gap: 8px;
  border: 1px solid transparent;
  border-radius: 9px;
  color: #778596;
  text-align: left;
  background: transparent;
  transition: color 0.15s, border-color 0.15s, background 0.15s, transform 0.15s;
}

.guide-menu-index-group > button:hover {
  color: #3f5367;
  background: #fff;
  transform: translateX(1px);
}

.guide-menu-index-group > button.active {
  border-color: #b9dcd3;
  color: #294f4a;
  background: #fff;
  box-shadow: 0 7px 16px rgba(38, 83, 73, 0.06);
}

.guide-menu-index-group > button > i {
  width: 38px;
  height: 38px;
  display: grid;
  place-items: center;
  border-radius: 8px;
  color: #617d9c;
  background: #e8edf3;
  font-size: 9px;
  font-style: normal;
  font-weight: 830;
}

.guide-menu-index-group > button.active > i {
  color: #226f5d;
  background: #dff1ec;
}

.guide-menu-index-group > button > div {
  min-width: 0;
  display: grid;
}

.guide-menu-index-group > button strong,
.guide-menu-index-group > button span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.guide-menu-index-group > button strong {
  color: inherit;
  font-size: 12px;
}

.guide-menu-index-group > button span {
  margin-top: 3px;
  color: #98a3ae;
  font-size: 9px;
}

.guide-menu-index-group > button em {
  color: #9ba7b2;
  font-size: 11px;
  font-style: normal;
}

.guide-menu-index-group > button.active em {
  color: #38907b;
}

.guide-menu-detail {
  min-width: 0;
  min-height: 650px;
  padding: 30px;
  animation: section-enter 0.18s cubic-bezier(0.2, 0.75, 0.35, 1);
}

.guide-menu-detail-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 20px;
}

.guide-menu-detail-identity {
  min-width: 0;
  display: grid;
  grid-template-columns: 58px minmax(0, 1fr);
  gap: 16px;
}

.guide-menu-detail-identity > i {
  width: 58px;
  height: 58px;
  display: grid;
  place-items: center;
  border-radius: 13px;
  color: #1f6657;
  background: linear-gradient(145deg, #d8eee8, #eaf6f3);
  box-shadow: 0 8px 20px rgba(41, 101, 87, 0.09);
  font-size: 12px;
  font-style: normal;
  font-weight: 840;
}

.guide-menu-detail-identity > div {
  min-width: 0;
}

.guide-menu-detail-identity span,
.guide-menu-subtitle span,
.guide-menu-outcome > span,
.guide-menu-next span {
  color: #319079;
  font-size: 9px;
  font-weight: 830;
  letter-spacing: 0.08em;
}

.guide-menu-detail-identity h3 {
  margin: 4px 0 0;
  color: #2e4056;
  font-size: 26px;
  letter-spacing: -0.025em;
}

.guide-menu-detail-identity p {
  max-width: 520px;
  margin: 6px 0 0;
  color: #778597;
  font-size: 12px;
  line-height: 1.6;
}

.guide-menu-detail-head > a {
  min-height: 42px;
  padding: 0 14px;
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 0 0 auto;
  border: 1px solid #cde1dc;
  border-radius: 8px;
  color: #287e69;
  background: #f2f9f7;
  font-size: 10px;
  font-weight: 730;
  text-decoration: none;
}

.guide-menu-detail-head > a em {
  font-style: normal;
}

.guide-menu-when {
  min-height: 56px;
  margin-top: 22px;
  padding: 12px 15px;
  display: flex;
  align-items: center;
  gap: 12px;
  border-left: 3px solid #52aa94;
  border-radius: 0 9px 9px 0;
  background: #f2f7f6;
}

.guide-menu-when span {
  flex: 0 0 auto;
  color: #67857e;
  font-size: 9px;
  font-weight: 780;
}

.guide-menu-when strong {
  color: #425b57;
  font-size: 11px;
}

.guide-menu-detail-layout {
  margin-top: 24px;
  display: grid;
  grid-template-columns: minmax(0, 1.25fr) minmax(260px, 0.75fr);
  align-items: stretch;
  gap: 12px;
}

.guide-menu-capabilities {
  min-width: 0;
}

.guide-menu-subtitle {
  display: grid;
}

.guide-menu-subtitle strong {
  margin-top: 4px;
  color: #405166;
  font-size: 14px;
}

.guide-menu-capabilities ol {
  margin: 13px 0 0;
  padding: 0;
  border-top: 1px solid #e1e7ea;
  list-style: none;
}

.guide-menu-capabilities li {
  min-height: 88px;
  padding: 14px 3px;
  display: grid;
  grid-template-columns: 36px minmax(0, 1fr);
  align-items: center;
  gap: 10px;
  border-bottom: 1px solid #e6eaed;
}

.guide-menu-capabilities li > i {
  width: 34px;
  height: 34px;
  display: grid;
  place-items: center;
  border-radius: 9px;
  color: #347f6d;
  background: #e8f4f1;
  font-size: 10px;
  font-style: normal;
  font-weight: 820;
}

.guide-menu-capabilities li > div {
  display: grid;
}

.guide-menu-capabilities li strong {
  color: #435367;
  font-size: 12px;
}

.guide-menu-capabilities li p {
  margin: 4px 0 0;
  color: #7d8998;
  font-size: 11px;
  line-height: 1.5;
}

.guide-menu-outcome {
  min-height: 320px;
  padding: 22px;
  display: flex;
  flex-direction: column;
  border: 1px solid #d5e6e1;
  border-radius: 12px;
  background: radial-gradient(circle at 100% 0, rgba(74, 180, 153, 0.11), transparent 36%), #f3f8f7;
}

.guide-menu-outcome h4 {
  margin: 7px 0 0;
  color: #374e4a;
  font-size: 17px;
  line-height: 1.35;
}

.guide-menu-outcome > p {
  margin: 9px 0 0;
  color: #6e8983;
  font-size: 12px;
  line-height: 1.65;
}

.guide-menu-next {
  margin-top: auto;
  padding-top: 15px;
  display: grid;
  border-top: 1px solid #d7e5e1;
}

.guide-menu-next strong {
  margin-top: 5px;
  color: #47615c;
  font-size: 10px;
  line-height: 1.55;
}

.guide-menu-detail-note {
  min-height: 52px;
  margin-top: 13px;
  padding: 10px 13px;
  display: grid;
  grid-template-columns: 24px minmax(0, 1fr);
  align-items: center;
  gap: 9px;
  border-radius: 9px;
  background: #faf6ee;
}

.guide-menu-detail-note i {
  width: 23px;
  height: 23px;
  display: grid;
  place-items: center;
  border-radius: 50%;
  color: #95682f;
  background: #f2e3c7;
  font-size: 8px;
  font-style: normal;
  font-weight: 820;
}

.guide-menu-detail-note span {
  color: #8d7654;
  font-size: 10px;
  line-height: 1.5;
}

.guide-quick-menu {
  margin-top: 13px;
  padding: 17px;
  border: 1px solid #dfe5e8;
  border-radius: 12px;
  background: #f8fafb;
}

.guide-quick-menu-head {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 18px;
}

.guide-quick-menu-head > div {
  display: grid;
}

.guide-quick-menu-head span {
  color: #31917b;
  font-size: 9px;
  font-weight: 830;
  letter-spacing: 0.09em;
}

.guide-quick-menu-head strong {
  margin-top: 4px;
  color: #405166;
  font-size: 14px;
}

.guide-quick-menu-head p {
  margin: 0 0 2px;
  color: #8793a1;
  font-size: 10px;
}

.guide-quick-menu-grid {
  margin-top: 13px;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px;
}

.guide-quick-menu-grid article {
  min-height: 104px;
  padding: 14px;
  display: grid;
  grid-template-columns: 38px minmax(0, 1fr);
  align-items: center;
  gap: 0 10px;
  border: 1px solid #e0e6e9;
  border-radius: 10px;
  background: #fff;
}

.guide-quick-menu-grid article > i {
  width: 38px;
  height: 38px;
  display: grid;
  place-items: center;
  grid-row: 1/span 2;
  border-radius: 9px;
  color: #307f6c;
  background: #e7f3ef;
  font-size: 11px;
  font-style: normal;
  font-weight: 820;
}

.guide-quick-menu-grid article > div {
  display: grid;
}

.guide-quick-menu-grid strong {
  color: #46566a;
  font-size: 11px;
}

.guide-quick-menu-grid p {
  margin: 3px 0 0;
  color: #7e8b9a;
  font-size: 10px;
  line-height: 1.45;
}

.guide-quick-menu-grid em {
  margin-top: 6px;
  grid-column: 2;
  color: #8a97a4;
  font-size: 9px;
  font-style: normal;
}

.guide-status-grid {
  margin-top: 22px;
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 9px;
}

.guide-status-grid article {
  min-height: 166px;
  padding: 15px;
  border: 1px solid #dfe5e8;
  border-radius: 12px;
  background: #fafcfc;
}

.guide-status-grid em {
  display: inline-flex;
  padding: 5px 7px;
  border-radius: 6px;
  font-size: 8px;
  font-style: normal;
  font-weight: 780;
}

.guide-status-grid strong {
  margin-top: 13px;
  display: block;
  color: #405066;
  font-size: 10px;
}

.guide-status-grid p {
  margin: 6px 0 0;
  color: #7d8998;
  font-size: 8px;
  line-height: 1.55;
}

.guide-term-grid {
  margin-top: 10px;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  border: 1px solid #e0e6e9;
  border-radius: 12px;
  overflow: hidden;
}

.guide-term-grid > div {
  min-height: 86px;
  padding: 15px;
  background: #fff;
}

.guide-term-grid > div:nth-child(even) {
  border-left: 1px solid #e6eaed;
}

.guide-term-grid > div:nth-child(n+3) {
  border-top: 1px solid #e6eaed;
}

.guide-term-grid strong {
  color: #347e6d;
  font-size: 10px;
}

.guide-term-grid p {
  margin: 5px 0 0;
  color: #7b8797;
  font-size: 8px;
  line-height: 1.55;
}

.guide-reference-intro {
  min-height: 96px;
  margin-top: 22px;
  padding: 16px;
  display: grid;
  grid-template-columns: 42px minmax(0, 1fr) auto;
  align-items: center;
  gap: 13px;
  border: 1px solid #d6e6e1;
  border-radius: 12px;
  background: linear-gradient(100deg, #eef8f5, #f9fbfb);
}

.reference-intro-icon {
  width: 42px;
  height: 42px;
  display: grid;
  place-items: center;
  border-radius: 12px;
  color: #2d826e;
  background: #dcefe9;
}

.reference-intro-icon svg {
  width: 21px;
  height: 21px;
}

.guide-reference-intro > div:nth-child(2) {
  display: grid;
}

.guide-reference-intro strong {
  color: #38544f;
  font-size: 11px;
}

.guide-reference-intro p {
  max-width: 720px;
  margin: 5px 0 0;
  color: #728b85;
  font-size: 9px;
  line-height: 1.6;
}

.guide-reference-intro time {
  align-self: start;
  color: #8ba09b;
  font-size: 7px;
}

.guide-reference-group {
  margin-top: 24px;
}

.reference-group-heading {
  min-height: 44px;
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 18px;
}

.reference-group-heading > div {
  display: flex;
  align-items: center;
  gap: 8px;
}

.reference-group-heading i {
  width: 25px;
  height: 25px;
  display: grid;
  place-items: center;
  border-radius: 7px;
  color: #337f6d;
  background: #e7f3ef;
  font-size: 7px;
  font-style: normal;
  font-weight: 820;
}

.reference-group-heading strong {
  color: #405166;
  font-size: 12px;
}

.reference-group-heading p {
  margin: 0 0 3px;
  color: #8793a1;
  font-size: 8px;
}

.guide-reference-grid {
  margin-top: 10px;
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 9px;
}

.guide-reference-card {
  min-height: 245px;
  padding: 15px;
  display: flex;
  flex-direction: column;
  border: 1px solid #dfe5e8;
  border-radius: 12px;
  color: inherit;
  background: #fff;
  text-decoration: none;
  transition: border-color 0.16s, box-shadow 0.16s, transform 0.16s;
}

.guide-reference-card:hover {
  border-color: #9ecfc3;
  box-shadow: 0 11px 25px rgba(36, 78, 69, 0.07);
  transform: translateY(-2px);
}

.reference-card-top {
  display: flex;
  align-items: center;
  gap: 9px;
}

.reference-card-top > span {
  color: #8894a2;
  font-size: 7px;
  font-weight: 780;
  letter-spacing: 0.07em;
}

.reference-mark {
  min-width: 35px;
  height: 29px;
  padding: 0 7px;
  display: grid;
  place-items: center;
  border-radius: 8px;
  color: #3c6e9f;
  background: #e8f0fa;
  font-size: 7px;
  font-weight: 830;
  letter-spacing: 0.03em;
}

.reference-mark.research {
  color: #805fa0;
  background: #f0eafa;
}

.reference-mark.standard {
  color: #a16a2f;
  background: #f8eedf;
}

.reference-mark.governance {
  color: #307f6c;
  background: #e4f3ef;
}

.guide-reference-card h3 {
  margin: 14px 0 0;
  color: #34465b;
  font-size: 12px;
  letter-spacing: -0.01em;
}

.guide-reference-card > p {
  min-height: 54px;
  margin: 7px 0 0;
  color: #7a8797;
  font-size: 8px;
  line-height: 1.6;
}

.reference-fit {
  margin-top: 12px;
  padding: 10px;
  display: grid;
  border-radius: 9px;
  background: #f5f8f8;
}

.reference-fit span {
  color: #8995a2;
  font-size: 7px;
}

.reference-fit strong {
  margin-top: 4px;
  color: #4d6372;
  font-size: 8px;
  line-height: 1.45;
}

.reference-link {
  margin-top: auto;
  padding-top: 13px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #2b806d;
  font-size: 8px;
  font-weight: 740;
}

.reference-link em {
  font-size: 11px;
  font-style: normal;
}

.guide-reference-note {
  min-height: 70px;
  margin-top: 14px;
  padding: 13px 15px;
  display: grid;
  grid-template-columns: 29px minmax(0, 1fr);
  align-items: center;
  gap: 11px;
  border: 1px solid #eadfc8;
  border-radius: 11px;
  background: #fffaf1;
}

.guide-reference-note > i {
  width: 29px;
  height: 29px;
  display: grid;
  place-items: center;
  border-radius: 50%;
  color: #fff;
  background: #bd8440;
  font-size: 9px;
  font-style: normal;
  font-weight: 820;
}

.guide-reference-note strong {
  color: #715a39;
  font-size: 10px;
}

.guide-reference-note p {
  margin: 4px 0 0;
  color: #927b58;
  font-size: 8px;
  line-height: 1.55;
}

.guide-faq-list {
  margin-top: 20px;
  border-top: 1px solid #dfe5e8;
}

.guide-faq-list details {
  border-bottom: 1px solid #e3e8eb;
}

.guide-faq-list summary {
  min-height: 53px;
  padding: 0 7px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  color: #405066;
  cursor: pointer;
  font-size: 10px;
  font-weight: 720;
  list-style: none;
}

.guide-faq-list summary::-webkit-details-marker {
  display: none;
}

.guide-faq-list summary::after {
  content: "+";
  color: #7c8b9c;
  font-size: 15px;
  font-weight: 450;
}

.guide-faq-list details[open] summary::after {
  content: "−";
}

.guide-faq-list details p {
  margin: -3px 38px 15px 7px;
  color: #758396;
  font-size: 9px;
  line-height: 1.65;
}

.guide-help-footer {
  min-height: 105px;
  margin-top: 20px;
  padding: 18px 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 25px;
  border-radius: 13px;
  background: #f0f7f5;
}

.guide-help-footer > div {
  display: grid;
}

.guide-help-footer strong {
  margin-top: 5px;
  color: #354c49;
  font-size: 14px;
}

.guide-help-footer p {
  margin: 5px 0 0;
  color: #748e89;
  font-size: 9px;
}

.guide-help-footer > a {
  min-height: 38px;
  padding: 0 14px;
  display: flex;
  align-items: center;
  gap: 18px;
  border-radius: 9px;
  color: #fff;
  background: #233e43;
  font-size: 9px;
  font-weight: 730;
  text-decoration: none;
}

.guide-help-footer > a em {
  font-style: normal;
}

.profile-layout {
  display: grid;
  grid-template-columns: 285px minmax(0, 1fr);
  gap: var(--platform-card-gap);
}

.profile-guide-shortcut {
  min-height: 92px;
  padding: 15px 18px;
  grid-column: 1/-1;
  display: grid;
  grid-template-columns: 42px minmax(0, 1fr) auto;
  align-items: center;
  gap: 13px;
  color: inherit;
  background: linear-gradient(100deg, #f0f8f5, #fff);
  text-decoration: none;
  transition: border-color 0.16s, transform 0.16s, box-shadow 0.16s;
}

.profile-guide-shortcut:hover {
  border-color: #a9d5ca;
  box-shadow: 0 10px 25px rgba(38, 89, 77, 0.06);
  transform: translateY(-1px);
}

.profile-guide-icon {
  width: 42px;
  height: 42px;
  display: grid;
  place-items: center;
  border-radius: 12px;
  color: #2d806e;
  background: #dff1ec;
}

.profile-guide-icon svg {
  width: 21px;
  height: 21px;
}

.profile-guide-shortcut > div:nth-child(2) {
  display: grid;
}

.profile-guide-shortcut span {
  color: #30917c;
  font-size: 7px;
  font-weight: 830;
  letter-spacing: 0.1em;
}

.profile-guide-shortcut strong {
  margin-top: 4px;
  color: #33475d;
  font-size: 13px;
}

.profile-guide-shortcut p {
  margin: 4px 0 0;
  color: #7e8b9a;
  font-size: 9px;
}

.profile-guide-shortcut > em {
  color: #287d69;
  font-size: 9px;
  font-style: normal;
  font-weight: 730;
}

.profile-card {
  min-height: 340px;
  padding: 27px 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.profile-avatar {
  width: 76px;
  height: 76px;
  display: grid;
  place-items: center;
  border-radius: 23px;
  color: #fff;
  background: linear-gradient(145deg, #2e7880, #304c7d);
  box-shadow: 0 12px 28px rgba(43, 79, 108, 0.18);
  font-size: 23px;
  font-weight: 820;
}

.profile-card h2 {
  margin: 17px 0 0;
  color: #324156;
  font-size: 18px;
}

.profile-card p {
  margin: 5px 0 0;
  color: #84909f;
  font-size: 9px;
}

.profile-card > em {
  margin-top: 10px;
  padding: 5px 8px;
  border-radius: 6px;
  color: #2e7d6b;
  background: #e6f4f0;
  font-size: 8px;
  font-style: normal;
}

.profile-stats {
  width: 100%;
  margin-top: 26px;
  padding-top: 18px;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  border-top: 1px solid #e5eaed;
}

.profile-stats > div {
  display: grid;
}

.profile-stats strong {
  color: #34445a;
  font-size: 16px;
}

.profile-stats span {
  margin-top: 3px;
  color: #8b96a4;
  font-size: 8px;
}

.authority-card {
  padding: 21px;
}

.authority-card h2,
.recent-decisions h2 {
  margin: 5px 0 15px;
  color: #334257;
  font-size: 17px;
}

.authority-row {
  min-height: 66px;
  padding: 10px 2px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-top: 1px solid #e7ebee;
}

.authority-row > div {
  display: grid;
}

.authority-row strong {
  color: #435167;
  font-size: 10px;
}

.authority-row span {
  margin-top: 3px;
  color: #8a95a3;
  font-size: 8px;
}

.authority-row em {
  color: #2a816c;
  font-size: 8px;
  font-style: normal;
  font-weight: 780;
}

.recent-decisions {
  min-height: 220px;
  padding: 21px;
  grid-column: 1/-1;
}

.recent-decision {
  min-height: 52px;
  padding: 8px 0;
  display: grid;
  grid-template-columns: 9px minmax(0, 1fr) auto;
  align-items: center;
  gap: 9px;
  border-top: 1px solid #e8ecef;
}

.recent-decision > i {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #8493a4;
}

.recent-decision > i.approved {
  background: #35b596;
}

.recent-decision > i.review {
  background: #d49a4f;
}

.recent-decision > i.rejected {
  background: #d1685e;
}

.recent-decision > div {
  display: grid;
}

.recent-decision strong {
  color: #425166;
  font-size: 10px;
}

.recent-decision span {
  margin-top: 3px;
  color: #8994a2;
  font-size: 8px;
}

.recent-decision > em {
  color: #758296;
  font-size: 8px;
  font-style: normal;
}

@keyframes section-enter {
  from {
    opacity: 0.35;
    transform: translateY(5px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@media (max-width: 1280px) {
  :host {
    min-width: 0;
  }
  .project-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .run-workbench {
    grid-template-columns: 1fr;
  }
  .linked-run-context.projects-context-compact {
    margin-right: 16px;
    margin-left: 16px;
  }
  .linked-run-context.knowledge-context-compact {
    margin-right: 16px;
    margin-left: 16px;
  }
  .linked-run-context.knowledge-context-compact {
    grid-template-columns: 190px minmax(290px, 1fr) 230px;
  }
  .knowledge-list {
    grid-template-columns: 1fr;
  }
  .report-grid {
    grid-template-columns: 1fr;
  }
}
@media (max-width: 1180px) {
  :host {
    min-width: 0;
  }
  .linked-run-context {
    margin-right: 18px;
    margin-left: 18px;
    grid-template-columns: 170px minmax(340px, 1fr) 280px;
  }
  .run-workbench {
    grid-template-columns: 1fr;
  }
  .project-grid {
    grid-template-columns: 1fr 1fr;
  }
  .project-filter-bar {
    grid-template-columns: minmax(160px, 1.35fr) repeat(4, minmax(88px, 1fr)) auto auto;
  }
  .project-filter-reset {
    grid-column: auto;
    width: auto;
  }
  .linked-run-context.projects-context-compact {
    grid-template-columns: 190px minmax(300px, 1fr) 250px;
  }
  .knowledge-filter-panel {
    flex-wrap: nowrap;
  }
  .knowledge-search {
    width: 180px;
  }
  .knowledge-type-tabs {
    min-width: 0;
  }
  .knowledge-status-filter {
    min-width: 105px;
    margin-left: 0;
  }
  .knowledge-ingestion {
    grid-template-columns: 170px 210px minmax(300px, 1fr);
  }
  .component-run-banner {
    grid-template-columns: 210px minmax(320px, 1fr) 126px;
    gap: 8px;
  }
  .component-filter-grid {
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }
  .report-filter-grid {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  .report-filter-result,
  .report-filter-reset {
    justify-content: center;
  }
}
@media (max-width: 860px) {
  .demo-page-header {
    height: 56px;
    min-height: 56px;
    padding: 0 20px;
    align-items: center;
  }
  .demo-content {
    padding: 18px;
  }
  .demo-content.guide-content {
    padding: 18px 12px 40px;
  }
  .component-run-banner {
    grid-template-columns: 1fr;
  }
  .component-run-constraints {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  .component-state-summary,
  .component-filter-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .component-quick-filters {
    overflow-x: auto;
  }
  .component-quick-filters > span,
  .component-quick-filters > button {
    flex: 0 0 auto;
  }
  .component-quick-filters > em {
    display: none;
  }
  .component-filter-summary {
    flex: 0 0 auto;
  }
  .component-confidence-basis {
    grid-template-columns: 1fr;
  }
  .component-search {
    width: 100%;
  }
  .report-banner {
    align-items: flex-start;
    flex-direction: column;
  }
  .report-banner-side {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .report-filter-head {
    align-items: flex-start;
    flex-direction: column;
    gap: 5px;
  }
  .report-filter-grid {
    grid-template-columns: 1fr 1fr;
  }
  .report-card-head {
    grid-template-columns: 44px minmax(0, 1fr);
  }
  .report-card.primary-report .report-card-head {
    grid-template-columns: 44px minmax(0, 1fr);
    gap: 11px;
  }
  .report-card.primary-report .report-icon {
    width: 44px;
    height: 44px;
  }
  .report-card-badges {
    grid-column: 1/-1;
    display: flex;
    justify-items: start;
  }
  .report-information {
    grid-template-columns: 1fr 1fr;
    row-gap: 10px;
  }
  .report-information > div:nth-child(3) {
    padding-left: 0;
    border-left: 0;
  }
  .report-card-actions {
    grid-template-columns: 1fr;
  }
  .report-card-export,
  .report-card-export select,
  .report-card-export button {
    width: 100%;
  }
  .report-layer-backdrop {
    padding: 14px;
  }
  .component-result-count {
    white-space: nowrap;
  }
  .linked-run-context {
    min-width: 820px;
    margin-right: 16px;
    margin-left: 16px;
  }
  .metric-strip,
  .project-grid,
  .run-workbench,
  .approval-layout,
  .knowledge-layout,
  .report-grid,
  .settings-layout,
  .guide-hero,
  .guide-layout,
  .profile-layout {
    grid-template-columns: 1fr;
  }
  .settings-nav {
    position: static;
  }
  .settings-scope-panel,
  .project-scope-picker {
    grid-template-columns: 1fr;
  }
  .project-scope-picker em {
    width: fit-content;
  }
  .setting-card {
    grid-template-columns: 1fr;
  }
  .setting-system-impact {
    align-items: flex-start;
    flex-wrap: wrap;
  }
  .setting-system-impact strong {
    overflow: visible;
    white-space: normal;
  }
  .setting-system-impact em {
    padding-left: 0;
    border-left: 0;
  }
  .setting-control {
    width: 100%;
    padding: 12px 0 0;
    align-items: center;
    flex-direction: row;
    justify-content: flex-start;
    gap: 8px;
    border-top: 1px solid #e4e9eb;
    border-left: 0;
  }
  .setting-control > strong {
    margin: 0 auto 0 0;
  }
  .setting-toggle,
  .setting-control > small {
    margin-top: 0;
  }
  .audit-log-entry {
    grid-template-columns: 120px 150px minmax(0, 1fr);
    gap: 12px;
  }
  .section-toolbar {
    align-items: flex-start;
    flex-direction: column;
  }
  .search-box {
    width: 100%;
  }
  .project-filter-bar {
    grid-template-columns: 1fr 1fr;
  }
  .project-search-filter {
    grid-column: 1/-1;
  }
  .project-filter-result,
  .project-filter-reset {
    grid-column: auto;
  }
  .guide-principles {
    padding: 15px 0 0;
    border-top: 1px solid rgba(255, 255, 255, 0.11);
    border-left: 0;
  }
  .guide-toc {
    position: static;
  }
  .guide-section {
    padding: 22px;
  }
  .guide-check-grid,
  .guide-reference-grid {
    grid-template-columns: 1fr 1fr;
  }
  .guide-quick-menu-grid {
    grid-template-columns: 1fr;
  }
  .guide-menu-browser-body,
  .guide-menu-detail-layout {
    grid-template-columns: 1fr;
  }
  .guide-menu-index {
    display: flex;
    gap: 10px;
    overflow-x: auto;
    border-right: 0;
    border-bottom: 1px solid #e1e7ea;
  }
  .guide-menu-index-group {
    min-width: 230px;
    flex: 0 0 auto;
  }
  .guide-menu-index-group + .guide-menu-index-group {
    margin-top: 0;
  }
  .guide-menu-detail-head {
    flex-direction: column;
  }
  .guide-menu-detail-head > a {
    align-self: flex-start;
  }
  .guide-menu-detail {
    min-height: 0;
    padding: 22px;
  }
  .guide-menu-when {
    align-items: flex-start;
    flex-direction: column;
    gap: 4px;
  }
  .guide-flow {
    grid-template-columns: 1fr;
  }
  .guide-flow-visual-head {
    align-items: flex-start;
    flex-direction: column;
  }
  .guide-flow-legend {
    justify-content: flex-start;
  }
  .guide-flow-caption {
    grid-template-columns: 1fr;
  }
  .guide-flow > i {
    transform: rotate(90deg);
  }
  .guide-action-head {
    display: none;
  }
  .guide-action-row {
    grid-template-columns: 1fr 1fr;
  }
  .guide-status-grid {
    grid-template-columns: 1fr 1fr;
  }
  .guide-quick-menu-head {
    align-items: flex-start;
    flex-direction: column;
    gap: 5px;
  }
  .reference-group-heading {
    align-items: flex-start;
    flex-direction: column;
    gap: 5px;
  }
  .guide-reference-intro {
    grid-template-columns: 42px minmax(0, 1fr);
  }
  .guide-reference-intro time {
    grid-column: 2;
  }
  .metric-strip {
    grid-template-columns: 1fr 1fr;
  }
  .linked-run-context.projects-context-compact {
    grid-template-columns: 1fr;
  }
  .knowledge-list {
    grid-template-columns: 1fr;
  }
  .knowledge-purpose-banner {
    grid-template-columns: 42px minmax(0, 1fr);
  }
  .knowledge-purpose-legend {
    padding: 10px 0 0 56px;
    grid-column: 1/-1;
    grid-template-columns: max-content max-content max-content;
    border-top: 1px solid #deebe7;
    border-left: 0;
  }
  .knowledge-ingestion {
    grid-template-columns: 1fr;
  }
  .knowledge-review-steps {
    flex-wrap: wrap;
  }
  .knowledge-approval-gate {
    align-items: flex-start;
    flex-direction: column;
  }
  .knowledge-detail-failure-flow {
    align-items: stretch;
    flex-direction: column;
  }
  .knowledge-detail-failure-flow > i {
    align-self: center;
    transform: rotate(90deg);
  }
  .knowledge-filter-panel {
    flex-wrap: wrap;
    align-items: stretch;
  }
  .knowledge-search,
  .knowledge-type-tabs {
    width: 100%;
    min-width: 0;
  }
  .knowledge-status-filter {
    margin-left: 0;
  }
  .knowledge-side {
    position: static;
  }
  .linked-run-context.knowledge-context-compact {
    grid-template-columns: 1fr;
  }
  .knowledge-register-form {
    grid-template-columns: 1fr;
  }
  .knowledge-register-form label.wide,
  .knowledge-register-actions.wide,
  .knowledge-register-notice {
    grid-column: auto;
  }
  .knowledge-evidence-row {
    grid-template-columns: 88px minmax(0, 1fr);
  }
  .knowledge-evidence-row > em {
    max-width: none;
    grid-column: 2;
    text-align: left;
  }
  .knowledge-evidence-focus {
    grid-template-columns: 42px minmax(0, 1fr);
  }
  .knowledge-evidence-focus-decision {
    padding: 10px 0 0 56px;
    grid-column: 1/-1;
    border-top: 1px solid #d9e6e2;
    border-left: 0;
  }
  .recent-decisions {
    grid-column: auto;
  }
  .profile-guide-shortcut {
    grid-column: auto;
  }
}
@media (max-width: 1023px) {
  .platform-mobile-menu {
    display: grid;
  }
  .demo-page-header {
    padding-right: 20px;
    padding-left: 20px;
    gap: 0;
  }
  .header-copy {
    margin-left: 12px;
    margin-right: auto;
  }
  .run-workbench {
    grid-template-columns: 1fr;
  }
}
@media (max-width: 860px) {
  .linked-run-context {
    width: auto;
    min-width: 0;
    grid-template-columns: 1fr;
  }
  .linked-run-context.approval-context-compact {
    grid-template-columns: 1fr;
  }
  .approval-overview {
    align-items: flex-start;
    flex-direction: column;
  }
  .decision-object-conditions dl {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .evidence-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .linked-run-id {
    border-right: 0;
  }
  .run-context-compact .linked-run-id {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .run-context-compact .linked-run-id > span,
  .run-context-compact .context-current-stage {
    grid-column: 1/-1;
  }
  .agent-flow-overview {
    flex-wrap: wrap;
    gap: 6px;
  }
  .agent-flow-step {
    min-width: 125px;
    flex: 1 1 calc(33.333% - 6px);
  }
  .agent-flow-overview > em {
    display: none;
  }
  .timeline-event-detail dl {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .timeline-event-detail dl > div:nth-child(2) {
    padding-right: 0;
    border-right: 0;
  }
  .timeline-event-detail dl > div:nth-child(n+3) {
    padding-top: 7px;
    border-top: 1px solid #e6ebed;
  }
  .stage-execution-context dl {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    row-gap: 9px;
  }
  .stage-execution-context dl > div:nth-child(3) {
    padding-left: 0;
    border-left: 0;
  }
}
@media (max-width: 768px) {
  .demo-page-header {
    padding-right: 16px;
    padding-left: 16px;
  }
  .workspace-label,
  .breadcrumb i,
  .header-help,
  .header-user strong {
    display: none;
  }
  .header-actions {
    gap: 8px;
  }
}
@media (max-width: 520px) {
  .header-user {
    display: none;
  }
}
@media (max-width: 620px) {
  .project-filter-bar {
    grid-template-columns: 1fr;
  }
  .project-search-filter,
  .project-filter-result,
  .project-filter-reset {
    grid-column: auto;
  }
  .project-filter-reset {
    width: 100%;
  }
  .run-context-compact .linked-run-id,
  .run-filter-selects,
  .stage-execution-context dl,
  .timeline-event-detail dl {
    grid-template-columns: 1fr;
  }
  .run-context-compact .linked-run-id > span,
  .run-context-compact .context-current-stage {
    grid-column: auto;
  }
  .stage-execution-context dl > div,
  .timeline-event-detail dl > div {
    padding: 8px 0 0;
    border-top: 1px solid #dbe9e5;
    border-right: 0;
    border-left: 0;
  }
  .timeline-event-summary {
    grid-template-columns: 52px 18px minmax(0, 1fr) 18px;
  }
  .timeline-event::after {
    left: 69px;
  }
  .timeline-event-detail {
    margin-left: 79px;
  }
  .approval-intro {
    align-items: flex-start;
  }
  .approval-summary {
    width: 100%;
  }
  .approval-summary > div {
    min-width: 0;
    flex: 1;
  }
  .approval-identity,
  .rejection-detail,
  .evidence-grid,
  .decision-object-conditions dl {
    grid-template-columns: 1fr;
  }
  .approver-avatar {
    grid-row: auto;
  }
  .change-row {
    grid-template-columns: 1fr 18px 1fr;
  }
  .change-table-head {
    grid-template-columns: 1fr 18px 1fr;
  }
  .change-table-head > span:first-child {
    grid-column: 1/-1;
  }
  .change-field,
  .change-row > p {
    grid-column: 1/-1;
  }
  .audit-footer {
    align-items: flex-end;
  }
  .audit-footer > div {
    flex-wrap: wrap;
  }
}
@media (max-width: 1180px) {
  .linked-run-context {
    width: calc(100% - 36px);
    margin: 6px auto 0;
    grid-template-columns: 92px minmax(150px, 1fr) minmax(140px, 0.75fr) minmax(170px, 0.9fr) minmax(220px, 1.1fr);
    gap: 8px;
  }
}
@media (max-width: 860px) {
  .linked-run-context {
    width: calc(100% - 32px);
    min-height: 96px;
    padding: 7px 9px;
    grid-template-columns: 84px repeat(3, minmax(0, 1fr));
    gap: 6px 8px;
  }
  .linked-run-context .linked-handoff {
    height: 34px;
    grid-column: 1/-1;
    grid-template-columns: 100px minmax(0, 1fr);
    align-items: center;
    gap: 8px;
  }
  .linked-run-context .linked-handoff-route {
    margin-top: 0;
  }
}
@media (max-width: 620px) {
  .linked-run-context {
    min-height: 0;
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .current-context-title,
  .linked-run-context .context-page-focus,
  .linked-run-context .linked-handoff {
    grid-column: 1/-1;
  }
}
@media (max-width: 860px) {
  .report-card-main {
    grid-template-columns: minmax(0, 1fr) 104px;
  }
  .report-card-preview {
    width: 104px;
  }
  .report-card.primary-report .report-card-head,
  .report-card-head {
    grid-template-columns: 40px minmax(0, 1fr);
    gap: 10px;
  }
  .report-card.primary-report .report-icon,
  .report-icon {
    width: 40px;
    height: 40px;
  }
  .report-card-badges {
    margin-top: 2px;
    grid-column: 2;
  }
  .report-card-footer .report-card-export {
    width: auto;
  }
  .report-card-footer .report-card-export select {
    width: 64px;
  }
  .report-card-footer .report-card-export button {
    width: auto;
  }
}
@media (max-width: 620px) {
  .demo-content.reports-content {
    padding-right: 12px;
    padding-left: 12px;
  }
  .report-banner-side {
    align-items: flex-start;
    flex-direction: column;
  }
  .report-package-trigger {
    min-width: 170px;
  }
  .report-card-main,
  .report-card-footer {
    grid-template-columns: 1fr;
  }
  .report-card-preview {
    width: 100%;
    min-height: 96px;
  }
  .report-card-badges {
    grid-column: 1/-1;
  }
  .report-version-track {
    grid-template-columns: auto 12px auto minmax(90px, 1fr);
  }
  .report-card-footer .report-card-export,
  .report-card-footer .report-card-export select,
  .report-card-footer .report-card-export button {
    width: 100%;
  }
  .report-selected-version-head {
    align-items: flex-start;
    flex-direction: column;
    gap: 3px;
  }
}
@media (max-width: 860px) {
  .report-layer-backdrop {
    padding: 8px;
  }
  .report-layer {
    height: calc(100vh - 16px);
    max-height: calc(100vh - 16px);
  }
  .report-document-workspace {
    grid-template-columns: 82px minmax(0, 1fr);
  }
  .report-page-rail {
    padding: 8px 5px;
  }
  .report-page-toolbar {
    align-items: flex-start;
    flex-direction: column;
  }
  .report-page-tools {
    width: 100%;
    justify-content: space-between;
  }
  .report-page-viewport {
    padding: 14px 14px 28px;
  }
  .report-confirm-document {
    overflow-y: auto;
    grid-template-columns: 1fr;
  }
  .report-confirm-preview {
    min-height: 560px;
    overflow: auto;
  }
  .report-confirm-panel {
    min-height: auto;
    overflow: visible;
  }
}
@media (max-width: 620px) {
  .report-page-rail {
    display: none;
  }
  .report-document-workspace {
    grid-template-columns: minmax(0, 1fr);
  }
  .report-layer-head {
    min-height: 64px;
    padding: 10px 12px;
  }
  .report-flow-steps {
    padding: 6px 8px;
    gap: 4px;
  }
  .report-flow-steps button {
    gap: 4px;
    font-size: 7px;
  }
  .report-flow-steps > em {
    display: none;
  }
  .report-change-legend {
    align-items: flex-start;
    flex-direction: column;
  }
  .report-layer-actions {
    padding: 10px 12px 12px;
  }
  .report-layer-actions button.report-download-primary {
    min-width: 0;
    flex: 1;
  }
  .report-page-toolbar .report-preview-version-picker {
    width: 100%;
    overflow-x: auto;
  }
  .report-page-tools {
    gap: 6px;
  }
  .report-zoom-controls .report-fit-page {
    min-width: 48px;
    padding-inline: 5px;
  }
  .report-page-viewport {
    justify-items: start;
  }
  .report-version-columns {
    grid-template-columns: 1fr;
  }
  .report-version-columns > i {
    transform: rotate(90deg);
  }
  .report-diff-row {
    grid-template-columns: 18px minmax(0, 1fr);
  }
  .report-diff-row small {
    grid-column: 2;
  }
}
/* Shared end-to-end journey and object lineage across Projects, Runs and deliverables. */
.design-journey-shell {
  width: min(100% - 32px, 1450px);
  margin: 8px auto 0;
  padding: 12px 14px;
  border: 1px solid #dce7e4;
  border-radius: 14px;
  background: linear-gradient(135deg, #fff 0%, #f7fbfa 100%);
  box-shadow: 0 8px 24px rgba(32, 60, 54, 0.04);
}

.design-journey-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
}

.design-journey-title {
  min-width: 0;
  display: grid;
  gap: 2px;
}

.design-journey-title h2 {
  margin: 0;
  color: #223247;
  font-size: 14px;
  line-height: 1.35;
}

.design-journey-title p {
  max-width: 720px;
  margin: 0;
  color: #718092;
  font-size: 8px;
  line-height: 1.45;
}

.design-object-path {
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 6px;
  white-space: nowrap;
}

.design-object-path > div {
  min-width: 0;
  padding: 5px 7px;
  display: grid;
  gap: 2px;
  border: 1px solid #e2e8eb;
  border-radius: 8px;
  background: #fff;
}

.design-object-path > div.current {
  border-color: #b8d9d1;
  background: #eff8f5;
}

.design-object-path span {
  color: #8a95a3;
  font-size: 6px;
  font-weight: 820;
  letter-spacing: 0.08em;
}

.design-object-path strong {
  max-width: 148px;
  overflow: hidden;
  color: #34455a;
  font-size: 8px;
  text-overflow: ellipsis;
}

.design-object-path > i {
  color: #4aa28d;
  font-style: normal;
}

.design-journey-track {
  margin-top: 10px;
  display: grid;
  grid-template-columns: repeat(8, minmax(0, 1fr));
  gap: 7px;
}

.design-journey-stage {
  min-width: 0;
  min-height: 76px;
  padding: 8px;
  display: grid;
  grid-template-columns: 24px minmax(0, 1fr) auto;
  align-items: start;
  gap: 6px;
  position: relative;
  border: 1px solid #e1e7e9;
  border-radius: 10px;
  color: inherit;
  text-decoration: none;
  background: #fff;
  transition: border-color 0.16s, box-shadow 0.16s, transform 0.16s;
}

.design-journey-stage:hover {
  transform: translateY(-1px);
  border-color: #aacfc6;
  box-shadow: 0 7px 16px rgba(39, 77, 68, 0.07);
}

.design-journey-stage > svg {
  width: 16px;
  height: 16px;
  position: absolute;
  top: 50%;
  right: -12px;
  z-index: 2;
  color: #8c999f;
  background: #fff;
  border-radius: 50%;
  transform: translateY(-50%);
}

.design-stage-index {
  width: 24px;
  height: 24px;
  display: grid;
  place-items: center;
  position: relative;
  border-radius: 8px;
  color: #657386;
  background: #f0f3f5;
  font-size: 8px;
  font-weight: 850;
}

.design-stage-index i {
  position: absolute;
  font-style: normal;
}

.design-journey-stage.done .design-stage-index span {
  opacity: 0;
}

.design-stage-copy {
  min-width: 0;
  display: grid;
  gap: 2px;
}

.design-stage-copy small,
.design-stage-copy strong,
.design-stage-copy em {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.design-stage-copy small {
  color: #8692a0;
  font-size: 6.5px;
}

.design-stage-copy strong {
  color: #354458;
  font-size: 9px;
}

.design-stage-copy em {
  color: #617185;
  font-size: 7px;
  font-style: normal;
}

.design-journey-stage > b {
  padding: 3px 5px;
  border-radius: 999px;
  color: #7b8795;
  background: #f2f4f5;
  font-size: 6px;
  font-weight: 780;
  white-space: nowrap;
}

.design-journey-stage.active {
  border-color: #4fae96;
  background: #eff9f6;
  box-shadow: 0 0 0 3px rgba(71, 162, 140, 0.09);
}

.design-journey-stage.active .design-stage-index,
.design-journey-stage.done .design-stage-index {
  color: #fff;
  background: #318b75;
}

.design-journey-stage.active > b,
.design-journey-stage.ready > b {
  color: #22725f;
  background: #dff3ed;
}

.design-journey-stage.done {
  border-color: #cce3dd;
}

.design-journey-stage.ready {
  border-color: #a9c7dc;
  background: #f5f9fc;
}

.design-journey-stage.locked {
  opacity: 0.58;
}

.design-journey-shell.evidence-journey {
  padding-bottom: 10px;
}

.design-journey-shell.evidence-journey .design-journey-stage {
  min-height: 68px;
}

.design-evidence-trace {
  min-height: 46px;
  margin-top: 9px;
  padding: 7px 9px;
  display: grid;
  grid-template-columns: 150px minmax(0, 1fr);
  align-items: center;
  gap: 12px;
  border-top: 1px solid #e1e8e6;
  border-radius: 8px;
  background: #f8fbfa;
}

.design-evidence-trace-title {
  min-width: 0;
  padding-right: 10px;
  display: grid;
  gap: 2px;
  border-right: 1px solid #dfe7e5;
}

.design-evidence-trace-title span {
  color: #28816c;
  font-size: 7px;
  font-weight: 840;
  letter-spacing: 0.1em;
}

.design-evidence-trace-title strong {
  color: #46586b;
  font-size: 8px;
}

.design-evidence-trace .evidence-trace-node > i {
  width: 20px;
  height: 20px;
}

.design-evidence-trace .evidence-trace-node strong {
  font-size: 7.5px;
}

.design-evidence-trace .evidence-trace-node small {
  font-size: 6px;
}

@media (max-width: 1180px) {
  .design-journey-head {
    align-items: flex-start;
    flex-direction: column;
    gap: 8px;
  }
  .design-object-path {
    width: 100%;
    overflow-x: auto;
  }
  .design-journey-track {
    overflow-x: auto;
    grid-template-columns: repeat(8, minmax(140px, 1fr));
  }
  .design-evidence-trace {
    grid-template-columns: 1fr;
  }
  .design-evidence-trace-title {
    grid-template-columns: auto auto;
    justify-content: start;
    gap: 8px;
    border-right: 0;
  }
}
@media (max-width: 1023px) {
  .run-metrics {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
@media (max-width: 860px) {
  .log-reasoning-flow {
    grid-template-columns: 1fr;
  }
  .log-flow-arrow {
    min-height: 14px;
    transform: rotate(90deg);
  }
  .log-trace-links {
    grid-template-columns: 1fr;
  }
  .log-trace-links > span {
    padding: 0 0 2px;
  }
  .recovery-flow {
    grid-template-columns: 1fr;
  }
  .recovery-flow > i {
    transform: rotate(90deg);
    text-align: center;
  }
}
@media (max-width: 860px) {
  .design-journey-shell {
    width: calc(100% - 24px);
    margin-right: 12px;
    margin-left: 12px;
    padding: 10px;
  }
  .design-journey-title h2 {
    font-size: 13px;
  }
  .design-object-path > div {
    flex: 0 0 auto;
  }
}`],
})
export class PagePlatformComponent implements OnInit, OnDestroy {
    constructor(@Inject( Service) public service: Service,@Inject( Router)  public router: Router) { }

    public readonly runStorageKey: string = "mobility-ai-demo-run";
    public readonly activeRunStorageKey: string = "mobility-ai-active-run";
    public readonly platformStateStorageKey: string = "mobility-ai-platform-state-v1";
    public readonly knowledgeStorageKey: string = "mobility-ai-knowledge-drafts";
    public readonly settingsStorageKey: string = "mobility-ai-demo-settings";
    public pageDataState: "loading" | "ready" | "error" = "loading";
    public pageDataMessage: string = "";
    public activeRunId: string = "NX4-PTG-2404";
    public linkedRunContext: any = {
        runId: "NX4-PTG-2404",
        project: "NX4 Tailgate Actuator",
        journeyStep: 7,
        stage: "Approval 완료",
        status: "완료",
        requirements: 8,
        designVariables: 5,
        simulationCandidates: 128,
        passCandidates: 27,
        recommendations: 3,
        selectedDesign: "균형 최적안",
        approved: true
    };
    public readonly runSnapshots: any = {
        "NX4-PTG-2404": { journeyStep: 7, stage: "Approval 완료", status: "완료", requirements: 8, designVariables: 5, simulationCandidates: 128, passCandidates: 27, recommendations: 3, selectedDesign: "균형 최적안", approved: true },
        "EV9-FRK-1182": { journeyStep: 2, stage: "Requirement 확인", status: "확인 대기", requirements: 11, designVariables: 3, simulationCandidates: 0, passCandidates: 0, recommendations: 0, selectedDesign: "—", approved: false },
        "SD-DRV-0831": { journeyStep: 5, stage: "Simulation 재해석", status: "실행 중", requirements: 9, designVariables: 4, simulationCandidates: 96, passCandidates: 34, recommendations: 0, selectedDesign: "—", approved: false },
        "GV7-SPL-0719": { journeyStep: 4, stage: "Simulation 중단", status: "재실행 필요", requirements: 7, designVariables: 4, simulationCandidates: 64, passCandidates: 0, recommendations: 0, selectedDesign: "—", approved: false }
    };
    public readonly serviceJourney: any[] = [
        { key: "input", number: "01", label: "자연어 입력", owner: "사용자 → 요구사항 Agent", output: "설계 요청", route: "workspace" },
        { key: "requirements", number: "02", label: "요구사항 확정", owner: "요구사항 Agent + 사용자", output: "Design Brief", route: "workspace", evidence: "design-brief" },
        { key: "design", number: "03", label: "설계·부품 생성", owner: "기구학·부품선정·최적화 Agent", output: "설계 후보", route: "workspace", evidence: "design-components" },
        { key: "cae", number: "04", label: "CAE·자동 재설계", owner: "해석/검증 ↔ 최적화 Agent", output: "Validation Pack", route: "workspace", evidence: "validation-pack" },
        { key: "recommendation", number: "05", label: "최적안 추천", owner: "평가/선정 Agent", output: "추천안 3개", route: "workspace", evidence: "recommendation" },
        { key: "evidence", number: "06", label: "Evidence 검토", owner: "사용자 검토", output: "Evidence Pack", route: "evidence" },
        { key: "approval", number: "07", label: "최종 승인", owner: "승인 권한자", output: "Decision Record", route: "approvals" },
        { key: "report", number: "08", label: "보고서·전달", owner: "Report Output", output: "Final Report", route: "reports" }
    ];
    public section: string = "projects";
    public routeItem: string = "";
    public routeSubscription: any = null;
    public selectedRun: number = 0;
    public selectedApproval: number = 0;
    public approvalSearchText: string = "";
    public approvalDateFilter: string = "all";
    public approvalApproverFilter: string = "all";
    public approvalStatusFilter: string = "all";
    public decisionObjectExpanded: boolean = false;
    public selectedProject: number = 0;
    public componentCategory: string = "전체";
    public componentSearchText: string = "";
    public componentMakerFilter: string = "전체";
    public componentPriceFilter: string = "all";
    public componentTemperatureFilter: string = "all";
    public componentConfidenceFilter: string = "all";
    public componentVerificationFilter: string = "전체";
    public componentStateFilter: string = "전체";
    public componentSortOrder: string = "agent";
    public selectedComponent: any = null;
    public componentDetailOpen: boolean = false;
    public selectedRunComponentPart: string = "";
    public componentSelectionNotice: string = "";
    public knowledgeFilter: string = "전체";
    public knowledgeDataFilter: string = "전체";
    public knowledgeStatusFilter: string = "전체";
    public knowledgeMetricFilter: string = "전체";
    public knowledgeSearchText: string = "";
    public knowledgeEvidenceId: string = "";
    public selectedKnowledge: any = null;
    public knowledgeDetailOpen: boolean = false;
    public knowledgeRegistrationOpen: boolean = false;
    public knowledgeRegistrationMode: "create" | "edit" = "create";
    public knowledgeEditingId: string = "";
    public knowledgeDraft: any = this.emptyKnowledgeDraft();
    public searchText: string = "";
    public projectMetricFilter: string = "all";
    public projectStatusFilter: string = "all";
    public projectOwnerFilter: string = "all";
    public projectUpdatedFilter: string = "all";
    public projectSortOrder: string = "recent";
    public runSearchText: string = "";
    public runStatusFilter: string = "all";
    public runProjectFilter: string = "all";
    public runSortOrder: string = "newest";
    public expandedTimelineIndex: number = -1;
    public selectedTimelineStage: string = "all";
    public selectedEvidence: any = null;
    public evidenceDetailOpen: boolean = false;
    public reportTypeFilter: string = "all";
    public reportProjectFilter: string = "all";
    public reportRunFilter: string = "NX4-PTG-2404";
    public reportApprovalFilter: string = "all";
    public reportVersionFilter: string = "latest";
    public reportDirectLinkId: string = "";
    public reportLinkOrigin: string = "";
    public selectedReport: any = null;
    public reportPreviewOpen: boolean = false;
    public reportCompareOpen: boolean = false;
    public reportConfirmOpen: boolean = false;
    public reportPreviewPage: number = 1;
    public readonly reportPreviewBaseWidth: number = 630;
    public readonly reportPreviewBaseHeight: number = 891;
    public readonly reportPreviewFitMin: number = 10;
    public readonly reportPreviewZoomMin: number = 25;
    public readonly reportPreviewZoomMax: number = 150;
    public readonly reportPreviewZoomStep: number = 10;
    public reportPreviewZoom: number = 65;
    public reportPreviewZoomMode: "fit" | "manual" = "fit";
    private reportPreviewResizeTimer: any = null;
    public selectedReportVersion: string = "";
    public reportDownloadFormats: any = {};
    public reportPackageFormat: string = "ZIP";
    public reportPackageMenuOpen: boolean = false;
    public reportPackageSelection: any = {};

    public pageMeta: any = {
        projects: {
            eyebrow: "PROJECT PORTFOLIO",
            title: "Projects",
            description: "차종과 설계 과제별 컨텍스트, Agent 진행 단계, 승인 상태를 관리합니다."
        },
        runs: {
            eyebrow: "AGENT EXECUTION RECORDS",
            title: "Agent Runs",
            description: "Run 목록을 조회하고 선택한 실행의 Agent 판단, 전달 데이터와 복구 이력을 시간순으로 확인합니다."
        },
        evidence: {
            eyebrow: "TRACEABLE VALIDATION EVIDENCE",
            title: "Evidence",
            description: "선택한 Run의 입력 스냅샷, Agent Handoff와 Simulation 검증 근거를 승인 전에 확인합니다."
        },
        approvals: {
            eyebrow: "HUMAN DECISION AUDIT",
            title: "Approval History",
            description: "승인 결과가 아니라 결정 근거와 변경 이력을 승인자·버전·Evidence와 함께 추적합니다."
        },
        knowledge: {
            eyebrow: "ENGINEERING KNOWLEDGE",
            title: "Knowledge Hub",
            description: "Agent가 설계 시 참고하는 승인 지식과 Run 결과에서 자동 축적된 근거를 검색하고 추적합니다."
        },
        components: {
            eyebrow: "QUALIFIED PARTS DATA",
            title: "Component Library",
            description: "모터·감속기·스핀들·브라켓 후보와 호환성, 원가, 검증 상태를 조회합니다."
        },
        reports: {
            eyebrow: "EVIDENCE DELIVERABLES",
            title: "Reports",
            description: "설계 Run의 요구사항, Agent 판단, CAE 검증 및 승인 근거를 문서로 내보냅니다."
        },
        settings: {
            eyebrow: "PLATFORM CONTROL",
            title: "Settings",
            description: "Agent 자율 실행 범위, 승인 Gate, 알림과 데이터 연계 정책을 설정합니다."
        },
        guide: {
            eyebrow: "PLATFORM USER GUIDE",
            title: "이용가이드",
            description: "현재 구현된 7단계 AI Workspace와 Run·Evidence·승인·보고서 연결 흐름을 안내합니다."
        },
        profile: {
            eyebrow: "ACCOUNT & AUTHORITY",
            title: "My Profile",
            description: "내 역할과 프로젝트 권한, 최근 승인 활동을 확인합니다."
        }
    };

    public selectedGuideMenu: string = "workspace";
    public guideMenuGroups: any[] = [
        {
            label: "설계·운영",
            caption: "WORKFLOW",
            items: [
                {
                    key: "workspace",
                    icon: "AI",
                    name: "AI Workspace",
                    eyebrow: "CREATE & DECIDE",
                    phase: "설계 작업",
                    description: "자연어 요청을 7단계 Journey로 진행하고 추천 설계안을 비교·확정하는 작업 화면입니다.",
                    when: "새 Run을 시작하거나 완성된 Agent Run 예시를 빠르게 체험할 때",
                    route: "/dashboard",
                    action: "AI Workspace 열기",
                    features: [
                        { title: "요청·자료 입력", detail: "자연어 목표와 CAD·PDF·이미지·카탈로그 파일을 선택해 Run 컨텍스트에 추가합니다." },
                        { title: "요구사항 검토", detail: "추출된 값·단위·출처·Confidence를 원문과 비교하고 수정·제외·확정합니다." },
                        { title: "7단계 결과 확인", detail: "Agent 역할·Handoff, 후보 탐색, 예시 CAE 복구, 추천안 비교와 최종 확정을 순서대로 체험합니다." }
                    ],
                    result: "현재 Run의 요구사항, Journey 단계, 추천안과 승인 상태가 브라우저에 저장되어 플랫폼 메뉴의 Current Context에 반영됩니다.",
                    next: "Agent Runs → Evidence → Approval History → Reports 순서로 같은 Run을 확인합니다.",
                    note: "요구사항 분석과 Agent·CAD·CAE 결과는 현재 데모 시나리오의 예시 동작이며 실제 Solver나 생성 시스템을 호출하지 않습니다."
                },
                {
                    key: "projects",
                    icon: "PJ",
                    name: "Projects",
                    eyebrow: "PORTFOLIO",
                    phase: "프로젝트 운영",
                    description: "여러 설계 과제의 Current Run 단계, 진행률과 승인 상태를 비교하는 포트폴리오입니다.",
                    when: "어떤 과제를 먼저 확인하거나 이어서 작업할지 정할 때",
                    route: "/platform/projects",
                    action: "Projects 열기",
                    features: [
                        { title: "지표로 빠른 필터", detail: "전체, 진행 중, 승인 대기와 이번 달 Run 지표를 선택해 목록을 좁힙니다." },
                        { title: "검색·정렬", detail: "프로젝트명·Run을 검색하고 상태, 담당자, 수정일과 진행률 기준으로 필터·정렬합니다." },
                        { title: "Run 작업 이동", detail: "카드에서 현재 Run 이력, 선택 Run ID의 Workspace 또는 새 Run 입력 화면으로 이동합니다." }
                    ],
                    result: "선택한 프로젝트의 Run이 Current Context가 되며 연결 화면에서도 같은 Run ID를 유지합니다.",
                    next: "실행 과정은 Agent Runs, 설계 단계는 AI Workspace에서 이어서 확인합니다.",
                    note: "프로젝트·지표는 데모 예시 데이터이며 선택 Run과 필터는 현재 브라우저에 저장됩니다."
                },
                {
                    key: "runs",
                    icon: "RN",
                    name: "Agent Runs",
                    eyebrow: "EXECUTION",
                    phase: "실행 추적",
                    description: "선택한 Run의 단계, Agent 입력·판단·출력·Handoff와 복구 흐름을 재구성합니다.",
                    when: "Agent의 판단 근거 또는 FAIL 이후 변경 과정을 찾을 때",
                    route: "/platform/runs",
                    action: "Agent Runs 열기",
                    features: [
                        { title: "Run 검색·필터", detail: "Run ID, 프로젝트, Part No.를 검색하고 상태·프로젝트·시간순으로 목록을 좁힙니다." },
                        { title: "단계·복구 흐름", detail: "Requirement부터 Approval까지 단계 상태와 FAIL → 재설계 → PASS 복구 여부를 봅니다." },
                        { title: "실행 로그 상세", detail: "단계별 로그를 선택하고 각 이벤트의 입력, Agent 판단, 출력과 다음 Handoff를 펼쳐 봅니다." }
                    ],
                    result: "선택한 Run이 공통 Current Context로 바뀌고 해당 Run의 실행·복구 근거를 단계별로 확인할 수 있습니다.",
                    next: "입력·검증 근거는 Evidence, 사용자 결정은 Approval History에서 이어서 봅니다.",
                    note: "현재 타임라인과 재생은 데모 로그이며 실제 Agent 실행 서버의 실시간 로그는 아닙니다."
                },
                {
                    key: "evidence",
                    icon: "EV",
                    name: "Evidence",
                    eyebrow: "TRACEABILITY",
                    phase: "설계 근거",
                    description: "현재 Run에서 생성된 입력·판단·Simulation 근거를 승인 전에 순서와 버전으로 확인합니다.",
                    when: "추천 또는 승인 판단에 사용된 원문과 검증 근거를 추적할 때",
                    route: "/platform/evidence",
                    action: "Evidence 열기",
                    features: [
                        { title: "Run 근거 현황", detail: "전체, 검증 완료, 확인 필요와 생성 대기 Evidence 수를 현재 Run 기준으로 봅니다." },
                        { title: "Lineage 확인", detail: "Evidence 생성 순서를 보고 카드에서 Source, Version, 상태와 연결 Run을 확인합니다." },
                        { title: "원본 화면 이동", detail: "근거 카드를 통해 AI Workspace 단계, Reports 또는 연결된 Knowledge 사용 이력으로 이동합니다." }
                    ],
                    result: "Approval에서 참조할 현재 Run의 Evidence 범위와 확인 필요 항목을 파악할 수 있습니다.",
                    next: "판단 근거 확인 후 Approval History에서 결정 기록과 연결 Evidence를 함께 봅니다.",
                    note: "Evidence 레지스트리는 데모 데이터와 브라우저 Run 컨텍스트로 구성되며 운영용 불변 원본 저장소는 연결되지 않았습니다."
                },
                {
                    key: "approvals",
                    icon: "AP",
                    name: "Approval History",
                    eyebrow: "DECISION",
                    phase: "승인 감사",
                    description: "요구사항 확정, 후보 선택과 최종 설계 결정의 근거·변경 전후·Evidence를 확인합니다.",
                    when: "승인·반려 근거를 검토하거나 감사 기록이 필요할 때",
                    route: "/platform/approvals",
                    action: "Approval History 열기",
                    features: [
                        { title: "결정 기록 탐색", detail: "기록·결정·승인자를 검색하고 날짜, 승인자와 상태로 현재 Run 이력을 필터링합니다." },
                        { title: "변경·반려 추적", detail: "승인 대상 조건, 판단 메모, 변경 전후 값과 반려 사유·재요청 Run을 확인합니다." },
                        { title: "Evidence·감사 내보내기", detail: "연결 Evidence로 이동하고 선택한 승인 레코드를 JSON 감사 기록으로 다운로드합니다." }
                    ],
                    result: "선택한 Human Gate의 승인자·시각·판단·변경·Evidence가 한 레코드 단위로 표시되고 내보내집니다.",
                    next: "승인 보고서와 Run 결과 패키지는 Reports에서 이어서 확인합니다.",
                    note: "화면의 Audit Hash는 DEMO 검증값이며 운영 감사 서명이나 서버 무결성 증명이 아닙니다."
                }
            ]
        },
        {
            label: "설계 자산",
            caption: "ENGINEERING DATA",
            items: [
                {
                    key: "knowledge",
                    icon: "KH",
                    name: "Knowledge Hub",
                    eyebrow: "KNOWLEDGE",
                    phase: "지식 관리",
                    description: "Agent가 참고할 승인 지식과 Run에서 축적된 시험·CAE·실패 근거를 관리·추적합니다.",
                    when: "추천이나 재설계에 사용된 규칙과 시험 근거를 찾을 때",
                    route: "/platform/knowledge",
                    action: "Knowledge Hub 열기",
                    features: [
                        { title: "복합 검색·필터", detail: "유형, 승인 상태, 등록 주체, Data Map과 검색어를 함께 적용해 지식을 찾습니다." },
                        { title: "출처·사용 이력", detail: "원문, 버전, 적용 규칙·Agent, 생성 Run과 사용 이력을 보고 해당 Run Evidence로 이동합니다." },
                        { title: "권한 기반 승인", detail: "관리 권한이 있으면 설계 규칙·전문가 지식을 등록·수정하고 검토 필요 지식을 승인합니다." }
                    ],
                    result: "직접 등록·수정한 데모 지식과 승인 상태가 브라우저에 저장되며, 승인된 항목과 Run 사용 근거를 구분해 볼 수 있습니다.",
                    next: "지식이 사용된 판단은 Evidence, 실행 순서는 Agent Runs에서 확인합니다.",
                    note: "신규 지식과 승인 변경은 현재 브라우저에만 저장되며 운영 원문 저장소·승인 API·Agent 적용에는 연결되지 않습니다."
                },
                {
                    key: "components",
                    icon: "CL",
                    name: "Component Library",
                    eyebrow: "PARTS",
                    phase: "부품 데이터",
                    description: "현재 Run 설계 변수에 맞춰 부품의 추천·호환성·Confidence·사용 이력을 비교합니다.",
                    when: "후보 부품의 사양·원가·호환 가능성을 비교할 때",
                    route: "/platform/components",
                    action: "Component Library 열기",
                    features: [
                        { title: "검색·상세 필터", detail: "유형, 제조사, 가격, 온도, Confidence, 검증·선택 상태를 함께 적용하고 정렬합니다." },
                        { title: "추천·호환 근거", detail: "추천 이유와 Confidence 산정 기준, 현재 Run 호환성, 상세 사양·CAD·데이터시트를 봅니다." },
                        { title: "후보·사용 이력", detail: "현재 Run 후보 선택 결과를 확인하고 Part No.로 이전 사용 Run 목록을 바로 필터링합니다." }
                    ],
                    result: "호환·조건부·선택 불가 판단과 후보 추가 피드백을 현재 화면에서 확인할 수 있습니다.",
                    next: "이전 사용 이력은 Agent Runs의 Part No. 필터로 이어서 확인합니다.",
                    note: "후보 선택은 데모 피드백이며 실제 Run BOM을 변경하지 않습니다. DB 동기화와 CAD·데이터시트 원본 열기도 데모 안내입니다."
                },
                {
                    key: "reports",
                    icon: "RP",
                    name: "Reports",
                    eyebrow: "DELIVERABLES",
                    phase: "산출물 관리",
                    description: "완료된 Run의 설계·검증·승인 내용을 공유 가능한 산출물로 제공합니다.",
                    when: "리뷰, 감사 또는 외부 전달용 문서가 필요할 때",
                    route: "/platform/reports",
                    action: "Reports 열기",
                    features: [
                        { title: "Design Report 중심 산출물", detail: "핵심 설계 보고서와 보조 Simulation Evidence·Approval Record를 함께 봅니다." },
                        { title: "필터·버전 조회", detail: "유형, 프로젝트, Run, 승인 상태, 최신 버전과 생성 Agent를 확인합니다." },
                        { title: "미리보기·버전 비교", detail: "Current와 Previous 버전의 주요 변경 내용을 비교하고 내보낼 버전을 선택합니다." },
                        { title: "파일·패키지 다운로드", detail: "개별 보고서 또는 선택한 문서 묶음을 PDF·ZIP·JSON 파일로 다운로드합니다." }
                    ],
                    result: "선택한 버전의 요약 보고서 또는 Run 단위 manifest 패키지가 브라우저에서 파일로 생성됩니다.",
                    next: "원본 실행은 Agent Runs, 결정 원장은 Approval History에서 확인합니다.",
                    note: "DEMO 샘플과 실제 생성 표시는 배지로 구분되지만, 다운로드 파일은 현재 화면 데이터로 만든 요약본이며 원본 CAD·Solver 파일은 포함하지 않습니다."
                }
            ]
        },
        {
            label: "시스템",
            caption: "SYSTEM",
            items: [
                {
                    key: "settings",
                    icon: "ST",
                    name: "Settings",
                    eyebrow: "POLICY",
                    phase: "플랫폼 정책",
                    description: "프로젝트 공통·개별 범위에서 Agent 정책의 영향과 데모 변경 이력을 확인합니다.",
                    when: "자동화 범위, 승인 Gate 또는 데이터 정책을 조정할 때",
                    route: "/platform/settings",
                    action: "Settings 열기",
                    features: [
                        { title: "적용 범위 선택", detail: "전체 프로젝트 기본값과 프로젝트별 샘플 정책을 독립적으로 선택합니다." },
                        { title: "영향 확인·변경", detail: "영향받는 Agent·Workflow와 고위험 경고를 확인한 뒤 정책 토글을 변경합니다." },
                        { title: "저장·Audit Log", detail: "변경값을 브라우저에 즉시 저장하고 변경자, 전후 값, 대상과 영향을 이력으로 봅니다." }
                    ],
                    result: "선택 범위의 데모 설정값과 Audit Log가 현재 브라우저 저장소에 기록됩니다.",
                    next: "Settings의 Audit Log 탭에서 방금 변경한 값과 적용 대상을 확인합니다.",
                    note: "변경값은 서버 정책이나 실제 Agent 실행에 적용되지 않으며 브라우저 데이터를 지우거나 다른 기기를 사용하면 공유되지 않습니다."
                },
                {
                    key: "profile",
                    icon: "ME",
                    name: "My Profile",
                    eyebrow: "ACCOUNT",
                    phase: "계정·권한",
                    description: "내 계정에 부여된 역할과 설계·승인 가능 범위를 확인합니다.",
                    when: "실행이나 승인 기능이 제한되었거나 내 활동을 확인할 때",
                    route: "/platform/profile",
                    action: "My Profile 열기",
                    features: [
                        { title: "계정 요약", detail: "이름, 이메일, 직무와 프로젝트·승인 활동 지표를 봅니다." },
                        { title: "권한 확인", detail: "Workspace 관리자, Run 실행, 최종 승인과 규칙 변경 권한을 봅니다." },
                        { title: "최근 결정 조회", detail: "최근 승인·반려 결정과 처리 상태를 확인합니다." }
                    ],
                    result: "로그인 계정 정보와 데모 시나리오에서 표시하는 역할·활동 범위를 확인할 수 있습니다.",
                    next: "권한에 맞는 작업은 AI Workspace, 승인 활동은 Approval History에서 진행합니다.",
                    note: "이름·이메일은 로그인 세션을 사용하지만 직무, 권한과 활동 지표는 현재 데모 시나리오의 예시입니다."
                }
            ]
        }
    ];

    public projects: any[] = [
        {
            code: "NX4",
            runId: "NX4-PTG-2404",
            projectGroup: "NX4",
            title: "NX4 Tailgate Actuator",
            type: "Power Tailgate",
            runs: 8,
            monthlyRuns: 8,
            owner: "김도윤",
            updated: "오늘 10:14",
            updatedAt: "2026-08-04T10:14:00",
            updatedDaysAgo: 0,
            description: "4.5초 개폐와 -30~80°C 조건을 만족하는 전동식 테일게이트 액추에이터 설계"
        },
        {
            code: "EV9",
            runId: "EV9-FRK-1182",
            projectGroup: "EV9",
            title: "EV9 Frunk Actuator",
            type: "Powered Frunk",
            runs: 3,
            monthlyRuns: 3,
            owner: "박현우",
            updated: "오늘 09:32",
            updatedAt: "2026-08-04T09:32:00",
            updatedDaysAgo: 0,
            description: "프렁크 패키지 공간과 저온 작동 성능을 고려한 스핀들 구동계 설계"
        },
        {
            code: "SD",
            runId: "SD-DRV-0831",
            projectGroup: "Sliding Door",
            title: "Sliding Door Drive",
            type: "Power Sliding Door",
            runs: 12,
            monthlyRuns: 12,
            owner: "이서연",
            updated: "어제 17:48",
            updatedAt: "2026-08-03T17:48:00",
            updatedDaysAgo: 1,
            description: "측면 충돌 패키지와 내구 수명을 만족하도록 모터·감속기 조합 최적화"
        },
        {
            code: "GV7",
            runId: "GV7-SPL-0719",
            projectGroup: "GV70",
            title: "GV70 Spoiler Lift",
            type: "Active Spoiler",
            runs: 5,
            monthlyRuns: 5,
            owner: "최민준",
            updated: "3일 전 14:27",
            updatedAt: "2026-08-01T14:27:00",
            updatedDaysAgo: 3,
            description: "스포일러 작동 패키지와 열 조건을 만족하는 리프트 구동계 설계"
        }
    ];

    public runs: any[] = [
        {
            id: "NX4-PTG-2404",
            projectId: "NX4",
            project: "NX4 Tailgate Actuator",
            projectGroup: "NX4",
            status: "완료",
            statusClass: "done",
            executionState: "완료",
            executionStateClass: "complete",
            isCurrent: true,
            autoRecovered: true,
            activeAgentCount: 0,
            totalAgentCount: 6,
            iteration: "03",
            averageRedesign: "1.7회",
            averageCompletionTime: "28m 42s",
            stageKey: "approval",
            currentStage: "Approval 완료",
            currentAgent: "Approval Gate",
            progress: 100,
            started: "2026-07-23 09:42",
            duration: "32m 18s",
            agent: "6 / 6",
            candidates: "12,480 → 128 → 27 → 3",
            approver: "김도윤",
            selected: "균형 최적안",
            score: "94",
            parts: ["BLDC-24-180", "PG-42-01", "SP-12-L6", "BR-NX4-B", "CP-10-FX", "BRG-608-H"],
            summary: "128개 설계 대안 중 구조·간섭·피로·열해석을 모두 통과한 균형 최적안을 승인했습니다."
        },
        {
            id: "EV9-FRK-1182",
            projectId: "EV9",
            project: "EV9 Frunk Actuator",
            projectGroup: "EV9",
            status: "확인 대기",
            statusClass: "review",
            executionState: "실행 중",
            executionStateClass: "running",
            isCurrent: false,
            autoRecovered: false,
            activeAgentCount: 1,
            totalAgentCount: 6,
            iteration: "01",
            averageRedesign: "0.8회",
            averageCompletionTime: "24m 10s",
            stageKey: "requirement",
            currentStage: "Requirement 확인",
            currentAgent: "Requirement Agent",
            progress: 20,
            started: "2026-07-23 09:18",
            duration: "12m 04s",
            agent: "1 / 6",
            candidates: "입력 분석 중",
            approver: "—",
            selected: "—",
            score: "—",
            parts: ["BLDC-24-160", "PG-48-03", "SEAL-12-LT"],
            summary: "Requirement Agent가 CAD와 PDF에서 추출한 11개 요구조건의 사용자 확정을 기다립니다."
        },
        {
            id: "SD-DRV-0831",
            projectId: "SD",
            project: "Sliding Door Drive",
            projectGroup: "Sliding Door",
            status: "실행 중",
            statusClass: "running",
            executionState: "실행 중",
            executionStateClass: "running",
            isCurrent: false,
            autoRecovered: false,
            activeAgentCount: 1,
            totalAgentCount: 6,
            iteration: "02",
            averageRedesign: "2.1회",
            averageCompletionTime: "35m 08s",
            stageKey: "simulation",
            currentStage: "Simulation 재해석",
            currentAgent: "Simulation Agent",
            progress: 60,
            started: "2026-07-22 17:21",
            duration: "27m 41s",
            agent: "5 / 6",
            candidates: "8,960 → 34",
            approver: "—",
            selected: "—",
            score: "—",
            parts: ["BLDC-24-180", "PG-42-01", "BR-SD-A", "SNS-HALL-02"],
            summary: "피로 수명 FAIL 결과를 반영해 Bracket 두께와 장착 위치를 수정하고 재해석 중입니다."
        },
        {
            id: "GV7-SPL-0719",
            projectId: "GV7",
            project: "GV70 Spoiler Lift",
            projectGroup: "GV70",
            status: "재실행 필요",
            statusClass: "retry",
            executionState: "FAIL",
            executionStateClass: "fail",
            isCurrent: false,
            autoRecovered: false,
            activeAgentCount: 0,
            totalAgentCount: 6,
            iteration: "01",
            averageRedesign: "1.3회",
            averageCompletionTime: "31m 26s",
            stageKey: "simulation",
            currentStage: "Simulation 중단",
            currentAgent: "Simulation Agent",
            progress: 60,
            started: "2026-07-19 14:06",
            duration: "18m 52s",
            agent: "4 / 6",
            candidates: "6,240 → 64 → 0",
            approver: "—",
            selected: "—",
            score: "—",
            parts: ["BLDC-24-160", "PG-48-03", "SP-12-L6"],
            summary: "Solver 연결이 중단되어 64개 후보의 열해석 결과를 확정하지 못했습니다. 연결 확인 후 재실행이 필요합니다."
        }
    ];

    public runTimeline: any[] = [
        { time: "09:42:08", agent: "Requirement Agent", action: "요구사항 분석", detail: "자연어·CAD·PDF에서 8개 조건 추출", status: "done", input: "자연어 설계 요청 · NX4_tailgate.step · motor_catalog.pdf", decision: "4.5초 개폐, -30~80°C, 72° 개방각과 기존 Bracket 유지 조건을 필수 검증 항목으로 분류", output: "필수 조건 6개 · 최적화 목표 1개 · 참고 조건 1개", handoff: "사용자 요구사항 검토로 Design Brief v3 전달" },
        { time: "09:45:21", agent: "김도윤", action: "요구사항 승인", detail: "필수 조건 6개·최적화 목표 1개 확정", status: "approval", input: "Design Brief v3 · 추출 요구사항 8개", decision: "Safety Rule v4.2와 NX4 패키지 조건에 맞아 설계 입력으로 사용 가능하다고 승인", output: "요구사항 스냅샷 승인 · 변경 잠금", handoff: "Design Agent에 승인된 요구사항과 설계 변수 5종 전달" },
        { time: "09:51:34", agent: "Design Agent", action: "설계 대안 생성", detail: "12,480개 조합 탐색 · 128개 CAD 대안", status: "done", input: "승인 요구사항 · 부품 라이브러리 v5.8 · 설계 규칙 v4.2", decision: "패키지 적합성과 토크 여유를 우선해 12,480개 조합 중 해석 가치가 높은 128개 후보를 선별", output: "CAD 후보 128개 · 후보 랭킹 및 파라미터 세트", handoff: "Simulation Agent에 해석 후보 128개와 CAE Template v1.9 전달" },
        { time: "10:02:17", agent: "Simulation Agent", action: "Iteration 01 FAIL", detail: "응력 186 MPa · 간섭 -2.1 mm", status: "fail", input: "CAD 후보 128개 · 구조·간섭·피로·열해석 조건", decision: "허용 응력 180 MPa 초과와 음의 패키지 여유가 동시에 발생해 Iteration 01을 FAIL로 판정", output: "응력 한계 초과 · 패키지 간섭 · Failure Evidence #18", handoff: "Design Agent에 FAIL 원인과 제약 위반 좌표 전달" },
        { time: "10:06:42", agent: "Design Agent", action: "자동 재설계", detail: "Bracket Z+8 mm · 감속비 42:1", status: "retry", input: "Iteration 01 FAIL 근거 · 응력/간섭 민감도", decision: "민감도 분석 결과 간섭 해소와 응력 분산 효과가 가장 큰 Z 위치, 두께, 감속비 조합을 변경", output: "Bracket Z+8 mm · 두께 2.4t · 감속비 42:1 변경안", handoff: "Simulation Agent에 수정 CAD와 변경 파라미터 전달" },
        { time: "10:11:05", agent: "Simulation Agent", action: "Iteration 03 PASS", detail: "4개 해석 통과 · PASS 후보 27개", status: "pass", input: "재설계 후보 · 동일 CAE 검증 기준", decision: "동일 Baseline으로 재검증한 구조·간섭·피로·열해석이 모두 기준을 충족해 PASS로 판정", output: "구조·간섭·피로·열해석 PASS · 후보 27개", handoff: "Evaluation Agent에 PASS 후보와 Validation Evidence 전달" },
        { time: "10:12:40", agent: "Evaluation Agent", action: "추천 후보 평가", detail: "PASS 후보 27개를 성능·안전·원가 기준으로 평가해 추천안 3개 선정", status: "done", input: "PASS 후보 27개 · Validation Evidence · 평가 가중치", decision: "성능 40%, 안전 35%, 원가 25% 가중치를 적용해 Pareto 우위 후보 3개를 추천", output: "균형·성능·원가 최적 추천안 3개와 비교 점수", handoff: "Approval Gate에 추천안 비교표와 Decision Evidence 전달" },
        { time: "10:14:26", agent: "김도윤", action: "최종 설계 승인", detail: "균형 최적안 · Evidence Pack v1.4", status: "approval", input: "추천안 3개 · 후보 비교표 · Evidence Pack v1.4", decision: "성능·안전·원가 기준을 모두 충족하고 변경 Trace가 완전한 균형 최적안을 최종 선택", output: "균형 최적안 최종 승인 · 감사 해시 생성", handoff: "Run Archive와 Reports에 승인 결과 및 Evidence 저장" }
    ];

    public approvals: any[] = [
        {
            id: "APR-20260723-042",
            run: "NX4-PTG-2404",
            project: "NX4 Tailgate Actuator",
            decision: "최종 설계 승인",
            type: "final",
            typeLabel: "최종 설계 승인",
            status: "APPROVED",
            statusClass: "approved",
            objectLabel: "최종 승인 대상",
            design: "균형 최적안 · BLDC 24V / 180W",
            approver: "김도윤",
            role: "리드 설계 엔지니어",
            timestamp: "2026-07-23 10:14:26",
            comment: "성능·안전·원가 기준을 모두 충족하며 Iteration 03 검증 근거를 확인함.",
            conditions: [
                { label: "Simulation", value: "구조·간섭·피로·열해석 PASS" },
                { label: "성능 기준", value: "개폐 4.18 s · 토크 31.8 Nm" },
                { label: "안전 기준", value: "안전율 1.82 · 피로 125k cycles" },
                { label: "원가 기준", value: "목표 BOM 범위 충족" }
            ],
            hash: "sha256:a94f…18ce",
            changes: [
                { field: "결정 상태", before: "최종 승인 대기", after: "최종 기준안 확정", note: "승인 이후 기준 설계 변경을 잠금" },
                { field: "Evidence Pack", before: "Validation v1.3", after: "Validation v1.4", note: "Iteration 03 PASS 결과 반영" },
                { field: "감사 기록", before: "해시 미생성", after: "서명·해시 고정", note: "승인자 세션과 근거 버전 보존" }
            ],
            evidence: [
                { key: "design-brief", name: "Design Brief v3", version: "요구사항 8개 · 승인본", status: "VERIFIED", route: "/dashboard", query: { evidence: "design-brief", run: "NX4-PTG-2404" } },
                { key: "simulation-batch", name: "Simulation Batch #128", version: "128개 후보 · Iteration 03", status: "VERIFIED", route: "/dashboard", query: { evidence: "simulation-batch", run: "NX4-PTG-2404" } },
                { key: "validation-pack", name: "Validation Pack v1.4", version: "구조·간섭·피로·열해석", status: "VERIFIED", route: "/platform/reports/NX4-PTG-2404", query: { type: "simulation", report: "RPT-NX4-2404-SIM", from: "approval-history" } },
                { key: "candidate-rank", name: "Candidate Rank #03", version: "최종 후보 3개 · 점수 근거", status: "VERIFIED", route: "/dashboard", query: { evidence: "candidate-rank", run: "NX4-PTG-2404" } }
            ]
        },
        {
            id: "APR-20260723-041",
            run: "NX4-PTG-2404",
            project: "NX4 Tailgate Actuator",
            decision: "균형 최적안 후보 선택",
            type: "candidate",
            typeLabel: "후보 선택",
            status: "APPROVED",
            statusClass: "approved",
            objectLabel: "선택 후보",
            design: "균형 최적안 · 종합 점수 94 / 100",
            approver: "김도윤",
            role: "리드 설계 엔지니어",
            timestamp: "2026-07-23 10:12:48",
            comment: "PASS 후보 27개 중 성능·안전·원가 균형이 가장 높은 안을 최종 승인 후보로 선택함.",
            conditions: [
                { label: "후보 범위", value: "PASS 후보 27개 중 추천 3개" },
                { label: "종합 점수", value: "94 / 100" },
                { label: "Confidence", value: "97%" },
                { label: "선택 기준", value: "성능·안전·원가 균형" }
            ],
            hash: "sha256:9f20…73bd",
            changes: [
                { field: "검토 범위", before: "PASS 후보 27개", after: "추천 후보 3개", note: "Evaluation Agent 다목적 평가 적용" },
                { field: "사용자 선택", before: "미선택", after: "균형 최적안", note: "종합 점수 94점·Confidence 97%" },
                { field: "다음 Gate", before: "후보 비교", after: "최종 승인 요청", note: "선택 후보와 근거 Pack 전달" }
            ],
            evidence: [
                { key: "simulation-batch", name: "Simulation Batch #128", version: "PASS 후보 27개", status: "VERIFIED", route: "/dashboard", query: { evidence: "simulation-batch", run: "NX4-PTG-2404" } },
                { key: "validation-pack", name: "Validation Pack v1.4", version: "Iteration 03 PASS", status: "VERIFIED", route: "/platform/reports/NX4-PTG-2404", query: { type: "simulation", report: "RPT-NX4-2404-SIM", from: "approval-history" } },
                { key: "candidate-rank", name: "Candidate Rank #03", version: "최종 후보 3개", status: "VERIFIED", route: "/dashboard", query: { evidence: "candidate-rank", run: "NX4-PTG-2404" } }
            ]
        },
        {
            id: "APR-20260723-040",
            run: "NX4-PTG-2404",
            project: "NX4 Tailgate Actuator",
            decision: "요구사항 확정",
            type: "requirement",
            typeLabel: "요구사항 확정",
            status: "APPROVED",
            statusClass: "approved",
            objectLabel: "확정 요구사항",
            design: "필수 조건 6 · 목표 1 · 참고 1",
            approver: "김도윤",
            role: "리드 설계 엔지니어",
            timestamp: "2026-07-23 09:45:21",
            comment: "CAD 유지 형상과 안전율 조건을 필수 조건으로 확정함.",
            conditions: [
                { label: "필수 조건", value: "6개" },
                { label: "최적화 목표", value: "1개" },
                { label: "설계 안전율", value: "≥ 1.5" },
                { label: "환경 조건", value: "-30~80°C" }
            ],
            hash: "sha256:4c7b…892a",
            changes: [
                { field: "안전율", before: "초안 ≥ 1.4", after: "확정 ≥ 1.5", note: "사내 Safety Rule v4.2 적용" },
                { field: "브래킷 형상", before: "참고 조건", after: "필수 유지 조건", note: "기존 차체 패키지 영향 차단" },
                { field: "저온 작동", before: "확인 필요", after: "-30°C 확정", note: "환경 시험 기준과 일치" }
            ],
            evidence: [
                { key: "design-brief", name: "Design Brief v3", version: "요구사항 확정본", status: "VERIFIED", route: "/dashboard", query: { evidence: "design-brief", run: "NX4-PTG-2404" } },
                { key: "natural-language-input", name: "Natural Language Input", version: "원문 스냅샷", status: "VERIFIED", route: "/dashboard", query: { evidence: "natural-language-input", run: "NX4-PTG-2404" } },
                { key: "source-cad", name: "NX4_tailgate.step", version: "CAD · 18.4 MB", status: "VERIFIED", route: "/dashboard", query: { evidence: "source-cad", run: "NX4-PTG-2404" } },
                { key: "motor-catalog", name: "motor_catalog.pdf", version: "Data sheet · 2.1 MB", status: "VERIFIED", route: "/dashboard", query: { evidence: "motor-catalog", run: "NX4-PTG-2404" } }
            ]
        },
        {
            id: "APR-20260723-039",
            run: "EV9-FRK-1182",
            project: "EV9 Frunk Actuator",
            decision: "요구사항 검토",
            type: "requirement",
            typeLabel: "요구사항 확정",
            status: "PENDING",
            statusClass: "review",
            objectLabel: "검토 대상",
            design: "11개 추출 조건",
            approver: "박현우",
            role: "프로젝트 매니저",
            timestamp: "검토 요청 · 09:31",
            comment: "저온 토크 기준과 목표 원가의 우선순위 확인이 필요함.",
            conditions: [
                { label: "추출 조건", value: "11개" },
                { label: "확인 필요", value: "저온 토크 기준" },
                { label: "우선순위", value: "성능 ↔ 목표 원가" }
            ],
            hash: "임시 기록",
            changes: [
                { field: "저온 토크", before: "기준 충돌", after: "확정 대기", note: "-30°C 기준 확인 필요" },
                { field: "목표 원가", before: "우선순위 미지정", after: "확정 대기", note: "성능 목표와 우선순위 검토" }
            ],
            evidence: [
                { key: "requirement-draft", name: "Requirement Draft v2", version: "11개 추출 조건", status: "REVIEW", route: "/platform/runs/EV9-FRK-1182", query: {} },
                { key: "ev9-source-cad", name: "EV9_frunk.step", version: "입력 CAD", status: "VERIFIED", route: "/platform/runs/EV9-FRK-1182", query: {} }
            ]
        },
        {
            id: "APR-20260722-036",
            run: "SD-DRV-0828",
            project: "Sliding Door Drive",
            decision: "최종 설계 반려",
            type: "final",
            typeLabel: "최종 설계 승인",
            status: "REJECTED",
            statusClass: "rejected",
            objectLabel: "반려 대상",
            design: "원가 우선안",
            approver: "이서연",
            role: "시뮬레이션 엔지니어",
            timestamp: "2026-07-22 16:08:14",
            comment: "피로 수명 92k cycles로 목표 120k를 충족하지 못해 재설계를 요청함.",
            rejectionReason: "피로 수명 92k cycles로 승인 기준 120k cycles를 28k 미달했습니다.",
            retryRun: "SD-DRV-0831",
            conditions: [
                { label: "피로 결과", value: "92k cycles · FAIL" },
                { label: "승인 기준", value: "≥ 120k cycles" },
                { label: "미달 값", value: "28k cycles" },
                { label: "후속 조치", value: "Bracket 재설계·재해석" }
            ],
            hash: "sha256:77d1…5fe2",
            changes: [
                { field: "승인 상태", before: "최종 승인 요청", after: "반려·재설계 요청", note: "피로 수명 기준 미달" },
                { field: "Bracket 두께", before: "2.2t", after: "2.6t 재설계", note: "재요청 Run SD-DRV-0831에 반영" },
                { field: "장착 위치", before: "기준 좌표", after: "X -4 mm", note: "취약부 응력 분산" }
            ],
            evidence: [
                { key: "fatigue-result", name: "Fatigue Result #0828", version: "92k cycles · FAIL", status: "VERIFIED", route: "/platform/runs/SD-DRV-0831", query: {} },
                { key: "failure-evidence", name: "Failure Evidence #19", version: "취약부·민감도", status: "VERIFIED", route: "/platform/runs/SD-DRV-0831", query: {} }
            ]
        }
    ];

    public readonly knowledgeTypes: string[] = ["전체", "설계 규칙", "시험 데이터", "실패 패턴", "전문가 지식"];
    public readonly manualKnowledgeTypes: string[] = ["설계 규칙", "전문가 지식"];
    public readonly knowledgeDataMaps: any[] = [
        { key: "CAD", label: "CAD", name: "CAD", agents: "기구학·최적화·검증", detail: "형상·좌표·질량 특성" },
        { key: "DB", label: "DB", name: "DB", agents: "부품선정·최적화", detail: "사양·원가·호환 규칙" },
        { key: "CAE", label: "CAE", name: "CAE", agents: "해석·검증·평가", detail: "구조·간섭·피로·열" },
        { key: "K", label: "K", name: "Knowledge", agents: "모든 Agent", detail: "전문가 규칙·실패 패턴" }
    ];
    public knowledgeItems: any[] = [
        {
            id: "KH-RULE-042",
            type: "설계 규칙",
            title: "테일게이트 액추에이터 안전율 기준",
            detail: "정적 하중 안전율 ≥ 1.5 · 충격 하중 ≥ 1.2",
            summary: "테일게이트 구동계의 정적·충격 하중 조합별 최소 안전율과 예외 승인 조건을 정의합니다.",
            version: "Rule v4.2",
            source: "사내 설계표준 MSE-PTG-014",
            original: "정격 위치 전 구간에서 정적 안전율 1.5 이상을 확보하고, 닫힘 충격 하중 조건에서는 1.2 이상을 만족해야 한다.",
            owner: "Safety Engineering",
            validUntil: "2027.12.31",
            status: "approved",
            statusLabel: "승인됨",
            registrationKind: "user",
            registrationLabel: "사용자 등록",
            generationSource: "Safety Engineering 직접 등록",
            createdRun: "직접 등록",
            createdAt: "2026.07.18 14:20",
            dataTypes: ["K", "CAE"],
            appliedAgents: ["Design Agent", "Evaluation Agent"],
            runCount: 18,
            lastUsed: "2026.08.04 · 10:08",
            rules: ["정적 하중 Safety Factor ≥ 1.5", "충격 하중 Safety Factor ≥ 1.2", "미달 후보는 Evaluation 단계에서 자동 제외"],
            history: [
                { runId: "NX4-PTG-2404", agent: "Evaluation Agent", decision: "균형 최적안의 구조 안전성 PASS 판단", result: "SF 1.64 · 승인 근거", usedAt: "2026.08.04 10:08" },
                { runId: "SD-DRV-0831", agent: "Design Agent", decision: "Bracket 두께 2.6t 재설계", result: "Iteration 02 반영", usedAt: "2026.08.03 17:48" }
            ]
        },
        {
            id: "KH-FAIL-031",
            type: "실패 패턴",
            title: "저온 조건 토크 여유 부족",
            detail: "-30°C에서 감속기 효율과 모터 Derating 동시 적용",
            summary: "저온 시 윤활 손실과 모터 출력 저하가 겹쳐 토크 마진이 급감하는 재현 패턴입니다.",
            version: "Pattern #031",
            source: "동계 시험 실패 분석 FA-2025-031",
            original: "-30°C Soak 이후 최초 3회 작동에서 감속 효율 11~16% 저하와 모터 출력 제한이 동시에 관찰됨.",
            owner: "CAE & Validation",
            validUntil: "2026.11.30",
            status: "approved",
            statusLabel: "승인됨",
            registrationKind: "agent",
            registrationLabel: "Agent 자동 생성",
            generationSource: "Simulation Agent · FAIL 원인 분석",
            createdRun: "NX4-PTG-2404",
            createdAt: "2026.08.04 09:44",
            dataTypes: ["CAE", "K"],
            appliedAgents: ["Simulation Agent", "Design Agent"],
            runCount: 7,
            lastUsed: "2026.08.04 · 09:46",
            rules: ["-20°C 이하에서 감속 효율 보정 동시 적용", "가용 토크 마진 12% 미만 시 재설계", "저온 FAIL 시 모터·감속비 조합 재탐색"],
            failureFlow: [
                { stage: "Simulation FAIL", detail: "NX4-PTG-2403 · 토크 마진 7%" },
                { stage: "원인 분석", detail: "저온 효율·모터 Derating 중첩" },
                { stage: "재설계", detail: "42:1 감속기 · 180 W 모터" },
                { stage: "PASS", detail: "NX4-PTG-2404 · 토크 마진 16%" }
            ],
            history: [
                { runId: "EV9-FRK-1182", agent: "Requirement Agent", decision: "저온 토크 기준 사용자 확인 요청", result: "Requirement Review", usedAt: "2026.08.04 09:31" },
                { runId: "NX4-PTG-2404", agent: "Simulation Agent", decision: "저온 작동 후보 14개 제외", result: "114개 후보 전달", usedAt: "2026.08.04 09:46" }
            ]
        },
        {
            id: "KH-TEST-118",
            type: "시험 데이터",
            title: "NX4 실차 개폐 하중 프로파일",
            detail: "차체 경사각과 실링 반력을 포함한 125k cycle 하중",
            summary: "실차 개폐 시험에서 수집한 위치별 하중 곡선과 환경 조건을 Simulation 입력으로 정규화했습니다.",
            version: "Test 24-118",
            source: "Vehicle Test / NX4-PTG-125K.csv",
            original: "차체 경사 -8°~+12°, -30~80°C 조건에서 125,000 cycle의 스핀들 축력과 모터 전류를 10 ms 간격으로 계측.",
            owner: "Vehicle Test",
            validUntil: "2027.06.30",
            status: "approved",
            statusLabel: "승인됨",
            registrationKind: "system",
            registrationLabel: "시스템 연동",
            generationSource: "Vehicle Test Data Lake 연동",
            createdRun: "NX4-PTG-2404",
            createdAt: "2026.08.04 09:18",
            dataTypes: ["CAE", "CAD"],
            appliedAgents: ["Simulation Agent", "Evaluation Agent"],
            runCount: 11,
            lastUsed: "2026.08.04 · 09:52",
            rules: ["경사각별 95 percentile 하중 적용", "실링 반력은 위치 곡선으로 보간", "125k cycle 피로 등가하중으로 변환"],
            history: [
                { runId: "NX4-PTG-2404", agent: "Simulation Agent", decision: "128개 후보의 실차 등가하중 해석", result: "27개 PASS", usedAt: "2026.08.04 09:52" }
            ]
        },
        {
            id: "KH-GUIDE-027",
            type: "전문가 지식",
            title: "Bracket 장착 좌표 설계 가이드",
            detail: "힌지 회전축과 가스 스프링 간 간섭 회피 규칙",
            summary: "숙련 설계자의 패키지 검토 기준을 좌표 제약과 간섭 검사 순서로 구조화한 가이드입니다.",
            version: "Guide v2.7",
            source: "Expert Note EN-BRACKET-07",
            original: "힌지 축 기준 X ±12 mm, Z +6~14 mm 범위에서 초기 후보를 생성하고 가스 스프링 Swept Volume과 최소 4 mm 이격한다.",
            owner: "김도윤",
            validUntil: "2026.09.15",
            status: "review",
            statusLabel: "검토 필요",
            registrationKind: "user",
            registrationLabel: "사용자 등록",
            generationSource: "김도윤 · Expert Note 등록",
            createdRun: "직접 등록",
            createdAt: "2026.08.04 09:12",
            dataTypes: ["CAD", "K"],
            appliedAgents: ["Kinematics Agent", "Design Agent"],
            runCount: 12,
            lastUsed: "2026.08.04 · 09:38",
            rules: ["힌지 기준 좌표 허용 범위 적용", "Swept Volume 최소 간격 4 mm", "예외 후보는 전문가 확인 Gate로 전달"],
            history: [
                { runId: "SD-DRV-0831", agent: "Design Agent", decision: "취약부 회피를 위해 장착점 X -4 mm 이동", result: "재해석 중", usedAt: "2026.08.03 17:48" },
                { runId: "NX4-PTG-2404", agent: "Kinematics Agent", decision: "간섭 후보 22개 사전 제외", result: "106개 후보 전달", usedAt: "2026.08.04 09:38" }
            ]
        },
        {
            id: "KH-RULE-066",
            type: "설계 규칙",
            title: "모터·감속기 조합 적합성 규칙",
            detail: "정격 전압, 연속 토크, 온도 등급과 공급 상태 교차 검증",
            summary: "부품 DB 후보를 작동점과 환경 요구조건에 맞춰 자동 제외하는 조합 규칙입니다.",
            version: "Rule v3.1",
            source: "Component DB Policy CP-066",
            original: "정격 전압 불일치, 연속 토크 마진 15% 미만, 온도 등급 미달 부품은 조합 후보에서 제외한다.",
            owner: "Component Engineering",
            validUntil: "2027.03.31",
            status: "approved",
            statusLabel: "승인됨",
            registrationKind: "system",
            registrationLabel: "시스템 연동",
            generationSource: "Component DB 정책 동기화",
            createdRun: "DB SYNC #804",
            createdAt: "2026.08.04 08:40",
            dataTypes: ["DB", "K"],
            appliedAgents: ["Component Agent", "Optimization Agent"],
            runCount: 24,
            lastUsed: "2026.08.04 · 09:42",
            rules: ["연속 토크 마진 ≥ 15%", "요구 온도 범위 완전 포함", "단종·공급 제한 부품 자동 제외"],
            history: [
                { runId: "NX4-PTG-2404", agent: "Component Agent", decision: "BLDC-24-180 + PG-42-01 조합 선정", result: "적합도 98%", usedAt: "2026.08.04 09:42" },
                { runId: "GV7-SPL-0719", agent: "Optimization Agent", decision: "원가·토크 조건으로 조합 73% 축소", result: "64개 해석 후보", usedAt: "2026.08.02 14:18" }
            ]
        },
        {
            id: "KH-TEST-126",
            type: "시험 데이터",
            title: "EV9 프렁크 저온 작동 시험",
            detail: "-30°C Soak 8h 이후 초기 작동 전류와 개폐 시간",
            summary: "EV9 선행 시제의 저온 작동 결과로, 측정 장비 교정 검토가 남아 있는 임시 데이터입니다.",
            version: "Test 26-041 draft",
            source: "Vehicle Test / EV9-LT-041.csv",
            original: "-30°C Soak 8h 조건에서 3대 시제의 최초 작동 전류와 개폐 시간을 측정. 채널 4 영점 보정 확인 필요.",
            owner: "Vehicle Test",
            validUntil: "2026.08.31",
            status: "review",
            statusLabel: "검토 필요",
            registrationKind: "system",
            registrationLabel: "시스템 연동",
            generationSource: "Vehicle Test Data Lake 연동",
            createdRun: "EV9-FRK-1182",
            createdAt: "2026.08.04 09:27",
            dataTypes: ["CAE"],
            appliedAgents: ["Requirement Agent"],
            runCount: 1,
            lastUsed: "2026.08.04 · 09:29",
            rules: ["검증 완료 전 참고 근거로만 사용", "최종 승인 근거에는 포함 금지", "채널 4 교정 확인 후 버전 승격"],
            history: [
                { runId: "EV9-FRK-1182", agent: "Requirement Agent", decision: "저온 토크 요구사항 충돌 감지", result: "사용자 확인 대기", usedAt: "2026.08.04 09:29" }
            ]
        }
    ];

    public readonly componentRunConstraints: any[] = [
        { key: "voltage", label: "정격 전압", value: "24 V" },
        { key: "ambient", label: "사용 온도", value: "-30~85°C" },
        { key: "package", label: "패키지 한계", value: "Ø48 × 430 mm" },
        { key: "torque", label: "출력 토크", value: "≥ 34 Nm" },
        { key: "interface", label: "장착 인터페이스", value: "NX4 PTG v3" }
    ];
    public readonly primaryComponentCategories: string[] = ["모터", "감속기", "스핀들", "브라켓"];

    public components: any[] = [
        {
            category: "모터", part: "BLDC-24-180", maker: "Mobility Motion", spec: "24 V · 180 W · 4,800 rpm", cost: "₩38,200", costValue: 38200,
            temp: "-40~105°C", tempMin: -40, tempMax: 105, confidence: "98%", confidenceValue: 98, verification: "verified", verificationLabel: "검증 완료",
            state: "applied", stateLabel: "적용 완료", compatibility: "compatible", compatibilityLabel: "5/5 호환", compatibilityScore: 100,
            summary: "NX4 Tailgate Actuator의 기준 모터로, 정격 전압과 저온 기동 토크 조건을 모두 만족합니다.", scope: ["Power Tailgate", "Power Frunk", "Sliding Door"],
            specs: [{ label: "정격 출력", value: "180 W" }, { label: "무부하 속도", value: "4,800 rpm" }, { label: "정격 토크", value: "0.36 Nm" }, { label: "보호 등급", value: "IP67" }],
            checks: [{ label: "정격 전압 24 V", result: "PASS", detail: "Run 기준과 일치" }, { label: "저온 -30°C", result: "PASS", detail: "보증 하한 -40°C" }, { label: "패키지 Ø48 mm", result: "PASS", detail: "외경 Ø42 mm" }, { label: "CAN / Hall Interface", result: "PASS", detail: "기존 ECU 연결 가능" }],
            assets: [{ type: "CAD", name: "BLDC-24-180_revC.step", meta: "STEP · Rev C · 8.4 MB" }, { type: "PDF", name: "BLDC-24-180_datasheet.pdf", meta: "Data sheet · v3.2" }],
            history: [{ runId: "NX4-PTG-2404", decision: "최종 설계 적용", result: "Iteration 03 PASS", usedAt: "2026.07.23" }, { runId: "SD-DRV-0831", decision: "재설계 후보 추천", result: "Simulation 진행 중", usedAt: "2026.07.22" }]
        },
        {
            category: "모터", part: "BLDC-24-160", maker: "DriveCore", spec: "24 V · 160 W · 4,500 rpm", cost: "₩31,400", costValue: 31400,
            temp: "-30~100°C", tempMin: -30, tempMax: 100, confidence: "94%", confidenceValue: 94, verification: "verified", verificationLabel: "검증 완료",
            state: "candidate", stateLabel: "후보", compatibility: "conditional", compatibilityLabel: "4/5 조건부", compatibilityScore: 80,
            summary: "목표 원가에는 유리하지만, 최대 래치 해제 조건에서 토크 마진 확인이 필요한 대체 모터입니다.", scope: ["Power Frunk", "Compact Tailgate"],
            specs: [{ label: "정격 출력", value: "160 W" }, { label: "무부하 속도", value: "4,500 rpm" }, { label: "정격 토크", value: "0.31 Nm" }, { label: "보호 등급", value: "IP67" }],
            checks: [{ label: "정격 전압 24 V", result: "PASS", detail: "Run 기준과 일치" }, { label: "저온 -30°C", result: "PASS", detail: "보증 하한과 동일" }, { label: "출력 토크 마진", result: "CHECK", detail: "-30°C에서 6% 부족 가능" }, { label: "장착 인터페이스", result: "PASS", detail: "어댑터 없이 체결" }],
            assets: [{ type: "CAD", name: "BLDC-24-160_revB.step", meta: "STEP · Rev B · 7.9 MB" }, { type: "PDF", name: "DC160_catalog.pdf", meta: "Data sheet · v2.8" }],
            history: [{ runId: "EV9-FRK-1182", decision: "원가 우선 후보", result: "요구사항 확인 대기", usedAt: "2026.07.23" }, { runId: "GV7-SPL-0719", decision: "초기 후보 추천", result: "Solver 재실행 필요", usedAt: "2026.07.19" }]
        },
        {
            category: "감속기", part: "PG-42-01", maker: "GearWorks", spec: "42:1 · 효율 82% · 36 Nm", cost: "₩14,800", costValue: 14800,
            temp: "-40~100°C", tempMin: -40, tempMax: 100, confidence: "97%", confidenceValue: 97, verification: "verified", verificationLabel: "검증 완료",
            state: "recommended", stateLabel: "추천", compatibility: "compatible", compatibilityLabel: "5/5 호환", compatibilityScore: 100,
            summary: "현재 Run의 토크·속도 균형 점수가 가장 높은 유성 감속기입니다.", scope: ["Power Tailgate", "Sliding Door", "Spoiler Lift"],
            specs: [{ label: "감속비", value: "42:1" }, { label: "전달 효율", value: "82%" }, { label: "최대 토크", value: "36 Nm" }, { label: "Backlash", value: "≤ 1.2°" }],
            checks: [{ label: "출력 토크 ≥ 34 Nm", result: "PASS", detail: "정격 36 Nm" }, { label: "패키지 외경 Ø48 mm", result: "PASS", detail: "외경 Ø44 mm" }, { label: "저온 -30°C", result: "PASS", detail: "저온 그리스 검증" }, { label: "모터 축 인터페이스", result: "PASS", detail: "BLDC-24 계열 공용" }],
            assets: [{ type: "CAD", name: "PG-42-01_assy.step", meta: "STEP · Rev D · 12.6 MB" }, { type: "PDF", name: "PG42_validation.pdf", meta: "Validation sheet · v4.1" }],
            history: [{ runId: "NX4-PTG-2404", decision: "Agent 추천 및 적용", result: "종합 적합도 97%", usedAt: "2026.07.23" }, { runId: "SD-DRV-0831", decision: "피로 재설계 조합", result: "Simulation 진행 중", usedAt: "2026.07.22" }]
        },
        {
            category: "감속기", part: "PG-48-03", maker: "GearWorks", spec: "48:1 · 효율 79% · 40 Nm", cost: "₩13,200", costValue: 13200,
            temp: "-30~90°C", tempMin: -30, tempMax: 90, confidence: "91%", confidenceValue: 91, verification: "conditional", verificationLabel: "조건부 검증",
            state: "excluded", stateLabel: "제외", exclusionReason: "작동 시간 4.2초로 목표 3.8초를 초과", compatibility: "incompatible", compatibilityLabel: "3/5 불일치", compatibilityScore: 60,
            summary: "출력 토크는 충분하지만 감속비 증가로 작동 시간 목표를 충족하지 못해 현재 Run에서 제외했습니다.", scope: ["High-load Tailgate", "Industrial Lift"],
            specs: [{ label: "감속비", value: "48:1" }, { label: "전달 효율", value: "79%" }, { label: "최대 토크", value: "40 Nm" }, { label: "Backlash", value: "≤ 1.5°" }],
            checks: [{ label: "출력 토크 ≥ 34 Nm", result: "PASS", detail: "정격 40 Nm" }, { label: "작동 시간 ≤ 3.8초", result: "FAIL", detail: "예측 4.2초" }, { label: "고온 85°C", result: "PASS", detail: "보증 상한 90°C" }, { label: "소음 ≤ 48 dBA", result: "CHECK", detail: "실차 검증 필요" }],
            assets: [{ type: "CAD", name: "PG-48-03_revA.step", meta: "STEP · Rev A · 13.1 MB" }, { type: "PDF", name: "PG48_datasheet.pdf", meta: "Data sheet · v1.6" }],
            history: [{ runId: "EV9-FRK-1182", decision: "고하중 후보", result: "조건부 유지", usedAt: "2026.07.23" }, { runId: "GV7-SPL-0719", decision: "열해석 후보", result: "결과 미확정", usedAt: "2026.07.19" }]
        },
        {
            category: "스핀들", part: "SP-12-L6", maker: "LinearTech", spec: "Ø12 · Lead 6 · 420 mm", cost: "₩11,900", costValue: 11900,
            temp: "-40~100°C", tempMin: -40, tempMax: 100, confidence: "96%", confidenceValue: 96, verification: "verified", verificationLabel: "검증 완료",
            state: "recommended", stateLabel: "추천", compatibility: "compatible", compatibilityLabel: "5/5 호환", compatibilityScore: 100,
            summary: "스트로크와 좌굴 안전율을 모두 만족하는 표준 스핀들 후보입니다.", scope: ["Power Tailgate", "Power Frunk", "Spoiler Lift"],
            specs: [{ label: "스크류 직경", value: "Ø12 mm" }, { label: "Lead", value: "6 mm" }, { label: "전장", value: "420 mm" }, { label: "좌굴 하중", value: "4.8 kN" }],
            checks: [{ label: "전장 ≤ 430 mm", result: "PASS", detail: "전장 420 mm" }, { label: "좌굴 안전율 ≥ 1.5", result: "PASS", detail: "해석 1.72" }, { label: "저온 -30°C", result: "PASS", detail: "보증 하한 -40°C" }, { label: "너트 인터페이스", result: "PASS", detail: "NX4 표준" }],
            assets: [{ type: "CAD", name: "SP-12-L6_420.step", meta: "STEP · Rev F · 5.2 MB" }, { type: "PDF", name: "SP12_specification.pdf", meta: "Data sheet · v5.0" }],
            history: [{ runId: "NX4-PTG-2404", decision: "Agent 추천 및 적용", result: "좌굴 PASS", usedAt: "2026.07.23" }, { runId: "GV7-SPL-0719", decision: "패키지 후보", result: "열해석 대기", usedAt: "2026.07.19" }]
        },
        {
            category: "브라켓", part: "BR-NX4-B", maker: "Internal", spec: "SPFH590 · 2.4t · Z+8", cost: "₩3,500", costValue: 3500,
            temp: "비해당", tempMin: null, tempMax: null, confidence: "99%", confidenceValue: 99, verification: "verified", verificationLabel: "CAE 검증 완료",
            state: "applied", stateLabel: "적용 완료", compatibility: "compatible", compatibilityLabel: "5/5 호환", compatibilityScore: 100,
            summary: "Iteration 03에서 간섭과 피로 수명을 통과한 NX4 전용 브라켓입니다.", scope: ["NX4 Tailgate Actuator"],
            specs: [{ label: "재질", value: "SPFH590" }, { label: "두께", value: "2.4t" }, { label: "장착 위치", value: "Z +8 mm" }, { label: "최대 응력", value: "142 MPa" }],
            checks: [{ label: "차체 인터페이스", result: "PASS", detail: "NX4 PTG v3 기준" }, { label: "패키지 간섭", result: "PASS", detail: "최소 여유 3.4 mm" }, { label: "피로 수명", result: "PASS", detail: "156k cycles" }, { label: "안전율 ≥ 1.5", result: "PASS", detail: "해석 1.63" }],
            assets: [{ type: "CAD", name: "BR-NX4-B_iter03.step", meta: "STEP · Iteration 03 · 4.7 MB" }, { type: "PDF", name: "BR-NX4-B_CAE.pdf", meta: "CAE result · v1.4" }],
            history: [{ runId: "NX4-PTG-2404", decision: "Iteration 03 적용", result: "4개 해석 PASS", usedAt: "2026.07.23" }]
        },
        {
            category: "커플링", part: "CP-10-FX", maker: "K-Drive", spec: "Ø10 · 18 Nm · Flexible", cost: "₩6,800", costValue: 6800,
            temp: "-30~120°C", tempMin: -30, tempMax: 120, confidence: "93%", confidenceValue: 93, verification: "verified", verificationLabel: "검증 완료",
            state: "candidate", stateLabel: "후보", compatibility: "compatible", compatibilityLabel: "5/5 호환", compatibilityScore: 100,
            summary: "모터와 감속기 축 편심을 허용하는 플렉시블 커플링 후보입니다.", scope: ["Power Tailgate", "Sliding Door"],
            specs: [{ label: "축 직경", value: "Ø10 mm" }, { label: "허용 토크", value: "18 Nm" }, { label: "편심 허용", value: "0.4 mm" }, { label: "재질", value: "SCM440" }],
            checks: [{ label: "축 직경 Ø10", result: "PASS", detail: "모터 축과 일치" }, { label: "허용 토크", result: "PASS", detail: "요구 대비 1.7배" }, { label: "고온 85°C", result: "PASS", detail: "상한 120°C" }, { label: "조립 공차", result: "PASS", detail: "현 공정 적용 가능" }],
            assets: [{ type: "CAD", name: "CP-10-FX.step", meta: "STEP · Rev B · 2.2 MB" }, { type: "PDF", name: "CP10_datasheet.pdf", meta: "Data sheet · v2.1" }],
            history: [{ runId: "NX4-PTG-2404", decision: "조립 공차 후보", result: "검증 완료", usedAt: "2026.07.23" }]
        },
        {
            category: "베어링", part: "BRG-608-H", maker: "NSK Mobility", spec: "608 · C3 · 3.3 kN", cost: "₩2,900", costValue: 2900,
            temp: "-40~120°C", tempMin: -40, tempMax: 120, confidence: "95%", confidenceValue: 95, verification: "verified", verificationLabel: "검증 완료",
            state: "candidate", stateLabel: "후보", compatibility: "compatible", compatibilityLabel: "5/5 호환", compatibilityScore: 100,
            summary: "고온 내구와 정격 하중을 만족하는 구동축 베어링입니다.", scope: ["Power Tailgate", "Power Frunk", "Sliding Door"],
            specs: [{ label: "규격", value: "608 C3" }, { label: "동정격 하중", value: "3.3 kN" }, { label: "회전 한계", value: "34,000 rpm" }, { label: "Seal", value: "2RS" }],
            checks: [{ label: "축 직경 Ø8", result: "PASS", detail: "설계 축과 일치" }, { label: "수명 150k cycles", result: "PASS", detail: "예측 224k cycles" }, { label: "고온 85°C", result: "PASS", detail: "상한 120°C" }, { label: "방진 Seal", result: "PASS", detail: "2RS 적용" }],
            assets: [{ type: "CAD", name: "BRG-608-H.step", meta: "STEP · Catalog · 1.1 MB" }, { type: "PDF", name: "608H_bearing.pdf", meta: "Data sheet · 4 pages" }],
            history: [{ runId: "NX4-PTG-2404", decision: "내구 후보 적용", result: "피로 PASS", usedAt: "2026.07.23" }]
        },
        {
            category: "씰", part: "SEAL-12-LT", maker: "SealPro", spec: "Ø12 · FKM · IP67", cost: "₩1,700", costValue: 1700,
            temp: "-25~150°C", tempMin: -25, tempMax: 150, confidence: "88%", confidenceValue: 88, verification: "review", verificationLabel: "검증 필요",
            state: "excluded", stateLabel: "제외", exclusionReason: "저온 보증 하한 -25°C로 Run 기준 -30°C 미달", compatibility: "incompatible", compatibilityLabel: "4/5 불일치", compatibilityScore: 80,
            summary: "고온 성능은 우수하지만 현재 Run의 저온 환경 요구조건을 만족하지 못합니다.", scope: ["Interior Actuator", "Warm-climate Tailgate"],
            specs: [{ label: "축 직경", value: "Ø12 mm" }, { label: "재질", value: "FKM" }, { label: "보호 등급", value: "IP67" }, { label: "마찰 계수", value: "0.18" }],
            checks: [{ label: "축 직경 Ø12", result: "PASS", detail: "스핀들 규격과 일치" }, { label: "저온 -30°C", result: "FAIL", detail: "보증 하한 -25°C" }, { label: "고온 85°C", result: "PASS", detail: "상한 150°C" }, { label: "IP67", result: "PASS", detail: "침수 시험 완료" }],
            assets: [{ type: "CAD", name: "SEAL-12-LT.step", meta: "STEP · Rev A · 0.8 MB" }, { type: "PDF", name: "SEAL12_material.pdf", meta: "Material sheet · v1.0" }],
            history: [{ runId: "EV9-FRK-1182", decision: "환경 조건 비교", result: "저온 검토 중", usedAt: "2026.07.23" }]
        },
        {
            category: "센서", part: "SNS-HALL-02", maker: "M-Sense", spec: "Hall · 5 V · Dual channel", cost: "₩4,600", costValue: 4600,
            temp: "-40~125°C", tempMin: -40, tempMax: 125, confidence: "90%", confidenceValue: 90, verification: "conditional", verificationLabel: "조건부 검증",
            state: "candidate", stateLabel: "후보", compatibility: "conditional", compatibilityLabel: "4/5 조건부", compatibilityScore: 80,
            summary: "위치 검출 범위는 충족하지만 현재 ECU 커넥터 변환이 필요한 Hall 센서 후보입니다.", scope: ["Power Tailgate", "Sliding Door", "Seat Actuator"],
            specs: [{ label: "입력 전압", value: "5 V" }, { label: "채널", value: "Dual" }, { label: "응답 주파수", value: "20 kHz" }, { label: "보호 등급", value: "IP6K7" }],
            checks: [{ label: "입력 전압 5 V", result: "PASS", detail: "ECU 출력과 일치" }, { label: "Dual channel", result: "PASS", detail: "진단 요구 충족" }, { label: "저온 -30°C", result: "PASS", detail: "하한 -40°C" }, { label: "커넥터 인터페이스", result: "CHECK", detail: "변환 Harness 필요" }],
            assets: [{ type: "CAD", name: "SNS-HALL-02.step", meta: "STEP · Rev A · 1.4 MB" }, { type: "PDF", name: "HALL02_datasheet.pdf", meta: "Data sheet · v1.3" }],
            history: [{ runId: "SD-DRV-0831", decision: "진단 강화 후보", result: "Harness 검토 중", usedAt: "2026.07.22" }]
        }
    ];

    public reports: any[] = [
        {
            id: "RPT-NX4-2404-DES", type: "design", typeLabel: "설계 보고서", category: "DESIGN REPORT",
            title: "NX4 Tailgate Actuator 설계 종합 보고서", detail: "요구사항 8개, 설계 대안 128개와 최종 추천 근거를 정리했습니다.",
            project: "NX4 Tailgate Actuator", projectGroup: "NX4", run: "NX4-PTG-2404", createdAt: "2026.07.23 10:15", version: "v1.4", previousVersion: "v1.3",
            agent: "Report Agent", approvalStatus: "approved", approvalLabel: "승인 완료", status: "READY", format: "PDF · 8 pages", source: "generated", sourceLabel: "실제 생성"
        },
        {
            id: "RPT-NX4-2404-SIM", type: "simulation", typeLabel: "시뮬레이션 보고서", category: "SIMULATION EVIDENCE",
            title: "구조·간섭·피로·열해석 검증 보고서", detail: "Iteration 01 FAIL부터 Iteration 03 PASS까지 Solver 결과와 판정 규칙을 보존합니다.",
            project: "NX4 Tailgate Actuator", projectGroup: "NX4", run: "NX4-PTG-2404", createdAt: "2026.07.23 10:12", version: "v1.4", previousVersion: "v1.3",
            agent: "Simulation Agent", approvalStatus: "approved", approvalLabel: "승인 완료", status: "VERIFIED", format: "PDF · 8 pages", source: "generated", sourceLabel: "실제 생성"
        },
        {
            id: "RPT-NX4-2404-APR", type: "approval", typeLabel: "승인 보고서", category: "APPROVAL RECORD",
            title: "승인 및 의사결정 감사 보고서", detail: "요구사항 확정, 후보 선택과 최종 승인 시점의 근거·담당자·감사 해시를 기록합니다.",
            project: "NX4 Tailgate Actuator", projectGroup: "NX4", run: "NX4-PTG-2404", createdAt: "2026.07.23 10:14", version: "v1.1", previousVersion: "v1.0",
            agent: "Audit Agent", approvalStatus: "approved", approvalLabel: "승인 완료", status: "SIGNED", format: "PDF/A · 8 pages", source: "generated", sourceLabel: "실제 생성"
        },
        {
            id: "RPT-EV9-1182-DES", type: "design", typeLabel: "설계 보고서", category: "DESIGN REPORT",
            title: "EV9 Frunk Actuator 요구사항 분석 보고서", detail: "확정 대기 중인 11개 요구조건과 확인 질문을 보여주는 데모 문서입니다.",
            project: "EV9 Frunk Actuator", projectGroup: "EV9", run: "EV9-FRK-1182", createdAt: "2026.07.23 09:32", version: "v0.2", previousVersion: "v0.1",
            agent: "Requirement Agent", approvalStatus: "pending", approvalLabel: "승인 대기", status: "DRAFT", format: "PDF · 8 pages", source: "demo", sourceLabel: "DEMO 샘플"
        },
        {
            id: "RPT-EV9-1182-SIM", type: "simulation", typeLabel: "시뮬레이션 보고서", category: "SIMULATION EVIDENCE",
            title: "EV9 사전 검증 조건 보고서", detail: "실행 전 Solver 조건과 예정 검증 항목을 예시 데이터로 구성했습니다.",
            project: "EV9 Frunk Actuator", projectGroup: "EV9", run: "EV9-FRK-1182", createdAt: "2026.07.23 09:33", version: "v0.2", previousVersion: "v0.1",
            agent: "Simulation Agent", approvalStatus: "pending", approvalLabel: "승인 대기", status: "SAMPLE", format: "PDF · 8 pages", source: "demo", sourceLabel: "DEMO 샘플"
        },
        {
            id: "RPT-EV9-1182-APR", type: "approval", typeLabel: "승인 보고서", category: "APPROVAL RECORD",
            title: "EV9 요구사항 검토 요청 보고서", detail: "승인자 질문과 미확정 요구조건을 보여주는 감사 기록 예시입니다.",
            project: "EV9 Frunk Actuator", projectGroup: "EV9", run: "EV9-FRK-1182", createdAt: "2026.07.23 09:31", version: "v0.2", previousVersion: "v0.1",
            agent: "Audit Agent", approvalStatus: "pending", approvalLabel: "승인 대기", status: "REVIEW", format: "PDF/A · 8 pages", source: "demo", sourceLabel: "DEMO 샘플"
        },
        {
            id: "RPT-SD-0831-DES", type: "design", typeLabel: "설계 보고서", category: "DESIGN REPORT",
            title: "Sliding Door Drive 재설계 보고서", detail: "피로 수명 FAIL 이후 Bracket 두께와 장착 위치 변경안을 정리한 데모 문서입니다.",
            project: "Sliding Door Drive", projectGroup: "Sliding Door", run: "SD-DRV-0831", createdAt: "2026.07.22 17:49", version: "v0.8", previousVersion: "v0.7",
            agent: "Design Agent", approvalStatus: "pending", approvalLabel: "승인 대기", status: "DRAFT", format: "PDF · 8 pages", source: "demo", sourceLabel: "DEMO 샘플"
        },
        {
            id: "RPT-SD-0831-SIM", type: "simulation", typeLabel: "시뮬레이션 보고서", category: "SIMULATION EVIDENCE",
            title: "Sliding Door Fatigue 검증 보고서", detail: "92k cycles FAIL 원인과 Iteration 02 재해석 조건을 담은 데모 Evidence입니다.",
            project: "Sliding Door Drive", projectGroup: "Sliding Door", run: "SD-DRV-0831", createdAt: "2026.07.22 17:48", version: "v0.8", previousVersion: "v0.7",
            agent: "Simulation Agent", approvalStatus: "rejected", approvalLabel: "반려", status: "FAIL", format: "PDF · 8 pages", source: "demo", sourceLabel: "DEMO 샘플", isLatest: false
        },
        {
            id: "RPT-SD-0831-APR", type: "approval", typeLabel: "승인 보고서", category: "APPROVAL RECORD",
            title: "Sliding Door 재실행 결정 보고서", detail: "반려 사유와 재설계 Run 연결을 보여주는 데모 감사 기록입니다.",
            project: "Sliding Door Drive", projectGroup: "Sliding Door", run: "SD-DRV-0831", createdAt: "2026.07.22 17:44", version: "v0.8", previousVersion: "v0.7",
            agent: "Audit Agent", approvalStatus: "rejected", approvalLabel: "반려", status: "REJECTED", format: "PDF/A · 8 pages", source: "demo", sourceLabel: "DEMO 샘플", isLatest: false
        },
        {
            id: "RPT-GV7-0719-DES", type: "design", typeLabel: "설계 보고서", category: "DESIGN REPORT",
            title: "GV70 Spoiler Lift 설계 후보 보고서", detail: "64개 해석 후보와 Solver 중단 시점의 입력을 보존한 데모 문서입니다.",
            project: "GV70 Spoiler Lift", projectGroup: "GV70", run: "GV7-SPL-0719", createdAt: "2026.07.19 14:26", version: "v0.6", previousVersion: "v0.5",
            agent: "Design Agent", approvalStatus: "pending", approvalLabel: "승인 대기", status: "DRAFT", format: "PDF · 8 pages", source: "demo", sourceLabel: "DEMO 샘플"
        },
        {
            id: "RPT-GV7-0719-SIM", type: "simulation", typeLabel: "시뮬레이션 보고서", category: "SIMULATION EVIDENCE",
            title: "GV70 Solver 중단 보고서", detail: "CAE-TIMEOUT-504 오류와 자동 재시도 3회의 로그를 정리한 데모 Evidence입니다.",
            project: "GV70 Spoiler Lift", projectGroup: "GV70", run: "GV7-SPL-0719", createdAt: "2026.07.19 14:25", version: "v0.6", previousVersion: "v0.5",
            agent: "Simulation Agent", approvalStatus: "rejected", approvalLabel: "반려", status: "ERROR", format: "PDF · 8 pages", source: "demo", sourceLabel: "DEMO 샘플", isLatest: false
        },
        {
            id: "RPT-GV7-0719-APR", type: "approval", typeLabel: "승인 보고서", category: "APPROVAL RECORD",
            title: "GV70 재실행 요청 보고서", detail: "중단 원인, 재실행 조건과 운영자 확인 항목을 담은 데모 기록입니다.",
            project: "GV70 Spoiler Lift", projectGroup: "GV70", run: "GV7-SPL-0719", createdAt: "2026.07.19 14:27", version: "v0.6", previousVersion: "v0.5",
            agent: "Audit Agent", approvalStatus: "pending", approvalLabel: "승인 대기", status: "RETRY", format: "PDF/A · 8 pages", source: "demo", sourceLabel: "DEMO 샘플"
        }
    ];

    public settingsView: string = "policy";
    public settingsScope: string = "global";
    public selectedSettingsProject: string = "NX4";
    public settingsAuditScopeFilter: string = "all";
    public settingSaveState: string = "saved";
    public settingSaveMessage: string = "모든 변경사항 저장됨";
    public settingSavedAt: string = "데모 기본값";
    public settingsProjects: any[] = [
        { id: "NX4", name: "NX4 Tailgate Actuator", meta: "NX4 · Tailgate" },
        { id: "EV9", name: "EV9 Frunk Actuator", meta: "EV9 · Frunk" },
        { id: "SD", name: "Sliding Door Drive", meta: "SD · Door" },
        { id: "GV7", name: "GV70 Spoiler Lift", meta: "GV70 · Spoiler" }
    ];
    public settingsGroups: any[] = [
        { key: "automation", title: "자동화 및 승인 정책", caption: "AUTONOMY & HUMAN GATES" },
        { key: "data", title: "데이터·감사 정책", caption: "DATA & TRACEABILITY" }
    ];
    public settingsCatalog: any[] = [
        {
            key: "autoRedesign",
            group: "automation",
            title: "FAIL 시 자동 재설계",
            description: "해석 FAIL 원인을 설계 변수로 변환하고 허용 횟수 안에서 자동으로 재실행합니다.",
            impact: "OFF로 변경하면 FAIL Run이 자동 복구되지 않고 담당자의 수동 재실행을 기다립니다.",
            agents: "Design Agent · Simulation Agent",
            workflow: "Simulation FAIL → 변수 조정 → 재해석",
            risk: "high",
            riskLabel: "높은 영향도",
            riskDetail: "FAIL 이후 복구 방식이 Agent 자동 반복 또는 담당자 수동 재실행으로 전환됩니다.",
            disableDetail: "끄면 FAIL 이후 자동 복구가 중단되고 담당자의 수동 재실행을 기다립니다."
        },
        {
            key: "requireRequirementApproval",
            group: "automation",
            title: "요구사항 확정 Gate",
            description: "Agent 실행 전에 사용자가 필수 조건과 설계 목표를 승인하도록 강제합니다.",
            impact: "OFF로 변경하면 미확정 요구사항 초안도 Design Workflow로 전달될 수 있습니다.",
            agents: "Requirement Agent · Design Agent",
            workflow: "요구사항 검토 → Human Gate → 설계 실행",
            risk: "high",
            riskLabel: "높은 영향도",
            riskDetail: "설계 Agent의 시작 조건과 사용자 개입 시점이 달라집니다.",
            disableDetail: "끄면 사용자 확정 없이 요구사항 초안이 Design Agent에 전달될 수 있습니다."
        },
        {
            key: "requireFinalApproval",
            group: "automation",
            title: "최종 설계 승인 Gate",
            description: "추천 결과가 담당 엔지니어의 승인을 거쳐야 기준안으로 확정되도록 합니다.",
            impact: "OFF로 변경하면 추천안이 최종 승인 없이 기준안과 후속 보고서에 반영될 수 있습니다.",
            agents: "Recommendation Agent · Audit Agent",
            workflow: "추천안 비교 → Human Gate → 기준안 확정",
            risk: "high",
            riskLabel: "높은 영향도",
            riskDetail: "추천안의 기준안 확정 조건과 후속 보고서 발행 시점이 달라집니다.",
            disableDetail: "끄면 추천안이 별도 최종 승인 없이 후속 보고서와 기준안에 반영될 수 있습니다."
        },
        {
            key: "preserveEvidence",
            group: "data",
            title: "승인 근거 영구 보존",
            description: "입력, Agent·규칙·Solver 버전과 사용자 결정을 변경 불가 Evidence로 보존합니다.",
            impact: "OFF로 변경하면 이후 Run의 승인 근거가 영구 보존 대상에서 제외됩니다.",
            agents: "전체 Agent · Audit Agent",
            workflow: "모든 Run → Evidence 고정 → Approval History",
            risk: "standard",
            riskLabel: "감사 정책",
            riskDetail: ""
        },
        {
            key: "notifyFailures",
            group: "data",
            title: "FAIL 즉시 알림",
            description: "하드 제약 위반이나 자동 반복 횟수 초과 시 프로젝트 담당자에게 알립니다.",
            impact: "OFF로 변경하면 FAIL이 발생해도 담당자 알림이 자동 발송되지 않습니다.",
            agents: "Simulation Agent · Notification Service",
            workflow: "FAIL 확정 → 담당자 알림 → 재실행 판단",
            risk: "standard",
            riskLabel: "운영 정책",
            riskDetail: ""
        },
        {
            key: "allowExternalData",
            group: "data",
            title: "외부 데이터 활용",
            description: "승인된 커넥터와 Allowlist에 등록된 외부 지식을 Agent 판단에 사용합니다.",
            impact: "ON으로 변경하면 승인된 외부 데이터가 요구사항 분석과 추천 근거에 포함됩니다.",
            agents: "Requirement Agent · Knowledge Agent",
            workflow: "외부 소스 수집 → 출처 검증 → 요구사항·추천",
            risk: "standard",
            riskLabel: "데이터 정책",
            riskDetail: ""
        }
    ];
    public settingsByScope: any = {
        global: {
            autoRedesign: true,
            requireRequirementApproval: true,
            requireFinalApproval: true,
            notifyFailures: true,
            preserveEvidence: true,
            allowExternalData: false
        },
        projects: {
            NX4: { autoRedesign: true, requireRequirementApproval: true, requireFinalApproval: true, notifyFailures: true, preserveEvidence: true, allowExternalData: false },
            EV9: { autoRedesign: false, requireRequirementApproval: true, requireFinalApproval: true, notifyFailures: true, preserveEvidence: true, allowExternalData: false },
            SD: { autoRedesign: true, requireRequirementApproval: true, requireFinalApproval: true, notifyFailures: true, preserveEvidence: true, allowExternalData: false },
            GV7: { autoRedesign: false, requireRequirementApproval: true, requireFinalApproval: true, notifyFailures: true, preserveEvidence: true, allowExternalData: false }
        }
    };
    public settingAuditLog: any[] = [
        {
            id: "AUD-240804-1024",
            at: "2026.08.04 10:24",
            actor: "박현우",
            role: "Platform Admin",
            scope: "프로젝트 공통",
            scopeType: "global",
            target: "전체 프로젝트",
            setting: "요구사항 확정 Gate",
            before: "OFF",
            after: "ON",
            change: "OFF → ON",
            agents: "Requirement Agent · Design Agent",
            workflow: "요구사항 검토 → Human Gate → 설계 실행"
        },
        {
            id: "AUD-240803-1641",
            at: "2026.08.03 16:41",
            actor: "정초롱",
            role: "Project Owner",
            scope: "프로젝트별",
            scopeType: "project",
            target: "EV9 Frunk Actuator",
            setting: "FAIL 시 자동 재설계",
            before: "ON",
            after: "OFF",
            change: "ON → OFF",
            agents: "Design Agent · Simulation Agent",
            workflow: "Simulation FAIL → 수동 재실행 대기"
        },
        {
            id: "AUD-240801-0912",
            at: "2026.08.01 09:12",
            actor: "박현우",
            role: "Platform Admin",
            scope: "프로젝트 공통",
            scopeType: "global",
            target: "전체 프로젝트",
            setting: "FAIL 즉시 알림",
            before: "OFF",
            after: "ON",
            change: "OFF → ON",
            agents: "Simulation Agent · Notification Service",
            workflow: "FAIL 확정 → 담당자 알림 → 재실행 판단"
        }
    ];

    public async ngOnInit() {
        try {
            await this.service.init();
            await this.service.auth.allow("/access");
            this.loadPlatformState();
            this.loadRunContext();
            this.loadKnowledgeDrafts();
            this.loadDemoSettings();
            this.applyPath(`${location.pathname}${location.search}`);
            this.pageDataState = "ready";
            this.routeSubscription = this.router.events.subscribe(async event => {
                if (!(event instanceof NavigationEnd)) return;
                this.applyPath(event.urlAfterRedirects);
                await this.service.render();
                this.scrollPageTop();
            });
        } catch (error) {
            this.pageDataState = "error";
            this.pageDataMessage = "플랫폼 데이터를 불러오지 못했습니다. 연결을 확인한 뒤 다시 시도해 주세요.";
        }
        await this.service.render();
    }

    public ngOnDestroy() {
        if (this.routeSubscription) this.routeSubscription.unsubscribe();
        if (this.reportPreviewResizeTimer) clearTimeout(this.reportPreviewResizeTimer);
    }

    public applyPath(path: string) {
        let routePath = path || "";
        let queryString = routePath.includes("?") ? routePath.split("?")[1].split("#")[0] : "";
        let cleanPath = routePath.split("?")[0].split("#")[0];
        let segments = cleanPath.split("/").filter(Boolean);
        this.applyRoute(segments[1] || "projects", segments[2] || "");
        let params = new URLSearchParams(queryString);
        if (this.section === "runs") {
            let projectFilter = params.get("project");
            let componentPart = params.get("component");
            if (projectFilter !== null) {
                this.runProjectFilter = this.runProjectOptions.includes(projectFilter) ? projectFilter : "all";
            }
            if (componentPart !== null && componentPart) {
                this.selectedRunComponentPart = componentPart;
                this.runSearchText = componentPart;
                let componentRunIndex = this.runs.findIndex(run => (run.parts || []).includes(componentPart));
                if (componentRunIndex >= 0) {
                    this.selectedRun = componentRunIndex;
                    this.activeRunId = this.runs[componentRunIndex].id;
                    this.expandedTimelineIndex = -1;
                    this.selectedTimelineStage = "all";
                    this.persistActiveRun();
                }
            } else if (componentPart !== null) {
                this.selectedRunComponentPart = "";
            }
        }
        if (this.section === "reports") {
            let requestedType = params.get("type");
            let requestedReportId = params.get("report") || "";
            if (requestedType !== null) {
                this.reportTypeFilter = ["all", "design", "simulation", "approval"].includes(requestedType) ? requestedType : "all";
            }
            this.reportLinkOrigin = params.get("from") || "";
            let directReport = this.reports.find(report => report.id === requestedReportId && report.run === this.activeRunId);
            if (!directReport && this.reportLinkOrigin && this.reportTypeFilter !== "all") {
                directReport = this.reports.find(report => report.run === this.activeRunId && report.type === this.reportTypeFilter);
            }
            if (directReport) {
                this.reportProjectFilter = "all";
                this.reportRunFilter = this.activeRunId;
                this.reportApprovalFilter = "all";
                if (!this.reportIsLatest(directReport)) this.reportVersionFilter = "all";
            }
            this.reportDirectLinkId = directReport?.id || "";
        }
        this.knowledgeEvidenceId = this.section === "evidence" ? params.get("knowledge") || "" : "";
        this.persistPlatformState();
    }

    public applyRoute(section: string, item: string) {
        this.section = this.pageMeta[section] ? section : "projects";
        this.routeItem = decodeURIComponent(item || "");
        if (this.section !== "evidence") {
            this.evidenceDetailOpen = false;
            this.selectedEvidence = null;
        }
        if (this.section !== "knowledge") {
            this.knowledgeDetailOpen = false;
            this.knowledgeRegistrationOpen = false;
        }
        if (this.section !== "components") {
            this.componentDetailOpen = false;
            this.componentSelectionNotice = "";
        }
        let runIndex = this.runs.findIndex(run => run.id === this.routeItem);
        if (runIndex >= 0) {
            this.selectedRun = runIndex;
            this.activeRunId = this.runs[runIndex].id;
            this.selectedSettingsProject = this.runs[runIndex].projectId;
            this.expandedTimelineIndex = -1;
            this.selectedTimelineStage = "all";
            this.persistActiveRun();
            let projectIndex = this.projects.findIndex(project => project.runId === this.activeRunId);
            if (projectIndex >= 0) this.selectedProject = projectIndex;
            this.selectedApproval = 0;
            this.decisionObjectExpanded = false;
            this.resetApprovalFilterState();
        } else {
            let activeIndex = this.runs.findIndex(run => run.id === this.activeRunId);
            if (activeIndex < 0) activeIndex = 0;
            this.selectedRun = activeIndex;
            this.activeRunId = this.runs[activeIndex].id;
            this.selectedSettingsProject = this.runs[activeIndex].projectId;
        }
    }

    public persistActiveRun() {
        if (typeof localStorage === "undefined") return;
        try {
            localStorage.setItem(this.activeRunStorageKey, this.activeRunId);
            this.persistPlatformState();
        } catch (error) {
            // Run-aware URLs remain the fallback when browser storage is restricted.
        }
    }

    public loadPlatformState() {
        if (typeof localStorage === "undefined") return;
        try {
            let stored = JSON.parse(localStorage.getItem(this.platformStateStorageKey) || "null");
            if (!stored || typeof stored !== "object") stored = {};
            let storedActiveRun = localStorage.getItem(this.activeRunStorageKey) || stored.activeRunId;
            let activeIndex = this.runs.findIndex(run => run.id === storedActiveRun);
            if (activeIndex >= 0) {
                this.selectedRun = activeIndex;
                this.activeRunId = this.runs[activeIndex].id;
                let projectIndex = this.projects.findIndex(project => project.code === this.runs[activeIndex].projectId);
                if (projectIndex >= 0) this.selectedProject = projectIndex;
            }
            let filters = stored.filters || {};
            let fields = [
                "searchText", "projectMetricFilter", "projectStatusFilter", "projectOwnerFilter", "projectUpdatedFilter", "projectSortOrder",
                "runSearchText", "runStatusFilter", "runProjectFilter", "runSortOrder", "selectedRunComponentPart",
                "knowledgeFilter", "knowledgeDataFilter", "knowledgeStatusFilter", "knowledgeMetricFilter", "knowledgeSearchText",
                "componentCategory", "componentSearchText", "componentMakerFilter", "componentPriceFilter", "componentTemperatureFilter",
                "componentConfidenceFilter", "componentVerificationFilter", "componentStateFilter", "componentSortOrder",
                "reportTypeFilter", "reportProjectFilter", "reportRunFilter", "reportApprovalFilter", "reportVersionFilter",
                "settingsView", "settingsScope", "selectedSettingsProject", "settingsAuditScopeFilter"
            ];
            fields.forEach(field => {
                if (typeof filters[field] === "string") (this as any)[field] = filters[field];
            });
            if (this.knowledgeStatusFilter === "unverified") this.knowledgeStatusFilter = "review";
            if (!["전체", "approved", "review"].includes(this.knowledgeStatusFilter)) this.knowledgeStatusFilter = "전체";
            if (!["전체", "approved", "review", "auto", "recent"].includes(this.knowledgeMetricFilter)) this.knowledgeMetricFilter = "전체";
            if (!["all", "active", "approval", "completed"].includes(this.projectStatusFilter)) {
                this.projectStatusFilter = "all";
            }
            if (!["all", "active", "approval", "monthly"].includes(this.projectMetricFilter)) {
                this.projectMetricFilter = "all";
            }
            if (["active", "approval"].includes(this.projectMetricFilter)) {
                this.projectStatusFilter = this.projectMetricFilter;
            } else if (["active", "approval"].includes(this.projectStatusFilter)) {
                this.projectMetricFilter = this.projectStatusFilter;
            } else if (this.projectStatusFilter === "completed") {
                this.projectMetricFilter = "all";
            }
        } catch (error) {
            // Invalid or restricted storage falls back to the in-memory defaults.
        }
    }

    public persistPlatformState() {
        if (typeof localStorage === "undefined") return;
        try {
            let fields = [
                "searchText", "projectMetricFilter", "projectStatusFilter", "projectOwnerFilter", "projectUpdatedFilter", "projectSortOrder",
                "runSearchText", "runStatusFilter", "runProjectFilter", "runSortOrder", "selectedRunComponentPart",
                "knowledgeFilter", "knowledgeDataFilter", "knowledgeStatusFilter", "knowledgeMetricFilter", "knowledgeSearchText",
                "componentCategory", "componentSearchText", "componentMakerFilter", "componentPriceFilter", "componentTemperatureFilter",
                "componentConfidenceFilter", "componentVerificationFilter", "componentStateFilter", "componentSortOrder",
                "reportTypeFilter", "reportProjectFilter", "reportRunFilter", "reportApprovalFilter", "reportVersionFilter",
                "settingsView", "settingsScope", "selectedSettingsProject", "settingsAuditScopeFilter"
            ];
            let filters: any = {};
            fields.forEach(field => filters[field] = (this as any)[field]);
            localStorage.setItem(this.activeRunStorageKey, this.activeRunId);
            localStorage.setItem(this.platformStateStorageKey, JSON.stringify({
                version: 1,
                activeProjectId: this.activeProjectId,
                activeRunId: this.activeRunId,
                filters,
                updatedAt: new Date().toISOString()
            }));
        } catch (error) {
            // Run-aware URLs remain the fallback when browser storage is restricted.
        }
    }

    public onFilterChange() {
        this.persistPlatformState();
    }

    public retryPageData() {
        if (typeof location !== "undefined") location.reload();
    }

    public loadRunContext() {
        if (typeof localStorage === "undefined") return;
        try {
            let stored = JSON.parse(localStorage.getItem(this.runStorageKey) || "null");
            if (stored && stored.runId) this.linkedRunContext = { ...this.linkedRunContext, ...stored };
        } catch (error) {
            this.linkedRunContext = { ...this.linkedRunContext };
        }
    }

    public scrollPageTop() {
        let node: any = document.querySelector(".platform-demo-page");
        while (node) {
            node.scrollTop = 0;
            node = node.parentElement;
        }
    }

    public get meta() {
        return this.pageMeta[this.section];
    }

    public get runProjectOptions() {
        return Array.from(new Set(this.runs.map(run => run.projectGroup)));
    }

    public get contextProjectOptions() {
        return this.runs.map(run => ({ id: run.projectId, name: run.project }))
            .filter((project, index, rows) => rows.findIndex(item => item.id === project.id) === index);
    }

    public get activeProjectId() {
        return this.currentRun?.projectId || this.contextProjectOptions[0]?.id || "—";
    }

    public get activeProjectLabel() {
        return this.currentRun?.project || this.contextProjectOptions[0]?.name || "프로젝트 미선택";
    }

    public get contextRunOptions() {
        return this.runs.filter(run => run.projectId === this.activeProjectId);
    }

    public get projectStatusOptions() {
        return [
            { value: "active", label: "진행 중" },
            { value: "approval", label: "승인 대기" },
            { value: "completed", label: "완료" }
        ];
    }

    public get projectOwnerOptions() {
        return Array.from(new Set(this.projects.map(project => project.owner))).sort();
    }

    public projectRunContext(runId: string) {
        if (runId === this.linkedRunContext.runId) return this.linkedRunContext;
        return this.runSnapshots[runId] || {};
    }

    public projectWorkflowStatus(context: any) {
        let step = Number(context.journeyStep || 1);
        if (context.approved) return "완료";
        if (step >= 6) return "승인 대기";
        if (step >= 5) return "검증 중";
        if (step >= 3) return "설계 중";
        return "분석 중";
    }

    public projectStatusClass(status: string) {
        let tones: any = {
            "분석 중": "running",
            "설계 중": "running",
            "검증 중": "running",
            "승인 대기": "review",
            "완료": "approved"
        };
        return tones[status] || "waiting";
    }

    public projectStageLabel(context: any) {
        let step = Math.max(1, Math.min(7, Number(context.journeyStep || 1)));
        let stages: any = {
            1: "입력 분석",
            2: "요구사항 분석",
            3: "설계 대안 생성",
            4: "Agent 협업",
            5: "시뮬레이션 검증",
            6: "설계안 비교",
            7: "최종 확정"
        };
        return stages[step];
    }

    public projectWorkflowProgress(context: any) {
        let step = Math.max(1, Math.min(7, Number(context.journeyStep || 1)));
        return Math.round((step / 7) * 100);
    }

    public projectApprovalStatus(context: any) {
        let step = Number(context.journeyStep || 1);
        if (context.approved) return "승인 완료";
        if (step === 2) return "요구사항 승인 대기";
        if (step >= 6) return "최종 승인 대기";
        return "승인 요청 전";
    }

    public get projectRows() {
        return this.projects.map(project => {
            let context = this.projectRunContext(project.runId);
            let status = this.projectWorkflowStatus(context);
            let journeyStep = Math.max(1, Math.min(7, Number(context.journeyStep || 1)));
            let approvalClass = context.approved ? "pass" : journeyStep === 2 || journeyStep >= 6 ? "review" : "waiting";
            let filterStatus = context.approved ? "completed" : approvalClass === "review" ? "approval" : "active";
            return {
                ...project,
                status,
                statusClass: this.projectStatusClass(status),
                progress: this.projectWorkflowProgress(context),
                journeyStep,
                workflowStageCount: 7,
                workflowProgressLabel: context.approved ? "7 / 7 단계 완료" : `${journeyStep} / 7 단계 도달`,
                currentStage: this.projectStageLabel(context),
                approvalStatus: this.projectApprovalStatus(context),
                approvalClass,
                filterStatus
            };
        });
    }

    public get projectStats() {
        let rows = this.projectRows;
        return {
            total: rows.length,
            active: rows.filter(project => project.filterStatus === "active").length,
            completed: rows.filter(project => project.filterStatus === "completed").length,
            approval: rows.filter(project => project.filterStatus === "approval").length,
            monthlyRuns: rows.reduce((total, project) => total + Number(project.monthlyRuns || 0), 0)
        };
    }

    public get filteredProjects() {
        let query = this.searchText.trim().toLowerCase();
        let filtered = this.projectRows.filter(project => {
            let matchesSearch = !query || [project.code, project.title, project.type, project.description, project.runId]
                .some(value => String(value || "").toLowerCase().includes(query));
            let matchesMetric = this.projectMetricFilter === "all"
                || (this.projectMetricFilter === "active" && project.filterStatus === "active")
                || (this.projectMetricFilter === "approval" && project.filterStatus === "approval")
                || (this.projectMetricFilter === "monthly" && Number(project.monthlyRuns || 0) > 0);
            let matchesStatus = this.projectStatusFilter === "all" || project.filterStatus === this.projectStatusFilter;
            let matchesOwner = this.projectOwnerFilter === "all" || project.owner === this.projectOwnerFilter;
            let updatedLimit: any = { today: 0, week: 7, month: 30 };
            let matchesUpdated = this.projectUpdatedFilter === "all"
                || Number(project.updatedDaysAgo || 0) <= updatedLimit[this.projectUpdatedFilter];
            return matchesSearch && matchesMetric && matchesStatus && matchesOwner && matchesUpdated;
        });
        return [...filtered].sort((first, second) => {
            if (this.projectSortOrder === "oldest") return first.updatedAt.localeCompare(second.updatedAt);
            if (this.projectSortOrder === "progress") return second.progress - first.progress;
            if (this.projectSortOrder === "name") return first.title.localeCompare(second.title);
            return second.updatedAt.localeCompare(first.updatedAt);
        });
    }

    public get hasActiveProjectFilters() {
        return Boolean(this.searchText.trim())
            || this.projectMetricFilter !== "all"
            || this.projectStatusFilter !== "all"
            || this.projectOwnerFilter !== "all"
            || this.projectUpdatedFilter !== "all"
            || this.projectSortOrder !== "recent";
    }

    public get filteredRuns() {
        let query = this.runSearchText.trim().toLowerCase();
        let filtered = this.runs.filter(run => {
            let matchesSearch = !query || [run.id, run.project, run.summary, ...(run.parts || [])]
                .some(value => String(value || "").toLowerCase().includes(query));
            let matchesStatus = this.runStatusFilter === "all" || run.executionStateClass === this.runStatusFilter;
            let matchesProject = this.runProjectFilter === "all" || run.projectGroup === this.runProjectFilter;
            return matchesSearch && matchesStatus && matchesProject;
        });
        return [...filtered].sort((first, second) => this.runSortOrder === "oldest"
            ? first.started.localeCompare(second.started)
            : second.started.localeCompare(first.started));
    }

    public get hasActiveRunFilters() {
        return Boolean(this.runSearchText.trim())
            || this.runStatusFilter !== "all"
            || this.runProjectFilter !== "all"
            || this.runSortOrder !== "newest";
    }

    public get currentRun() {
        let run = this.runs[this.selectedRun];
        if (!run || this.activeRunId !== this.linkedRunContext.runId || run.id !== this.linkedRunContext.runId) return run;
        let hasRecommendation = Number(this.linkedRunContext.journeyStep || 0) >= 6;
        return {
            ...run,
            status: this.linkedRunContext.approved ? "완료" : this.linkedRunContext.status || run.status,
            statusClass: this.linkedRunContext.approved ? "done" : hasRecommendation ? "review" : "running",
            selected: hasRecommendation ? this.linkedRunContext.selectedDesign || run.selected : "—",
            approver: this.linkedRunContext.approved ? run.approver : "—"
        };
    }

    public get currentRunKpis() {
        let run = this.currentRun || {};
        let activeAgentCount = Number(run.activeAgentCount || 0);
        let totalAgentCount = Number(run.totalAgentCount || 6);
        return [
            {
                label: "실행 중 Agent",
                value: `${activeAgentCount} / ${totalAgentCount}`,
                detail: activeAgentCount > 0 ? `${run.currentAgent} 작업 중` : `${run.executionState || run.status} · 활성 Agent 없음`,
                tone: activeAgentCount > 0 ? "running" : "neutral"
            },
            {
                label: "현재 Iteration",
                value: `Iteration ${run.iteration || "01"}`,
                detail: run.currentStage || "실행 단계 확인 중",
                tone: run.executionStateClass === "fail" ? "fail" : "iteration"
            },
            {
                label: "평균 재설계 횟수",
                value: run.averageRedesign || "0.0회",
                detail: `${run.projectGroup || run.project || "선택 프로젝트"} 최근 완료 Run 기준`,
                tone: "redesign"
            },
            {
                label: "평균 완료 시간",
                value: run.averageCompletionTime || run.duration || "—",
                detail: `${run.projectGroup || run.project || "선택 프로젝트"} 완료 Run 평균`,
                tone: "duration"
            }
        ];
    }

    public get currentApproval() {
        let approval = this.runApprovals[this.selectedApproval] || this.runApprovals[0] || this.approvals[0];
        if (!approval || !this.linkedRunContext.approved || approval.run !== this.linkedRunContext.runId || approval.decision !== "최종 설계 승인") return approval;
        return {
            ...approval,
            design: approval.design.includes(this.linkedRunContext.selectedDesign || "")
                ? approval.design
                : this.linkedRunContext.selectedDesign || approval.design,
            comment: approval.comment
        };
    }

    public get runApprovals() {
        let linked = this.approvals.filter(item => item.run === this.activeRunId || item.retryRun === this.activeRunId);
        if (linked.length > 0) return linked;
        return [{
            id: "APPROVAL-NOT-CREATED",
            run: this.activeRunId,
            project: this.currentRun.project,
            decision: "Approval 대기",
            type: "pending",
            typeLabel: "승인 요청 전",
            status: "PENDING",
            statusClass: "review",
            objectLabel: "승인 대상",
            design: "—",
            approver: "—",
            role: "승인자 미지정",
            timestamp: "기록 없음",
            comment: "현재 Run에는 아직 연결된 Approval 기록이 없습니다.",
            conditions: [],
            hash: "생성 전",
            changes: [],
            evidence: []
        }];
    }

    public approvalDateKey(approval: any) {
        let timestampMatch = String(approval?.timestamp || "").match(/\d{4}-\d{2}-\d{2}/);
        if (timestampMatch) return timestampMatch[0];
        let idMatch = String(approval?.id || "").match(/APR-(\d{4})(\d{2})(\d{2})/);
        return idMatch ? `${idMatch[1]}-${idMatch[2]}-${idMatch[3]}` : "";
    }

    public get approvalDateOptions() {
        return Array.from(new Set(this.runApprovals.map(item => this.approvalDateKey(item)).filter(Boolean))).sort().reverse();
    }

    public get approvalApproverOptions() {
        return Array.from(new Set(this.runApprovals.map(item => item.approver).filter(value => value && value !== "—"))).sort();
    }

    public get filteredRunApprovals() {
        let query = this.approvalSearchText.trim().toLowerCase();
        return this.runApprovals.filter(approval => {
            let matchesSearch = !query || [approval.id, approval.decision, approval.typeLabel, approval.project, approval.approver, approval.comment]
                .some(value => String(value || "").toLowerCase().includes(query));
            let matchesDate = this.approvalDateFilter === "all" || this.approvalDateKey(approval) === this.approvalDateFilter;
            let matchesApprover = this.approvalApproverFilter === "all" || approval.approver === this.approvalApproverFilter;
            let matchesStatus = this.approvalStatusFilter === "all" || approval.status === this.approvalStatusFilter;
            return matchesSearch && matchesDate && matchesApprover && matchesStatus;
        });
    }

    public get hasActiveApprovalFilters() {
        return Boolean(this.approvalSearchText.trim())
            || this.approvalDateFilter !== "all"
            || this.approvalApproverFilter !== "all"
            || this.approvalStatusFilter !== "all";
    }

    public get currentApprovalConditions() {
        if ((this.currentApproval.conditions || []).length > 0) return this.currentApproval.conditions;
        return (this.currentApproval.changes || []).map((change: any) => ({ label: change.field, value: change.after }));
    }

    public approvalStatusCount(status: string) {
        return this.runApprovals.filter(item => item.status === status).length;
    }

    public approvalStatusLabel(status: string) {
        let labels: any = {
            APPROVED: "승인 완료",
            PENDING: "확인 대기",
            REJECTED: "반려",
            REVIEW: "재검토"
        };
        return labels[status] || status;
    }

    public approvalStatusClass(status: string) {
        let classes: any = {
            APPROVED: "approved",
            PENDING: "review",
            REJECTED: "rejected",
            REVIEW: "retry"
        };
        return classes[status] || "waiting";
    }

    public evidenceDestinationLabel(evidence: any) {
        let destinations: any = {
            "design-brief": "Requirement 상세",
            "natural-language-input": "Requirement 상세",
            "source-cad": "CAD 상세",
            "motor-catalog": "Data sheet 상세",
            "simulation-batch": "Simulation 상세",
            "validation-pack": "Report 상세",
            "candidate-rank": "후보 비교 상세",
            "requirement-draft": "Requirement Run",
            "ev9-source-cad": "Requirement Run",
            "fatigue-result": "Simulation Run",
            "failure-evidence": "Simulation Run"
        };
        return destinations[evidence?.key] || "Evidence 상세";
    }

    public get activeRunContext() {
        if (this.activeRunId === this.linkedRunContext.runId) return this.linkedRunContext;
        return this.runSnapshots[this.activeRunId] || {};
    }

    public get currentRunTimeline() {
        if (this.activeRunId === "EV9-FRK-1182") {
            return [
                { time: "09:18:04", agent: "Requirement Agent", action: "요구사항 분석", detail: "자연어·CAD·PDF에서 11개 조건 추출", status: "done", input: "EV9 프렁크 설계 요청 · EV9_frunk.step · 성능 기준 PDF", output: "필수 조건 8개 · 목표 2개 · 확인 항목 1개", handoff: "사용자에게 Requirement Draft v2 검토 요청" },
                { time: "09:31:22", agent: "Requirement Agent", action: "Review 요청", detail: "저온 토크 기준과 목표 원가 우선순위 확인 대기", status: "review", input: "추출 요구사항 11개 · 충돌 조건 2개", output: "저온 토크 기준과 원가 우선순위 확인 질문", handoff: "박현우 승인 대기열로 Review 요청 전달" }
            ];
        }
        if (this.activeRunId === "SD-DRV-0831") {
            return [
                { time: "17:21:08", agent: "Requirement Agent", action: "요구사항 확정", detail: "9개 조건과 4종 Design Parameter 전달", status: "done", input: "Sliding Door 패키지 · 내구 목표 · 원가 한계", output: "검증된 요구사항 9개와 설계 변수 4종", handoff: "Design Agent에 확정 스냅샷 전달" },
                { time: "17:34:16", agent: "Design Agent", action: "설계 대안 생성", detail: "96개 Simulation 후보 생성", status: "done", input: "요구사항 9개 · Bracket 설계 규칙 · 부품 후보", output: "Simulation 후보 96개", handoff: "Simulation Agent에 CAD와 해석 조건 전달" },
                { time: "17:42:03", agent: "Simulation Agent", action: "Fatigue FAIL", detail: "피로 수명 92k cycles · 목표 120k 미달", status: "fail", input: "후보 96개 · Fatigue Template v2.1", output: "피로 수명 미달 · Failure Evidence #19", handoff: "Design Agent에 취약부와 민감도 데이터 전달" },
                { time: "17:48:27", agent: "Design Agent", action: "재설계 실행", detail: "Bracket 두께와 장착 위치 변경 후 재해석 요청", status: "retry", input: "Fatigue FAIL 근거 · 취약부 좌표", output: "Bracket 2.6t · 장착점 X-4 mm 변경 후보", handoff: "Simulation Agent에 Iteration 02 재해석 요청" },
                { time: "17:52:09", agent: "Simulation Agent", action: "Iteration 02 재해석 중", detail: "수정 후보의 구조·피로 해석을 실행하고 있습니다.", status: "running", input: "Bracket 2.6t · 장착점 X-4 mm 수정 후보", output: "Solver 진행률 63% · 중간 결과 수집 중", handoff: "PASS 판정 후 Evaluation Agent에 검증 결과 전달 예정" }
            ];
        }
        if (this.activeRunId === "GV7-SPL-0719") {
            return [
                { time: "14:06:11", agent: "Requirement Agent", action: "요구사항 확정", detail: "7개 조건과 설계 변수 4종 확정", status: "done", input: "GV70 스포일러 리프트 요청 · 패키지 CAD", output: "필수 조건 7개 · 설계 변수 4종", handoff: "Design Agent에 요구사항 스냅샷 전달" },
                { time: "14:18:44", agent: "Design Agent", action: "설계 후보 생성", detail: "6,240개 조합 중 64개 해석 후보 생성", status: "done", input: "요구사항 · 부품 DB · 설계 규칙", output: "해석 후보 64개 · CAD/파라미터 세트", handoff: "Simulation Agent에 열해석 Batch 전달" },
                { time: "14:25:03", agent: "Simulation Agent", action: "Solver 연결 중단", detail: "열해석 결과 수신 실패 · 자동 재시도 3회 초과", status: "fail", input: "열해석 후보 64개 · Solver Queue #281", output: "연결 오류 CAE-TIMEOUT-504 · 결과 미확정", handoff: "운영자 확인 대기열에 재실행 요청과 오류 로그 전달" }
            ];
        }
        return this.runTimeline;
    }

    public timelineStageKey(event: any) {
        return this.timelineStageLabel(event).toLowerCase();
    }

    public get filteredRunTimeline() {
        if (this.selectedTimelineStage === "all") return this.currentRunTimeline;
        return this.currentRunTimeline.filter(event => this.timelineStageKey(event) === this.selectedTimelineStage);
    }

    public get selectedStageContext() {
        let labels: any = {
            requirement: "Requirement",
            design: "Design",
            simulation: "Simulation",
            evaluation: "Evaluation",
            approval: "Approval"
        };
        let agents: any = {
            requirement: "Requirement Agent",
            design: "Design Agent",
            simulation: "Simulation Agent",
            evaluation: "Evaluation Agent",
            approval: "Approval Gate"
        };
        let stageKey = this.selectedTimelineStage === "all" ? this.currentRun.stageKey : this.selectedTimelineStage;
        let events = this.currentRunTimeline.filter(event => this.timelineStageKey(event) === stageKey);
        let first = events[0];
        let last = events[events.length - 1];
        let step = this.agentFlowSteps.find(item => item.key === stageKey) || { tone: "waiting", status: "대기" };
        let responsibleAgents = Array.from(new Set(events.map(event => event.agent))).join(" · ");
        return {
            key: stageKey,
            label: labels[stageKey] || "Agent",
            tone: step.tone,
            status: step.status,
            agent: responsibleAgents || agents[stageKey] || "담당 Agent 미정",
            input: first?.input || "단계 시작 전 · 입력 데이터 대기",
            output: last?.output || "실행 후 출력 데이터가 생성됩니다.",
            handoff: last?.handoff || this.stageHandoffLabel(stageKey)
        };
    }

    public stageHandoffLabel(stageKey: string) {
        let handoffs: any = {
            requirement: "Design Agent로 확정 요구사항 전달 예정",
            design: "Simulation Agent로 설계 후보 전달 예정",
            simulation: "Evaluation Agent로 검증 결과 전달 예정",
            evaluation: "Approval Gate로 추천안 전달 예정",
            approval: "Run Archive와 Reports로 승인 기록 전달 예정"
        };
        return handoffs[stageKey] || "다음 단계 전달 데이터 대기";
    }

    public runProgress(run: any) {
        if (!run) return 0;
        if (run.statusClass === "done") return 100;
        let progressByStage: any = {
            requirement: 20,
            design: 40,
            simulation: 60,
            evaluation: 80,
            approval: 90
        };
        return progressByStage[run.stageKey] || 0;
    }

    public get agentFlowSteps() {
        let stages = [
            { key: "requirement", label: "Requirement" },
            { key: "design", label: "Design" },
            { key: "simulation", label: "Simulation" },
            { key: "evaluation", label: "Evaluation" },
            { key: "approval", label: "Approval" }
        ];
        let activeIndex = Math.max(0, stages.findIndex(stage => stage.key === this.currentRun.stageKey));
        let completed = this.currentRun.statusClass === "done";
        return stages.map((stage, index) => {
            if (completed || index < activeIndex) {
                return { ...stage, tone: "pass", status: "완료", current: index === activeIndex };
            }
            if (index > activeIndex) {
                return { ...stage, tone: "waiting", status: "대기", current: false };
            }
            let activeState: any = {
                review: { tone: "review", status: "확인 대기" },
                retry: { tone: "retry", status: "재실행 필요" },
                running: { tone: "running", status: "실행 중" }
            };
            return { ...stage, ...(activeState[this.currentRun.statusClass] || { tone: "running", status: "진행 중" }), current: true };
        });
    }

    public get hasRecoveryFlow() {
        let statuses = this.currentRunTimeline.map(event => event.status);
        return ["fail", "retry"].every(status => statuses.includes(status));
    }

    public get recoveryFlowSummary() {
        let timeline = this.currentRunTimeline;
        let failure = timeline.find(event => event.status === "fail") || {};
        let change = timeline.find(event => event.status === "retry") || {};
        let changeIndex = timeline.indexOf(change);
        let result = timeline.slice(Math.max(0, changeIndex + 1)).find(event => ["pass", "running", "fail"].includes(event.status)) || {};
        let isPass = result.status === "pass";
        return {
            failure: {
                time: failure.time || "—",
                title: failure.action || "FAIL 감지",
                detail: failure.detail || failure.output || "검증 기준 미달 원인 확인",
                causeLine: failure.output || failure.decision || "허용 기준 초과와 제약 위반 좌표가 동시에 확인됨"
            },
            change: {
                time: change.time || "—",
                title: change.action || "자동 재설계",
                detail: change.output || change.detail || "설계 변수 변경 후 재해석",
                reasonLine: change.decision || "민감도 분석에서 실패 원인 개선 효과가 가장 큰 설계 변수 조합을 선택"
            },
            result: {
                time: result.time || "대기",
                title: result.action || "재검증 대기",
                detail: result.detail || result.output || "변경안의 개선 결과를 검증하는 중입니다.",
                improvementLine: result.output || (isPass
                    ? "동일 Baseline의 재검증 항목을 모두 충족해 개선 효과를 확인"
                    : "동일 Baseline에서 변경안의 개선 효과를 검증하는 중"),
                tone: isPass ? "pass" : result.status === "fail" ? "fail" : "running"
            }
        };
    }

    public timelineStatusTone(status: string) {
        if (["done", "pass", "approval"].includes(status)) return "pass";
        if (status === "review") return "review";
        if (status === "waiting") return "waiting";
        if (status === "fail") return "fail";
        if (status === "retry") return "retry";
        return "running";
    }

    public timelineStatusLabel(status: string) {
        let labels: any = {
            done: "완료",
            approval: "승인",
            review: "확인 대기",
            running: "진행 중",
            waiting: "대기",
            fail: "FAIL",
            retry: "재설계",
            pass: "PASS"
        };
        return labels[status] || "실행 중";
    }

    public timelineStatusIcon(status: string) {
        let icons: any = {
            done: "✓",
            pass: "✓",
            approval: "✓",
            running: "●",
            review: "!",
            waiting: "·",
            fail: "×",
            retry: "↻"
        };
        return icons[status] || "●";
    }

    public isCurrentTimelineEvent(event: any) {
        if (this.currentRun.statusClass === "done") return false;
        return this.currentRunTimeline.indexOf(event) === this.currentRunTimeline.length - 1;
    }

    public timelineStageLabel(event: any) {
        let value = `${event?.agent || ""} ${event?.action || ""}`.toLowerCase();
        if (value.includes("requirement") || value.includes("요구사항")) return "Requirement";
        if (value.includes("simulation") || value.includes("iteration") || value.includes("solver") || value.includes("fatigue")) return "Simulation";
        if (value.includes("evaluation") || value.includes("추천") || value.includes("평가")) return "Evaluation";
        if (value.includes("approval") || value.includes("최종") || value.includes("승인")) return "Approval";
        if (value.includes("design") || value.includes("optimization") || value.includes("설계")) return "Design";
        return "Agent";
    }

    public timelinePayload(event: any, field: string) {
        if (event && event[field]) return event[field];
        if (field === "input") return `${this.activeRunId} 실행 컨텍스트와 이전 Agent 결과`;
        if (field === "decision") {
            if (event?.status === "fail") return `${event.detail || "검증 결과"}가 허용 기준을 벗어나 FAIL로 판정`;
            if (event?.status === "retry") return `${event.detail || "설계 변수"} 변경이 실패 원인 개선에 가장 효과적인 대안으로 판단`;
            if (event?.status === "pass") return `${event.detail || "재검증 결과"}가 동일 검증 기준을 충족해 PASS로 판정`;
            return `${event?.agent || "Agent"} 판단 · ${event?.action || event?.detail || "실행 기준 확인"}`;
        }
        if (field === "output") return event?.detail || "출력 데이터 없음";
        return "Run 실행 기록과 다음 단계에 전달 데이터 저장";
    }

    public timelineResources(event: any) {
        let stage = this.timelineStageKey(event);
        let simulationDetail = ["Simulation", "Design"].includes(stage) || ["fail", "retry", "pass"].includes(event?.status)
            ? "CAE 결과·Iteration"
            : "연결 Validation Pack";
        return [
            {
                code: "EV",
                label: "Evidence",
                detail: "입력·판단 근거",
                route: this.runLink("evidence"),
                query: { event: event?.time, stage: stage.toLowerCase() }
            },
            {
                code: "SIM",
                label: "Simulation",
                detail: simulationDetail,
                route: this.runLink("reports"),
                query: { type: "simulation", report: this.reportIdFor(this.activeRunId, "simulation"), event: event?.time, from: "run-log" }
            },
            {
                code: "KN",
                label: "Knowledge",
                detail: "적용 규칙·실패 패턴",
                route: "/platform/knowledge",
                query: { run: this.activeRunId, stage: stage.toLowerCase(), from: "run-log" }
            }
        ];
    }

    public get currentReports() {
        let context = this.activeRunContext;
        return this.reports.filter(report => report.run === this.activeRunId).map(report => ({
            ...report,
            title: report.type === "design" ? `${this.currentRun.project} 설계 종합 보고서` : report.title,
            detail: report.type === "design" && report.source === "generated"
                ? `요구사항 ${context.requirements ?? 0}개 · Simulation ${context.simulationCandidates ?? 0}개 · 추천 근거`
                : report.detail
        }));
    }

    public get packageSelectedReports() {
        return this.currentReports.filter(report => this.packageReportSelected(report));
    }

    public get currentRunEvidence() {
        let context = this.activeRunContext;
        let step = Number(context.journeyStep || 1);
        let timeline = this.currentRunTimeline;
        let hasPass = timeline.some(event => event.status === "pass");
        let hasFail = timeline.some(event => event.status === "fail");
        let aiDecisions = timeline.filter(event => String(event.agent || "").includes("Agent") && event.decision);
        let designDecision = timeline.find(event => String(event.agent || "").includes("Evaluation Agent"))
            || timeline.find(event => String(event.agent || "").includes("Design Agent"));
        let simulationDecision = [...timeline].reverse().find(event => String(event.agent || "").includes("Simulation Agent"));
        let approval = this.currentApproval;
        let simulationTone = hasPass ? "pass" : hasFail ? (step >= 5 ? "retry" : "fail") : step >= 5 ? "running" : "waiting";
        let simulationLabel = hasPass ? "검증 완료" : hasFail ? (step >= 5 ? "재검증 중" : "FAIL") : step >= 5 ? "검증 중" : "대기";
        return [
            {
                id: `REQ-${this.activeRunId}`,
                type: "input",
                typeLabel: "Input",
                icon: "IN",
                category: "INPUT",
                title: "요구사항·원본 입력",
                detail: `요구사항 ${context.requirements ?? 0}개, CAD와 설계 변수 ${context.designVariables ?? 0}종을 승인 시점으로 고정`,
                source: "Requirement Agent",
                version: "Design Brief v3",
                status: step >= 2 ? "pass" : "waiting",
                statusLabel: step >= 2 ? "검증 완료" : "대기",
                evidenceCount: context.requirements ?? 0,
                detailEvidence: [
                    { label: "입력 요구사항", value: `${context.requirements ?? 0}개 조건 · Design Brief v3`, tone: "input" },
                    { label: "원본 자산", value: "NX4_tailgate.step · motor_catalog.pdf", tone: "asset" },
                    { label: "설계 변수", value: `${context.designVariables ?? 0}종 · 승인 시점 잠금`, tone: "rule" },
                    { label: "출처 상태", value: step >= 2 ? "원문·단위·버전 연결 완료" : "사용자 확인 대기", tone: "status" }
                ],
                reasoning: {
                    eyebrow: "INPUT NORMALIZATION",
                    title: "승인된 입력만 후속 판단의 기준으로 사용",
                    detail: `자연어 요청과 CAD·PDF에서 추출한 ${context.requirements ?? 0}개 조건을 단위와 출처 기준으로 정규화하고 Design Brief v3로 잠갔습니다.`,
                    confidence: "SOURCE LOCKED",
                    rules: ["개폐 시간·온도·개방각을 필수 검증 조건으로 분류", "승인 이후 입력 변경은 새 버전으로만 반영", "CAD 원본과 추출 조건의 출처를 함께 보존"]
                },
                route: this.runLink("runs"),
                query: null
            },
            {
                id: `LOG-${this.activeRunId}`,
                type: "decision",
                typeLabel: "Decision",
                icon: "AI",
                category: "DECISION",
                title: "AI 판단·설계 선택",
                detail: `${aiDecisions.length}개 Agent 판단의 사용 규칙, 후보 축소와 다음 Handoff 근거`,
                source: "Design · Evaluation Agent",
                version: `Decision Trace · ${aiDecisions.length} records`,
                status: aiDecisions.length > 0 ? "pass" : "waiting",
                statusLabel: aiDecisions.length > 0 ? "근거 확인" : "대기",
                evidenceCount: aiDecisions.length,
                recommendationReason: context.recommendations
                    ? `성능·안전·원가 균형이 가장 높은 ${context.recommendations}개안 추천`
                    : "Simulation PASS 후보 확보 후 추천",
                rulesUsed: "Safety Rule v4.2 · 패키지 적합성",
                knowledgeUsed: "KH-RULE-042 · KH-FAIL-031",
                simulationBasis: hasPass ? `Validation v1.4 · ${context.passCandidates ?? 0} PASS` : simulationLabel,
                detailEvidence: [
                    { label: "AI 추천 이유", value: context.recommendations ? `성능 40% · 안전 35% · 원가 25% 평가에서 Pareto 우위 ${context.recommendations}개안 선정` : "추천 판단 대기", tone: "decision" },
                    { label: "사용 Rule", value: "Safety Rule v4.2 · 정적 안전율 ≥ 1.5 · 패키지 간섭 ≥ 0 mm", tone: "rule" },
                    { label: "관련 Knowledge", value: "KH-RULE-042 안전율 기준 · KH-FAIL-031 저온 토크 실패 패턴", tone: "knowledge" },
                    { label: "Simulation 근거", value: hasPass ? `Validation Pack v1.4 · 후보 ${context.simulationCandidates ?? 0}개 중 ${context.passCandidates ?? 0}개 PASS` : simulationLabel, tone: "simulation" }
                ],
                reasoning: {
                    eyebrow: "AI DECISION BASIS",
                    title: designDecision?.action || "Agent 판단 대기",
                    detail: designDecision?.decision || "입력 조건과 설계 규칙이 확보되면 후보 선택 근거가 기록됩니다.",
                    confidence: context.recommendations ? `추천 ${context.recommendations}개` : "판단 대기",
                    rules: ["패키지 적합성과 토크 여유를 우선 평가", "검증 가치가 높은 후보만 Simulation으로 전달", "성능·안전·원가 가중치와 추천 이유를 함께 기록"]
                },
                route: this.runLink("runs"),
                query: null
            },
            {
                id: `CAE-${this.activeRunId}`,
                type: "simulation",
                typeLabel: "Simulation",
                icon: "SIM",
                category: "SIMULATION",
                title: "CAE 검증·복구 결과",
                detail: `Simulation 후보 ${context.simulationCandidates ?? 0}개 · PASS 후보 ${context.passCandidates ?? 0}개 · FAIL/재설계 이력`,
                source: "Simulation Agent",
                version: hasPass ? "Validation Pack v1.4" : "Working Evidence",
                status: simulationTone,
                statusLabel: simulationLabel,
                evidenceCount: context.passCandidates ?? 0,
                detailEvidence: [
                    { label: "FAIL Evidence", value: "Iteration 01 · 응력 186 MPa · 간섭 -2.1 mm", tone: "fail" },
                    { label: "설계 변경", value: "Bracket Z +8 mm · 두께 2.4t · 감속비 42:1", tone: "retry" },
                    { label: "PASS Evidence", value: `Iteration 03 · 4개 해석 통과 · ${context.passCandidates ?? 0}개 후보`, tone: "pass" },
                    { label: "검증 기준", value: "구조 · 간섭 · 피로 · 열해석 동일 Baseline", tone: "simulation" }
                ],
                reasoning: {
                    eyebrow: "SIMULATION VERDICT",
                    title: simulationDecision?.action || "Simulation 결과 대기",
                    detail: simulationDecision?.decision || "동일 Baseline으로 구조·간섭·피로·열해석을 검증하고 결과를 연결합니다.",
                    confidence: hasPass ? `${context.passCandidates ?? 0} PASS` : simulationLabel,
                    rules: ["허용 응력과 패키지 간섭을 동일 Baseline으로 비교", "FAIL 좌표와 민감도를 설계 변경에 직접 연결", "재설계안은 동일 검증 기준으로 다시 판정"]
                },
                route: this.runLink("reports"),
                query: { type: "simulation", report: this.reportIdFor(this.activeRunId, "simulation"), from: "evidence" }
            },
            {
                id: `DEC-${this.activeRunId}`,
                type: "approval",
                typeLabel: "Approval",
                icon: "AP",
                category: "APPROVAL",
                title: "승인 근거·결정 기록",
                detail: context.approved ? `${context.selectedDesign || this.currentRun.selected}의 비교 점수와 최종 승인 근거` : "추천안 생성과 Human Gate 결정 후 근거가 고정됩니다.",
                source: "Human Gate · Audit Agent",
                version: context.approved ? "Decision Pack v1.0" : "생성 대기",
                status: context.approved ? "pass" : "waiting",
                statusLabel: context.approved ? "검증 완료" : "대기",
                evidenceCount: (approval?.conditions || []).length,
                approvalId: approval?.id || "생성 대기",
                approver: approval?.approver || "승인자 미지정",
                approvedAt: approval?.timestamp || "승인 대기",
                approvalConditionSummary: (approval?.conditions || []).slice(0, 2).map((condition: any) => condition.value).join(" · ") || "승인 조건 대기",
                detailEvidence: [
                    { label: "Approval ID", value: approval?.id || "생성 대기", tone: "approval" },
                    { label: "승인자·시각", value: `${approval?.approver || "미지정"} · ${approval?.timestamp || "승인 대기"}`, tone: "person" },
                    { label: "최종 결정", value: approval?.decision ? `${approval.decision} · ${context.selectedDesign || this.currentRun.selected}` : "승인 대기", tone: "decision" },
                    { label: "승인 조건", value: (approval?.conditions || []).map((condition: any) => `${condition.label} ${condition.value}`).join(" · ") || "조건 생성 대기", tone: "rule" }
                ],
                reasoning: {
                    eyebrow: "APPROVAL BASIS",
                    title: approval?.decision || "승인 결정 대기",
                    detail: approval?.comment || "Simulation과 추천안 검토가 완료되면 승인자의 판단과 연결 Evidence가 고정됩니다.",
                    confidence: context.approved ? "APPROVED" : "HUMAN GATE",
                    rules: (approval?.conditions || []).slice(0, 3).map((condition: any) => `${condition.label} · ${condition.value}`)
                },
                route: this.runLink("approvals"),
                query: null
            }
        ];
    }

    public get evidenceStats() {
        let total = this.currentRunEvidence.length;
        let verified = this.currentRunEvidence.filter(item => item.status === "pass").length;
        let attention = this.currentRunEvidence.filter(item => ["fail", "retry", "review"].includes(item.status)).length;
        let waiting = this.currentRunEvidence.filter(item => item.status === "waiting").length;
        let reviewRequired = attention + waiting;
        let approved = Boolean(this.activeRunContext.approved);
        return {
            total,
            verified,
            attention,
            waiting,
            reviewRequired,
            traceLinked: approved ? 6 : Math.min(5, Math.max(1, Number(this.activeRunContext.journeyStep || 1))),
            finalGate: approved ? "APPROVED" : "PENDING",
            approvalId: this.currentApproval?.id || "Approval 생성 대기"
        };
    }

    public get evidenceTraceabilitySteps() {
        let context = this.activeRunContext;
        let journeyStep = Number(context.journeyStep || 1);
        let hasPass = this.currentRunTimeline.some(event => event.status === "pass");
        return [
            { key: "requirement", label: "Requirement", detail: `${context.requirements ?? 0}개 조건`, state: journeyStep >= 2 ? "done" : "waiting", route: "/dashboard", query: { run: this.activeRunId, evidence: "design-brief" } },
            { key: "design", label: "Design", detail: `${context.simulationCandidates ?? 0}개 후보`, state: journeyStep >= 3 ? "done" : "waiting", route: "/dashboard", query: { run: this.activeRunId, evidence: "design-components" } },
            { key: "simulation", label: "Simulation", detail: hasPass ? `${context.passCandidates ?? 0} PASS` : "검증 진행", state: hasPass ? "done" : journeyStep >= 4 ? "attention" : "waiting", route: this.runLink("reports"), query: { type: "simulation", report: this.reportIdFor(this.activeRunId, "simulation"), from: "evidence-trace" } },
            { key: "evidence", label: "Evidence", detail: `${this.evidenceStats.verified}/${this.evidenceStats.total} 확인`, state: "active", route: this.runLink("evidence"), query: null },
            { key: "approval", label: "Approval", detail: context.approved ? "결정 고정" : "승인 대기", state: context.approved ? "done" : "waiting", route: this.runLink("approvals"), query: null },
            { key: "report", label: "Report", detail: context.approved ? "연결 완료" : "생성 대기", state: context.approved ? "ready" : "waiting", route: this.runLink("reports"), query: null }
        ];
    }

    public evidenceLinkedAssets(evidence: any) {
        return [
            { kind: "RU", label: "Rule", title: "Safety Rule v4.2", detail: "AI 판단에 적용된 임계값·제약 조건", route: "/platform/knowledge", query: { type: "설계 규칙", run: this.activeRunId, evidence: evidence?.id, from: "evidence-rule" } },
            { kind: "KN", label: "Knowledge", title: "적용 규칙·실패 패턴", detail: "설계 판단에 사용된 승인 지식", route: "/platform/knowledge", query: { run: this.activeRunId, evidence: evidence?.id, from: "evidence" } },
            { kind: "SIM", label: "Simulation", title: "Validation Pack", detail: "FAIL·재설계·PASS Solver 결과", route: this.runLink("reports"), query: { type: "simulation", report: this.reportIdFor(this.activeRunId, "simulation"), from: "evidence-detail" } },
            { kind: "CAD", label: "CAD", title: "입력·변경 형상", detail: "원본 STEP와 Iteration 변경안", route: "/dashboard", query: { run: this.activeRunId, evidence: "source-cad", from: "evidence" } },
            { kind: "AP", label: "Approval", title: "Decision Record", detail: "승인자·결정 조건·Audit Hash", route: this.runLink("approvals"), query: { evidence: evidence?.id, from: "evidence" } },
            { kind: "RPT", label: "Report", title: "Final Report", detail: "승인 근거가 반영된 결과 보고서", route: this.runLink("reports"), query: { type: "design", report: this.reportIdFor(this.activeRunId, "design"), from: "evidence-detail" } }
        ];
    }

    public async openEvidenceDetail(evidence: any) {
        this.selectedEvidence = evidence;
        this.evidenceDetailOpen = true;
        await this.service.render();
    }

    public async closeEvidenceDetail() {
        this.evidenceDetailOpen = false;
        this.selectedEvidence = null;
        await this.service.render();
    }

    public get reportProjectOptions() {
        return Array.from(new Set(this.reports.map(report => report.project))).sort();
    }

    public get reportRunOptions() {
        return this.runs.map(run => ({ id: run.id, project: run.project }));
    }

    public get filteredReports() {
        let priority: any = { design: 0, simulation: 1, approval: 2 };
        return this.reports.filter(report => {
            return (this.reportTypeFilter === "all" || report.type === this.reportTypeFilter)
                && (this.reportProjectFilter === "all" || report.project === this.reportProjectFilter)
                && (this.reportRunFilter === "all" || report.run === this.reportRunFilter)
                && (this.reportApprovalFilter === "all" || report.approvalStatus === this.reportApprovalFilter)
                && (this.reportVersionFilter === "all"
                    || (this.reportVersionFilter === "latest" && this.reportIsLatest(report))
                    || (this.reportVersionFilter === "outdated" && !this.reportIsLatest(report)));
        }).sort((first, second) => (priority[first.type] ?? 9) - (priority[second.type] ?? 9));
    }

    public get reportStats() {
        let rows = this.filteredReports;
        return {
            total: rows.length,
            generated: rows.filter(report => report.source === "generated").length,
            demo: rows.filter(report => report.source === "demo").length,
            approved: rows.filter(report => report.approvalStatus === "approved").length,
            latest: rows.filter(report => this.reportIsLatest(report)).length
        };
    }

    public reportIsLatest(report: any) {
        return report?.isLatest !== false;
    }

    public reportVersionLabel(report: any) {
        return this.reportIsLatest(report) ? "최신 버전" : "업데이트 필요";
    }

    public reportDownloadFormat(report: any) {
        return this.reportDownloadFormats[report?.id] || (report?.type === "simulation" ? "ZIP" : "PDF");
    }

    public setReportDownloadFormat(report: any, format: string) {
        if (!report?.id || !["PDF", "ZIP", "JSON"].includes(format)) return;
        this.reportDownloadFormats[report.id] = format;
    }

    public packageReportSelected(report: any) {
        return report?.id ? this.reportPackageSelection[report.id] !== false : false;
    }

    public async togglePackageReport(report: any) {
        if (!report?.id) return;
        this.reportPackageSelection[report.id] = !this.packageReportSelected(report);
        await this.service.render();
    }

    public async toggleReportPackageMenu() {
        this.reportPackageMenuOpen = !this.reportPackageMenuOpen;
        await this.service.render();
    }

    public async closeReportPackageMenu() {
        this.reportPackageMenuOpen = false;
        await this.service.render();
    }

    public reportSelectedVersion(report: any) {
        if (!report) return "";
        return this.selectedReport?.id === report.id && this.selectedReportVersion
            ? this.selectedReportVersion
            : report.version;
    }

    public get selectedReportView() {
        if (!this.selectedReport) return null;
        return { ...this.selectedReport, version: this.reportSelectedVersion(this.selectedReport) };
    }

    public async selectReportVersion(version: string) {
        if (!this.selectedReport || ![this.selectedReport.version, this.selectedReport.previousVersion].includes(version)) return;
        this.selectedReportVersion = version;
        await this.service.render();
    }

    public reportIdFor(runId: string, type: string) {
        return this.reports.find(report => report.run === runId && report.type === type)?.id || "";
    }

    public reportOriginLabel(origin: string) {
        let labels: any = {
            "simulation-evidence": "Simulation Evidence",
            "evidence": "Evidence",
            "approval-history": "Approval History",
            "agent-runs": "Agent Runs"
        };
        return labels[origin] || "연결 화면";
    }

    public reportPreviewSections(report: any) {
        let context = this.runSnapshots[report?.run] || this.activeRunContext;
        let sections: any = {
            design: [
                { label: "입력 기준", value: `요구사항 ${context.requirements ?? 0}개 · 설계 변수 ${context.designVariables ?? 0}종` },
                { label: "대안 탐색", value: `Simulation 후보 ${context.simulationCandidates ?? 0}개 · PASS ${context.passCandidates ?? 0}개` },
                { label: "설계 결론", value: context.selectedDesign && context.selectedDesign !== "—" ? context.selectedDesign : "추천안 생성 전" }
            ],
            simulation: [
                { label: "검증 범위", value: "구조 · 간섭 · 피로 · 열해석" },
                { label: "판정", value: report?.approvalStatus === "approved" ? `PASS 후보 ${context.passCandidates ?? 0}개 · VERIFIED` : report?.status },
                { label: "Evidence", value: `${report?.version} · Solver 설정 및 Iteration 기록` }
            ],
            approval: [
                { label: "결정 상태", value: report?.approvalLabel },
                { label: "승인 대상", value: context.selectedDesign && context.selectedDesign !== "—" ? context.selectedDesign : "확정 대기" },
                { label: "감사 범위", value: "승인자 · 타임스탬프 · 근거 버전 · 감사 해시" }
            ]
        };
        return sections[report?.type] || [];
    }

    public reportVersionChanges(report: any) {
        let changes: any = {
            design: [
                { field: "설계 대안", before: `${report?.previousVersion} 후보 기준`, after: `${report?.version} 최종 후보 반영`, changed: true },
                { field: "추천 결론", before: "평가 진행 중", after: report?.approvalStatus === "approved" ? "승인 설계안 고정" : "검토 상태 갱신", changed: true },
                { field: "근거 연결", before: "이전 Simulation Pack", after: "최신 Validation Evidence 연결", changed: true }
            ],
            simulation: [
                { field: "Iteration", before: `${report?.previousVersion} 검증 결과`, after: `${report?.version} 재해석 결과`, changed: true },
                { field: "판정", before: "FAIL 또는 미확정", after: report?.status, changed: true },
                { field: "Solver 근거", before: "이전 결과 필드", after: "최신 설정·Margin·판정 규칙", changed: true }
            ],
            approval: [
                { field: "결정 기록", before: `${report?.previousVersion} 검토 기록`, after: `${report?.version} ${report?.approvalLabel}`, changed: true },
                { field: "근거 버전", before: "이전 Evidence", after: "현재 보고서 버전으로 고정", changed: true },
                { field: "감사 상태", before: "해시 갱신 전", after: report?.status, changed: true }
            ]
        };
        return [
            ...(changes[report?.type] || []),
            { field: "Run ID", before: report?.run, after: report?.run, changed: false },
            { field: "생성 Agent", before: report?.agent, after: report?.agent, changed: false }
        ];
    }

    public reportVersionSummary(report: any, version: string = "") {
        if (!report) return "버전 변경 정보가 없습니다.";
        let selectedVersion = version || report.version;
        let isCurrent = selectedVersion === report.version;
        let summaries: any = {
            design: isCurrent
                ? "최종 설계안과 최신 Validation Evidence를 반영했습니다."
                : "최종 설계안 확정 전의 후보 평가 기준입니다.",
            simulation: isCurrent
                ? "재해석 결과와 Solver 판정 근거를 최신 상태로 갱신했습니다."
                : "재해석 전 Iteration 결과를 보존한 비교 기준입니다.",
            approval: isCurrent
                ? "승인 상태, 근거 버전과 감사 해시를 최신 기록으로 고정했습니다."
                : "최종 결정이 반영되기 전의 검토 기록입니다."
        };
        return summaries[report.type] || (isCurrent ? "최신 변경사항을 반영했습니다." : "이전 버전 비교 기준입니다.");
    }

    public reportVersionSummaryPoints(report: any, version: string = "") {
        if (!report) return [];
        let selectedVersion = version || report.version;
        let target = selectedVersion === report.version ? "after" : "before";
        return this.reportVersionChanges(report)
            .filter((change: any) => change.changed)
            .map((change: any) => `${change.field} · ${change[target]}`);
    }

    public reportDocumentPages(report: any) {
        return [
            { page: 1, label: "Executive Summary" },
            { page: 2, label: "Requirements Traceability" },
            { page: 3, label: "Candidate Selection" },
            { page: 4, label: "Simulation Results" },
            { page: 5, label: "BOM & Design Parameters" },
            { page: 6, label: "AI Rationale & Trade-off" },
            { page: 7, label: "Change History & Evidence" },
            { page: 8, label: "Approval & Document Control" }
        ];
    }

    public reportPageCount(report: any) {
        return this.reportDocumentPages(report).length;
    }

    public reportDisplayFormat(report: any) {
        let format = report?.type === "approval" ? "PDF/A" : "PDF";
        return `${format} · ${this.reportPageCount(report)} pages`;
    }

    public reportPreviewThumbnails(report: any) {
        return this.reportDocumentPages(report).map(item => item.page);
    }

    public async setReportPreviewPage(page: number) {
        let total = this.reportPageCount(this.selectedReport);
        this.reportPreviewPage = Math.max(1, Math.min(total, Number(page) || 1));
        await this.service.render();
    }

    public async moveReportPreviewPage(direction: number) {
        await this.setReportPreviewPage(this.reportPreviewPage + direction);
    }

    public get reportPreviewScale() {
        return this.reportPreviewZoom / 100;
    }

    public async changeReportPreviewZoom(direction: number) {
        let nextZoom = this.reportPreviewZoom + (direction * this.reportPreviewZoomStep);
        this.reportPreviewZoom = Math.max(this.reportPreviewZoomMin, Math.min(this.reportPreviewZoomMax, nextZoom));
        this.reportPreviewZoomMode = "manual";
        await this.service.render();
    }

    public async fitReportPreviewPage(refreshBeforeMeasure: boolean = true) {
        this.reportPreviewZoomMode = "fit";
        if (refreshBeforeMeasure) await this.service.render();
        if (typeof document === "undefined" || typeof window === "undefined") return;

        await new Promise(resolve => setTimeout(resolve, 0));
        let viewport = document.querySelector(".report-layer .report-page-viewport") as HTMLElement;
        if (!viewport) return;

        let style = window.getComputedStyle(viewport);
        let horizontalPadding = (parseFloat(style.paddingLeft) || 0) + (parseFloat(style.paddingRight) || 0);
        let verticalPadding = (parseFloat(style.paddingTop) || 0) + (parseFloat(style.paddingBottom) || 0);
        let availableWidth = Math.max(1, viewport.clientWidth - horizontalPadding);
        let availableHeight = Math.max(1, viewport.clientHeight - verticalPadding);
        let fittedZoom = Math.floor(Math.min(
            availableWidth / this.reportPreviewBaseWidth,
            availableHeight / this.reportPreviewBaseHeight
        ) * 100);
        fittedZoom = Math.max(this.reportPreviewFitMin, Math.min(this.reportPreviewZoomMax, fittedZoom));
        if (fittedZoom === this.reportPreviewZoom) return;

        this.reportPreviewZoom = fittedZoom;
        await this.service.render();
    }

    public reportPageLabel(page: number, report: any) {
        return this.reportDocumentPages(report).find(item => item.page === page)?.label || "Report Page";
    }

    public reportExecutiveKpis(report: any) {
        let context = this.runSnapshots[report?.run] || this.activeRunContext;
        let approved = report?.approvalStatus === "approved";
        return [
            { label: "요구사항", value: `${context.requirements ?? 0}`, detail: "확정 설계 조건" },
            { label: "설계 대안", value: `${context.simulationCandidates ?? 0}`, detail: "Simulation 후보" },
            { label: "PASS 후보", value: `${context.passCandidates ?? 0}`, detail: "전체 검증 통과" },
            { label: "최소 안전율", value: approved ? "1.26" : "0.92", detail: approved ? "허용 기준 이상" : "재검토 필요" }
        ];
    }

    public reportDesignPurpose(report: any) {
        let context = this.runSnapshots[report?.run] || this.activeRunContext;
        return `${report?.project || "Tailgate Actuator"}의 개폐 성능, 구조 안전성, 내구 수명과 패키지 간극을 동시에 만족하는 양산 기준안을 확정합니다. ${context.simulationCandidates ?? 0}개 후보를 동일한 요구사항과 Solver 조건으로 평가했습니다.`;
    }

    public reportRequirementMatrix(report: any) {
        let approved = report?.approvalStatus === "approved";
        return [
            { id: "REQ-01", user: "테일게이트 완전 개방 ≤ 5.2 s", agent: "Motion profile 0–100%, overshoot ≤ 2%", result: "4.8 s", status: "PASS" },
            { id: "REQ-02", user: "경사 15°에서 안정 개폐", agent: "Peak spindle load ≤ 4.5 kN", result: "3.92 kN", status: "PASS" },
            { id: "REQ-03", user: "브라켓 영구 변형 없음", agent: "von Mises ≤ 210 MPa / SF ≥ 1.20", result: approved ? "168 MPa / 1.26" : "224 MPa / 0.94", status: approved ? "PASS" : "FAIL" },
            { id: "REQ-04", user: "차체·트림 간섭 없음", agent: "전 구간 최소 Clearance ≥ 8 mm", result: "11.6 mm", status: "PASS" },
            { id: "REQ-05", user: "10만 회 이상 내구 수명", agent: "L10 fatigue life ≥ 100k cycles", result: approved ? "128k cycles" : "92k cycles", status: approved ? "PASS" : "FAIL" },
            { id: "REQ-06", user: "고온 환경 정상 작동", agent: "85°C ambient / winding ≤ 105°C", result: "91.4°C", status: "PASS" },
            { id: "REQ-07", user: "차량 정지 전류 제한", agent: "Peak current ≤ 18 A @ 13.5 V", result: "15.7 A", status: "PASS" },
            { id: "REQ-08", user: "목표 원가 범위 준수", agent: "Baseline 대비 BOM 증분 ≤ 5%", result: "+2.8%", status: "PASS" }
        ];
    }

    public reportCandidateComparisons(report: any) {
        return [
            { rank: "01", name: "Balanced #03", motion: "4.8 s", load: "3.92 kN", clearance: "11.6 mm", fatigue: "128k", cost: "+2.8%", score: 92, selected: true },
            { rank: "02", name: "Performance #17", motion: "4.5 s", load: "4.08 kN", clearance: "9.4 mm", fatigue: "136k", cost: "+7.6%", score: 88, selected: false },
            { rank: "03", name: "Cost #42", motion: "5.1 s", load: "4.31 kN", clearance: "8.7 mm", fatigue: "109k", cost: "-1.9%", score: 83, selected: false }
        ];
    }

    public reportSelectionReasons(report: any) {
        return [
            "모든 필수 요구사항을 통과한 후보 중 성능·안전·원가 종합 점수 1위입니다.",
            "최소 Clearance 11.6 mm와 피로 수명 128k cycles로 양산 편차 여유를 확보했습니다.",
            "Performance 후보 대비 개방 시간은 0.3 s 느리지만 BOM 증분을 4.8%p 절감했습니다."
        ];
    }

    public reportSimulationResults(report: any) {
        let approved = report?.approvalStatus === "approved";
        return [
            { category: "Motion", metric: "Full-open time", target: "≤ 5.2 s", result: "4.8 s", margin: "+7.7%", status: "PASS", score: 81 },
            { category: "Load", metric: "Peak spindle load", target: "≤ 4.5 kN", result: "3.92 kN", margin: "+12.9%", status: "PASS", score: 84 },
            { category: "Static", metric: "Bracket von Mises", target: "≤ 210 MPa", result: approved ? "168 MPa" : "224 MPa", margin: approved ? "+20.0%" : "-6.7%", status: approved ? "PASS" : "FAIL", score: approved ? 88 : 63 },
            { category: "Clearance", metric: "Minimum package gap", target: "≥ 8.0 mm", result: "11.6 mm", margin: "+45.0%", status: "PASS", score: 96 },
            { category: "Fatigue", metric: "L10 durability life", target: "≥ 100k cycles", result: approved ? "128k cycles" : "92k cycles", margin: approved ? "+28.0%" : "-8.0%", status: approved ? "PASS" : "FAIL", score: approved ? 94 : 66 },
            { category: "Thermal", metric: "Motor winding temp.", target: "≤ 105°C", result: "91.4°C", margin: "+13.0%", status: "PASS", score: 85 }
        ];
    }

    public reportBomItems(report: any) {
        return [
            { item: "Motor", partNo: "MTR-PTG-135", specification: "BLDC 13.5 V · 420 W", qty: 1, status: "RELEASED" },
            { item: "Reducer", partNo: "GR-PTG-042", specification: "Planetary 42:1 · η 86%", qty: 1, status: "RELEASED" },
            { item: "Spindle", partNo: "SPD-NX4-610", specification: "Lead 8 mm · stroke 610 mm", qty: 2, status: "RELEASED" },
            { item: "Upper Bracket", partNo: "BRK-NX4-U03", specification: "SPFC590 · t2.6 mm", qty: 2, status: "CAE PASS" },
            { item: "Lower Bracket", partNo: "BRK-NX4-L04", specification: "SPFC590 · t3.0 mm", qty: 2, status: "CAE PASS" },
            { item: "Drive ECU", partNo: "ECU-PTG-24A", specification: "13.5 V · CAN FD", qty: 1, status: "TESTED" }
        ];
    }

    public reportDesignParameters(report: any) {
        return [
            { label: "Gear ratio", value: "42:1", tolerance: "±0.5", source: "CAD" },
            { label: "Spindle lead", value: "8.0 mm", tolerance: "±0.1 mm", source: "CAD" },
            { label: "Bracket thickness", value: "2.6 / 3.0 mm", tolerance: "±0.08 mm", source: "CAE" },
            { label: "Motor current limit", value: "18 A", tolerance: "SW locked", source: "TEST" },
            { label: "Opening angle", value: "82°", tolerance: "±1°", source: "MOTION" },
            { label: "Control voltage", value: "13.5 V", tolerance: "9–16 V", source: "TEST" }
        ];
    }

    public reportAiRationale(report: any) {
        return [
            { title: "다목적 최적화 1위", detail: "성능 35%, 안전 35%, 원가 20%, 중량 10% 목적함수에서 최고 종합 점수 92점을 기록했습니다.", evidence: "OPT-RANK-003", confidence: "94%" },
            { title: "양산 편차 Robustness", detail: "브라켓 두께와 마찰계수 Monte Carlo 1,000회에서 요구사항 통과 확률 97.8%를 확인했습니다.", evidence: "DOE-MC-1000", confidence: "92%" },
            { title: "실패 패턴 회피", detail: "과거 Bracket crack 지식과 비교해 응력 집중 위치를 18 mm 이동하고 국부 곡률을 완화했습니다.", evidence: "KH-2025-BRK-017", confidence: "89%" }
        ];
    }

    public reportTradeoffs(report: any) {
        return [
            { axis: "성능 ↔ 원가", decision: "개방 시간 +0.3 s 수용", benefit: "Performance 후보 대비 BOM 4.8%p 절감" },
            { axis: "중량 ↔ 내구", decision: "Bracket +0.18 kg 수용", benefit: "피로 수명 +19k cycles 확보" },
            { axis: "패키지 ↔ 강성", decision: "상단 장착점 +4 mm 이동", benefit: "Clearance +2.2 mm, 응력 -14%" }
        ];
    }

    public reportChangeHistory(report: any) {
        return [
            { version: report?.version, date: report?.createdAt, author: report?.agent, summary: this.reportVersionSummary(report, report?.version), status: "CURRENT" },
            { version: report?.previousVersion, date: "2026.07.23 09:42", author: "Design Agent", summary: this.reportVersionSummary(report, report?.previousVersion), status: "PREVIOUS" },
            { version: "v1.2", date: "2026.07.22 18:10", author: "Simulation Agent", summary: "Static·Fatigue FAIL 원인과 재해석 조건을 기록했습니다.", status: "ARCHIVED" }
        ];
    }

    public reportEvidenceLinks(report: any) {
        return [
            { kind: "CAD", title: "NX4 PTG Assembly / Bracket Rev.C", id: "CAD-NX4-PTG-031", route: "/platform/components", query: { run: report?.run }, status: "LINKED" },
            { kind: "CAE", title: "Motion·Load·Static·Clearance·Fatigue·Thermal Pack", id: "CAE-NX4-128", route: `/platform/evidence/${report?.run}`, query: { evidence: "simulation" }, status: "VERIFIED" },
            { kind: "TEST DATA", title: "Bench cycle & thermal correlation", id: "TST-PTG-024", route: `/platform/evidence/${report?.run}`, query: { evidence: "test" }, status: "VERIFIED" },
            { kind: "APPROVAL", title: "Final design approval record", id: "APR-NX4-041", route: `/platform/approvals/${report?.run}`, query: {}, status: "SIGNED" },
            { kind: "KNOWLEDGE", title: "Bracket crack prevention rule", id: "KH-2025-BRK-017", route: "/platform/knowledge", query: { run: report?.run }, status: "APPLIED" }
        ];
    }

    public reportApprovalControl(report: any) {
        return [
            { label: "승인 상태", value: report?.approvalLabel || "승인 대기" },
            { label: "최종 승인자", value: report?.approvalStatus === "approved" ? "김도윤 · 책임연구원" : "승인 대기" },
            { label: "생성 Agent", value: report?.agent || "Report Agent" },
            { label: "생성 일시", value: report?.createdAt || "—" },
            { label: "Report Version", value: report?.version || "—" },
            { label: "Audit Hash", value: `SHA256:${String(report?.run || "RUN").replace(/-/g, "").slice(0, 8)}…8F41` }
        ];
    }

    public reportEvidenceItems(report: any) {
        let verified = report?.approvalStatus === "approved" ? "VERIFIED" : "REVIEW";
        return [
            { kind: "STRUCTURE", id: "EVD-STR-128", title: "Bracket structural result", source: "Abaqus 2026 · Iteration 03", version: report?.version, status: verified },
            { kind: "TORQUE", id: "EVD-TRQ-128", title: "Drive torque envelope", source: "Motion Solver · Peak load", version: report?.version, status: "VERIFIED" },
            { kind: "THERMAL", id: "EVD-THM-128", title: "Motor thermal balance", source: "Thermal Map · 85°C ambient", version: report?.version, status: "VERIFIED" },
            { kind: "FATIGUE", id: "EVD-FAT-128", title: "Durability cycle result", source: "Fatigue Solver · 128k cycles", version: report?.version, status: verified },
            { kind: "APPROVAL", id: "APR-NX4-041", title: "Final design approval record", source: "Audit Agent · immutable hash", version: report?.version, status: verified }
        ];
    }

    public reportFinalConclusion(report: any) {
        let context = this.runSnapshots[report?.run] || this.activeRunContext;
        if (report?.approvalStatus !== "approved") return "현재 설계안은 보완 후 재검증이 필요합니다.";
        return `${context.selectedDesign && context.selectedDesign !== "—" ? context.selectedDesign : "최종 추천 설계안"}을 기준안으로 확정합니다.`;
    }

    public reportConclusionItems(report: any) {
        return [
            { label: "설계 결정", value: this.reportFinalConclusion(report) },
            { label: "검증 결과", value: report?.approvalStatus === "approved" ? "Motion·Load·Static·Clearance·Fatigue·Thermal 6개 항목 PASS" : "실패 항목 보완 후 Iteration 재실행" },
            { label: "근거 추적", value: `${this.reportEvidenceLinks(report).length}개 Evidence 원본을 ${report?.version}에 연결` },
            { label: "후속 조치", value: report?.approvalStatus === "approved" ? "양산 상세설계 및 부품 발주 검토 진행" : "재설계 Run 생성 및 승인 재요청" }
        ];
    }

    public get showDesignJourney() {
        return ["projects", "runs", "evidence", "approvals", "components", "reports"].includes(this.section);
    }

    public get designJourneyActiveKey() {
        if (this.section === "evidence") return "evidence";
        if (this.section === "approvals") return "approval";
        if (this.section === "reports") return "report";
        if (this.section === "components") return "design";
        if (this.section !== "runs") return "";
        let step = Number(this.activeRunContext.journeyStep || 1);
        if (step <= 1) return "input";
        if (step === 2) return "requirements";
        if (step <= 4) return "design";
        if (step === 5) return "cae";
        if (step === 6) return "recommendation";
        return this.activeRunContext.approved ? "approval" : "recommendation";
    }

    public designJourneyStageState(stage: any) {
        if (this.designJourneyActiveKey === stage.key) return "active";
        if (this.activeRunContext.approved) return "done";

        let currentStep = Number(this.activeRunContext.journeyStep || 1);
        let reachedIndex = currentStep <= 1 ? 0 : currentStep === 2 ? 1 : currentStep <= 4 ? 2 : currentStep === 5 ? 3 : 4;
        let stageIndex = this.serviceJourney.findIndex(item => item.key === stage.key);
        if (stageIndex < reachedIndex) return "done";
        if (stageIndex === reachedIndex && !this.designJourneyActiveKey) return "active";
        if (stage.key === "evidence" && Number(this.activeRunContext.recommendations || 0) > 0) return "ready";
        if (stage.key === "approval" && Number(this.activeRunContext.recommendations || 0) > 0) return "ready";
        return "locked";
    }

    public designJourneyStatusLabel(stage: any) {
        let labels: any = { active: "현재", done: "완료", ready: "확인 가능", locked: "대기" };
        return labels[this.designJourneyStageState(stage)] || "대기";
    }

    public serviceJourneyRoute(stage: any) {
        return stage.route === "workspace" ? "/dashboard" : this.runLink(stage.route);
    }

    public serviceJourneyQuery(stage: any) {
        if (stage.route !== "workspace") return null;
        let query: any = { run: this.activeRunId };
        if (stage.evidence) query.evidence = stage.evidence;
        return query;
    }

    public get showCurrentContext() {
        return ["runs", "evidence", "approvals", "components", "reports"].includes(this.section);
    }

    public get currentPageContext() {
        if (this.section === "evidence") {
            let evidence = this.evidenceStats;
            return {
                label: "Evidence 상태",
                value: `${evidence.total}개 중 ${evidence.verified}개 검증 완료`,
                badge: evidence.attention > 0 ? `주의 ${evidence.attention}` : evidence.waiting > 0 ? `대기 ${evidence.waiting}` : "READY",
                status: evidence.attention > 0 ? "review" : evidence.waiting > 0 ? "pending" : "ready"
            };
        }
        if (this.section === "approvals") {
            let approval = this.currentApproval;
            return {
                label: "승인 상태",
                value: approval?.decision || "승인 기록 없음",
                badge: this.approvalStatusLabel(approval?.status || "PENDING"),
                status: approval?.status || "PENDING"
            };
        }
        if (this.section === "components") {
            let conditions = this.componentRunConstraints
                .filter(condition => ["voltage", "ambient", "torque"].includes(condition.key))
                .map(condition => condition.value)
                .join(" · ");
            return {
                label: "설계 조건",
                value: conditions,
                badge: `${this.componentRunConstraints.length}개 조건`,
                status: "active"
            };
        }
        if (this.section === "reports") {
            let selectedReport = this.selectedReport?.run === this.activeRunId ? this.selectedReportView : null;
            let report = selectedReport
                || this.currentReports.find(item => this.reportTypeFilter === "all" || item.type === this.reportTypeFilter)
                || this.currentReports[0];
            let version = selectedReport ? this.reportSelectedVersion(selectedReport) : report?.version;
            return {
                label: "보고서 버전",
                value: report ? `${report.typeLabel} · ${version}` : "생성된 보고서 없음",
                badge: report ? version === report.version ? this.reportVersionLabel(report) : "이전 버전" : "대기",
                status: report ? version === report.version ? report.approvalStatus || report.status : "review" : "pending"
            };
        }
        return {
            label: "실행 단계",
            value: this.currentRun.currentStage,
            badge: this.canonicalStatusLabel(this.currentRun.status),
            status: this.currentRun.statusClass || this.currentRun.status
        };
    }

    public get currentHandoff() {
        let context = this.activeRunContext;
        let requirementCount = context.requirements ?? 0;
        let simulationCount = context.simulationCandidates ?? 0;
        let passCount = context.passCandidates ?? 0;
        let recommendationCount = context.recommendations ?? 0;
        let handoffs: any = {
            projects: { from: "사용자", to: "요구사항 Agent", payload: "자연어 요청 · CAD/PDF · 프로젝트 컨텍스트", status: "INPUT" },
            runs: Number(context.journeyStep || 0) <= 2
                ? { from: "요구사항 Agent", to: "사용자", payload: `요구사항 ${requirementCount}개 · Design Brief Review`, status: "REVIEW" }
                : { from: "Design Agent", to: "Simulation Agent", payload: `Simulation 후보 ${simulationCount}개 · Design Parameter · Evidence`, status: Number(context.journeyStep || 0) >= 6 ? "DELIVERED" : "REVIEW" },
            evidence: { from: "Simulation Agent", to: "Human Gate", payload: `PASS 후보 ${passCount}개 · 검증 근거 ${this.evidenceStats.total}건`, status: this.evidenceStats.attention > 0 ? "REVIEW" : "READY" },
            approvals: recommendationCount > 0
                ? { from: "Evaluation Agent", to: "사용자", payload: `PASS 후보 ${passCount}개 · 추천안 ${recommendationCount}개 · ${this.currentRun.selected}`, status: "DECISION" }
                : { from: "Evaluation Agent", to: "사용자", payload: "추천안 생성 후 Approval 요청 예정", status: "WAITING" },
            reports: context.approved
                ? { from: "사용자", to: "Run Archive", payload: `${this.currentRun.selected} · Approval · Validation Evidence`, status: "ARCHIVED" }
                : { from: "Approval", to: "Report", payload: "Approval 완료 후 Output 생성 예정", status: "WAITING" },
            knowledge: { from: "Knowledge Hub", to: "Agent", payload: `${this.activeProjectId} 설계 규칙 · 시험 근거 · 실패 패턴`, status: "READY" },
            components: { from: "Component Library", to: "Design Agent", payload: `${this.activeRunId} 호환 부품과 선택 근거`, status: "READY" },
            settings: { from: "Settings", to: "Agent Workflow", payload: `${this.settingsScopeLabel} · 승인 Gate · 데이터 정책`, status: "ACTIVE" },
            guide: { from: "Project", to: "Run", payload: "Evidence → Approval → Report 추적 흐름", status: "READY" },
            profile: { from: "권한", to: "Human Gate", payload: `${this.activeProjectId} 실행·승인 권한`, status: "ACTIVE" }
        };
        return handoffs[this.section] || handoffs.runs;
    }

    public runLink(section: string) {
        return `/platform/${section}/${this.activeRunId}`;
    }

    public contextualRoute(route: string) {
        if (route === "/dashboard") return route;
        if (route.startsWith("/platform/")) return `${route}/${this.activeRunId}`;
        return route;
    }

    public contextualQuery(route: string) {
        return route === "/dashboard" ? { run: this.activeRunId } : null;
    }

    public statusTone(status: string) {
        let value = String(status || "").toLowerCase();
        if (["pass", "approved", "done", "ready", "delivered", "archived", "완료", "승인 완료", "검증 완료", "승인됨"].includes(value)) return "pass";
        if (["review", "decision", "pending", "확인 대기", "승인 대기", "검토 대기", "검증 필요", "조건부 검증"].includes(value)) return "review";
        if (["running", "active", "input", "분석 중", "설계 중", "검증 중", "실행 중"].includes(value)) return "running";
        if (["fail", "rejected", "error", "반려", "실패", "오류"].includes(value)) return "fail";
        if (["retry", "재실행 필요", "재설계"].includes(value)) return "retry";
        return "waiting";
    }

    public canonicalStatusLabel(status: string) {
        let value = String(status || "").toLowerCase();
        let labels: any = {
            approved: "승인 완료",
            pending: "승인 대기",
            rejected: "반려",
            done: "완료",
            running: "실행 중",
            retry: "재실행 필요",
            verified: "검증 완료",
            unverified: "검증 필요",
            review: "검토 필요",
            conditional: "조건부 검증"
        };
        return labels[value] || status;
    }

    public get componentCategories() {
        return ["전체", ...Array.from(new Set(this.components.map(item => item.category)))];
    }

    public get componentMakerOptions() {
        return ["전체", ...Array.from(new Set(this.components.map(item => item.maker))).sort()];
    }

    public componentRecommendationReason(component: any) {
        let reasons: any = {
            "BLDC-24-180": "목표 출력·온도 조건 만족 · 2개 Run 재현",
            "PG-42-01": "목표 토크 34 Nm 충족 · 저온 검증 · 2개 Run 사용",
            "SP-12-L6": "좌굴 안전율·온도 조건 만족 · 2개 Run 사용",
            "BR-NX4-B": "간섭·피로 PASS · NX4 Iteration 03 적용"
        };
        return reasons[component?.part] || "";
    }

    public componentDesignRole(component: any) {
        let roles: any = {
            "BLDC-24-180": "Tailgate 개폐에 필요한 회전 동력을 생성하는 주 구동원",
            "BLDC-24-160": "원가 우선 설계안에서 주 구동원을 대체하는 모터 후보",
            "PG-42-01": "모터 회전을 42:1로 감속해 목표 출력 토크를 확보",
            "PG-48-03": "고하중 조건에서 토크를 높이는 대체 감속 경로",
            "SP-12-L6": "감속기 회전을 Tailgate 개폐용 직선 운동으로 변환",
            "BR-NX4-B": "구동계를 차체 장착점에 고정하고 해석 하중을 전달",
            "CP-10-FX": "모터·감속기 축을 연결하고 조립 편심을 흡수",
            "BRG-608-H": "구동축을 지지해 회전 마찰과 축 흔들림을 저감",
            "SEAL-12-LT": "스핀들 내부 유입물을 차단해 방수 성능을 확보",
            "SNS-HALL-02": "구동축 위치와 회전 방향을 ECU에 피드백"
        };
        return roles[component?.part] || `${component?.category || "부품"} 기능을 담당하는 설계 후보`;
    }

    public componentConfidenceBasis(component: any) {
        let checks = component?.checks || [];
        let history = component?.history || [];
        let passCount = checks.filter((check: any) => check.result === "PASS").length;
        let verificationTone = component?.verification === "verified"
            ? "compatible"
            : component?.verification === "conditional" ? "conditional" : "incompatible";
        return [
            {
                label: "설계 변수 적합성",
                weight: "40%",
                result: component?.compatibilityLabel,
                detail: `${checks.length}개 기준 중 ${passCount}개 PASS`,
                tone: component?.compatibility
            },
            {
                label: "시험·CAE 검증",
                weight: "35%",
                result: component?.verificationLabel,
                detail: component?.verification === "verified" ? "승인된 검증 Evidence 반영" : "추가 검증 항목이 점수에 반영됨",
                tone: verificationTone
            },
            {
                label: "기존 Run 재현성",
                weight: "25%",
                result: `${history.length}개 Run`,
                detail: history.length > 0 ? history.map((item: any) => item.runId).join(" · ") : "사용 이력 없음",
                tone: history.length > 0 ? "compatible" : "conditional"
            }
        ];
    }

    public componentConfidenceTooltip(component: any) {
        return `${component.confidence} · ${component.compatibilityLabel} · ${component.verificationLabel} · 이전 Run ${component.history.length}건`;
    }

    public get filteredComponents() {
        let query = this.componentSearchText.trim().toLowerCase();
        let priceLimit: any = { "15000": 15000, "30000": 30000, "40000": 40000 };
        let confidenceLimit: any = { "90": 90, "95": 95, "98": 98 };
        let filtered = this.components.filter(item => {
            let matchesSearch = !query || [item.part, item.maker, item.category, item.spec, item.summary]
                .some(value => String(value || "").toLowerCase().includes(query));
            let matchesCategory = this.componentCategory === "전체" || item.category === this.componentCategory;
            let matchesMaker = this.componentMakerFilter === "전체" || item.maker === this.componentMakerFilter;
            let matchesPrice = this.componentPriceFilter === "all" || item.costValue <= priceLimit[this.componentPriceFilter];
            let matchesTemperature = this.componentTemperatureFilter === "all"
                || (this.componentTemperatureFilter === "cold" && item.tempMin <= -30)
                || (this.componentTemperatureFilter === "wide" && item.tempMin <= -40 && item.tempMax >= 100)
                || (this.componentTemperatureFilter === "hot" && item.tempMax >= 120);
            let matchesConfidence = this.componentConfidenceFilter === "all" || item.confidenceValue >= confidenceLimit[this.componentConfidenceFilter];
            let matchesVerification = this.componentVerificationFilter === "전체" || item.verification === this.componentVerificationFilter;
            let matchesState = this.componentStateFilter === "전체" || item.state === this.componentStateFilter;
            return matchesSearch && matchesCategory && matchesMaker && matchesPrice && matchesTemperature
                && matchesConfidence && matchesVerification && matchesState;
        });
        let stateOrder: any = { applied: 0, recommended: 1, candidate: 2, excluded: 3 };
        return [...filtered].sort((first, second) => {
            if (this.componentSortOrder === "confidence") return second.confidenceValue - first.confidenceValue;
            if (this.componentSortOrder === "price-low") return first.costValue - second.costValue;
            if (this.componentSortOrder === "price-high") return second.costValue - first.costValue;
            if (this.componentSortOrder === "maker") return first.maker.localeCompare(second.maker);
            return stateOrder[first.state] - stateOrder[second.state] || second.confidenceValue - first.confidenceValue;
        });
    }

    public get componentStateCounts() {
        return {
            applied: this.components.filter(item => item.state === "applied").length,
            recommended: this.components.filter(item => item.state === "recommended").length,
            candidate: this.components.filter(item => item.state === "candidate").length,
            excluded: this.components.filter(item => item.state === "excluded").length
        };
    }

    public get hasActiveComponentFilters() {
        return Boolean(this.componentSearchText.trim())
            || this.componentCategory !== "전체"
            || this.componentMakerFilter !== "전체"
            || this.componentPriceFilter !== "all"
            || this.componentTemperatureFilter !== "all"
            || this.componentConfidenceFilter !== "all"
            || this.componentVerificationFilter !== "전체"
            || this.componentStateFilter !== "전체"
            || this.componentSortOrder !== "agent";
    }

    public emptyKnowledgeDraft() {
        return {
            title: "",
            type: "설계 규칙",
            source: "",
            version: "",
            owner: "",
            validUntil: "",
            summary: ""
        };
    }

    public loadKnowledgeDrafts() {
        if (typeof localStorage === "undefined") return;
        try {
            let stored = JSON.parse(localStorage.getItem(this.knowledgeStorageKey) || "[]");
            if (!Array.isArray(stored)) return;
            let currentIds = new Set(this.knowledgeItems.map(item => item.id));
            stored
                .filter(item => item && item.id && !currentIds.has(item.id))
                .map(item => ({
                    ...item,
                    status: item.status === "unverified" ? "review" : item.status,
                    statusLabel: item.status === "unverified" ? "검토 필요" : item.statusLabel,
                    registrationKind: item.registrationKind || "user",
                    registrationLabel: item.registrationLabel || "사용자 등록",
                    generationSource: item.generationSource || `${item.owner || "설계 담당자"} 직접 등록`,
                    createdRun: item.createdRun || "직접 등록"
                }))
                .reverse()
                .forEach(item => this.knowledgeItems.unshift(item));
        } catch (error) {
            // The built-in demo registry remains available when browser storage is restricted.
        }
    }

    public persistKnowledgeDrafts() {
        if (typeof localStorage === "undefined") return;
        try {
            let drafts = this.knowledgeItems.filter(item => String(item.id || "").startsWith("KH-DRAFT-"));
            localStorage.setItem(this.knowledgeStorageKey, JSON.stringify(drafts));
        } catch (error) {
            // The new card remains available for the current screen session.
        }
    }

    public get filteredKnowledgeItems() {
        let query = this.knowledgeSearchText.trim().toLowerCase();
        return this.knowledgeItems.filter(item => {
            let matchesType = this.knowledgeFilter === "전체" || item.type === this.knowledgeFilter;
            let matchesData = this.knowledgeDataFilter === "전체" || item.dataTypes.includes(this.knowledgeDataFilter);
            let matchesStatus = this.knowledgeStatusFilter === "전체" || this.knowledgeValidationState(item) === this.knowledgeStatusFilter;
            let matchesMetric = this.knowledgeMetricFilter === "전체"
                || (this.knowledgeMetricFilter === "approved" && this.knowledgeValidationState(item) === "approved")
                || (this.knowledgeMetricFilter === "review" && this.knowledgeValidationState(item) === "review")
                || (this.knowledgeMetricFilter === "auto" && item.registrationKind !== "user")
                || (this.knowledgeMetricFilter === "recent" && item.runCount > 0);
            let searchValues = [
                item.id,
                item.type,
                item.title,
                item.detail,
                item.source,
                item.generationSource,
                item.createdRun,
                this.knowledgeRegistrationLabel(item),
                item.owner,
                ...(item.appliedAgents || [])
            ];
            let matchesSearch = !query || searchValues.some(value => String(value || "").toLowerCase().includes(query));
            return matchesType && matchesData && matchesStatus && matchesMetric && matchesSearch;
        });
    }

    public knowledgeValidationState(item: any) {
        return item?.status === "approved" ? "approved" : "review";
    }

    public knowledgeRegistrationLabel(item: any) {
        let labels: any = { user: "사용자 등록", agent: "Agent 자동 생성", system: "시스템 연동" };
        return item?.registrationLabel || labels[item?.registrationKind] || "사용자 등록";
    }

    public knowledgeTypeCount(type: string) {
        if (type === "전체") return this.knowledgeItems.length;
        return this.knowledgeItems.filter(item => item.type === type).length;
    }

    public knowledgeDataCount(key: string) {
        return this.knowledgeItems.filter(item => item.dataTypes.includes(key)).length;
    }

    public knowledgeDataLabel(key: string) {
        return this.knowledgeDataMaps.find(map => map.key === key)?.name || key;
    }

    public knowledgeSourceKind(item: any) {
        if (item?.type === "설계 규칙") return "rule";
        if (item?.type === "시험 데이터") return "test";
        if (item?.type === "실패 패턴") return "cae";
        return "expert";
    }

    public knowledgeSourceLabel(item: any) {
        let labels: any = {
            rule: "DESIGN RULE",
            test: "TEST DATA",
            cae: "CAE / FAILURE",
            expert: "EXPERT KNOWLEDGE"
        };
        return labels[this.knowledgeSourceKind(item)] || "KNOWLEDGE";
    }

    public knowledgeEvidenceRoute(item: any) {
        let runId = item?.history?.[0]?.runId || this.activeRunId;
        return `/platform/evidence/${runId}`;
    }

    public get linkedKnowledgeEvidence() {
        if (!this.knowledgeEvidenceId) return null;
        return this.knowledgeItems.find(item => item.id === this.knowledgeEvidenceId) || null;
    }

    public get linkedKnowledgeHistory() {
        let item = this.linkedKnowledgeEvidence;
        if (!item) return null;
        return item.history.find((history: any) => history.runId === this.activeRunId) || item.history[0] || null;
    }

    public get knowledgeApprovedCount() {
        return this.knowledgeItems.filter(item => item.status === "approved").length;
    }

    public get knowledgeReviewCount() {
        return this.knowledgeItems.filter(item => this.knowledgeValidationState(item) === "review").length;
    }

    public get knowledgeAutoCount() {
        return this.knowledgeItems.filter(item => item.registrationKind !== "user").length;
    }

    public get knowledgeRecentCount() {
        return this.knowledgeItems.filter(item => item.runCount > 0).length;
    }

    public get canManageKnowledge() {
        let role = String(this.service.auth.session?.role || "").toLowerCase();
        return ["admin", "editor", "design_manager", "knowledge_admin"].includes(role);
    }

    public get knowledgeAccessLabel() {
        return this.canManageKnowledge ? "설계 지식 관리 권한" : "검색·조회·Evidence 확인 권한";
    }

    public isManualKnowledge(item: any) {
        return item?.registrationKind === "user" && this.manualKnowledgeTypes.includes(item?.type);
    }

    public get hasActiveKnowledgeFilters() {
        return Boolean(this.knowledgeSearchText.trim())
            || this.knowledgeFilter !== "전체"
            || this.knowledgeDataFilter !== "전체"
            || this.knowledgeStatusFilter !== "전체"
            || this.knowledgeMetricFilter !== "전체";
    }

    public async setKnowledgeMetricFilter(filter: string) {
        this.knowledgeMetricFilter = this.knowledgeMetricFilter === filter && filter !== "전체" ? "전체" : filter;
        this.persistPlatformState();
        await this.service.render();
    }

    public async setKnowledgeFilter(filter: string) {
        this.knowledgeFilter = filter;
        this.persistPlatformState();
        await this.service.render();
    }

    public async setKnowledgeDataFilter(filter: string) {
        this.knowledgeDataFilter = this.knowledgeDataFilter === filter ? "전체" : filter;
        this.persistPlatformState();
        await this.service.render();
    }

    public async resetKnowledgeFilters() {
        this.knowledgeSearchText = "";
        this.knowledgeFilter = "전체";
        this.knowledgeDataFilter = "전체";
        this.knowledgeStatusFilter = "전체";
        this.knowledgeMetricFilter = "전체";
        this.persistPlatformState();
        await this.service.render();
    }

    public async openKnowledgeDetail(item: any) {
        this.selectedKnowledge = item;
        this.knowledgeRegistrationOpen = false;
        this.knowledgeDetailOpen = true;
        await this.service.render();
    }

    public async openKnowledgeRegistration() {
        if (!this.canManageKnowledge) {
            await this.demoAction("조회 전용 권한", "지식 등록·수정은 관리자 또는 설계 담당자만 사용할 수 있습니다.");
            return;
        }
        this.knowledgeDraft = this.emptyKnowledgeDraft();
        this.knowledgeRegistrationMode = "create";
        this.knowledgeEditingId = "";
        this.knowledgeDetailOpen = false;
        this.knowledgeRegistrationOpen = true;
        await this.service.render();
    }

    public async openKnowledgeEdit(item: any) {
        if (!this.canManageKnowledge || !this.isManualKnowledge(item)) return;
        this.knowledgeDraft = {
            title: item.title,
            type: item.type,
            source: item.source,
            version: item.version,
            owner: item.owner,
            validUntil: item.validUntil,
            summary: item.summary
        };
        this.knowledgeRegistrationMode = "edit";
        this.knowledgeEditingId = item.id;
        this.knowledgeDetailOpen = false;
        this.knowledgeRegistrationOpen = true;
        await this.service.render();
    }

    public async closeKnowledgeLayer() {
        this.knowledgeDetailOpen = false;
        this.knowledgeRegistrationOpen = false;
        await this.service.render();
    }

    public async registerKnowledge() {
        if (!this.canManageKnowledge) {
            await this.demoAction("권한 확인", "지식 등록·수정은 관리자 또는 설계 담당자만 사용할 수 있습니다.");
            return;
        }
        let draft = this.knowledgeDraft;
        if (![draft.title, draft.type, draft.source, draft.version, draft.owner, draft.validUntil].every(value => String(value || "").trim())) {
            await this.demoAction("필수 정보 확인", "지식명, 유형, 출처, 버전, 담당자와 유효기간을 모두 입력해 주세요.");
            return;
        }
        if (this.knowledgeRegistrationMode === "edit") {
            let editing = this.knowledgeItems.find(item => item.id === this.knowledgeEditingId);
            if (!editing || !this.isManualKnowledge(editing)) return;
            Object.assign(editing, {
                type: draft.type,
                title: draft.title.trim(),
                detail: draft.summary.trim() || editing.detail,
                summary: draft.summary.trim() || editing.summary,
                version: draft.version.trim(),
                source: draft.source.trim(),
                owner: draft.owner.trim(),
                validUntil: draft.validUntil,
                status: "review",
                statusLabel: "검토 필요",
                generationSource: `${draft.owner.trim()} 직접 수정`
            });
            this.persistKnowledgeDrafts();
            this.knowledgeRegistrationOpen = false;
            this.selectedKnowledge = editing;
            this.knowledgeDetailOpen = true;
            await this.service.render();
            return;
        }
        let created = {
            id: `KH-DRAFT-${String(this.knowledgeItems.length + 1).padStart(3, "0")}`,
            type: draft.type,
            title: draft.title.trim(),
            detail: draft.summary.trim() || "등록 검토 중인 신규 지식입니다.",
            summary: draft.summary.trim() || "요약이 입력되지 않았습니다.",
            version: draft.version.trim(),
            source: draft.source.trim(),
            original: "원문 저장소 연결과 내용 검증이 필요합니다.",
            owner: draft.owner.trim(),
            validUntil: draft.validUntil,
            status: "review",
            statusLabel: "검토 필요",
            registrationKind: "user",
            registrationLabel: "사용자 등록",
            generationSource: `${draft.owner.trim()} 직접 등록`,
            createdRun: "직접 등록",
            createdAt: new Date().toLocaleString("ko-KR", { hour12: false }),
            dataTypes: ["K"],
            appliedAgents: ["적용 전"],
            runCount: 0,
            lastUsed: "사용 이력 없음",
            rules: ["검증·승인 완료 후 Agent 판단에 적용"],
            history: []
        };
        this.knowledgeItems.unshift(created);
        this.persistKnowledgeDrafts();
        this.knowledgeRegistrationOpen = false;
        this.knowledgeSearchText = "";
        this.knowledgeFilter = "전체";
        this.knowledgeDataFilter = "전체";
        this.knowledgeStatusFilter = "전체";
        this.knowledgeMetricFilter = "전체";
        this.selectedKnowledge = created;
        this.knowledgeDetailOpen = true;
        await this.service.render();
    }

    public async approveKnowledge(item: any) {
        if (!this.canManageKnowledge || !item || this.knowledgeValidationState(item) === "approved") return;
        item.status = "approved";
        item.statusLabel = "승인 완료";
        item.approvedAt = new Date().toLocaleString("ko-KR", { hour12: false });
        this.persistKnowledgeDrafts();
        await this.service.render();
    }

    @HostListener('document:keydown.escape')
    public closeLayerOnEscape() {
        if (this.reportPreviewOpen || this.reportCompareOpen || this.reportConfirmOpen) {
            this.closeReportLayer();
            return;
        }
        if (this.reportPackageMenuOpen) {
            this.closeReportPackageMenu();
            return;
        }
        if (this.evidenceDetailOpen) {
            this.closeEvidenceDetail();
            return;
        }
        if (this.componentDetailOpen) {
            this.closeComponentDetail();
            return;
        }
        if (this.knowledgeDetailOpen || this.knowledgeRegistrationOpen) this.closeKnowledgeLayer();
    }

    @HostListener('window:resize')
    public refitReportPreviewOnResize() {
        if (!this.reportPreviewOpen || this.reportPreviewZoomMode !== "fit") return;
        if (this.reportPreviewResizeTimer) clearTimeout(this.reportPreviewResizeTimer);
        this.reportPreviewResizeTimer = setTimeout(() => {
            this.reportPreviewResizeTimer = null;
            if (this.reportPreviewOpen && this.reportPreviewZoomMode === "fit") this.fitReportPreviewPage(false);
        }, 100);
    }

    public get currentGuideMenu() {
        for (let group of this.guideMenuGroups) {
            let menu = group.items.find((item: any) => item.key === this.selectedGuideMenu);
            if (menu) return menu;
        }
        return this.guideMenuGroups[0].items[0];
    }

    public get guideMenuCount() {
        return this.guideMenuGroups.reduce((count, group) => count + group.items.length, 0);
    }

    public async setRunStatusFilter(filter: string) {
        this.runStatusFilter = filter;
        let visibleRuns = this.filteredRuns;
        if (visibleRuns.length > 0 && !visibleRuns.some(run => run.id === this.activeRunId)) {
            await this.selectContextRun(visibleRuns[0].id, "runs");
            return;
        }
        this.persistPlatformState();
        await this.service.render();
    }

    public async setProjectMetricFilter(filter: string) {
        this.projectMetricFilter = filter;
        this.projectStatusFilter = ["active", "approval"].includes(filter) ? filter : "all";
        this.persistPlatformState();
        await this.service.render();
    }

    public onProjectStatusFilterChange() {
        this.projectMetricFilter = ["active", "approval"].includes(this.projectStatusFilter)
            ? this.projectStatusFilter
            : "all";
        this.persistPlatformState();
    }

    public async resetProjectFilters() {
        this.searchText = "";
        this.projectMetricFilter = "all";
        this.projectStatusFilter = "all";
        this.projectOwnerFilter = "all";
        this.projectUpdatedFilter = "all";
        this.projectSortOrder = "recent";
        this.persistPlatformState();
        await this.service.render();
    }

    public async resetRunFilters() {
        this.runSearchText = "";
        this.selectedRunComponentPart = "";
        this.runStatusFilter = "all";
        this.runProjectFilter = "all";
        this.runSortOrder = "newest";
        this.persistPlatformState();
        await this.service.render();
    }

    public async toggleTimeline(index: number) {
        this.expandedTimelineIndex = this.expandedTimelineIndex === index ? -1 : index;
        await this.service.render();
    }

    public async selectTimelineStage(stageKey: string) {
        this.selectedTimelineStage = stageKey;
        this.expandedTimelineIndex = stageKey === "all" || this.filteredRunTimeline.length === 0 ? -1 : 0;
        await this.service.render();
    }

    public async selectRun(run: any) {
        await this.selectContextRun(run.id, "runs");
    }

    public async selectContextProject(projectId: string) {
        let run = this.runs.find(item => item.projectId === projectId);
        if (!run) return;
        await this.selectContextRun(run.id, this.section);
    }

    public async selectContextRun(runId: string, targetSection: string = this.section) {
        let run = this.runs.find(item => item.id === runId);
        if (!run) return;
        this.evidenceDetailOpen = false;
        this.selectedEvidence = null;
        let index = this.runs.findIndex(item => item.id === run.id);
        this.selectedRun = index;
        this.activeRunId = run.id;
        this.selectedSettingsProject = run.projectId;
        let projectIndex = this.projects.findIndex(project => project.code === run.projectId);
        if (projectIndex >= 0) this.selectedProject = projectIndex;
        if (targetSection === "reports") this.reportRunFilter = run.id;
        this.expandedTimelineIndex = -1;
        this.selectedTimelineStage = "all";
        this.selectedApproval = 0;
        this.decisionObjectExpanded = false;
        this.resetApprovalFilterState();
        this.persistActiveRun();
        this.service.href(this.runLink(targetSection));
        await this.service.render();
    }

    public async selectApproval(index: number) {
        if (!this.runApprovals[index]) return;
        this.selectedApproval = index;
        this.decisionObjectExpanded = false;
        await this.service.render();
    }

    public async selectApprovalRecord(approval: any) {
        let index = this.runApprovals.findIndex(item => item.id === approval.id);
        if (index < 0) return;
        await this.selectApproval(index);
    }

    public isApprovalSelected(approval: any) {
        return this.currentApproval?.id === approval?.id;
    }

    public async toggleDecisionObject() {
        this.decisionObjectExpanded = !this.decisionObjectExpanded;
        await this.service.render();
    }

    public async onApprovalFilterChange() {
        let selectedId = this.currentApproval?.id;
        if (this.filteredRunApprovals.length > 0 && !this.filteredRunApprovals.some(item => item.id === selectedId)) {
            this.selectedApproval = this.runApprovals.findIndex(item => item.id === this.filteredRunApprovals[0].id);
            this.decisionObjectExpanded = false;
        }
        await this.service.render();
    }

    public async resetApprovalFilters() {
        this.resetApprovalFilterState();
        await this.onApprovalFilterChange();
    }

    public resetApprovalFilterState() {
        this.approvalSearchText = "";
        this.approvalDateFilter = "all";
        this.approvalApproverFilter = "all";
        this.approvalStatusFilter = "all";
    }

    public async setReportProjectFilter(project: string) {
        this.reportProjectFilter = project;
        this.reportDirectLinkId = "";
        this.reportLinkOrigin = "";
        this.persistPlatformState();
        await this.service.render();
    }

    public async setReportRunFilter(runId: string) {
        this.reportRunFilter = runId;
        this.reportDirectLinkId = "";
        this.reportLinkOrigin = "";
        if (runId === "all") {
            this.persistPlatformState();
            await this.service.render();
            return;
        }
        await this.selectContextRun(runId, "reports");
    }

    public async resetReportFilters() {
        this.reportTypeFilter = "all";
        this.reportProjectFilter = "all";
        this.reportRunFilter = this.activeRunId;
        this.reportApprovalFilter = "all";
        this.reportVersionFilter = "latest";
        this.reportDirectLinkId = "";
        this.reportLinkOrigin = "";
        this.persistPlatformState();
        await this.service.render();
    }

    public async openReportPreview(report: any, requestedVersion: string = "") {
        if (!report) return;
        let continuingFlow = this.selectedReport?.id === report.id && (this.reportPreviewOpen || this.reportCompareOpen || this.reportConfirmOpen);
        this.selectedReport = report;
        this.selectedReportVersion = requestedVersion || (continuingFlow ? this.selectedReportVersion : report.version);
        this.reportPreviewPage = continuingFlow ? this.reportPreviewPage : 1;
        if (!continuingFlow) {
            this.reportPreviewZoom = 65;
            this.reportPreviewZoomMode = "fit";
        }
        this.reportPackageMenuOpen = false;
        this.reportCompareOpen = false;
        this.reportConfirmOpen = false;
        this.reportPreviewOpen = true;
        await this.service.render();
        if (this.reportPreviewZoomMode === "fit") await this.fitReportPreviewPage(false);
    }

    public async openReportCompare(report: any, requestedVersion: string = "") {
        if (!report) return;
        let continuingFlow = this.selectedReport?.id === report.id && (this.reportPreviewOpen || this.reportCompareOpen || this.reportConfirmOpen);
        this.selectedReport = report;
        this.selectedReportVersion = requestedVersion || (continuingFlow ? this.selectedReportVersion : report.version);
        this.reportPackageMenuOpen = false;
        this.reportPreviewOpen = false;
        this.reportConfirmOpen = false;
        this.reportCompareOpen = true;
        await this.service.render();
    }

    public async openReportConfirm(report: any, requestedVersion: string = "") {
        if (!report) return;
        let continuingFlow = this.selectedReport?.id === report.id && (this.reportPreviewOpen || this.reportCompareOpen || this.reportConfirmOpen);
        this.selectedReport = report;
        this.selectedReportVersion = requestedVersion || (continuingFlow ? this.selectedReportVersion : report.version);
        this.reportPackageMenuOpen = false;
        this.reportPreviewOpen = false;
        this.reportCompareOpen = false;
        this.reportConfirmOpen = true;
        await this.service.render();
    }

    public async confirmReportDownload() {
        if (!this.selectedReport) return;
        this.downloadReport(this.selectedReport, this.reportDownloadFormat(this.selectedReport), this.reportSelectedVersion(this.selectedReport));
        await this.closeReportLayer();
    }

    public async closeReportLayer() {
        this.reportPreviewOpen = false;
        this.reportCompareOpen = false;
        this.reportConfirmOpen = false;
        this.reportPreviewPage = 1;
        this.reportPreviewZoom = 65;
        this.reportPreviewZoomMode = "fit";
        this.selectedReportVersion = "";
        this.selectedReport = null;
        await this.service.render();
    }

    public reportExportPayload(report: any, version: string = report?.version) {
        let reportView = { ...report, version };
        return {
            schema: "mobility-ai.report-manifest.v1",
            exportedAt: new Date().toISOString(),
            report: {
                id: report.id,
                type: report.typeLabel,
                title: report.title,
                project: report.project,
                run: report.run,
                createdAt: report.createdAt,
                version,
                generatedBy: report.agent,
                approvalStatus: report.approvalLabel,
                source: report.sourceLabel,
                format: this.reportDisplayFormat(reportView),
                summary: report.detail,
                pageCount: this.reportPageCount(reportView),
                sections: this.reportPreviewSections(reportView),
                designPurpose: this.reportDesignPurpose(reportView),
                executiveKpis: this.reportExecutiveKpis(reportView),
                requirements: this.reportRequirementMatrix(reportView),
                candidates: this.reportCandidateComparisons(reportView),
                selectionReasons: this.reportSelectionReasons(reportView),
                simulationResults: this.reportSimulationResults(reportView),
                bom: this.reportBomItems(reportView),
                designParameters: this.reportDesignParameters(reportView),
                aiRationale: this.reportAiRationale(reportView),
                tradeoffs: this.reportTradeoffs(reportView),
                changeHistory: this.reportChangeHistory(reportView),
                evidence: this.reportEvidenceLinks(reportView),
                approvalControl: this.reportApprovalControl(reportView),
                conclusion: this.reportConclusionItems(reportView)
            }
        };
    }

    public downloadReport(report: any, requestedFormat: string = this.reportDownloadFormat(report), requestedVersion: string = report?.version) {
        let format = ["PDF", "ZIP", "JSON"].includes(requestedFormat) ? requestedFormat : "JSON";
        let version = requestedVersion || report.version;
        let reportView = { ...report, version };
        let payload = this.reportExportPayload(report, version);
        let filename = `${report.id}_${version}`;
        if (format === "PDF") {
            this.saveReportBlob(this.createReportPdfBlob(reportView), `${filename}.pdf`);
            return;
        }
        if (format === "ZIP") {
            let content = JSON.stringify(payload, null, 2);
            this.saveReportBlob(this.createReportZipBlob(`${filename}_manifest.json`, content), `${filename}.zip`);
            return;
        }
        this.saveReportBlob(new Blob([JSON.stringify(payload, null, 2)], { type: "application/json;charset=utf-8" }), `${filename}_manifest.json`);
    }

    public downloadReportPackage(requestedFormat: string = this.reportPackageFormat) {
        let packageReports = this.packageSelectedReports;
        if (packageReports.length === 0) return;
        let payload = {
            schema: "mobility-ai.report-package.v1",
            exportedAt: new Date().toISOString(),
            run: this.activeRunId,
            project: this.currentRun.project,
            reportCount: packageReports.length,
            reports: packageReports.map(report => this.reportExportPayload(report, report.version).report)
        };
        let format = ["PDF", "ZIP", "JSON"].includes(requestedFormat) ? requestedFormat : "ZIP";
        let filename = `${this.activeRunId}_report-package`;
        if (format === "PDF") {
            let packageReport = {
                id: filename,
                type: "package",
                typeLabel: "Run Report Package",
                title: `${this.currentRun.project} Report Package`,
                project: this.currentRun.project,
                run: this.activeRunId,
                createdAt: new Date().toISOString(),
                version: "latest",
                agent: "Report Agent",
                approvalStatus: this.activeRunContext.approved ? "approved" : "pending",
                approvalLabel: this.activeRunContext.approved ? "승인 완료" : "승인 대기",
                sourceLabel: "실제 생성",
                format: "PDF",
                includedReports: packageReports.map(report => `${report.id} · ${report.version}`)
            };
            this.saveReportBlob(this.createReportPdfBlob(packageReport), `${filename}.pdf`);
            return;
        }
        if (format === "ZIP") {
            let files = [
                { filename: `${filename}_manifest.json`, content: JSON.stringify(payload, null, 2) },
                ...packageReports.map(report => ({
                    filename: `${report.id}_${report.version}.json`,
                    content: JSON.stringify(this.reportExportPayload(report, report.version), null, 2)
                }))
            ];
            this.saveReportBlob(this.createReportZipBundle(files), `${filename}.zip`);
            return;
        }
        this.saveReportBlob(new Blob([JSON.stringify(payload, null, 2)], { type: "application/json;charset=utf-8" }), `${filename}.json`);
    }

    public saveReportBlob(blob: Blob, filename: string) {
        let url = URL.createObjectURL(blob);
        let anchor = document.createElement("a");
        anchor.href = url;
        anchor.download = filename;
        document.body.appendChild(anchor);
        anchor.click();
        anchor.remove();
        setTimeout(() => URL.revokeObjectURL(url), 0);
    }

    public createReportPdfBlob(report: any) {
        let typeLabels: any = { design: "Design Report", simulation: "Simulation Evidence", approval: "Approval Record" };
        let reportType = typeLabels[report.type] || report.typeLabel || "Report Package";
        let version = report.version || "latest";
        let approval = String(report.approvalStatus || "pending").toUpperCase();
        let simulation = this.reportSimulationResults(report);
        let kpis = this.reportExecutiveKpis(report);
        let requirements = this.reportRequirementMatrix(report);
        let candidates = this.reportCandidateComparisons(report);
        let bom = this.reportBomItems(report);
        let parameters = this.reportDesignParameters(report);
        let evidenceLinks = this.reportEvidenceLinks(report);
        let stream = "";
        let text = (value: any, x: number, y: number, size: number, font: string = "F1", color: string = "0.16 0.22 0.28") => {
            stream += `${color} rg BT /${font} ${size} Tf ${x} ${y} Td (${this.escapePdfText(String(value || ""))}) Tj ET\n`;
        };
        let rect = (x: number, y: number, width: number, height: number, color: string, stroke: string = "") => {
            stream += `${color} rg ${x} ${y} ${width} ${height} re f\n`;
            if (stroke) stream += `${stroke} RG ${x} ${y} ${width} ${height} re S\n`;
        };

        rect(0, 786, 595, 56, "0.10 0.16 0.22");
        rect(44, 801, 28, 28, "0.36 0.82 0.72");
        text("MA", 50, 811, 9, "F2", "0.06 0.20 0.17");
        text("MOBILITY AI", 82, 815, 11, "F2", "1 1 1");
        text("ENGINEERING REPORT", 82, 804, 6, "F1", "0.68 0.77 0.82");
        text(`VERSION ${version}`, 470, 815, 8, "F2", "0.45 0.86 0.76");
        text(approval, 470, 803, 6, "F1", "0.76 0.82 0.86");

        text(`${reportType.toUpperCase()}  /  ${report.id || "REPORT-PACKAGE"}`, 44, 755, 7, "F2", "0.12 0.47 0.39");
        text(report.project || "Mobility AI Engineering", 44, 727, 21, "F2");
        text(`${reportType} - Design Validation Deliverable`, 44, 707, 11, "F1", "0.34 0.41 0.47");
        text(`RUN ${report.run || this.activeRunId}`, 44, 687, 8, "F2", "0.45 0.51 0.56");

        rect(44, 632, 507, 42, "0.96 0.97 0.97", "0.84 0.87 0.88");
        [
            ["ISSUE DATE", report.createdAt || new Date().toISOString()],
            ["PREPARED BY", report.agent || "Report Agent"],
            ["APPROVAL", approval],
            ["DOCUMENT", `${version} / ${this.reportPageCount(report)} pages`]
        ].forEach((item, index) => {
            let x = 54 + index * 126;
            text(item[0], x, 657, 6, "F2", "0.50 0.55 0.59");
            text(item[1], x, 642, 7, "F2", "0.22 0.29 0.35");
        });

        text("01", 44, 608, 8, "F2", "0.12 0.47 0.39");
        text("EXECUTIVE SUMMARY", 68, 608, 12, "F2");
        rect(44, 548, 507, 44, "0.94 0.97 0.96");
        text("This report consolidates the final design recommendation, simulation results,", 56, 572, 8, "F1", "0.31 0.38 0.43");
        text("traceable evidence and approval status for the selected actuator configuration.", 56, 558, 8, "F1", "0.31 0.38 0.43");

        let kpiWidth = 121;
        kpis.forEach((kpi: any, index: number) => {
            let x = 44 + index * 129;
            rect(x, 472, kpiWidth, 58, "0.98 0.98 0.98", "0.85 0.88 0.89");
            text(["REQUIREMENTS", "ALTERNATIVES", "PASS CANDIDATES", "MIN. SAFETY FACTOR"][index], x + 9, 513, 6, "F2", "0.45 0.51 0.56");
            text(kpi.value, x + 9, 490, 17, "F2", "0.12 0.24 0.31");
            text(kpi.detail, x + 9, 479, 6, "F1", "0.57 0.61 0.65");
        });

        text("02", 44, 446, 8, "F2", "0.12 0.47 0.39");
        text("DESIGN PURPOSE", 68, 446, 12, "F2");
        rect(44, 370, 507, 56, "0.95 0.97 0.97", "0.82 0.88 0.86");
        text("Select a production-ready tailgate actuator configuration that satisfies motion,", 58, 404, 8, "F1", "0.31 0.38 0.43");
        text("load, strength, clearance, durability, thermal and cost requirements together.", 58, 388, 8, "F1", "0.31 0.38 0.43");
        text("03", 44, 342, 8, "F2", "0.12 0.47 0.39");
        text("FINAL RECOMMENDATION", 68, 342, 12, "F2");
        rect(44, 244, 507, 78, "0.10 0.16 0.22");
        text("SELECTED CANDIDATE", 58, 298, 6, "F2", "0.42 0.83 0.73");
        text("BALANCED #03 / MULTI-OBJECTIVE SCORE 92", 58, 276, 14, "F2", "1 1 1");
        text("All 8 requirements and 6 simulation domains passed. Approved for baseline release.", 58, 257, 8, "F1", "0.83 0.88 0.91");
        rect(44, 180, 507, 46, "0.91 0.97 0.95", "0.70 0.84 0.80");
        text("OVERALL VALIDATION", 58, 207, 6, "F2", "0.12 0.47 0.39");
        text(report.approvalStatus === "approved" ? "ALL PASS / APPROVED" : "REVIEW REQUIRED", 58, 190, 11, "F2", report.approvalStatus === "approved" ? "0.12 0.45 0.36" : "0.68 0.22 0.19");

        text(report.id || "REPORT-PACKAGE", 44, 38, 6, "F1", "0.52 0.57 0.61");
        text("MOBILITY AI / CONFIDENTIAL", 238, 38, 6, "F1", "0.52 0.57 0.61");
        text(`1 / ${this.reportPageCount(report)}`, 516, 38, 6, "F2", "0.30 0.37 0.42");
        stream += "0.84 0.87 0.88 RG 44 52 507 0.6 re S\n";
        let encoder = new TextEncoder();
        let pageCount = this.reportPageCount(report);
        let pageStreams = [stream];
        for (let page = 2; page <= pageCount; page++) {
            let pageStream = "";
            let pageText = (value: any, x: number, y: number, size: number, font: string = "F1", color: string = "0.16 0.22 0.28") => {
                pageStream += `${color} rg BT /${font} ${size} Tf ${x} ${y} Td (${this.escapePdfText(String(value || ""))}) Tj ET\n`;
            };
            let pageRect = (x: number, y: number, width: number, height: number, color: string, stroke: string = "") => {
                pageStream += `${color} rg ${x} ${y} ${width} ${height} re f\n`;
                if (stroke) pageStream += `${stroke} RG ${x} ${y} ${width} ${height} re S\n`;
            };
            pageRect(0, 786, 595, 56, "0.10 0.16 0.22");
            pageRect(44, 801, 28, 28, "0.36 0.82 0.72");
            pageText("MA", 50, 811, 9, "F2", "0.06 0.20 0.17");
            pageText("MOBILITY AI", 82, 815, 11, "F2", "1 1 1");
            pageText("ENGINEERING REPORT", 82, 804, 6, "F1", "0.68 0.77 0.82");
            pageText(`VERSION ${version}`, 470, 815, 8, "F2", "0.45 0.86 0.76");
            pageText(`${String(page).padStart(2, "0")}  /  ${this.reportPageLabel(page, report).toUpperCase()}`, 44, 754, 7, "F2", "0.12 0.47 0.39");
            pageText(this.reportPageLabel(page, report), 44, 724, 21, "F2");
            pageText(`${report.project || "Mobility AI Engineering"} / ${report.run || this.activeRunId}`, 44, 703, 8, "F1", "0.42 0.48 0.53");
            pageStream += "0.84 0.87 0.88 RG 44 685 507 0.6 re S\n";

            if (page === 2) {
                pageText("USER REQUIREMENT / AGENT-NORMALIZED CRITERIA", 44, 656, 10, "F2");
                pageRect(44, 622, 507, 22, "0.16 0.23 0.29");
                ["ID", "USER REQUIREMENT", "AGENT CRITERIA", "RESULT", "STATUS"].forEach((label, index) => pageText(label, [52, 104, 260, 447, 506][index], 630, 5.5, "F2", "1 1 1"));
                let requirementEnglish = [
                    ["Full-open time <= 5.2 s", "Motion profile / overshoot <= 2%"],
                    ["Stable operation at 15 deg", "Peak spindle load <= 4.5 kN"],
                    ["No permanent bracket set", "Stress <= 210 MPa / SF >= 1.20"],
                    ["No body or trim interference", "Minimum clearance >= 8 mm"],
                    ["Durability above 100k cycles", "L10 fatigue life >= 100k"],
                    ["High-temperature operation", "85C ambient / winding <= 105C"],
                    ["Vehicle current limit", "Peak current <= 18 A at 13.5 V"],
                    ["Meet target cost", "BOM delta <= 5% vs baseline"]
                ];
                requirements.forEach((requirement: any, index: number) => {
                    let y = 591 - index * 52;
                    if (index % 2 === 1) pageRect(44, y - 14, 507, 48, "0.97 0.98 0.98");
                    pageText(requirement.id, 52, y + 8, 6, "F2");
                    pageText(requirementEnglish[index][0], 104, y + 8, 6.5);
                    pageText(requirementEnglish[index][1], 260, y + 8, 6.5);
                    pageText(requirement.result, 447, y + 8, 6.5, "F2");
                    pageText(requirement.status, 506, y + 8, 6, "F2", requirement.status === "PASS" ? "0.12 0.45 0.36" : "0.68 0.22 0.19");
                });
                pageRect(44, 138, 507, 50, "0.94 0.97 0.96", "0.74 0.85 0.82");
                pageText("TRACEABILITY RULE", 58, 169, 6, "F2", "0.12 0.47 0.39");
                pageText("Original requirement, normalized criterion, result and evidence are version-locked together.", 58, 150, 7.5);
            } else if (page === 3) {
                pageText("PASS CANDIDATE COMPARISON", 44, 656, 10, "F2");
                pageRect(44, 622, 507, 22, "0.16 0.23 0.29");
                ["CANDIDATE", "MOTION", "LOAD", "CLEARANCE", "FATIGUE", "COST", "SCORE"].forEach((label, index) => pageText(label, [52, 180, 235, 292, 370, 432, 502][index], 630, 5.5, "F2", "1 1 1"));
                candidates.forEach((candidate: any, index: number) => {
                    let y = 578 - index * 58;
                    pageRect(44, y - 13, 507, 48, candidate.selected ? "0.92 0.97 0.95" : index % 2 ? "0.97 0.98 0.98" : "1 1 1", candidate.selected ? "0.32 0.66 0.56" : "0.86 0.88 0.89");
                    pageText(`${candidate.rank} / ${candidate.name}`, 52, y + 7, 7.5, "F2");
                    pageText(candidate.motion, 180, y + 7, 7);
                    pageText(candidate.load, 235, y + 7, 7);
                    pageText(candidate.clearance, 292, y + 7, 7);
                    pageText(candidate.fatigue, 370, y + 7, 7);
                    pageText(candidate.cost, 432, y + 7, 7);
                    pageText(candidate.score, 510, y + 7, 9, "F2", "0.12 0.45 0.36");
                });
                pageText("FINAL SELECTION / BALANCED #03", 44, 398, 10, "F2");
                [
                    "Highest combined performance, safety, cost and mass score among all-pass candidates.",
                    "11.6 mm clearance and 128k-cycle fatigue life provide robust production margin.",
                    "Accepts +0.3 s opening time versus Performance #17 to reduce BOM delta by 4.8%p."
                ].forEach((reason, index) => {
                    let y = 340 - index * 62;
                    pageRect(44, y, 507, 46, "0.96 0.98 0.97", "0.82 0.88 0.86");
                    pageText(String(index + 1).padStart(2, "0"), 58, y + 17, 7, "F2", "0.12 0.47 0.39");
                    pageText(reason, 88, y + 17, 7.5);
                });
            } else if (page === 4) {
                pageText("SIX-DOMAIN VALIDATION TABLE", 44, 656, 10, "F2");
                pageRect(44, 622, 507, 22, "0.16 0.23 0.29");
                ["DOMAIN / METRIC", "TARGET", "RESULT", "MARGIN", "STATUS"].forEach((label, index) => pageText(label, [52, 220, 330, 415, 500][index], 630, 5.5, "F2", "1 1 1"));
                simulation.forEach((result: any, index: number) => {
                    let y = 590 - index * 39;
                    if (index % 2 === 1) pageRect(44, y - 10, 507, 35, "0.97 0.98 0.98");
                    pageText(`${result.category} / ${result.metric}`, 52, y + 4, 6.5, "F2");
                    pageText(result.target, 220, y + 4, 6.5);
                    pageText(result.result, 330, y + 4, 6.5);
                    pageText(result.margin, 415, y + 4, 6.5);
                    pageText(result.status, 500, y + 4, 6, "F2", result.status === "PASS" ? "0.12 0.45 0.36" : "0.68 0.22 0.19");
                });
                pageText("NORMALIZED VALIDATION MARGIN", 44, 338, 10, "F2");
                simulation.forEach((result: any, index: number) => {
                    let y = 302 - index * 32;
                    pageText(result.category, 52, y + 3, 6.5, "F2");
                    pageRect(120, y, 373, 10, "0.90 0.92 0.92");
                    pageRect(120, y, Math.max(0, Math.min(373, result.score * 3.73)), 10, result.status === "PASS" ? "0.25 0.62 0.52" : "0.76 0.35 0.31");
                    pageText(String(result.score), 508, y + 2, 6.5, "F2");
                });
            } else if (page === 5) {
                pageText("FINAL BILL OF MATERIALS", 44, 656, 10, "F2");
                pageRect(44, 622, 507, 22, "0.16 0.23 0.29");
                ["ITEM", "PART NO.", "SPECIFICATION", "QTY", "STATUS"].forEach((label, index) => pageText(label, [52, 146, 270, 456, 494][index], 630, 5.5, "F2", "1 1 1"));
                bom.forEach((item: any, index: number) => {
                    let y = 590 - index * 42;
                    if (index % 2 === 1) pageRect(44, y - 10, 507, 37, "0.97 0.98 0.98");
                    pageText(item.item, 52, y + 4, 6.5, "F2");
                    pageText(item.partNo, 146, y + 4, 6.5);
                    pageText(item.specification, 270, y + 4, 6.5);
                    pageText(item.qty, 460, y + 4, 6.5, "F2");
                    pageText(item.status, 494, y + 4, 5.5, "F2", "0.12 0.45 0.36");
                });
                pageText("RELEASED DESIGN PARAMETERS", 44, 318, 10, "F2");
                parameters.forEach((parameter: any, index: number) => {
                    let column = index % 3;
                    let row = Math.floor(index / 3);
                    let x = 44 + column * 171;
                    let y = 234 - row * 92;
                    pageRect(x, y, 160, 72, "0.96 0.98 0.98", "0.84 0.88 0.89");
                    pageText(parameter.label.toUpperCase(), x + 10, y + 50, 5.5, "F2", "0.42 0.49 0.54");
                    pageText(parameter.value, x + 10, y + 29, 10, "F2");
                    pageText(`${parameter.tolerance} / ${parameter.source}`, x + 10, y + 13, 6, "F1", "0.49 0.55 0.59");
                });
            } else if (page === 6) {
                pageText("AI RECOMMENDATION BASIS", 44, 656, 10, "F2");
                let rationaleEnglish = [
                    ["OPT-RANK-003 / CONFIDENCE 94%", "Multi-objective optimization rank #1", "Highest weighted score across performance, safety, cost and mass."],
                    ["DOE-MC-1000 / CONFIDENCE 92%", "Production-variation robustness", "97.8% requirement pass probability in 1,000-run Monte Carlo analysis."],
                    ["KH-2025-BRK-017 / CONFIDENCE 89%", "Historical failure-pattern avoidance", "Stress concentration moved 18 mm and local bracket curvature was reduced."]
                ];
                rationaleEnglish.forEach((item, index) => {
                    let y = 548 - index * 104;
                    pageRect(44, y, 507, 84, "0.97 0.98 0.98", "0.82 0.88 0.86");
                    pageRect(44, y, 4, 84, "0.25 0.62 0.52");
                    pageText(item[0], 58, y + 61, 6, "F2", "0.12 0.47 0.39");
                    pageText(item[1], 58, y + 40, 10, "F2");
                    pageText(item[2], 58, y + 19, 7.5, "F1", "0.39 0.46 0.51");
                });
                pageText("ACCEPTED TRADE-OFFS", 44, 322, 10, "F2");
                [
                    ["PERFORMANCE vs COST", "+0.3 s opening time", "4.8%p lower BOM delta"],
                    ["MASS vs DURABILITY", "+0.18 kg bracket mass", "+19k fatigue cycles"],
                    ["PACKAGE vs STIFFNESS", "+4 mm upper mount shift", "+2.2 mm clearance / -14% stress"]
                ].forEach((item, index) => {
                    let x = 44 + index * 171;
                    pageRect(x, 208, 160, 86, "0.94 0.97 0.96", "0.78 0.86 0.83");
                    pageText(item[0], x + 10, 271, 5.5, "F2", "0.12 0.47 0.39");
                    pageText(item[1], x + 10, 247, 7.5, "F2");
                    pageText(item[2], x + 10, 225, 6.5, "F1", "0.39 0.46 0.51");
                });
            } else if (page === 7) {
                pageText("VERSION HISTORY & DIFF", 44, 656, 10, "F2");
                let historyEnglish = [
                    [version, "CURRENT", "Final candidate, validation and evidence locked."],
                    [report.previousVersion || "v1.3", "PREVIOUS", "Candidate evaluation baseline before final approval."],
                    ["v1.2", "ARCHIVED", "Static and fatigue failure causes recorded."]
                ];
                historyEnglish.forEach((item, index) => {
                    let x = 44 + index * 171;
                    pageRect(x, 544, 160, 88, "0.97 0.98 0.98", "0.84 0.88 0.89");
                    pageText(`${item[0]} / ${item[1]}`, x + 10, 608, 6, "F2", "0.12 0.47 0.39");
                    pageText(item[2], x + 10, 582, 6.5, "F1");
                    pageText(index === 0 ? report.createdAt : index === 1 ? "2026.07.23 09:42" : "2026.07.22 18:10", x + 10, 558, 5.5, "F1", "0.49 0.55 0.59");
                });
                pageText("FIELD DIFF", 44, 512, 9, "F2");
                this.reportVersionChanges(report).filter((change: any) => change.changed).forEach((change: any, index: number) => {
                    let y = 465 - index * 44;
                    pageText(change.field, 52, y + 9, 6, "F2");
                    pageRect(126, y, 202, 28, "0.99 0.92 0.91");
                    pageText(`- ${change.before}`, 134, y + 9, 6, "F1", "0.62 0.24 0.25");
                    pageRect(336, y, 215, 28, "0.88 0.96 0.93");
                    pageText(`+ ${change.after}`, 344, y + 9, 6, "F1", "0.12 0.45 0.36");
                });
                pageText("LINKED ENGINEERING EVIDENCE", 44, 326, 9, "F2");
                evidenceLinks.forEach((evidence: any, index: number) => {
                    let y = 282 - index * 38;
                    pageRect(44, y, 507, 30, index % 2 ? "0.97 0.98 0.98" : "1 1 1", "0.86 0.88 0.89");
                    pageText(evidence.kind, 52, y + 10, 5.5, "F2", "0.12 0.47 0.39");
                    pageText(evidence.title, 122, y + 10, 6.5, "F2");
                    pageText(evidence.id, 410, y + 10, 6, "F1");
                    pageText(evidence.status, 500, y + 10, 5.5, "F2", "0.12 0.45 0.36");
                });
            } else if (page === 8) {
                pageRect(44, 550, 507, 104, "0.10 0.16 0.22");
                pageText("FINAL RECOMMENDATION", 62, 625, 7, "F2", "0.42 0.83 0.73");
                pageText(report.approvalStatus === "approved" ? "BALANCED #03 / BASELINE RELEASE" : "REVISION AND RE-VALIDATION REQUIRED", 62, 596, 15, "F2", "1 1 1");
                pageText("8 requirements and 6 simulation domains are linked to this release decision.", 62, 574, 8, "F1", "0.76 0.82 0.86");
                pageText("APPROVAL & DOCUMENT CONTROL", 44, 514, 10, "F2");
                let approvalRows = [
                    ["APPROVAL STATUS", approval],
                    ["FINAL APPROVER", report.approvalStatus === "approved" ? "KIM DO YOON / LEAD ENGINEER" : "PENDING"],
                    ["GENERATED BY", report.agent || "Report Agent"],
                    ["GENERATED AT", report.createdAt || "-"],
                    ["REPORT VERSION", version],
                    ["AUDIT HASH", `SHA256:${String(report.run || "RUN").replace(/-/g, "").slice(0, 8)}...8F41`]
                ];
                approvalRows.forEach((item, index) => {
                    let column = index % 2;
                    let row = Math.floor(index / 2);
                    let x = 44 + column * 254;
                    let y = 420 - row * 76;
                    pageRect(x, y, 247, 60, "0.97 0.98 0.98", "0.84 0.88 0.89");
                    pageText(item[0], x + 12, y + 39, 6, "F2", "0.47 0.53 0.57");
                    pageText(item[1], x + 12, y + 18, 8, "F2");
                });
                pageRect(44, 140, 507, 62, "0.92 0.97 0.95", "0.70 0.84 0.80");
                pageText("RELEASE DECISION", 58, 179, 6, "F2", "0.12 0.47 0.39");
                pageText(report.approvalStatus === "approved" ? "APPROVED / PROCEED TO DETAILED RELEASE" : "HOLD / CREATE REDESIGN RUN", 58, 157, 10, "F2");
            }
            pageText(report.id || "REPORT-PACKAGE", 44, 38, 6, "F1", "0.52 0.57 0.61");
            pageText("MOBILITY AI / CONFIDENTIAL", 238, 38, 6, "F1", "0.52 0.57 0.61");
            pageText(`${page} / ${pageCount}`, 516, 38, 6, "F2", "0.30 0.37 0.42");
            pageStream += "0.84 0.87 0.88 RG 44 52 507 0.6 re S\n";
            pageStreams.push(pageStream);
        }

        let fontRegularId = 3 + pageStreams.length * 2;
        let fontBoldId = fontRegularId + 1;
        let pageIds = pageStreams.map((_, index) => 3 + index * 2);
        let objects: string[] = [
            "<< /Type /Catalog /Pages 2 0 R >>",
            `<< /Type /Pages /Kids [${pageIds.map(id => `${id} 0 R`).join(" ")}] /Count ${pageStreams.length} >>`
        ];
        pageStreams.forEach((pageStream, index) => {
            let contentId = 4 + index * 2;
            objects.push(`<< /Type /Page /Parent 2 0 R /MediaBox [0 0 595 842] /Resources << /Font << /F1 ${fontRegularId} 0 R /F2 ${fontBoldId} 0 R >> >> /Contents ${contentId} 0 R >>`);
            objects.push(`<< /Length ${encoder.encode(pageStream).length} >>\nstream\n${pageStream}\nendstream`);
        });
        objects.push("<< /Type /Font /Subtype /Type1 /BaseFont /Helvetica >>");
        objects.push("<< /Type /Font /Subtype /Type1 /BaseFont /Helvetica-Bold >>");
        let pdf = "%PDF-1.4\n";
        let offsets: number[] = [0];
        objects.forEach((object, index) => {
            offsets.push(encoder.encode(pdf).length);
            pdf += `${index + 1} 0 obj\n${object}\nendobj\n`;
        });
        let xrefOffset = encoder.encode(pdf).length;
        pdf += `xref\n0 ${objects.length + 1}\n0000000000 65535 f \n`;
        offsets.slice(1).forEach(offset => pdf += `${String(offset).padStart(10, "0")} 00000 n \n`);
        pdf += `trailer\n<< /Size ${objects.length + 1} /Root 1 0 R >>\nstartxref\n${xrefOffset}\n%%EOF`;
        return new Blob([encoder.encode(pdf)], { type: "application/pdf" });
    }

    public escapePdfText(value: string) {
        return String(value || "")
            .replace(/[^\x20-\x7E]/g, " ")
            .replace(/\\/g, "\\\\")
            .replace(/\(/g, "\\(")
            .replace(/\)/g, "\\)");
    }

    public createReportZipBlob(filename: string, content: string) {
        return this.createReportZipBundle([{ filename, content }]);
    }

    public createReportZipBundle(files: any[]) {
        let encoder = new TextEncoder();
        let local: number[] = [];
        let central: number[] = [];
        files.forEach(file => {
            let name = encoder.encode(String(file.filename || "report.json"));
            let data = encoder.encode(String(file.content || ""));
            let crc = this.reportCrc32(data);
            let localOffset = local.length;
            this.writeReportUint32(local, 0x04034b50);
            this.writeReportUint16(local, 20);
            this.writeReportUint16(local, 0);
            this.writeReportUint16(local, 0);
            this.writeReportUint16(local, 0);
            this.writeReportUint16(local, 0);
            this.writeReportUint32(local, crc);
            this.writeReportUint32(local, data.length);
            this.writeReportUint32(local, data.length);
            this.writeReportUint16(local, name.length);
            this.writeReportUint16(local, 0);
            local.push(...Array.from(name), ...Array.from(data));
            this.writeReportUint32(central, 0x02014b50);
            this.writeReportUint16(central, 20);
            this.writeReportUint16(central, 20);
            this.writeReportUint16(central, 0);
            this.writeReportUint16(central, 0);
            this.writeReportUint16(central, 0);
            this.writeReportUint16(central, 0);
            this.writeReportUint32(central, crc);
            this.writeReportUint32(central, data.length);
            this.writeReportUint32(central, data.length);
            this.writeReportUint16(central, name.length);
            this.writeReportUint16(central, 0);
            this.writeReportUint16(central, 0);
            this.writeReportUint16(central, 0);
            this.writeReportUint16(central, 0);
            this.writeReportUint32(central, 0);
            this.writeReportUint32(central, localOffset);
            central.push(...Array.from(name));
        });
        let end: number[] = [];
        this.writeReportUint32(end, 0x06054b50);
        this.writeReportUint16(end, 0);
        this.writeReportUint16(end, 0);
        this.writeReportUint16(end, files.length);
        this.writeReportUint16(end, files.length);
        this.writeReportUint32(end, central.length);
        this.writeReportUint32(end, local.length);
        this.writeReportUint16(end, 0);
        return new Blob([new Uint8Array([...local, ...central, ...end])], { type: "application/zip" });
    }

    public reportCrc32(data: Uint8Array) {
        let crc = 0xffffffff;
        data.forEach(byte => {
            crc ^= byte;
            for (let bit = 0; bit < 8; bit++) crc = (crc >>> 1) ^ ((crc & 1) ? 0xedb88320 : 0);
        });
        return (crc ^ 0xffffffff) >>> 0;
    }

    public writeReportUint16(target: number[], value: number) {
        target.push(value & 0xff, (value >>> 8) & 0xff);
    }

    public writeReportUint32(target: number[], value: number) {
        target.push(value & 0xff, (value >>> 8) & 0xff, (value >>> 16) & 0xff, (value >>> 24) & 0xff);
    }

    public exportAuditRecord() {
        let approval = this.currentApproval;
        let payload = {
            schema: "mobility-ai.approval-audit.v1",
            exportedAt: new Date().toISOString(),
            scope: {
                activeRun: this.activeRunId,
                approvalId: approval.id
            },
            run: {
                id: this.activeRunId,
                project: this.currentRun.project,
                status: this.currentRun.status
            },
            approval: {
                id: approval.id,
                sourceRun: approval.run,
                type: approval.typeLabel,
                decision: approval.decision,
                status: this.approvalStatusLabel(approval.status),
                approver: approval.approver,
                role: approval.role,
                timestamp: approval.timestamp,
                object: approval.design,
                comment: approval.comment,
                rejectionReason: approval.rejectionReason || null,
                retryRun: approval.retryRun || null,
                changes: approval.changes || [],
                evidence: (approval.evidence || []).map((item: any) => ({
                    name: item.name,
                    version: item.version,
                    integrity: item.status
                })),
                auditHash: approval.hash,
                auditHashEnvironment: "DEMO",
                auditHashNotice: "검증용 Demo Audit Hash이며 운영 감사 서명이 아닙니다."
            }
        };
        this.service.file.download(payload, `${this.activeRunId}_${approval.id}_audit-record.json`);
    }

    public workspaceLink(project: any) {
        return `/dashboard?run=${encodeURIComponent(project.runId)}`;
    }

    public async openProjectWorkspace(project: any) {
        let index = this.projects.findIndex(item => item.runId === project.runId);
        if (index >= 0) this.selectedProject = index;
        let runIndex = this.runs.findIndex(item => item.id === project.runId);
        if (runIndex >= 0) this.selectedRun = runIndex;
        this.activeRunId = project.runId;
        this.persistActiveRun();
        this.service.href(this.workspaceLink(project));
    }

    public async setComponentCategory(category: string) {
        this.componentCategory = category;
        this.persistPlatformState();
        await this.service.render();
    }

    public async setComponentStateFilter(state: string) {
        this.componentStateFilter = this.componentStateFilter === state ? "전체" : state;
        this.persistPlatformState();
        await this.service.render();
    }

    public async resetComponentFilters() {
        this.componentSearchText = "";
        this.componentCategory = "전체";
        this.componentMakerFilter = "전체";
        this.componentPriceFilter = "all";
        this.componentTemperatureFilter = "all";
        this.componentConfidenceFilter = "all";
        this.componentVerificationFilter = "전체";
        this.componentStateFilter = "전체";
        this.componentSortOrder = "agent";
        this.persistPlatformState();
        await this.service.render();
    }

    public async openComponentDetail(component: any) {
        this.selectedComponent = component;
        this.componentSelectionNotice = "";
        this.componentDetailOpen = true;
        await this.service.render();
    }

    public async openComponentConfidence(component: any, event?: any) {
        if (event) event.stopPropagation();
        await this.openComponentDetail(component);
    }

    public async closeComponentDetail() {
        this.componentDetailOpen = false;
        this.componentSelectionNotice = "";
        await this.service.render();
    }

    public async selectComponentForRun(component: any) {
        if (component.state === "excluded" || component.compatibility === "incompatible") {
            this.componentSelectionNotice = `선택 불가 · ${component.exclusionReason || "현재 Run 설계 변수와 호환되지 않습니다."}`;
        } else if (component.compatibility === "conditional") {
            this.componentSelectionNotice = "조건부 후보로 추가 · CHECK 항목을 검증한 뒤 Agent가 최종 조합을 평가합니다.";
        } else {
            this.componentSelectionNotice = `${component.part}을(를) 현재 Run 후보로 추가했습니다. ${component.compatibilityLabel} 결과가 Agent에 전달됩니다.`;
        }
        await this.service.render();
    }

    public openComponentRuns(part: string, event?: any) {
        if (event) event.stopPropagation();
        this.componentDetailOpen = false;
        this.runSearchText = part;
        this.selectedRunComponentPart = part;
        this.persistPlatformState();
        this.service.href(`/platform/runs/${this.activeRunId}?component=${encodeURIComponent(part)}`);
    }

    public async openComponentAsset(component: any, asset: any) {
        await this.demoAction(asset.name, `${component.part}의 ${asset.type} 자산(${asset.meta})을 PLM 원본 저장소에서 여는 기능입니다.`);
    }

    public get settings() {
        if (this.settingsScope === "global") return this.settingsByScope.global;
        return this.settingsByScope.projects[this.selectedSettingsProject] || this.settingsByScope.global;
    }

    public get currentSettingsProject() {
        return this.settingsProjects.find(project => project.id === this.selectedSettingsProject) || this.settingsProjects[0];
    }

    public get settingsScopeLabel() {
        return this.settingsScope === "global" ? "프로젝트 공통" : "프로젝트별";
    }

    public get settingsScopeTarget() {
        return this.settingsScope === "global" ? "전체 프로젝트" : this.currentSettingsProject.name;
    }

    public get filteredSettingAuditLog() {
        if (this.settingsAuditScopeFilter === "all") return this.settingAuditLog;
        return this.settingAuditLog.filter(log => log.scopeType === this.settingsAuditScopeFilter);
    }

    public settingsForGroup(group: string) {
        return this.settingsCatalog.filter(setting => setting.group === group);
    }

    public settingAuditCount(scope: string) {
        return this.settingAuditLog.filter(log => log.scopeType === scope).length;
    }

    public settingAuditValue(log: any, side: string) {
        if (log?.[side]) return log[side];
        let values = String(log?.change || "").split("→").map(value => value.trim());
        if (side === "before") return values[0] || "—";
        return values[1] || "—";
    }

    public loadDemoSettings() {
        if (typeof localStorage === "undefined") return;
        try {
            let stored = JSON.parse(localStorage.getItem(this.settingsStorageKey) || "null");
            if (!stored) return;
            if (stored.global) {
                this.settingsByScope.global = { ...this.settingsByScope.global, ...stored.global };
            }
            if (stored.projects) {
                this.settingsProjects.forEach(project => {
                    if (!stored.projects[project.id]) return;
                    this.settingsByScope.projects[project.id] = {
                        ...this.settingsByScope.projects[project.id],
                        ...stored.projects[project.id]
                    };
                });
            }
            if (Array.isArray(stored.auditLog)) this.settingAuditLog = stored.auditLog;
            if (stored.savedAt) this.settingSavedAt = stored.savedAt;
        } catch (error) {
            // Demo defaults remain available when browser storage is restricted or invalid.
        }
    }

    public persistDemoSettings() {
        if (typeof localStorage === "undefined") return;
        try {
            localStorage.setItem(this.settingsStorageKey, JSON.stringify({
                global: this.settingsByScope.global,
                projects: this.settingsByScope.projects,
                auditLog: this.settingAuditLog,
                savedAt: this.settingSavedAt
            }));
        } catch (error) {
            // The current screen state remains usable when browser storage is restricted.
        }
    }

    public settingsTimestamp() {
        let now = new Date();
        let pad = (value: number) => String(value).padStart(2, "0");
        return `${now.getFullYear()}.${pad(now.getMonth() + 1)}.${pad(now.getDate())} ${pad(now.getHours())}:${pad(now.getMinutes())}`;
    }

    public async setSettingsView(view: string) {
        this.settingsView = view;
        this.persistPlatformState();
        await this.service.render();
    }

    public async setSettingsScope(scope: string) {
        this.settingsScope = scope;
        this.persistPlatformState();
        await this.service.render();
    }

    public async selectSettingsProject(projectId: string) {
        this.selectedSettingsProject = projectId;
        await this.selectContextProject(projectId);
    }

    public async toggleSetting(key: string) {
        let setting = this.settingsCatalog.find(item => item.key === key);
        if (!setting) return;
        let previous = Boolean(this.settings[key]);
        let next = !previous;
        if (setting.risk === "high") {
            let changeImpact = next
                ? `이 설정을 켜면 ${setting.workflow} 흐름이 필수 정책으로 즉시 적용됩니다.`
                : setting.disableDetail;
            let confirmed = await this.service.modal.show({
                title: `${setting.title}을(를) ${next ? "켜시겠습니까?" : "끄시겠습니까?"}`,
                message: `적용 범위 · ${this.settingsScopeLabel} / ${this.settingsScopeTarget}\n영향 Agent · ${setting.agents}\n영향 Workflow · ${setting.workflow}\n\n${changeImpact}\n\nDEMO MODE에서는 실제 시스템이 아닌 샘플 설정만 변경됩니다.`,
                cancel: "취소",
                action: "변경 적용",
                actionBtn: "warning",
                status: "warning"
            });
            if (!confirmed) return;
        }
        await this.commitSettingChange(setting, previous, next);
    }

    public async commitSettingChange(setting: any, previous: boolean, next: boolean) {
        this.settingSaveState = "saving";
        this.settingSaveMessage = `${setting.title} 저장 중…`;
        this.settings[setting.key] = next;
        await this.service.render();

        this.settingSavedAt = this.settingsTimestamp();
        let before = previous ? "ON" : "OFF";
        let after = next ? "ON" : "OFF";
        this.settingAuditLog.unshift({
            id: `AUD-${Date.now()}`,
            at: this.settingSavedAt,
            actor: "박현우",
            role: "Platform Admin",
            scope: this.settingsScopeLabel,
            scopeType: this.settingsScope,
            target: this.settingsScopeTarget,
            setting: setting.title,
            before,
            after,
            change: `${before} → ${after}`,
            agents: setting.agents,
            workflow: setting.workflow
        });
        this.persistDemoSettings();
        this.settingSaveState = "saved";
        this.settingSaveMessage = `${setting.title} 저장 완료`;
        await this.service.render();
    }

    public async showExternalDataGuide() {
        await this.service.modal.show({
            title: "외부 데이터 연동 방법",
            message: "1. 데이터 연계에서 승인된 커넥터를 등록합니다.\n2. 보안 검토 후 사용할 도메인과 데이터 유형을 Allowlist에 추가합니다.\n3. 프로젝트 권한자가 적용 범위를 승인합니다.\n4. 연결 테스트가 PASS되면 외부 데이터 활용을 켭니다.\n\n현재 DEMO MODE에는 실제 커넥터가 연결되지 않습니다.",
            cancel: false,
            action: "확인",
            actionBtn: "success",
            status: "success"
        });
    }

    public async openSettingsPolicyFromAudit() {
        this.settingsView = "policy";
        this.persistPlatformState();
        await this.service.render();
    }

    public async selectGuideMenu(key: string) {
        this.selectedGuideMenu = key;
        await this.service.render();
    }

    public scrollToGuide(id: string) {
        let target: any = document.getElementById(id);
        if (!target) return;
        target.scrollIntoView({ behavior: "smooth", block: "start" });
    }

    public async demoAction(title: string, message: string = "") {
        await this.service.modal.show({
            title,
            message: message || "데모 화면에서 기능 흐름을 확인했습니다. 실제 운영에서는 프로젝트 권한과 서버 데이터에 연결됩니다.",
            cancel: false,
            action: "확인",
            actionBtn: "success",
            status: "success"
        });
    }
}

export default PagePlatformComponent;